// aaa
if (
    ((window.hsonslidecart = window.hsonslidecart || {}),
    (window.hsonslidecart = window.hsonslidecart || {}),
    (hsonslidecart.Currency = {
        formatMoney: function (t, e) {
            "string" == typeof t && (t = t.replace(".", ""));
            var a = "",
                i = /\{\{\s*(\w+)\s*\}\}/,
                r = e || "${{amount}}";
            function n(t, e, a, i) {
                if (((a = a || ","), (i = i || "."), isNaN(t) || null == t)) return 0;
                var r = (t = (t / 100).toFixed(e)).split(".");
                return r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) + (r[1] ? i + r[1] : "");
            }
            switch (r.match(i)[1]) {
                case "amount":
                    a = n(t, 2);
                    break;
                case "amount_no_decimals":
                    a = n(t, 0);
                    break;
                case "amount_with_comma_separator":
                    a = n(t, 2, ".", ",");
                    break;
                case "amount_no_decimals_with_comma_separator":
                    a = n(t, 0, ".", ",");
                    break;
                case "amount_no_decimals_with_space_separator":
                    a = n(t, 0, " ");
            }
            return "<span class=money>" + r.replace(i, a) + "</span>";
        },
    }),
    void 0 === HsCurrency)
)
    var HsCurrency = {};
HsCurrency.moneyFormats = {
    USD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} USD" },
    EUR: { money_format: "&euro;{{amount}}", money_with_currency_format: "&euro;{{amount}} EUR" },
    GBP: { money_format: "&pound;{{amount}}", money_with_currency_format: "&pound;{{amount}} GBP" },
    CAD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} CAD" },
    ALL: { money_format: "Lek {{amount}}", money_with_currency_format: "Lek {{amount}} ALL" },
    DZD: { money_format: "DA {{amount}}", money_with_currency_format: "DA {{amount}} DZD" },
    AOA: { money_format: "Kz{{amount}}", money_with_currency_format: "Kz{{amount}} AOA" },
    ARS: { money_format: "${{amount_with_comma_separator}}", money_with_currency_format: "${{amount_with_comma_separator}} ARS" },
    AMD: { money_format: "{{amount}} AMD", money_with_currency_format: "{{amount}} AMD" },
    AWG: { money_format: "Afl{{amount}}", money_with_currency_format: "Afl{{amount}} AWG" },
    AUD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} AUD" },
    BBD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} Bds" },
    AZN: { money_format: "m.{{amount}}", money_with_currency_format: "m.{{amount}} AZN" },
    BDT: { money_format: "Tk {{amount}}", money_with_currency_format: "Tk {{amount}} BDT" },
    BSD: { money_format: "BS${{amount}}", money_with_currency_format: "BS${{amount}} BSD" },
    BHD: { money_format: "{{amount}}0 BD", money_with_currency_format: "{{amount}}0 BHD" },
    BYR: { money_format: "Br {{amount}}", money_with_currency_format: "Br {{amount}} BYR" },
    BZD: { money_format: "BZ${{amount}}", money_with_currency_format: "BZ${{amount}} BZD" },
    BTN: { money_format: "Nu {{amount}}", money_with_currency_format: "Nu {{amount}} BTN" },
    BAM: { money_format: "KM {{amount_with_comma_separator}}", money_with_currency_format: "KM {{amount_with_comma_separator}} BAM" },
    BRL: { money_format: "R$ {{amount_with_comma_separator}}", money_with_currency_format: "R$ {{amount_with_comma_separator}} BRL" },
    BOB: { money_format: "Bs{{amount_with_comma_separator}}", money_with_currency_format: "Bs{{amount_with_comma_separator}} BOB" },
    BWP: { money_format: "P{{amount}}", money_with_currency_format: "P{{amount}} BWP" },
    BND: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} BND" },
    BGN: { money_format: "{{amount}} лв", money_with_currency_format: "{{amount}} лв BGN" },
    MMK: { money_format: "K{{amount}}", money_with_currency_format: "K{{amount}} MMK" },
    KHR: { money_format: "KHR{{amount}}", money_with_currency_format: "KHR{{amount}}" },
    KYD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} KYD" },
    XAF: { money_format: "FCFA{{amount}}", money_with_currency_format: "FCFA{{amount}} XAF" },
    CLP: { money_format: "${{amount_no_decimals}}", money_with_currency_format: "${{amount_no_decimals}} CLP" },
    CNY: { money_format: "&#165;{{amount}}", money_with_currency_format: "&#165;{{amount}} CNY" },
    COP: { money_format: "${{amount_with_comma_separator}}", money_with_currency_format: "${{amount_with_comma_separator}} COP" },
    CRC: { money_format: "&#8353; {{amount_with_comma_separator}}", money_with_currency_format: "&#8353; {{amount_with_comma_separator}} CRC" },
    HRK: { money_format: "{{amount_with_comma_separator}} kn", money_with_currency_format: "{{amount_with_comma_separator}} kn HRK" },
    CZK: { money_format: "{{amount_with_comma_separator}} K&#269;", money_with_currency_format: "{{amount_with_comma_separator}} K&#269;" },
    DKK: { money_format: "{{amount_with_comma_separator}}", money_with_currency_format: "kr.{{amount_with_comma_separator}}" },
    DOP: { money_format: "RD$ {{amount}}", money_with_currency_format: "RD$ {{amount}}" },
    XCD: { money_format: "${{amount}}", money_with_currency_format: "EC${{amount}}" },
    EGP: { money_format: "LE {{amount}}", money_with_currency_format: "LE {{amount}} EGP" },
    ETB: { money_format: "Br{{amount}}", money_with_currency_format: "Br{{amount}} ETB" },
    XPF: { money_format: "{{amount_no_decimals_with_comma_separator}} XPF", money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} XPF" },
    FJD: { money_format: "${{amount}}", money_with_currency_format: "FJ${{amount}}" },
    GMD: { money_format: "D {{amount}}", money_with_currency_format: "D {{amount}} GMD" },
    GHS: { money_format: "GH&#8373;{{amount}}", money_with_currency_format: "GH&#8373;{{amount}}" },
    GTQ: { money_format: "Q{{amount}}", money_with_currency_format: "{{amount}} GTQ" },
    GYD: { money_format: "G${{amount}}", money_with_currency_format: "${{amount}} GYD" },
    GEL: { money_format: "{{amount}} GEL", money_with_currency_format: "{{amount}} GEL" },
    HNL: { money_format: "L {{amount}}", money_with_currency_format: "L {{amount}} HNL" },
    HKD: { money_format: "${{amount}}", money_with_currency_format: "HK${{amount}}" },
    HUF: { money_format: "{{amount_no_decimals_with_comma_separator}}", money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} Ft" },
    ISK: { money_format: "{{amount_no_decimals}} kr", money_with_currency_format: "{{amount_no_decimals}} kr ISK" },
    INR: { money_format: "Rs. {{amount}}", money_with_currency_format: "Rs. {{amount}}" },
    IDR: { money_format: "{{amount_with_comma_separator}}", money_with_currency_format: "Rp {{amount_with_comma_separator}}" },
    ILS: { money_format: "{{amount}} NIS", money_with_currency_format: "{{amount}} NIS" },
    JMD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} JMD" },
    JPY: { money_format: "&#165;{{amount_no_decimals}}", money_with_currency_format: "&#165;{{amount_no_decimals}} JPY" },
    JEP: { money_format: "&pound;{{amount}}", money_with_currency_format: "&pound;{{amount}} JEP" },
    JOD: { money_format: "{{amount}}0 JD", money_with_currency_format: "{{amount}}0 JOD" },
    KZT: { money_format: "{{amount}} KZT", money_with_currency_format: "{{amount}} KZT" },
    KES: { money_format: "KSh{{amount}}", money_with_currency_format: "KSh{{amount}}" },
    KWD: { money_format: "{{amount}}0 KD", money_with_currency_format: "{{amount}}0 KWD" },
    KGS: { money_format: "лв{{amount}}", money_with_currency_format: "лв{{amount}}" },
    LVL: { money_format: "Ls {{amount}}", money_with_currency_format: "Ls {{amount}} LVL" },
    LBP: { money_format: "L&pound;{{amount}}", money_with_currency_format: "L&pound;{{amount}} LBP" },
    LTL: { money_format: "{{amount}} Lt", money_with_currency_format: "{{amount}} Lt" },
    MGA: { money_format: "Ar {{amount}}", money_with_currency_format: "Ar {{amount}} MGA" },
    MKD: { money_format: "ден {{amount}}", money_with_currency_format: "ден {{amount}} MKD" },
    MOP: { money_format: "MOP${{amount}}", money_with_currency_format: "MOP${{amount}}" },
    MVR: { money_format: "Rf{{amount}}", money_with_currency_format: "Rf{{amount}} MRf" },
    MXN: { money_format: "$ {{amount}}", money_with_currency_format: "$ {{amount}} MXN" },
    MYR: { money_format: "RM{{amount}} MYR", money_with_currency_format: "RM{{amount}} MYR" },
    MUR: { money_format: "Rs {{amount}}", money_with_currency_format: "Rs {{amount}} MUR" },
    MDL: { money_format: "{{amount}} MDL", money_with_currency_format: "{{amount}} MDL" },
    MAD: { money_format: "{{amount}} dh", money_with_currency_format: "Dh {{amount}} MAD" },
    MNT: { money_format: "{{amount_no_decimals}} &#8366", money_with_currency_format: "{{amount_no_decimals}} MNT" },
    MZN: { money_format: "{{amount}} Mt", money_with_currency_format: "Mt {{amount}} MZN" },
    NAD: { money_format: "N${{amount}}", money_with_currency_format: "N${{amount}} NAD" },
    NPR: { money_format: "Rs{{amount}}", money_with_currency_format: "Rs{{amount}} NPR" },
    ANG: { money_format: "&fnof;{{amount}}", money_with_currency_format: "{{amount}} NA&fnof;" },
    NZD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} NZD" },
    NIO: { money_format: "C${{amount}}", money_with_currency_format: "C${{amount}} NIO" },
    NGN: { money_format: "&#8358;{{amount}}", money_with_currency_format: "&#8358;{{amount}} NGN" },
    NOK: { money_format: "kr {{amount_with_comma_separator}}", money_with_currency_format: "kr {{amount_with_comma_separator}} NOK" },
    OMR: { money_format: "{{amount_with_comma_separator}} OMR", money_with_currency_format: "{{amount_with_comma_separator}} OMR" },
    PKR: { money_format: "Rs.{{amount}}", money_with_currency_format: "Rs.{{amount}} PKR" },
    PGK: { money_format: "K {{amount}}", money_with_currency_format: "K {{amount}} PGK" },
    PYG: { money_format: "Gs. {{amount_no_decimals_with_comma_separator}}", money_with_currency_format: "Gs. {{amount_no_decimals_with_comma_separator}} PYG" },
    PEN: { money_format: "S/. {{amount}}", money_with_currency_format: "S/. {{amount}} PEN" },
    PHP: { money_format: "&#8369;{{amount}}", money_with_currency_format: "&#8369;{{amount}} PHP" },
    PLN: { money_format: "{{amount_with_comma_separator}} zl", money_with_currency_format: "{{amount_with_comma_separator}} zl PLN" },
    QAR: { money_format: "QAR {{amount_with_comma_separator}}", money_with_currency_format: "QAR {{amount_with_comma_separator}}" },
    RON: { money_format: "{{amount_with_comma_separator}} lei", money_with_currency_format: "{{amount_with_comma_separator}} lei RON" },
    RUB: { money_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}", money_with_currency_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB" },
    RWF: { money_format: "{{amount_no_decimals}} RF", money_with_currency_format: "{{amount_no_decimals}} RWF" },
    WST: { money_format: "WS$ {{amount}}", money_with_currency_format: "WS$ {{amount}} WST" },
    SAR: { money_format: "{{amount}} SR", money_with_currency_format: "{{amount}} SAR" },
    STD: { money_format: "Db {{amount}}", money_with_currency_format: "Db {{amount}} STD" },
    RSD: { money_format: "{{amount}} RSD", money_with_currency_format: "{{amount}} RSD" },
    SCR: { money_format: "Rs {{amount}}", money_with_currency_format: "Rs {{amount}} SCR" },
    SGD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} SGD" },
    SYP: { money_format: "S&pound;{{amount}}", money_with_currency_format: "S&pound;{{amount}} SYP" },
    ZAR: { money_format: "R {{amount}}", money_with_currency_format: "R {{amount}} ZAR" },
    KRW: { money_format: "&#8361;{{amount_no_decimals}}", money_with_currency_format: "&#8361;{{amount_no_decimals}} KRW" },
    LKR: { money_format: "Rs {{amount}}", money_with_currency_format: "Rs {{amount}} LKR" },
    SEK: { money_format: "{{amount_no_decimals}} kr", money_with_currency_format: "{{amount_no_decimals}} kr SEK" },
    CHF: { money_format: "SFr. {{amount}}", money_with_currency_format: "SFr. {{amount}} CHF" },
    TWD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} TWD" },
    THB: { money_format: "{{amount}} &#xe3f;", money_with_currency_format: "{{amount}} &#xe3f; THB" },
    TZS: { money_format: "{{amount}} TZS", money_with_currency_format: "{{amount}} TZS" },
    TTD: { money_format: "${{amount}}", money_with_currency_format: "${{amount}} TTD" },
    TND: { money_format: "{{amount}}", money_with_currency_format: "{{amount}} DT" },
    TRY: { money_format: "{{amount}}TL", money_with_currency_format: "{{amount}}TL" },
    UGX: { money_format: "Ush {{amount_no_decimals}}", money_with_currency_format: "Ush {{amount_no_decimals}} UGX" },
    UAH: { money_format: "₴{{amount}}", money_with_currency_format: "₴{{amount}} UAH" },
    AED: { money_format: "Dhs. {{amount}}", money_with_currency_format: "Dhs. {{amount}} AED" },
    UYU: { money_format: "${{amount_with_comma_separator}}", money_with_currency_format: "${{amount_with_comma_separator}} UYU" },
    VUV: { money_format: "${{amount}}", money_with_currency_format: "${{amount}}VT" },
    VEF: { money_format: "Bs. {{amount_with_comma_separator}}", money_with_currency_format: "Bs. {{amount_with_comma_separator}} VEF" },
    VND: { money_format: "{{amount_no_decimals_with_comma_separator}}&#8363;", money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} VND" },
    XBT: { money_format: "{{amount_no_decimals}} BTC", money_with_currency_format: "{{amount_no_decimals}} BTC" },
    XOF: { money_format: "CFA{{amount}}", money_with_currency_format: "CFA{{amount}} XOF" },
    ZMW: { money_format: "K{{amount_no_decimals_with_comma_separator}}", money_with_currency_format: "ZMW{{amount_no_decimals_with_comma_separator}}" },
};
var delay = (function () {
    var t = 0;
    return function (e, a) {
        clearTimeout(t), (t = setTimeout(e, a));
    };
})();
Object.defineProperty(Array.prototype, "chunk_inefficient2", {
    enumerable: !1,
    writable: !0,
    value: function (t) {
        var e = this;
        return [].concat.apply(
            [],
            e.map(function (a, i) {
                return i % t ? [] : [e.slice(i, i + t)];
            })
        );
    },
}),
    (Array.prototype.unique = (function (t) {
        return function () {
            return this.filter(t);
        };
    })(function (t, e, a) {
        return a.indexOf(t, e + 1) < 0;
    }));
function hsSlReturnToVariants() {
    const target = document.getElementById('product-variants');
    if (!target) return;
    if (!target.hasAttribute('tabindex')) {
      target.setAttribute('tabindex', '-1');
    }
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(() => {
      target.focus({ preventScroll: true });
    }, 300);
}

var HsCartDrawer = {
  		qtyAddToCartBar : {"click":false,"qty":1},
  		quick_buyIcon:`<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 442.238 442.238" style="enable-background:new 0 0 442.238 442.238;" xml:space="preserve">
        <g><g><g><path d="M156.672,323.074c-29.689-0.281-53.986,23.558-54.267,53.248s23.558,53.986,53.248,54.267s53.986-23.558,54.267-53.248     c0.003-0.34,0.003-0.68,0-1.019C209.92,346.914,186.08,323.074,156.672,323.074z"/>
        <circle cx="328.704" cy="376.322" r="53.76"/>
        <path d="M439.296,117.762c-3.095-3.558-7.572-5.611-12.288-5.632h-60.416C359.307,49.78,302.856,5.14,240.505,12.425     c-52.325,6.114-93.591,47.38-99.705,99.705H94.72L79.872,43.01c-1.475-6.984-7.711-11.93-14.848-11.776H0v30.72h52.736     l48.128,222.72c1.444,7.078,7.625,12.193,14.848,12.288h272.896c7.198,0.012,13.503-4.822,15.36-11.776l37.888-154.112     C442.836,126.473,441.913,121.671,439.296,117.762z M336.896,126.466c-0.279,45.692-37.252,82.665-82.944,82.944     c-46.091,0.282-83.683-36.853-83.965-82.944c-0.282-46.091,36.853-83.683,82.944-83.965     c46.091-0.282,83.683,36.853,83.965,82.944C336.898,125.786,336.898,126.126,336.896,126.466z"/>
        <polygon points="269.312,78.85 238.592,78.85 238.592,111.106 206.336,111.106 206.336,141.826 238.592,141.826 238.592,173.57      269.312,173.57 269.312,141.826 301.056,141.826 301.056,111.106 269.312,111.106    "/>
        </g></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>
        </svg>`,
        shopifyUrl: "plushbedsshop.myshopify.com",
        pathname: window.location.href,
        obj: [],
        params: [],
        arr_variants: [],
        arr_free_shipping_products: [],
        where: "",
        feed: "",
        textcart: "",
        scroll: "",
        total: "",
        footer: "",
        color: "",
        colorThumb: "",
        count: 0,
        next: 0,
        back: 0,
        css: "",
        status_text_checkout: "",
        status_text_cart: "",
        display_variant: "none",
        display_variant_position: "absolute",
        display_swatch: "none",
        display_popup: "none",
        display_addtocart: "none",
        content_popup: "490px",
        position_slide_cart: "sticky",
        style: "",
        query: !1,
        json: !1,
        text_style: "",
        openSlideCart: 'header a[href="/cart"],header a[href="#cart"],a[href="#cart"],.hs-sticky-cart-cart-drawer a[href="/cart"],.navigation a[href="/cart"],a[href="/cart"],.cart-wrap,.tt-desctop-parent-cart,.cart-summary',
        empty_cart:
            '<svg width="60px" id="Capa_1" data-name="Capa 1" viewBox="0 0 1042 1186.53"><defs><style>.cls-1{fill:#f2f2f2;}.cls-2{fill:#bababa;}.cls-3{fill:#fefefe;}.cls-4{fill:#ebebeb;}.cls-5{fill:#6d6d6d;}</style></defs><title>heysenior_cart</title><path class="cls-1" d="M79.11,1148.9V182.64c1.81-3.35-1.14-9,4.94-10.31C93,164.7,103.48,163,115,163q485,.23,970,.12c1.09,0,2.18.06,3.26,0,10.8-.69,20.19,2.16,27.29,10.76,4.74,1.78,4.22,6.35,5.32,10.07v3.91c-1.3,2.69-.62,5.56-.62,8.33q-.06,473.87,0,947.71c0,26.92-16.76,45.54-43.81,48.69a2.22,2.22,0,0,0-1.11.6H124.68c-15.62-1.63-28.3-8.38-37.4-21.41C82.47,1164.89,80.47,1157,79.11,1148.9Z" transform="translate(-79 -6.74)"></path><path class="cls-2" d="M1117.1,177.52c-9.15-11-21.36-12-34.67-11.94q-486.5.3-973,0c-9.49,0-17.52,2.66-24.14,9.17-3.36,3.3-2-.23-2.36-1.3-1.84-5.35,2.45-8.17,5.32-10.76,21.09-19,41.85-38.27,62.89-57.28,16.38-14.8,32.66-29.73,49-44.6C218.71,44,237.2,27,255.92,10.23c1.66-1.49,3.77-2.09,5.5-3.39H937.28c14.92,11.22,27.83,24.7,41.71,37.1,22.29,19.9,44.32,40.1,66.39,60.25,17.43,15.91,35,31.64,52.15,47.91,5.18,4.92,11.38,8.8,15.64,14.62C1115.45,169.85,1119.28,172.66,1117.1,177.52Z" transform="translate(-79 -6.74)"></path><path class="cls-3" d="M1117.1,177.52c-1.48-6.75-6.24-11.24-11-15.59-12.42-11.32-25-22.43-37.49-33.72q-35.47-32.12-70.84-64.36c-11.16-10.17-22.2-20.48-33.35-30.66-8.11-7.41-16.32-14.72-24.5-22-1.33-1.19-2.48-2.42-2.62-4.3q89.37,0,178.73-.1c4,0,5,.89,5,5q-.24,86.12-.11,172.23c-1.81-.23-2.72-1.08-1.78-2.92C1120.29,178.74,1118.54,178.24,1117.1,177.52Z" transform="translate(-79 -6.74)"></path><path class="cls-3" d="M261.42,6.84c-6.45,8.84-15.61,14.89-23.36,22.4-11,10.67-22.82,20.55-34.21,30.84q-34.65,31.35-69.23,62.77c-15.06,13.68-30.13,27.35-45,41.2A23,23,0,0,0,83,173.5c-4,1.92-.43,7-3.84,9.14q0-85.47-.11-170.93c0-4.08.94-5,5-5Q172.7,7,261.42,6.84Z" transform="translate(-79 -6.74)"></path><path class="cls-4" d="M1119.58,1146.28q0-474.85.07-949.72c0-2.9-1.17-6.1,1.24-8.71V1146.3C1120.45,1146.89,1120,1146.92,1119.58,1146.28Z" transform="translate(-79 -6.74)"></path><path class="cls-3" d="M1119.58,1146.28l1.31,0c0,14.54-.09,29.08.09,43.62,0,2.8-.54,3.38-3.34,3.34-14.11-.18-28.22-.08-42.32-.08,7.89-3.33,16.47-5,23.48-10.44C1110.84,1173.47,1118.33,1161.67,1119.58,1146.28Z" transform="translate(-79 -6.74)"></path><path class="cls-3" d="M79.11,1148.9c3.73,7.26,5.29,15.52,10.1,22.28,7.76,10.92,18.87,16.73,31.37,20.39,1.42.41,3.06.23,4.1,1.61-14.1,0-28.21-.1-42.32.08-2.8,0-3.38-.54-3.34-3.34C79.21,1176.25,79.11,1162.57,79.11,1148.9Z" transform="translate(-79 -6.74)"></path><path class="cls-5" d="M830.88,471.23c0,26.65,1.23,53.37-5.41,79.59C806.13,627.26,760.56,682,688,712.47c-90.54,38-193.23,14.58-259.69-58.12-31.83-34.83-50.93-76.08-57.65-123C367,506.25,369,481.09,368.44,456c-.22-10.19-.08-20.39,0-30.59.09-16.3,10.67-27.79,25.52-27.83,14.61,0,25.92,11.59,26.08,27.54.29,28-.47,56,.43,84,1.27,39.75,15.78,74.8,41.19,105.19s57.59,50.44,96.17,59.67q58.14,13.92,113.27-9.75a176.89,176.89,0,0,0,77.79-64.1c20.93-30.74,30.94-65.16,30.85-102.44-.06-24.31-.12-48.61,0-72.91.1-16,11.22-27.35,26.17-27.17,13.37.17,24.62,10.77,24.89,24.21C831.13,438.24,830.88,454.74,830.88,471.23Z" transform="translate(-79 -6.74)"></path></svg>',
        text_style_active: "",
        freeShipping: function (t, e) {
            if (t.slide_cart_products) {
                var a = [
                        {
                            id: 4446739365986,
                            title: "Free Bonus! Organic Cotton Sateen Sheet Set",
                            handle: "bonus-organic-cotton-sateen-sheet-set",
                            description:
                                '<p>This 300 thread count Egyptian cotton sheet set features organic certification by GOTS (Global Organic Textile Standard). If you are looking for an organic sleep experience, these are the sheets for you - not only are they organic, but they have a nice buttery feel to them. Your 100% organic sateen sheet is lightweight, so even the warmest bodies sleep cool. There are no dyes or chemicals in this set, and being hypoallergenic it is a great pick for you if you have sensitive skin or allergies.</p>\n\x3c!-- split --\x3e\n<div class="plusbed_twentyeight">\n<div class="simple_block">\n<div class="simple_txt">\n<p>Besides the flat sheet, your fitted sheet is sewn with elastic around the whole perimeter, and has 13" deep pockets. As well, this set comes with 2 matching natural color pillowcases, except the Twin and Twin XL sizes, which complete the set with a single pillowcase. Your organic cotton bed sheet set comes in a nice natural color.</p>\n<p>Not sure of your bed size? Consult our <a href="#size_guide_block" style="color: #69951b;">size guide</a> below for mattress measurements before purchase.</p>\n</div>\n<div class="two_points" style="margin-bottom: 10px; clear: both; overflow: hidden;">\n<div class="default_title">\n<h2>INCLUDED</h2>\n</div>\n<ul class="two_points_row">\n<li>One flat sheet, one fitted sheet, &amp; two pillowcases (one pillowcase on Twin &amp; Twin XL)</li>\n<li>Gorgeous 100% GOTS certified organic, long staple cotton woven into 300 TC sateen for a perfectly soft hand</li>\n<li>Oversized flat sheet never has trouble tucking</li>\n<li>French seam with garment quality tailoring</li>\n<li>Fitted sheet sewn wtih premium encased elastic around entire opening</li>\n<li>Reg 13" deep pockets</li>\n<li>No dyes or harsh chemicals and hypoallergenic</li>\n<li>Biodegradable packaging of hemp and corn film</li>\n</ul>\n</div>\n<p><strong>Care:</strong> Machine wash warm or cold, dry low. We recommend removing from dryer promptly for less wrinkles.</p>\n<p>Exchange / Return Policy: Sheets can be returned in new, unopened condition for an exchange or refund minus round trip shipping costs. Once opened, sheets are no longer returnable. Please call <a href="tel:1-888-758-7423"><span class="bottom-text">1-888-758-7423</span></a> for assistance.</p>\n</div>\n<div id="size_guide_block"></div>\n<div class="two_points two_section_img">\n<div class="point_one">\n<div class="default_title">\n<h2>Size Guide</h2>\n</div>\n<img src="https://cdn.shopify.com/s/files/1/0061/7195/1202/files/Sateen_Img_04.png" alt="">\n</div>\n<div class="point_one">\n<div class="default_title">\n<h2>What is GOTS Certification?</h2>\n<p>The Global Organic Textile Standard (GOTS) is the leading worldwide standard for organic fibres, including ecological and social criteria, backed up by independent certification of the entire textile supply chain. GOTS certification represents the most demanding organic standards that any product or manufacturer can meet.</p>\n<p> </p>\n</div>\n<img src="https://cdn.shopify.com/s/files/1/0061/7195/1202/files/Sateen_Img_03_882da552-18aa-4e8f-afcd-f7f05cd77b87.jpg" alt="">\n</div>\n</div>\n</div>',
                            published_at: "2020-06-12T08:26:05-07:00",
                            created_at: "2020-06-12T07:47:34-07:00",
                            vendor: "PlushBeds",
                            type: "HSSLIDE_HIDDEN_PRODUCT",
                            tags: ["2.0", "Bonus", "certification:GOTS", "cs123", "hidden_2.0", "material:Organic Cotton", "NO-DONEGOOD", "Organic Cotton Sheets", "Sheets"],
                            price: 0,
                            price_min: 0,
                            price_max: 0,
                            available: !0,
                            price_varies: !1,
                            compare_at_price: 22400,
                            compare_at_price_min: 22400,
                            compare_at_price_max: 43600,
                            compare_at_price_varies: !0,
                            variants: [
                                {
                                    id: 31746609840226,
                                    title: "Twin / Natural",
                                    option1: "Twin",
                                    option2: "Natural",
                                    option3: null,
                                    sku: "B-ORGCOTSAN01",
                                    requires_shipping: !0,
                                    taxable: !0,
                                    featured_image: null,
                                    available: !0,
                                    name: "Free Bonus! Organic Cotton Sateen Sheet Set - Twin / Natural",
                                    public_title: "Twin / Natural",
                                    options: ["Twin", "Natural"],
                                    price: 0,
                                    weight: 0,
                                    compare_at_price: 22400,
                                    inventory_management: "shopify",
                                    barcode: "",
                                },
                                {
                                    id: 31746609872994,
                                    title: "Twin XL / Natural",
                                    option1: "Twin XL",
                                    option2: "Natural",
                                    option3: null,
                                    sku: "B-ORGCOTSAN02",
                                    requires_shipping: !0,
                                    taxable: !0,
                                    featured_image: null,
                                    available: !0,
                                    name: "Free Bonus! Organic Cotton Sateen Sheet Set - Twin XL / Natural",
                                    public_title: "Twin XL / Natural",
                                    options: ["Twin XL", "Natural"],
                                    price: 0,
                                    weight: 0,
                                    compare_at_price: 24900,
                                    inventory_management: "shopify",
                                    barcode: "",
                                },
                                {
                                    id: 31746609905762,
                                    title: "Full / Natural",
                                    option1: "Full",
                                    option2: "Natural",
                                    option3: null,
                                    sku: "B-ORGCOTSAN03",
                                    requires_shipping: !0,
                                    taxable: !0,
                                    featured_image: null,
                                    available: !0,
                                    name: "Free Bonus! Organic Cotton Sateen Sheet Set - Full / Natural",
                                    public_title: "Full / Natural",
                                    options: ["Full", "Natural"],
                                    price: 0,
                                    weight: 0,
                                    compare_at_price: 27400,
                                    inventory_management: "shopify",
                                    barcode: "",
                                },
                                {
                                    id: 31746609938530,
                                    title: "Queen / Natural",
                                    option1: "Queen",
                                    option2: "Natural",
                                    option3: null,
                                    sku: "B-ORGCOTSAN05",
                                    requires_shipping: !0,
                                    taxable: !0,
                                    featured_image: null,
                                    available: !0,
                                    name: "Free Bonus! Organic Cotton Sateen Sheet Set - Queen / Natural",
                                    public_title: "Queen / Natural",
                                    options: ["Queen", "Natural"],
                                    price: 0,
                                    weight: 0,
                                    compare_at_price: 29900,
                                    inventory_management: "shopify",
                                    barcode: "",
                                },
                                {
                                    id: 31746609971298,
                                    title: "King / Natural",
                                    option1: "King",
                                    option2: "Natural",
                                    option3: null,
                                    sku: "B-ORGCOTSAN06",
                                    requires_shipping: !0,
                                    taxable: !0,
                                    featured_image: null,
                                    available: !0,
                                    name: "Free Bonus! Organic Cotton Sateen Sheet Set - King / Natural",
                                    public_title: "King / Natural",
                                    options: ["King", "Natural"],
                                    price: 0,
                                    weight: 0,
                                    compare_at_price: 32400,
                                    inventory_management: "shopify",
                                    barcode: "",
                                },
                                {
                                    id: 31746610004066,
                                    title: "Cal King / Natural",
                                    option1: "Cal King",
                                    option2: "Natural",
                                    option3: null,
                                    sku: "B-ORGCOTSAN07",
                                    requires_shipping: !0,
                                    taxable: !0,
                                    featured_image: null,
                                    available: !0,
                                    name: "Free Bonus! Organic Cotton Sateen Sheet Set - Cal King / Natural",
                                    public_title: "Cal King / Natural",
                                    options: ["Cal King", "Natural"],
                                    price: 0,
                                    weight: 0,
                                    compare_at_price: 32400,
                                    inventory_management: "shopify",
                                    barcode: "",
                                },
                                {
                                    id: 31746610036834,
                                    title: "Split King / Natural",
                                    option1: "Split King",
                                    option2: "Natural",
                                    option3: null,
                                    sku: "B-ORGCOTSAN08",
                                    requires_shipping: !0,
                                    taxable: !0,
                                    featured_image: null,
                                    available: !0,
                                    name: "Free Bonus! Organic Cotton Sateen Sheet Set - Split King / Natural",
                                    public_title: "Split King / Natural",
                                    options: ["Split King", "Natural"],
                                    price: 0,
                                    weight: 0,
                                    compare_at_price: 43600,
                                    inventory_management: "shopify",
                                    barcode: "",
                                },
                                {
                                    id: 31746610069602,
                                    title: "Split Cal King / Natural",
                                    option1: "Split Cal King",
                                    option2: "Natural",
                                    option3: null,
                                    sku: "B-ORGCOTSAN09",
                                    requires_shipping: !0,
                                    taxable: !0,
                                    featured_image: null,
                                    available: !0,
                                    name: "Free Bonus! Organic Cotton Sateen Sheet Set - Split Cal King / Natural",
                                    public_title: "Split Cal King / Natural",
                                    options: ["Split Cal King", "Natural"],
                                    price: 0,
                                    weight: 0,
                                    compare_at_price: 43600,
                                    inventory_management: "shopify",
                                    barcode: "",
                                },
                                {
                                    id: 31746610102370,
                                    title: "Split Queen / Natural",
                                    option1: "Split Queen",
                                    option2: "Natural",
                                    option3: null,
                                    sku: "B-ORGCOTSAN10",
                                    requires_shipping: !0,
                                    taxable: !0,
                                    featured_image: null,
                                    available: !0,
                                    name: "Free Bonus! Organic Cotton Sateen Sheet Set - Split Queen / Natural",
                                    public_title: "Split Queen / Natural",
                                    options: ["Split Queen", "Natural"],
                                    price: 0,
                                    weight: 0,
                                    compare_at_price: 41100,
                                    inventory_management: "shopify",
                                    barcode: "",
                                },
                            ],
                            images: [
                                "//cdn.shopify.com/s/files/1/0061/7195/1202/products/bonus-organic-cotton-sateen-sheet-set-711515.jpg?v=1592941308",
                                "//cdn.shopify.com/s/files/1/0061/7195/1202/products/bonus-organic-cotton-sateen-sheet-set-158945.jpg?v=1592941308",
                                "//cdn.shopify.com/s/files/1/0061/7195/1202/products/bonus-organic-cotton-sateen-sheet-set-545793.jpg?v=1592941308",
                            ],
                            featured_image: "//cdn.shopify.com/s/files/1/0061/7195/1202/products/bonus-organic-cotton-sateen-sheet-set-711515.jpg?v=1592941308",
                            options: ["Choose a Size", "Choose a Color"],
                            media: [
                                {
                                    alt: "Bonus - Organic Cotton Sateen Sheet Set - PlushBeds",
                                    id: 6283856117858,
                                    position: 1,
                                    preview_image: { aspect_ratio: 1.5, height: 1e3, width: 1500, src: "https://cdn.shopify.com/s/files/1/0061/7195/1202/products/bonus-organic-cotton-sateen-sheet-set-711515.jpg?v=1592941308" },
                                    aspect_ratio: 1.5,
                                    height: 1e3,
                                    media_type: "image",
                                    src: "https://cdn.shopify.com/s/files/1/0061/7195/1202/products/bonus-organic-cotton-sateen-sheet-set-711515.jpg?v=1592941308",
                                    width: 1500,
                                },
                                {
                                    alt: "Bonus - Organic Cotton Sateen Sheet Set - PlushBeds",
                                    id: 6283856150626,
                                    position: 2,
                                    preview_image: { aspect_ratio: 1.5, height: 1e3, width: 1500, src: "https://cdn.shopify.com/s/files/1/0061/7195/1202/products/bonus-organic-cotton-sateen-sheet-set-158945.jpg?v=1592941308" },
                                    aspect_ratio: 1.5,
                                    height: 1e3,
                                    media_type: "image",
                                    src: "https://cdn.shopify.com/s/files/1/0061/7195/1202/products/bonus-organic-cotton-sateen-sheet-set-158945.jpg?v=1592941308",
                                    width: 1500,
                                },
                                {
                                    alt: "Bonus - Organic Cotton Sateen Sheet Set - PlushBeds",
                                    id: 6283856183394,
                                    position: 3,
                                    preview_image: { aspect_ratio: 1.499, height: 1001, width: 1500, src: "https://cdn.shopify.com/s/files/1/0061/7195/1202/products/bonus-organic-cotton-sateen-sheet-set-545793.jpg?v=1592941308" },
                                    aspect_ratio: 1.499,
                                    height: 1001,
                                    media_type: "image",
                                    src: "https://cdn.shopify.com/s/files/1/0061/7195/1202/products/bonus-organic-cotton-sateen-sheet-set-545793.jpg?v=1592941308",
                                    width: 1500,
                                },
                            ],
                            content:
                                '<p>This 300 thread count Egyptian cotton sheet set features organic certification by GOTS (Global Organic Textile Standard). If you are looking for an organic sleep experience, these are the sheets for you - not only are they organic, but they have a nice buttery feel to them. Your 100% organic sateen sheet is lightweight, so even the warmest bodies sleep cool. There are no dyes or chemicals in this set, and being hypoallergenic it is a great pick for you if you have sensitive skin or allergies.</p>\n\x3c!-- split --\x3e\n<div class="plusbed_twentyeight">\n<div class="simple_block">\n<div class="simple_txt">\n<p>Besides the flat sheet, your fitted sheet is sewn with elastic around the whole perimeter, and has 13" deep pockets. As well, this set comes with 2 matching natural color pillowcases, except the Twin and Twin XL sizes, which complete the set with a single pillowcase. Your organic cotton bed sheet set comes in a nice natural color.</p>\n<p>Not sure of your bed size? Consult our <a href="#size_guide_block" style="color: #69951b;">size guide</a> below for mattress measurements before purchase.</p>\n</div>\n<div class="two_points" style="margin-bottom: 10px; clear: both; overflow: hidden;">\n<div class="default_title">\n<h2>INCLUDED</h2>\n</div>\n<ul class="two_points_row">\n<li>One flat sheet, one fitted sheet, &amp; two pillowcases (one pillowcase on Twin &amp; Twin XL)</li>\n<li>Gorgeous 100% GOTS certified organic, long staple cotton woven into 300 TC sateen for a perfectly soft hand</li>\n<li>Oversized flat sheet never has trouble tucking</li>\n<li>French seam with garment quality tailoring</li>\n<li>Fitted sheet sewn wtih premium encased elastic around entire opening</li>\n<li>Reg 13" deep pockets</li>\n<li>No dyes or harsh chemicals and hypoallergenic</li>\n<li>Biodegradable packaging of hemp and corn film</li>\n</ul>\n</div>\n<p><strong>Care:</strong> Machine wash warm or cold, dry low. We recommend removing from dryer promptly for less wrinkles.</p>\n<p>Exchange / Return Policy: Sheets can be returned in new, unopened condition for an exchange or refund minus round trip shipping costs. Once opened, sheets are no longer returnable. Please call <a href="tel:1-888-758-7423"><span class="bottom-text">1-888-758-7423</span></a> for assistance.</p>\n</div>\n<div id="size_guide_block"></div>\n<div class="two_points two_section_img">\n<div class="point_one">\n<div class="default_title">\n<h2>Size Guide</h2>\n</div>\n<img src="https://cdn.shopify.com/s/files/1/0061/7195/1202/files/Sateen_Img_04.png" alt="">\n</div>\n<div class="point_one">\n<div class="default_title">\n<h2>What is GOTS Certification?</h2>\n<p>The Global Organic Textile Standard (GOTS) is the leading worldwide standard for organic fibres, including ecological and social criteria, backed up by independent certification of the entire textile supply chain. GOTS certification represents the most demanding organic standards that any product or manufacturer can meet.</p>\n<p> </p>\n</div>\n<img src="https://cdn.shopify.com/s/files/1/0061/7195/1202/files/Sateen_Img_03_882da552-18aa-4e8f-afcd-f7f05cd77b87.jpg" alt="">\n</div>\n</div>\n</div>',
                        },
                    ],
                    i = "",
                    r = "",
                    n = "",
                    s = "";
                a &&
                    ((HsCartDrawer.arr_free_shipping_products = a),
                    e.each(a, function (a, o) {
                        if (void 0 !== o.error) return !1;
                        (r = ""),
                            e.each(o.variants, function (t, e) {
                                r = r.concat(
                                    '<option value="' +
                                        e.id +
                                        '" title="' +
                                        e.title +
                                        '" data-id="' +
                                        o.id +
                                        '" data-price="' +
                                        e.price +
                                        '" data-sku="' +
                                        e.sku +
                                        '" data-available="' +
                                        e.available +
                                        '" data-barcode="' +
                                        e.barcode +
                                        '" data-featuredimage="' +
                                        o.featured_image +
                                        '" data-inventorymanagement="' +
                                        e.inventory_management +
                                        '" data-compareatprice="' +
                                        e.compare_at_price +
                                        '" data-variantid="' +
                                        e.id +
                                        '">' +
                                        e.title +
                                        "</option>"
                                );
                            }),
                            (n = ""),
                            1 == o.variants.length && (n = " hs-hidden-element"),
                            (i = '<select class="hs-swipper-option-parent-' + o.id + " hs-swipper-select-option-add-to-cart" + n + '" data-id="' + o.id + '">' + r + "</select>");
                        var l = o.variants[0].price,
                            c = o.variants[0].compare_at_price;
                        c > l ? ((c = HsCartDrawer.vat(c, t, e)), (c = '<div class="hs-compare-price-sw">' + (c = hsonslidecart.Currency.formatMoney(c, t.money_format)) + "</div>")) : (c = ""),
                            (l = HsCartDrawer.vat(l, t, e)),
                            (l = '<div class="hs-price-sw">' + hsonslidecart.Currency.formatMoney(l, t.money_format) + "</div>"),
                            (s = s.concat(
                                '<div class="swiper-slide"><div class="hs-content-product-slide-cart"><div class="hs-product-content-image-swipper"><a href="javascript:void(0);" class="hs-product-link-image"><img src="' +
                                    HsCartDrawer.resizeSrc(o.featured_image, "x65") +
                                    '" /></a></div><div class="hs-content-title-price-swiper"><div class="hs-title-swiper">' +
                                    o.title +
                                    '</div><div class="hs-content-price-swiper">' +
                                    c +
                                    l +
                                    '<div class="hs-price-per">(FREE)</div></div><div class="hs-variants-swipper' +
                                    n +
                                    '">' +
                                    i +
                                    '</div><div class="hs-upsell-add"><button type="button" class="hs-upsell-add-to-cart"><span class="hs-add--to--cart">' +
                                    t.text_add +
                                    '</span><span class="hs--loading"><i class="fa fa-circle-o-notch fa-spin fa-1x fa-fw margin-bottom"></i></span></button></div></div></div></div>'
                            ));
                    }),
                    parseInt(t.upsell_mode) ? e(".hs-products-stacked").html(s) : e(".hs-swiper-content-free-shipping").html(s),
                    HsCartDrawer.swiperHSCart(t, e),
                    HsCartDrawer.upsellVariants(t, e),
                    HsCartDrawer.addToCartFreeShipping(t, e));
            }
        },
        addstyle: function (t, e) {
            var a = t.stickycart_position,
                i = "",
                r = "",
                n = t.toppositionwidget + "%",
                s = "undefined" != typeof InstallTrigger;
            e(".hs-sticky-cart-cart-drawer").css("right", ""),
                e(".hs-sticky-cart-cart-drawer").css("top", ""),
                e(".hs-sticky-cart-cart-drawer").css("right", ""),
                e(".hs-sticky-cart-cart-drawer").css("bottom", ""),
                e(".hs-sticky-cart-cart-drawer").css("left", ""),
                e(".hs-sticky-cart-cart-drawer").css("top", ""),
                e(".hs-sticky-cart-cart-drawer").css("left", ""),
                e(".hs-sticky-cart-cart-drawer").css("bottom", ""),
                "hs-top-right" === a && ((i = "right"), (r = "top")),
                "hs-bottom-right" === a && ((i = "right"), (r = "bottom")),
                "hs-top-left" === a && ((i = "left"), (r = "top")),
                "hs-bottom-left" === a && ((i = "left"), (r = "bottom")),
                1 == t.status_swatch && (HsCartDrawer.display_swatch = "block"),
                1 == t.variants_options_status && ((HsCartDrawer.display_variant = "block"), (HsCartDrawer.display_variant_position = "relative")),
                1 == t.status && (HsCartDrawer.display_popup = "block"),
                1 == t.add_to_cart_status && (HsCartDrawer.display_addtocart = "block"),
                0 == t.style &&
                    ((HsCartDrawer.text_style_active =
                        "body.hs-open-cart:before {background: rgba(0,0,0,0.5); }.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-image {  width: 20%; }.hs-popup-cart-sp-load .hs-site-cart-popup .hs-empty-page-content.hs-text-center {  height: 100%; }.hs-popup-cart-sp-load .hs-site-cart-popup{display:block !important;}.hs-popup-cart-sp-load.active {right: 0px !important;}.hs-site-cart-popup,.hs-popup-cart-sp-load .hs-site-cart-popup form{background:#fff;}.hs-drawer-checkout {width: 100%; z-index: 10; }"),
                    (HsCartDrawer.text_style = "max-width:30%;top: 0px !important;height: 100%;right: -30% !important;-ms-overflow-style: none; transition: all 0.2s;")),
                2 == t.style &&
                    ((HsCartDrawer.text_style_active =
                        ".hs-popup-cart-sp-load .hs-site-cart-popup .hs-empty-page-content.hs-text-center {  height: 100%; }.hs-popup-cart-sp-load .hs-site-cart-popup{display:block !important;}.hs-popup-cart-sp-load.active {right: 0px !important;}.hs-site-cart-popup,.hs-popup-cart-sp-load .hs-site-cart-popup form{background:#fff;}.hs-drawer-checkout {width: 100%; z-index: 10; }"),
                    (HsCartDrawer.text_style = "max-width:30%;top: 0px !important;height: 100%;right: -30% !important;-ms-overflow-style: none; transition: all 0.2s;")),
                "Not IE" !== HsCartDrawer.IEdetection(t, e) && (HsCartDrawer.position_slide_cart = "relative"),
                s && (HsCartDrawer.position_slide_cart = "relative"),
                (HsCartDrawer.style =
                    HsCartDrawer.text_style_active +
                    ".hs-popup-cart-sp-load {\t\tdisplay: inline-block;\t\tvertical-align: middle;\t\tposition: " +
                    t.position +
                    ";\t\tz-index:2147483646 !important;\t\tborder:0px !important;\t\twidth:700px;        " +
                    HsCartDrawer.text_style +
                    "\t}\t.hs-sticky-cart-cart-drawer {\t\tz-index: 90000;\t}\t@media (max-width: 1600px) {\t\t.hs-popup-cart-sp-load {\t\t\twidth:600px;\t\t\tmin-width:460px;\t\t\tright: -460px !important;\t\t\tmax-width: 460px;\t\t}\t}\t@media (max-width: 769px) {\t\t.hs-popup-cart-sp-load {\t\t\twidth:100%;\t\t}\t}"),
                1 == t.style &&
                    ((HsCartDrawer.content_popup = "200px"),
                    (HsCartDrawer.style =
                        ".hs-popup-cart-sp-load {\t\tdisplay: inline-block;\t\tvertical-align: middle;\t\tposition: " +
                        t.position +
                        ";\t\tz-index:2147483646 !important;\t\twidth:460px;\t}\t.hs-product-content-image-swipper { width: 20%; }\t.hs-sticky-cart-cart-drawer {\t\tz-index: 2147483647;\t}\t")),
                (HsCartDrawer.css =
                    t.custom_css +
                    HsCartDrawer.style +
                    '.hs-product-review .yotpo-reviews-star-ratings-widget {\ justify-content: left !important;\ margin: 0 !important;\ }\ .hs-product-review .star_ratings_bar_bb {\ padding: 5px 0 !important;\ margin-bottom: 0 !important;\ }\form.sn-cart .hs-banner-best-bedding { display: none !important; }.hs-total-save { color: #7cb420; font-size: 14px; text-align: right; padding: 0px 30px; }.hs-increase-compare-at-price { display: none !important; color: #7cb420; margin-top: 10px; }.hs-business-days { color: #000;font-size: 14px;text-align: center;padding: 0px 20px; margin-bottom: 20px; margin-top: 20px;}.hs-business-days p img { display: inline-block; max-width: 30px; margin-left: 10px; }.hs-business-label-checkout { color: #000;font-size: 14px;text-align: center;padding: 0px 20px; margin-bottom: 20px;}.hs-banner-best-bedding { padding-bottom: 15px; }.hs-banner-best-bedding img{ max-width: 100%; }s.product-single__price--compare {margin-left: 5px;color: #cc1515;}.grid-popup-cart.col-items {position: relative;width: 100%;}.hs-item-cart-image a:last-child { text-align: center;}.hs-close-popup-cart h1 {font-size: 20px;margin:0px;line-height: 0px;}.hs-close-popup-cart { text-align: right;}.hs-close-popup-cart a img {width: 15px !important; height: 15px !important;min-width: 15px;border: 0px !important;}.jspContainer{overflow:hidden;position:relative;outline: 0;}.jspHorizontalBar,.jspPane,.jspVerticalBar{position:absolute}.jspVerticalBar{top:0;right:0;width:5px;height:100%;background:#3c3c3c}.jspHorizontalBar{bottom:0;left:0;width:100%;height:16px;background:red}.jspCap{display:none}.jspHorizontalBar .jspCap{float:left}.jspTrack{background:#f1f1f1;position:relative}.jspDrag{background:#c1c1c1;position:relative;top:0;left:0;cursor:pointer}.jspHorizontalBar .jspDrag,.jspHorizontalBar .jspTrack{float:left;height:100%}.jspArrow{background:#50506d;text-indent:-20000px;display:block;cursor:pointer;padding:0;margin:0}.jspArrow.jspDisabled{cursor:default;background:#80808d}.jspVerticalBar .jspArrow{height:16px}.jspHorizontalBar .jspArrow{width:16px;float:left;height:100%}.jspVerticalBar .jspArrow:focus{outline:0}.jspCorner{background:#eeeef4;float:left;height:100%}* html .jspCorner{margin:0 -3px 0 0}\t.animated{-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-fill-mode:both;animation-fill-mode:both}.animated.infinite{-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}.animated.hinge{-webkit-animation-duration:2s;animation-duration:2s}.animated.bounceIn,.animated.bounceOut,.animated.flipOutX,.animated.flipOutY{-webkit-animation-duration:.75s;animation-duration:.75s}@-webkit-keyframes bounce{0%,20%,53%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1);-webkit-transform:translateZ(0);transform:translateZ(0)}40%,43%{-webkit-transform:translate3d(0,-30px,0);transform:translate3d(0,-30px,0)}40%,43%,70%{-webkit-animation-timing-function:cubic-bezier(.755,.05,.855,.06);animation-timing-function:cubic-bezier(.755,.05,.855,.06)}70%{-webkit-transform:translate3d(0,-15px,0);transform:translate3d(0,-15px,0)}90%{-webkit-transform:translate3d(0,-4px,0);transform:translate3d(0,-4px,0)}}@keyframes bounce{0%,20%,53%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1);-webkit-transform:translateZ(0);transform:translateZ(0)}40%,43%{-webkit-transform:translate3d(0,-30px,0);transform:translate3d(0,-30px,0)}40%,43%,70%{-webkit-animation-timing-function:cubic-bezier(.755,.05,.855,.06);animation-timing-function:cubic-bezier(.755,.05,.855,.06)}70%{-webkit-transform:translate3d(0,-15px,0);transform:translate3d(0,-15px,0)}90%{-webkit-transform:translate3d(0,-4px,0);transform:translate3d(0,-4px,0)}}.bounce{-webkit-animation-name:bounce;animation-name:bounce;-webkit-transform-origin:center bottom;transform-origin:center bottom}@-webkit-keyframes flash{0%,50%,to{opacity:1}25%,75%{opacity:0}}@keyframes flash{0%,50%,to{opacity:1}25%,75%{opacity:0}}.flash{-webkit-animation-name:flash;animation-name:flash}@-webkit-keyframes pulse{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}50%{-webkit-transform:scale3d(1.05,1.05,1.05);transform:scale3d(1.05,1.05,1.05)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}@keyframes pulse{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}50%{-webkit-transform:scale3d(1.05,1.05,1.05);transform:scale3d(1.05,1.05,1.05)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}.pulse{-webkit-animation-name:pulse;animation-name:pulse}@-webkit-keyframes rubberBand{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}30%{-webkit-transform:scale3d(1.25,.75,1);transform:scale3d(1.25,.75,1)}40%{-webkit-transform:scale3d(.75,1.25,1);transform:scale3d(.75,1.25,1)}50%{-webkit-transform:scale3d(1.15,.85,1);transform:scale3d(1.15,.85,1)}65%{-webkit-transform:scale3d(.95,1.05,1);transform:scale3d(.95,1.05,1)}75%{-webkit-transform:scale3d(1.05,.95,1);transform:scale3d(1.05,.95,1)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}@keyframes rubberBand{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}30%{-webkit-transform:scale3d(1.25,.75,1);transform:scale3d(1.25,.75,1)}40%{-webkit-transform:scale3d(.75,1.25,1);transform:scale3d(.75,1.25,1)}50%{-webkit-transform:scale3d(1.15,.85,1);transform:scale3d(1.15,.85,1)}65%{-webkit-transform:scale3d(.95,1.05,1);transform:scale3d(.95,1.05,1)}75%{-webkit-transform:scale3d(1.05,.95,1);transform:scale3d(1.05,.95,1)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}.rubberBand{-webkit-animation-name:rubberBand;animation-name:rubberBand}@-webkit-keyframes shake{0%,to{-webkit-transform:translateZ(0);transform:translateZ(0)}10%,30%,50%,70%,90%{-webkit-transform:translate3d(-10px,0,0);transform:translate3d(-10px,0,0)}20%,40%,60%,80%{-webkit-transform:translate3d(10px,0,0);transform:translate3d(10px,0,0)}}@keyframes shake{0%,to{-webkit-transform:translateZ(0);transform:translateZ(0)}10%,30%,50%,70%,90%{-webkit-transform:translate3d(-10px,0,0);transform:translate3d(-10px,0,0)}20%,40%,60%,80%{-webkit-transform:translate3d(10px,0,0);transform:translate3d(10px,0,0)}}.shake{-webkit-animation-name:shake;animation-name:shake}@-webkit-keyframes headShake{0%{-webkit-transform:translateX(0);transform:translateX(0)}6.5%{-webkit-transform:translateX(-6px) rotateY(-9deg);transform:translateX(-6px) rotateY(-9deg)}18.5%{-webkit-transform:translateX(5px) rotateY(7deg);transform:translateX(5px) rotateY(7deg)}31.5%{-webkit-transform:translateX(-3px) rotateY(-5deg);transform:translateX(-3px) rotateY(-5deg)}43.5%{-webkit-transform:translateX(2px) rotateY(3deg);transform:translateX(2px) rotateY(3deg)}50%{-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes headShake{0%{-webkit-transform:translateX(0);transform:translateX(0)}6.5%{-webkit-transform:translateX(-6px) rotateY(-9deg);transform:translateX(-6px) rotateY(-9deg)}18.5%{-webkit-transform:translateX(5px) rotateY(7deg);transform:translateX(5px) rotateY(7deg)}31.5%{-webkit-transform:translateX(-3px) rotateY(-5deg);transform:translateX(-3px) rotateY(-5deg)}43.5%{-webkit-transform:translateX(2px) rotateY(3deg);transform:translateX(2px) rotateY(3deg)}50%{-webkit-transform:translateX(0);transform:translateX(0)}}.headShake{-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;-webkit-animation-name:headShake;animation-name:headShake}@-webkit-keyframes swing{20%{-webkit-transform:rotate(15deg);transform:rotate(15deg)}40%{-webkit-transform:rotate(-10deg);transform:rotate(-10deg)}60%{-webkit-transform:rotate(5deg);transform:rotate(5deg)}80%{-webkit-transform:rotate(-5deg);transform:rotate(-5deg)}to{-webkit-transform:rotate(0deg);transform:rotate(0deg)}}@keyframes swing{20%{-webkit-transform:rotate(15deg);transform:rotate(15deg)}40%{-webkit-transform:rotate(-10deg);transform:rotate(-10deg)}60%{-webkit-transform:rotate(5deg);transform:rotate(5deg)}80%{-webkit-transform:rotate(-5deg);transform:rotate(-5deg)}to{-webkit-transform:rotate(0deg);transform:rotate(0deg)}}.swing{-webkit-transform-origin:top center;transform-origin:top center;-webkit-animation-name:swing;animation-name:swing}@-webkit-keyframes tada{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}10%,20%{-webkit-transform:scale3d(.9,.9,.9) rotate(-3deg);transform:scale3d(.9,.9,.9) rotate(-3deg)}30%,50%,70%,90%{-webkit-transform:scale3d(1.1,1.1,1.1) rotate(3deg);transform:scale3d(1.1,1.1,1.1) rotate(3deg)}40%,60%,80%{-webkit-transform:scale3d(1.1,1.1,1.1) rotate(-3deg);transform:scale3d(1.1,1.1,1.1) rotate(-3deg)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}@keyframes tada{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}10%,20%{-webkit-transform:scale3d(.9,.9,.9) rotate(-3deg);transform:scale3d(.9,.9,.9) rotate(-3deg)}30%,50%,70%,90%{-webkit-transform:scale3d(1.1,1.1,1.1) rotate(3deg);transform:scale3d(1.1,1.1,1.1) rotate(3deg)}40%,60%,80%{-webkit-transform:scale3d(1.1,1.1,1.1) rotate(-3deg);transform:scale3d(1.1,1.1,1.1) rotate(-3deg)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}.tada{-webkit-animation-name:tada;animation-name:tada}@-webkit-keyframes wobble{0%{-webkit-transform:none;transform:none}15%{-webkit-transform:translate3d(-25%,0,0) rotate(-5deg);transform:translate3d(-25%,0,0) rotate(-5deg)}30%{-webkit-transform:translate3d(20%,0,0) rotate(3deg);transform:translate3d(20%,0,0) rotate(3deg)}45%{-webkit-transform:translate3d(-15%,0,0) rotate(-3deg);transform:translate3d(-15%,0,0) rotate(-3deg)}60%{-webkit-transform:translate3d(10%,0,0) rotate(2deg);transform:translate3d(10%,0,0) rotate(2deg)}75%{-webkit-transform:translate3d(-5%,0,0) rotate(-1deg);transform:translate3d(-5%,0,0) rotate(-1deg)}to{-webkit-transform:none;transform:none}}@keyframes wobble{0%{-webkit-transform:none;transform:none}15%{-webkit-transform:translate3d(-25%,0,0) rotate(-5deg);transform:translate3d(-25%,0,0) rotate(-5deg)}30%{-webkit-transform:translate3d(20%,0,0) rotate(3deg);transform:translate3d(20%,0,0) rotate(3deg)}45%{-webkit-transform:translate3d(-15%,0,0) rotate(-3deg);transform:translate3d(-15%,0,0) rotate(-3deg)}60%{-webkit-transform:translate3d(10%,0,0) rotate(2deg);transform:translate3d(10%,0,0) rotate(2deg)}75%{-webkit-transform:translate3d(-5%,0,0) rotate(-1deg);transform:translate3d(-5%,0,0) rotate(-1deg)}to{-webkit-transform:none;transform:none}}.wobble{-webkit-animation-name:wobble;animation-name:wobble}@-webkit-keyframes jello{0%,11.1%,to{-webkit-transform:none;transform:none}22.2%{-webkit-transform:skewX(-12.5deg) skewY(-12.5deg);transform:skewX(-12.5deg) skewY(-12.5deg)}33.3%{-webkit-transform:skewX(6.25deg) skewY(6.25deg);transform:skewX(6.25deg) skewY(6.25deg)}44.4%{-webkit-transform:skewX(-3.125deg) skewY(-3.125deg);transform:skewX(-3.125deg) skewY(-3.125deg)}55.5%{-webkit-transform:skewX(1.5625deg) skewY(1.5625deg);transform:skewX(1.5625deg) skewY(1.5625deg)}66.6%{-webkit-transform:skewX(-.78125deg) skewY(-.78125deg);transform:skewX(-.78125deg) skewY(-.78125deg)}77.7%{-webkit-transform:skewX(.390625deg) skewY(.390625deg);transform:skewX(.390625deg) skewY(.390625deg)}88.8%{-webkit-transform:skewX(-.1953125deg) skewY(-.1953125deg);transform:skewX(-.1953125deg) skewY(-.1953125deg)}}@keyframes jello{0%,11.1%,to{-webkit-transform:none;transform:none}22.2%{-webkit-transform:skewX(-12.5deg) skewY(-12.5deg);transform:skewX(-12.5deg) skewY(-12.5deg)}33.3%{-webkit-transform:skewX(6.25deg) skewY(6.25deg);transform:skewX(6.25deg) skewY(6.25deg)}44.4%{-webkit-transform:skewX(-3.125deg) skewY(-3.125deg);transform:skewX(-3.125deg) skewY(-3.125deg)}55.5%{-webkit-transform:skewX(1.5625deg) skewY(1.5625deg);transform:skewX(1.5625deg) skewY(1.5625deg)}66.6%{-webkit-transform:skewX(-.78125deg) skewY(-.78125deg);transform:skewX(-.78125deg) skewY(-.78125deg)}77.7%{-webkit-transform:skewX(.390625deg) skewY(.390625deg);transform:skewX(.390625deg) skewY(.390625deg)}88.8%{-webkit-transform:skewX(-.1953125deg) skewY(-.1953125deg);transform:skewX(-.1953125deg) skewY(-.1953125deg)}}.jello{-webkit-animation-name:jello;animation-name:jello;-webkit-transform-origin:center;transform-origin:center}@-webkit-keyframes bounceIn{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}20%{-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1)}40%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}60%{opacity:1;-webkit-transform:scale3d(1.03,1.03,1.03);transform:scale3d(1.03,1.03,1.03)}80%{-webkit-transform:scale3d(.97,.97,.97);transform:scale3d(.97,.97,.97)}to{opacity:1;-webkit-transform:scaleX(1);transform:scaleX(1)}}@keyframes bounceIn{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}20%{-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1)}40%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}60%{opacity:1;-webkit-transform:scale3d(1.03,1.03,1.03);transform:scale3d(1.03,1.03,1.03)}80%{-webkit-transform:scale3d(.97,.97,.97);transform:scale3d(.97,.97,.97)}to{opacity:1;-webkit-transform:scaleX(1);transform:scaleX(1)}}.bounceIn{-webkit-animation-name:bounceIn;animation-name:bounceIn}@-webkit-keyframes bounceInDown{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(0,-3000px,0);transform:translate3d(0,-3000px,0)}60%{opacity:1;-webkit-transform:translate3d(0,25px,0);transform:translate3d(0,25px,0)}75%{-webkit-transform:translate3d(0,-10px,0);transform:translate3d(0,-10px,0)}90%{-webkit-transform:translate3d(0,5px,0);transform:translate3d(0,5px,0)}to{-webkit-transform:none;transform:none}}@keyframes bounceInDown{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(0,-3000px,0);transform:translate3d(0,-3000px,0)}60%{opacity:1;-webkit-transform:translate3d(0,25px,0);transform:translate3d(0,25px,0)}75%{-webkit-transform:translate3d(0,-10px,0);transform:translate3d(0,-10px,0)}90%{-webkit-transform:translate3d(0,5px,0);transform:translate3d(0,5px,0)}to{-webkit-transform:none;transform:none}}.bounceInDown{-webkit-animation-name:bounceInDown;animation-name:bounceInDown}@-webkit-keyframes bounceInLeft{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(-3000px,0,0);transform:translate3d(-3000px,0,0)}60%{opacity:1;-webkit-transform:translate3d(25px,0,0);transform:translate3d(25px,0,0)}75%{-webkit-transform:translate3d(-10px,0,0);transform:translate3d(-10px,0,0)}90%{-webkit-transform:translate3d(5px,0,0);transform:translate3d(5px,0,0)}to{-webkit-transform:none;transform:none}}@keyframes bounceInLeft{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(-3000px,0,0);transform:translate3d(-3000px,0,0)}60%{opacity:1;-webkit-transform:translate3d(25px,0,0);transform:translate3d(25px,0,0)}75%{-webkit-transform:translate3d(-10px,0,0);transform:translate3d(-10px,0,0)}90%{-webkit-transform:translate3d(5px,0,0);transform:translate3d(5px,0,0)}to{-webkit-transform:none;transform:none}}.bounceInLeft{-webkit-animation-name:bounceInLeft;animation-name:bounceInLeft}@-webkit-keyframes bounceInRight{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(3000px,0,0);transform:translate3d(3000px,0,0)}60%{opacity:1;-webkit-transform:translate3d(-25px,0,0);transform:translate3d(-25px,0,0)}75%{-webkit-transform:translate3d(10px,0,0);transform:translate3d(10px,0,0)}90%{-webkit-transform:translate3d(-5px,0,0);transform:translate3d(-5px,0,0)}to{-webkit-transform:none;transform:none}}@keyframes bounceInRight{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(3000px,0,0);transform:translate3d(3000px,0,0)}60%{opacity:1;-webkit-transform:translate3d(-25px,0,0);transform:translate3d(-25px,0,0)}75%{-webkit-transform:translate3d(10px,0,0);transform:translate3d(10px,0,0)}90%{-webkit-transform:translate3d(-5px,0,0);transform:translate3d(-5px,0,0)}to{-webkit-transform:none;transform:none}}.bounceInRight{-webkit-animation-name:bounceInRight;animation-name:bounceInRight}@-webkit-keyframes bounceInUp{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(0,3000px,0);transform:translate3d(0,3000px,0)}60%{opacity:1;-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0)}75%{-webkit-transform:translate3d(0,10px,0);transform:translate3d(0,10px,0)}90%{-webkit-transform:translate3d(0,-5px,0);transform:translate3d(0,-5px,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes bounceInUp{0%,60%,75%,90%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{opacity:0;-webkit-transform:translate3d(0,3000px,0);transform:translate3d(0,3000px,0)}60%{opacity:1;-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0)}75%{-webkit-transform:translate3d(0,10px,0);transform:translate3d(0,10px,0)}90%{-webkit-transform:translate3d(0,-5px,0);transform:translate3d(0,-5px,0)}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.bounceInUp{-webkit-animation-name:bounceInUp;animation-name:bounceInUp}@-webkit-keyframes bounceOut{20%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}50%,55%{opacity:1;-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1)}to{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}}@keyframes bounceOut{20%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}50%,55%{opacity:1;-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1)}to{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}}.bounceOut{-webkit-animation-name:bounceOut;animation-name:bounceOut}@-webkit-keyframes bounceOutDown{20%{-webkit-transform:translate3d(0,10px,0);transform:translate3d(0,10px,0)}40%,45%{opacity:1;-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0)}to{opacity:0;-webkit-transform:translate3d(0,2000px,0);transform:translate3d(0,2000px,0)}}@keyframes bounceOutDown{20%{-webkit-transform:translate3d(0,10px,0);transform:translate3d(0,10px,0)}40%,45%{opacity:1;-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0)}to{opacity:0;-webkit-transform:translate3d(0,2000px,0);transform:translate3d(0,2000px,0)}}.bounceOutDown{-webkit-animation-name:bounceOutDown;animation-name:bounceOutDown}@-webkit-keyframes bounceOutLeft{20%{opacity:1;-webkit-transform:translate3d(20px,0,0);transform:translate3d(20px,0,0)}to{opacity:0;-webkit-transform:translate3d(-2000px,0,0);transform:translate3d(-2000px,0,0)}}@keyframes bounceOutLeft{20%{opacity:1;-webkit-transform:translate3d(20px,0,0);transform:translate3d(20px,0,0)}to{opacity:0;-webkit-transform:translate3d(-2000px,0,0);transform:translate3d(-2000px,0,0)}}.bounceOutLeft{-webkit-animation-name:bounceOutLeft;animation-name:bounceOutLeft}@-webkit-keyframes bounceOutRight{20%{opacity:1;-webkit-transform:translate3d(-20px,0,0);transform:translate3d(-20px,0,0)}to{opacity:0;-webkit-transform:translate3d(2000px,0,0);transform:translate3d(2000px,0,0)}}@keyframes bounceOutRight{20%{opacity:1;-webkit-transform:translate3d(-20px,0,0);transform:translate3d(-20px,0,0)}to{opacity:0;-webkit-transform:translate3d(2000px,0,0);transform:translate3d(2000px,0,0)}}.bounceOutRight{-webkit-animation-name:bounceOutRight;animation-name:bounceOutRight}@-webkit-keyframes bounceOutUp{20%{-webkit-transform:translate3d(0,-10px,0);transform:translate3d(0,-10px,0)}40%,45%{opacity:1;-webkit-transform:translate3d(0,20px,0);transform:translate3d(0,20px,0)}to{opacity:0;-webkit-transform:translate3d(0,-2000px,0);transform:translate3d(0,-2000px,0)}}@keyframes bounceOutUp{20%{-webkit-transform:translate3d(0,-10px,0);transform:translate3d(0,-10px,0)}40%,45%{opacity:1;-webkit-transform:translate3d(0,20px,0);transform:translate3d(0,20px,0)}to{opacity:0;-webkit-transform:translate3d(0,-2000px,0);transform:translate3d(0,-2000px,0)}}.bounceOutUp{-webkit-animation-name:bounceOutUp;animation-name:bounceOutUp}@-webkit-keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.fadeIn{-webkit-animation-name:fadeIn;animation-name:fadeIn}@-webkit-keyframes fadeInDown{0%{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInDown{0%{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInDown{-webkit-animation-name:fadeInDown;animation-name:fadeInDown}@-webkit-keyframes fadeInDownBig{0%{opacity:0;-webkit-transform:translate3d(0,-2000px,0);transform:translate3d(0,-2000px,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInDownBig{0%{opacity:0;-webkit-transform:translate3d(0,-2000px,0);transform:translate3d(0,-2000px,0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInDownBig{-webkit-animation-name:fadeInDownBig;animation-name:fadeInDownBig}@-webkit-keyframes fadeInLeft{0%{opacity:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInLeft{0%{opacity:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInLeft{-webkit-animation-name:fadeInLeft;animation-name:fadeInLeft}@-webkit-keyframes fadeInLeftBig{0%{opacity:0;-webkit-transform:translate3d(-2000px,0,0);transform:translate3d(-2000px,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInLeftBig{0%{opacity:0;-webkit-transform:translate3d(-2000px,0,0);transform:translate3d(-2000px,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInLeftBig{-webkit-animation-name:fadeInLeftBig;animation-name:fadeInLeftBig}@-webkit-keyframes fadeInRight{0%{opacity:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInRight{0%{opacity:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInRight{-webkit-animation-name:fadeInRight;animation-name:fadeInRight}@-webkit-keyframes fadeInRightBig{0%{opacity:0;-webkit-transform:translate3d(2000px,0,0);transform:translate3d(2000px,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInRightBig{0%{opacity:0;-webkit-transform:translate3d(2000px,0,0);transform:translate3d(2000px,0,0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInRightBig{-webkit-animation-name:fadeInRightBig;animation-name:fadeInRightBig}@-webkit-keyframes fadeInUp{0%{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInUp{0%{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInUp{-webkit-animation-name:fadeInUp;animation-name:fadeInUp}@-webkit-keyframes fadeInUpBig{0%{opacity:0;-webkit-transform:translate3d(0,2000px,0);transform:translate3d(0,2000px,0)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes fadeInUpBig{0%{opacity:0;-webkit-transform:translate3d(0,2000px,0);transform:translate3d(0,2000px,0)}to{opacity:1;-webkit-transform:none;transform:none}}.fadeInUpBig{-webkit-animation-name:fadeInUpBig;animation-name:fadeInUpBig}@-webkit-keyframes fadeOut{0%{opacity:1}to{opacity:0}}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}.fadeOut{-webkit-animation-name:fadeOut;animation-name:fadeOut}@-webkit-keyframes fadeOutDown{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}@keyframes fadeOutDown{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}.fadeOutDown{-webkit-animation-name:fadeOutDown;animation-name:fadeOutDown}@-webkit-keyframes fadeOutDownBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,2000px,0);transform:translate3d(0,2000px,0)}}@keyframes fadeOutDownBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,2000px,0);transform:translate3d(0,2000px,0)}}.fadeOutDownBig{-webkit-animation-name:fadeOutDownBig;animation-name:fadeOutDownBig}@-webkit-keyframes fadeOutLeft{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}@keyframes fadeOutLeft{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}.fadeOutLeft{-webkit-animation-name:fadeOutLeft;animation-name:fadeOutLeft}@-webkit-keyframes fadeOutLeftBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(-2000px,0,0);transform:translate3d(-2000px,0,0)}}@keyframes fadeOutLeftBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(-2000px,0,0);transform:translate3d(-2000px,0,0)}}.fadeOutLeftBig{-webkit-animation-name:fadeOutLeftBig;animation-name:fadeOutLeftBig}@-webkit-keyframes fadeOutRight{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}@keyframes fadeOutRight{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}.fadeOutRight{-webkit-animation-name:fadeOutRight;animation-name:fadeOutRight}@-webkit-keyframes fadeOutRightBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(2000px,0,0);transform:translate3d(2000px,0,0)}}@keyframes fadeOutRightBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(2000px,0,0);transform:translate3d(2000px,0,0)}}.fadeOutRightBig{-webkit-animation-name:fadeOutRightBig;animation-name:fadeOutRightBig}@-webkit-keyframes fadeOutUp{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}@keyframes fadeOutUp{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}.fadeOutUp{-webkit-animation-name:fadeOutUp;animation-name:fadeOutUp}@-webkit-keyframes fadeOutUpBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,-2000px,0);transform:translate3d(0,-2000px,0)}}@keyframes fadeOutUpBig{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(0,-2000px,0);transform:translate3d(0,-2000px,0)}}.fadeOutUpBig{-webkit-animation-name:fadeOutUpBig;animation-name:fadeOutUpBig}@-webkit-keyframes flip{0%{-webkit-transform:perspective(400px) rotateY(-1turn);transform:perspective(400px) rotateY(-1turn)}0%,40%{-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}40%{-webkit-transform:perspective(400px) translateZ(150px) rotateY(-190deg);transform:perspective(400px) translateZ(150px) rotateY(-190deg)}50%{-webkit-transform:perspective(400px) translateZ(150px) rotateY(-170deg);transform:perspective(400px) translateZ(150px) rotateY(-170deg)}50%,80%{-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}80%{-webkit-transform:perspective(400px) scale3d(.95,.95,.95);transform:perspective(400px) scale3d(.95,.95,.95)}to{-webkit-transform:perspective(400px);transform:perspective(400px);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}}@keyframes flip{0%{-webkit-transform:perspective(400px) rotateY(-1turn);transform:perspective(400px) rotateY(-1turn)}0%,40%{-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}40%{-webkit-transform:perspective(400px) translateZ(150px) rotateY(-190deg);transform:perspective(400px) translateZ(150px) rotateY(-190deg)}50%{-webkit-transform:perspective(400px) translateZ(150px) rotateY(-170deg);transform:perspective(400px) translateZ(150px) rotateY(-170deg)}50%,80%{-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}80%{-webkit-transform:perspective(400px) scale3d(.95,.95,.95);transform:perspective(400px) scale3d(.95,.95,.95)}to{-webkit-transform:perspective(400px);transform:perspective(400px);-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}}.animated.flip{-webkit-backface-visibility:visible;backface-visibility:visible;-webkit-animation-name:flip;animation-name:flip}@-webkit-keyframes flipInX{0%{-webkit-transform:perspective(400px) rotateX(90deg);transform:perspective(400px) rotateX(90deg);opacity:0}0%,40%{-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}40%{-webkit-transform:perspective(400px) rotateX(-20deg);transform:perspective(400px) rotateX(-20deg)}60%{-webkit-transform:perspective(400px) rotateX(10deg);transform:perspective(400px) rotateX(10deg);opacity:1}80%{-webkit-transform:perspective(400px) rotateX(-5deg);transform:perspective(400px) rotateX(-5deg)}to{-webkit-transform:perspective(400px);transform:perspective(400px)}}@keyframes flipInX{0%{-webkit-transform:perspective(400px) rotateX(90deg);transform:perspective(400px) rotateX(90deg);opacity:0}0%,40%{-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}40%{-webkit-transform:perspective(400px) rotateX(-20deg);transform:perspective(400px) rotateX(-20deg)}60%{-webkit-transform:perspective(400px) rotateX(10deg);transform:perspective(400px) rotateX(10deg);opacity:1}80%{-webkit-transform:perspective(400px) rotateX(-5deg);transform:perspective(400px) rotateX(-5deg)}to{-webkit-transform:perspective(400px);transform:perspective(400px)}}.flipInX{-webkit-backface-visibility:visible!important;backface-visibility:visible!important;-webkit-animation-name:flipInX;animation-name:flipInX}@-webkit-keyframes flipInY{0%{-webkit-transform:perspective(400px) rotateY(90deg);transform:perspective(400px) rotateY(90deg);opacity:0}0%,40%{-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}40%{-webkit-transform:perspective(400px) rotateY(-20deg);transform:perspective(400px) rotateY(-20deg)}60%{-webkit-transform:perspective(400px) rotateY(10deg);transform:perspective(400px) rotateY(10deg);opacity:1}80%{-webkit-transform:perspective(400px) rotateY(-5deg);transform:perspective(400px) rotateY(-5deg)}to{-webkit-transform:perspective(400px);transform:perspective(400px)}}@keyframes flipInY{0%{-webkit-transform:perspective(400px) rotateY(90deg);transform:perspective(400px) rotateY(90deg);opacity:0}0%,40%{-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}40%{-webkit-transform:perspective(400px) rotateY(-20deg);transform:perspective(400px) rotateY(-20deg)}60%{-webkit-transform:perspective(400px) rotateY(10deg);transform:perspective(400px) rotateY(10deg);opacity:1}80%{-webkit-transform:perspective(400px) rotateY(-5deg);transform:perspective(400px) rotateY(-5deg)}to{-webkit-transform:perspective(400px);transform:perspective(400px)}}.flipInY{-webkit-backface-visibility:visible!important;backface-visibility:visible!important;-webkit-animation-name:flipInY;animation-name:flipInY}@-webkit-keyframes flipOutX{0%{-webkit-transform:perspective(400px);transform:perspective(400px)}30%{-webkit-transform:perspective(400px) rotateX(-20deg);transform:perspective(400px) rotateX(-20deg);opacity:1}to{-webkit-transform:perspective(400px) rotateX(90deg);transform:perspective(400px) rotateX(90deg);opacity:0}}@keyframes flipOutX{0%{-webkit-transform:perspective(400px);transform:perspective(400px)}30%{-webkit-transform:perspective(400px) rotateX(-20deg);transform:perspective(400px) rotateX(-20deg);opacity:1}to{-webkit-transform:perspective(400px) rotateX(90deg);transform:perspective(400px) rotateX(90deg);opacity:0}}.flipOutX{-webkit-animation-name:flipOutX;animation-name:flipOutX;-webkit-backface-visibility:visible!important;backface-visibility:visible!important}@-webkit-keyframes flipOutY{0%{-webkit-transform:perspective(400px);transform:perspective(400px)}30%{-webkit-transform:perspective(400px) rotateY(-15deg);transform:perspective(400px) rotateY(-15deg);opacity:1}to{-webkit-transform:perspective(400px) rotateY(90deg);transform:perspective(400px) rotateY(90deg);opacity:0}}@keyframes flipOutY{0%{-webkit-transform:perspective(400px);transform:perspective(400px)}30%{-webkit-transform:perspective(400px) rotateY(-15deg);transform:perspective(400px) rotateY(-15deg);opacity:1}to{-webkit-transform:perspective(400px) rotateY(90deg);transform:perspective(400px) rotateY(90deg);opacity:0}}.flipOutY{-webkit-backface-visibility:visible!important;backface-visibility:visible!important;-webkit-animation-name:flipOutY;animation-name:flipOutY}@-webkit-keyframes lightSpeedIn{0%{-webkit-transform:translate3d(100%,0,0) skewX(-30deg);transform:translate3d(100%,0,0) skewX(-30deg);opacity:0}60%{-webkit-transform:skewX(20deg);transform:skewX(20deg)}60%,80%{opacity:1}80%{-webkit-transform:skewX(-5deg);transform:skewX(-5deg)}to{-webkit-transform:none;transform:none;opacity:1}}@keyframes lightSpeedIn{0%{-webkit-transform:translate3d(100%,0,0) skewX(-30deg);transform:translate3d(100%,0,0) skewX(-30deg);opacity:0}60%{-webkit-transform:skewX(20deg);transform:skewX(20deg)}60%,80%{opacity:1}80%{-webkit-transform:skewX(-5deg);transform:skewX(-5deg)}to{-webkit-transform:none;transform:none;opacity:1}}.lightSpeedIn{-webkit-animation-name:lightSpeedIn;animation-name:lightSpeedIn;-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}@-webkit-keyframes lightSpeedOut{0%{opacity:1}to{-webkit-transform:translate3d(100%,0,0) skewX(30deg);transform:translate3d(100%,0,0) skewX(30deg);opacity:0}}@keyframes lightSpeedOut{0%{opacity:1}to{-webkit-transform:translate3d(100%,0,0) skewX(30deg);transform:translate3d(100%,0,0) skewX(30deg);opacity:0}}.lightSpeedOut{-webkit-animation-name:lightSpeedOut;animation-name:lightSpeedOut;-webkit-animation-timing-function:ease-in;animation-timing-function:ease-in}@-webkit-keyframes rotateIn{0%{transform-origin:center;-webkit-transform:rotate(-200deg);transform:rotate(-200deg);opacity:0}0%,to{-webkit-transform-origin:center}to{transform-origin:center;-webkit-transform:none;transform:none;opacity:1}}@keyframes rotateIn{0%{transform-origin:center;-webkit-transform:rotate(-200deg);transform:rotate(-200deg);opacity:0}0%,to{-webkit-transform-origin:center}to{transform-origin:center;-webkit-transform:none;transform:none;opacity:1}}.rotateIn{-webkit-animation-name:rotateIn;animation-name:rotateIn}@-webkit-keyframes rotateInDownLeft{0%{transform-origin:left bottom;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);opacity:0}0%,to{-webkit-transform-origin:left bottom}to{transform-origin:left bottom;-webkit-transform:none;transform:none;opacity:1}}@keyframes rotateInDownLeft{0%{transform-origin:left bottom;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);opacity:0}0%,to{-webkit-transform-origin:left bottom}to{transform-origin:left bottom;-webkit-transform:none;transform:none;opacity:1}}.rotateInDownLeft{-webkit-animation-name:rotateInDownLeft;animation-name:rotateInDownLeft}@-webkit-keyframes rotateInDownRight{0%{transform-origin:right bottom;-webkit-transform:rotate(45deg);transform:rotate(45deg);opacity:0}0%,to{-webkit-transform-origin:right bottom}to{transform-origin:right bottom;-webkit-transform:none;transform:none;opacity:1}}@keyframes rotateInDownRight{0%{transform-origin:right bottom;-webkit-transform:rotate(45deg);transform:rotate(45deg);opacity:0}0%,to{-webkit-transform-origin:right bottom}to{transform-origin:right bottom;-webkit-transform:none;transform:none;opacity:1}}.rotateInDownRight{-webkit-animation-name:rotateInDownRight;animation-name:rotateInDownRight}@-webkit-keyframes rotateInUpLeft{0%{transform-origin:left bottom;-webkit-transform:rotate(45deg);transform:rotate(45deg);opacity:0}0%,to{-webkit-transform-origin:left bottom}to{transform-origin:left bottom;-webkit-transform:none;transform:none;opacity:1}}@keyframes rotateInUpLeft{0%{transform-origin:left bottom;-webkit-transform:rotate(45deg);transform:rotate(45deg);opacity:0}0%,to{-webkit-transform-origin:left bottom}to{transform-origin:left bottom;-webkit-transform:none;transform:none;opacity:1}}.rotateInUpLeft{-webkit-animation-name:rotateInUpLeft;animation-name:rotateInUpLeft}@-webkit-keyframes rotateInUpRight{0%{transform-origin:right bottom;-webkit-transform:rotate(-90deg);transform:rotate(-90deg);opacity:0}0%,to{-webkit-transform-origin:right bottom}to{transform-origin:right bottom;-webkit-transform:none;transform:none;opacity:1}}@keyframes rotateInUpRight{0%{transform-origin:right bottom;-webkit-transform:rotate(-90deg);transform:rotate(-90deg);opacity:0}0%,to{-webkit-transform-origin:right bottom}to{transform-origin:right bottom;-webkit-transform:none;transform:none;opacity:1}}.rotateInUpRight{-webkit-animation-name:rotateInUpRight;animation-name:rotateInUpRight}@-webkit-keyframes rotateOut{0%{transform-origin:center;opacity:1}0%,to{-webkit-transform-origin:center}to{transform-origin:center;-webkit-transform:rotate(200deg);transform:rotate(200deg);opacity:0}}@keyframes rotateOut{0%{transform-origin:center;opacity:1}0%,to{-webkit-transform-origin:center}to{transform-origin:center;-webkit-transform:rotate(200deg);transform:rotate(200deg);opacity:0}}.rotateOut{-webkit-animation-name:rotateOut;animation-name:rotateOut}@-webkit-keyframes rotateOutDownLeft{0%{transform-origin:left bottom;opacity:1}0%,to{-webkit-transform-origin:left bottom}to{transform-origin:left bottom;-webkit-transform:rotate(45deg);transform:rotate(45deg);opacity:0}}@keyframes rotateOutDownLeft{0%{transform-origin:left bottom;opacity:1}0%,to{-webkit-transform-origin:left bottom}to{transform-origin:left bottom;-webkit-transform:rotate(45deg);transform:rotate(45deg);opacity:0}}.rotateOutDownLeft{-webkit-animation-name:rotateOutDownLeft;animation-name:rotateOutDownLeft}@-webkit-keyframes rotateOutDownRight{0%{transform-origin:right bottom;opacity:1}0%,to{-webkit-transform-origin:right bottom}to{transform-origin:right bottom;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);opacity:0}}@keyframes rotateOutDownRight{0%{transform-origin:right bottom;opacity:1}0%,to{-webkit-transform-origin:right bottom}to{transform-origin:right bottom;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);opacity:0}}.rotateOutDownRight{-webkit-animation-name:rotateOutDownRight;animation-name:rotateOutDownRight}@-webkit-keyframes rotateOutUpLeft{0%{transform-origin:left bottom;opacity:1}0%,to{-webkit-transform-origin:left bottom}to{transform-origin:left bottom;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);opacity:0}}@keyframes rotateOutUpLeft{0%{transform-origin:left bottom;opacity:1}0%,to{-webkit-transform-origin:left bottom}to{transform-origin:left bottom;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);opacity:0}}.rotateOutUpLeft{-webkit-animation-name:rotateOutUpLeft;animation-name:rotateOutUpLeft}@-webkit-keyframes rotateOutUpRight{0%{transform-origin:right bottom;opacity:1}0%,to{-webkit-transform-origin:right bottom}to{transform-origin:right bottom;-webkit-transform:rotate(90deg);transform:rotate(90deg);opacity:0}}@keyframes rotateOutUpRight{0%{transform-origin:right bottom;opacity:1}0%,to{-webkit-transform-origin:right bottom}to{transform-origin:right bottom;-webkit-transform:rotate(90deg);transform:rotate(90deg);opacity:0}}.rotateOutUpRight{-webkit-animation-name:rotateOutUpRight;animation-name:rotateOutUpRight}@-webkit-keyframes hinge{0%{transform-origin:top left}0%,20%,60%{-webkit-transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}20%,60%{-webkit-transform:rotate(80deg);transform:rotate(80deg);transform-origin:top left}40%,80%{-webkit-transform:rotate(60deg);transform:rotate(60deg);-webkit-transform-origin:top left;transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;opacity:1}to{-webkit-transform:translate3d(0,700px,0);transform:translate3d(0,700px,0);opacity:0}}@keyframes hinge{0%{transform-origin:top left}0%,20%,60%{-webkit-transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out}20%,60%{-webkit-transform:rotate(80deg);transform:rotate(80deg);transform-origin:top left}40%,80%{-webkit-transform:rotate(60deg);transform:rotate(60deg);-webkit-transform-origin:top left;transform-origin:top left;-webkit-animation-timing-function:ease-in-out;animation-timing-function:ease-in-out;opacity:1}to{-webkit-transform:translate3d(0,700px,0);transform:translate3d(0,700px,0);opacity:0}}.hinge{-webkit-animation-name:hinge;animation-name:hinge}@-webkit-keyframes rollIn{0%{opacity:0;-webkit-transform:translate3d(-100%,0,0) rotate(-120deg);transform:translate3d(-100%,0,0) rotate(-120deg)}to{opacity:1;-webkit-transform:none;transform:none}}@keyframes rollIn{0%{opacity:0;-webkit-transform:translate3d(-100%,0,0) rotate(-120deg);transform:translate3d(-100%,0,0) rotate(-120deg)}to{opacity:1;-webkit-transform:none;transform:none}}.rollIn{-webkit-animation-name:rollIn;animation-name:rollIn}@-webkit-keyframes rollOut{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(100%,0,0) rotate(120deg);transform:translate3d(100%,0,0) rotate(120deg)}}@keyframes rollOut{0%{opacity:1}to{opacity:0;-webkit-transform:translate3d(100%,0,0) rotate(120deg);transform:translate3d(100%,0,0) rotate(120deg)}}.rollOut{-webkit-animation-name:rollOut;animation-name:rollOut}@-webkit-keyframes zoomIn{0%{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes zoomIn{0%{opacity:0;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}50%{opacity:1}}.zoomIn{-webkit-animation-name:zoomIn;animation-name:zoomIn}@-webkit-keyframes zoomInDown{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,-1000px,0);transform:scale3d(.1,.1,.1) translate3d(0,-1000px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,60px,0);transform:scale3d(.475,.475,.475) translate3d(0,60px,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes zoomInDown{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,-1000px,0);transform:scale3d(.1,.1,.1) translate3d(0,-1000px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,60px,0);transform:scale3d(.475,.475,.475) translate3d(0,60px,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInDown{-webkit-animation-name:zoomInDown;animation-name:zoomInDown}@-webkit-keyframes zoomInLeft{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(-1000px,0,0);transform:scale3d(.1,.1,.1) translate3d(-1000px,0,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(10px,0,0);transform:scale3d(.475,.475,.475) translate3d(10px,0,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes zoomInLeft{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(-1000px,0,0);transform:scale3d(.1,.1,.1) translate3d(-1000px,0,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(10px,0,0);transform:scale3d(.475,.475,.475) translate3d(10px,0,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInLeft{-webkit-animation-name:zoomInLeft;animation-name:zoomInLeft}@-webkit-keyframes zoomInRight{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(1000px,0,0);transform:scale3d(.1,.1,.1) translate3d(1000px,0,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(-10px,0,0);transform:scale3d(.475,.475,.475) translate3d(-10px,0,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes zoomInRight{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(1000px,0,0);transform:scale3d(.1,.1,.1) translate3d(1000px,0,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(-10px,0,0);transform:scale3d(.475,.475,.475) translate3d(-10px,0,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInRight{-webkit-animation-name:zoomInRight;animation-name:zoomInRight}@-webkit-keyframes zoomInUp{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,1000px,0);transform:scale3d(.1,.1,.1) translate3d(0,1000px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes zoomInUp{0%{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,1000px,0);transform:scale3d(.1,.1,.1) translate3d(0,1000px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}60%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomInUp{-webkit-animation-name:zoomInUp;animation-name:zoomInUp}@-webkit-keyframes zoomOut{0%{opacity:1}50%{-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}50%,to{opacity:0}}@keyframes zoomOut{0%{opacity:1}50%{-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}50%,to{opacity:0}}.zoomOut{-webkit-animation-name:zoomOut;animation-name:zoomOut}@-webkit-keyframes zoomOutDown{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}to{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,2000px,0);transform:scale3d(.1,.1,.1) translate3d(0,2000px,0);-webkit-transform-origin:center bottom;transform-origin:center bottom;-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes zoomOutDown{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);transform:scale3d(.475,.475,.475) translate3d(0,-60px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}to{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,2000px,0);transform:scale3d(.1,.1,.1) translate3d(0,2000px,0);-webkit-transform-origin:center bottom;transform-origin:center bottom;-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomOutDown{-webkit-animation-name:zoomOutDown;animation-name:zoomOutDown}@-webkit-keyframes zoomOutLeft{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(42px,0,0);transform:scale3d(.475,.475,.475) translate3d(42px,0,0)}to{opacity:0;-webkit-transform:scale(.1) translate3d(-2000px,0,0);transform:scale(.1) translate3d(-2000px,0,0);-webkit-transform-origin:left center;transform-origin:left center}}@keyframes zoomOutLeft{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(42px,0,0);transform:scale3d(.475,.475,.475) translate3d(42px,0,0)}to{opacity:0;-webkit-transform:scale(.1) translate3d(-2000px,0,0);transform:scale(.1) translate3d(-2000px,0,0);-webkit-transform-origin:left center;transform-origin:left center}}.zoomOutLeft{-webkit-animation-name:zoomOutLeft;animation-name:zoomOutLeft}@-webkit-keyframes zoomOutRight{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(-42px,0,0);transform:scale3d(.475,.475,.475) translate3d(-42px,0,0)}to{opacity:0;-webkit-transform:scale(.1) translate3d(2000px,0,0);transform:scale(.1) translate3d(2000px,0,0);-webkit-transform-origin:right center;transform-origin:right center}}@keyframes zoomOutRight{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(-42px,0,0);transform:scale3d(.475,.475,.475) translate3d(-42px,0,0)}to{opacity:0;-webkit-transform:scale(.1) translate3d(2000px,0,0);transform:scale(.1) translate3d(2000px,0,0);-webkit-transform-origin:right center;transform-origin:right center}}.zoomOutRight{-webkit-animation-name:zoomOutRight;animation-name:zoomOutRight}@-webkit-keyframes zoomOutUp{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,60px,0);transform:scale3d(.475,.475,.475) translate3d(0,60px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}to{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,-2000px,0);transform:scale3d(.1,.1,.1) translate3d(0,-2000px,0);-webkit-transform-origin:center bottom;transform-origin:center bottom;-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}@keyframes zoomOutUp{40%{opacity:1;-webkit-transform:scale3d(.475,.475,.475) translate3d(0,60px,0);transform:scale3d(.475,.475,.475) translate3d(0,60px,0);-webkit-animation-timing-function:cubic-bezier(.55,.055,.675,.19);animation-timing-function:cubic-bezier(.55,.055,.675,.19)}to{opacity:0;-webkit-transform:scale3d(.1,.1,.1) translate3d(0,-2000px,0);transform:scale3d(.1,.1,.1) translate3d(0,-2000px,0);-webkit-transform-origin:center bottom;transform-origin:center bottom;-webkit-animation-timing-function:cubic-bezier(.175,.885,.32,1);animation-timing-function:cubic-bezier(.175,.885,.32,1)}}.zoomOutUp{-webkit-animation-name:zoomOutUp;animation-name:zoomOutUp}@-webkit-keyframes slideInDown{0%{-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes slideInDown{0%{-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.slideInDown{-webkit-animation-name:slideInDown;animation-name:slideInDown}@-webkit-keyframes slideInLeft{0%{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes slideInLeft{0%{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.slideInLeft{-webkit-animation-name:slideInLeft;animation-name:slideInLeft}@-webkit-keyframes slideInRight{0%{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes slideInRight{0%{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.slideInRight{-webkit-animation-name:slideInRight;animation-name:slideInRight}@-webkit-keyframes slideInUp{0%{-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}@keyframes slideInUp{0%{-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0);visibility:visible}to{-webkit-transform:translateZ(0);transform:translateZ(0)}}.slideInUp{-webkit-animation-name:slideInUp;animation-name:slideInUp}@-webkit-keyframes slideOutDown{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}@keyframes slideOutDown{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(0,100%,0);transform:translate3d(0,100%,0)}}.slideOutDown{-webkit-animation-name:slideOutDown;animation-name:slideOutDown}@-webkit-keyframes slideOutLeft{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}@keyframes slideOutLeft{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}}.slideOutLeft{-webkit-animation-name:slideOutLeft;animation-name:slideOutLeft}@-webkit-keyframes slideOutRight{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}@keyframes slideOutRight{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}}.slideOutRight{-webkit-animation-name:slideOutRight;animation-name:slideOutRight}@-webkit-keyframes slideOutUp{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}@keyframes slideOutUp{0%{-webkit-transform:translateZ(0);transform:translateZ(0)}to{visibility:hidden;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}}.slideOutUp{-webkit-animation-name:slideOutUp;animation-name:slideOutUp}\t@font-face{font-family:hs-swiper-icons;src:url("data:application/font-woff;charset=utf-8;base64, d09GRgABAAAAAAZgABAAAAAADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABGRlRNAAAGRAAAABoAAAAci6qHkUdERUYAAAWgAAAAIwAAACQAYABXR1BPUwAABhQAAAAuAAAANuAY7+xHU1VCAAAFxAAAAFAAAABm2fPczU9TLzIAAAHcAAAASgAAAGBP9V5RY21hcAAAAkQAAACIAAABYt6F0cBjdnQgAAACzAAAAAQAAAAEABEBRGdhc3AAAAWYAAAACAAAAAj//wADZ2x5ZgAAAywAAADMAAAD2MHtryVoZWFkAAABbAAAADAAAAA2E2+eoWhoZWEAAAGcAAAAHwAAACQC9gDzaG10eAAAAigAAAAZAAAArgJkABFsb2NhAAAC0AAAAFoAAABaFQAUGG1heHAAAAG8AAAAHwAAACAAcABAbmFtZQAAA/gAAAE5AAACXvFdBwlwb3N0AAAFNAAAAGIAAACE5s74hXjaY2BkYGAAYpf5Hu/j+W2+MnAzMYDAzaX6QjD6/4//Bxj5GA8AuRwMYGkAPywL13jaY2BkYGA88P8Agx4j+/8fQDYfA1AEBWgDAIB2BOoAeNpjYGRgYNBh4GdgYgABEMnIABJzYNADCQAACWgAsQB42mNgYfzCOIGBlYGB0YcxjYGBwR1Kf2WQZGhhYGBiYGVmgAFGBiQQkOaawtDAoMBQxXjg/wEGPcYDDA4wNUA2CCgwsAAAO4EL6gAAeNpj2M0gyAACqxgGNWBkZ2D4/wMA+xkDdgAAAHjaY2BgYGaAYBkGRgYQiAHyGMF8FgYHIM3DwMHABGQrMOgyWDLEM1T9/w8UBfEMgLzE////P/5//f/V/xv+r4eaAAeMbAxwIUYmIMHEgKYAYjUcsDAwsLKxc3BycfPw8jEQA/gZBASFhEVExcQlJKWkZWTl5BUUlZRVVNXUNTQZBgMAAMR+E+gAEQFEAAAAKgAqACoANAA+AEgAUgBcAGYAcAB6AIQAjgCYAKIArAC2AMAAygDUAN4A6ADyAPwBBgEQARoBJAEuATgBQgFMAVYBYAFqAXQBfgGIAZIBnAGmAbIBzgHsAAB42u2NMQ6CUAyGW568x9AneYYgm4MJbhKFaExIOAVX8ApewSt4Bic4AfeAid3VOBixDxfPYEza5O+Xfi04YADggiUIULCuEJK8VhO4bSvpdnktHI5QCYtdi2sl8ZnXaHlqUrNKzdKcT8cjlq+rwZSvIVczNiezsfnP/uznmfPFBNODM2K7MTQ45YEAZqGP81AmGGcF3iPqOop0r1SPTaTbVkfUe4HXj97wYE+yNwWYxwWu4v1ugWHgo3S1XdZEVqWM7ET0cfnLGxWfkgR42o2PvWrDMBSFj/IHLaF0zKjRgdiVMwScNRAoWUoH78Y2icB/yIY09An6AH2Bdu/UB+yxopYshQiEvnvu0dURgDt8QeC8PDw7Fpji3fEA4z/PEJ6YOB5hKh4dj3EvXhxPqH/SKUY3rJ7srZ4FZnh1PMAtPhwP6fl2PMJMPDgeQ4rY8YT6Gzao0eAEA409DuggmTnFnOcSCiEiLMgxCiTI6Cq5DZUd3Qmp10vO0LaLTd2cjN4fOumlc7lUYbSQcZFkutRG7g6JKZKy0RmdLY680CDnEJ+UMkpFFe1RN7nxdVpXrC4aTtnaurOnYercZg2YVmLN/d/gczfEimrE/fs/bOuq29Zmn8tloORaXgZgGa78yO9/cnXm2BpaGvq25Dv9S4E9+5SIc9PqupJKhYFSSl47+Qcr1mYNAAAAeNptw0cKwkAAAMDZJA8Q7OUJvkLsPfZ6zFVERPy8qHh2YER+3i/BP83vIBLLySsoKimrqKqpa2hp6+jq6RsYGhmbmJqZSy0sraxtbO3sHRydnEMU4uR6yx7JJXveP7WrDycAAAAAAAH//wACeNpjYGRgYOABYhkgZgJCZgZNBkYGLQZtIJsFLMYAAAw3ALgAeNolizEKgDAQBCchRbC2sFER0YD6qVQiBCv/H9ezGI6Z5XBAw8CBK/m5iQQVauVbXLnOrMZv2oLdKFa8Pjuru2hJzGabmOSLzNMzvutpB3N42mNgZGBg4GKQYzBhYMxJLMlj4GBgAYow/P/PAJJhLM6sSoWKfWCAAwDAjgbRAAB42mNgYGBkAIIbCZo5IPrmUn0hGA0AO8EFTQAA") format("woff");font-weight:400;font-style:normal}:root{--hs-swiper-theme-color:#007aff}.hs-container-swp .swiper-container{margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1}.hs-container-swp .swiper-container-vertical>.swiper-wrapper{flex-direction:column}.hs-container-swp .swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;box-sizing:content-box}.hs-container-swp .swiper-container-android .swiper-slide,.hs-container-swp .swiper-wrapper{transform:translate3d(0,0,0)}.hs-container-swp .swiper-container-multirow>.swiper-wrapper{flex-wrap:wrap}.hs-container-swp .swiper-container-multirow-column>.swiper-wrapper{flex-wrap:wrap;flex-direction:column}.hs-container-swp .swiper-container-free-mode>.swiper-wrapper{transition-timing-function:ease-out;margin:0 auto}.hs-container-swp .swiper-slide{flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform}.hs-container-swp .swiper-slide-invisible-blank{visibility:hidden}.hs-container-swp .swiper-container-autoheight,.hs-container-swp .swiper-container-autoheight .swiper-slide{height:auto}.hs-container-swp .swiper-container-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.hs-container-swp .swiper-container-3d{perspective:1200px}.hs-container-swp .swiper-container-3d .swiper-cube-shadow,.hs-container-swp .swiper-container-3d .swiper-slide,.hs-container-swp .swiper-container-3d .swiper-slide-shadow-bottom,.hs-container-swp .swiper-container-3d .swiper-slide-shadow-left,.hs-container-swp .swiper-container-3d .swiper-slide-shadow-right,.hs-container-swp .swiper-container-3d .swiper-slide-shadow-top,.hs-container-swp .swiper-container-3d .swiper-wrapper{transform-style:preserve-3d}.hs-container-swp .swiper-container-3d .swiper-slide-shadow-bottom,.hs-container-swp .swiper-container-3d .swiper-slide-shadow-left,.hs-container-swp .swiper-container-3d .swiper-slide-shadow-right,.hs-container-swp .swiper-container-3d .swiper-slide-shadow-top{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}.hs-container-swp .swiper-container-3d .swiper-slide-shadow-left{background-image:linear-gradient(to left,rgba(0,0,0,.5),rgba(0,0,0,0))}.hs-container-swp .swiper-container-3d .swiper-slide-shadow-right{background-image:linear-gradient(to right,rgba(0,0,0,.5),rgba(0,0,0,0))}.hs-container-swp .swiper-container-3d .swiper-slide-shadow-top{background-image:linear-gradient(to top,rgba(0,0,0,.5),rgba(0,0,0,0))}.hs-container-swp .swiper-container-3d .swiper-slide-shadow-bottom{background-image:linear-gradient(to bottom,rgba(0,0,0,.5),rgba(0,0,0,0))}.hs-container-swp .swiper-container-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.hs-container-swp .swiper-container-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.hs-container-swp .swiper-container-css-mode>.swiper-wrapper>.swiper-slide{scroll-snap-align:start start}.hs-container-swp .swiper-container-horizontal.swiper-container-css-mode>.swiper-wrapper{scroll-snap-type:x mandatory}.hs-container-swp .swiper-container-vertical.swiper-container-css-mode>.swiper-wrapper{scroll-snap-type:y mandatory}:root{--hs-swiper-navigation-size:44px}.hs-container-swp .swiper-button-next,.hs-container-swp .swiper-button-prev{position:absolute;top:50%;width:calc(var(--hs-swiper-navigation-size)/ 44 * 27);height:var(--hs-swiper-navigation-size);margin-top:calc(-1 * var(--hs-swiper-navigation-size)/ 2);z-index:10;cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--hs-swiper-navigation-color,var(--hs-swiper-theme-color))}.hs-container-swp .swiper-button-next.swiper-button-disabled,.hs-container-swp .swiper-button-prev.swiper-button-disabled{opacity:.35;cursor:auto;pointer-events:none}.hs-container-swp .swiper-button-next:after,.hs-container-swp .swiper-button-prev:after{font-family:hs-swiper-icons;font-size:16px;text-transform:none!important;letter-spacing:0;text-transform:none;font-variant:initial}.hs-container-swp .swiper-button-prev,.hs-container-swp .swiper-container-rtl .swiper-button-next{left:-20px;right:auto}.hs-container-swp .swiper-button-next,.hs-container-swp .swiper-container-rtl .swiper-button-prev{right:-20px;left:auto}.hs-container-swp .swiper-button-prev:after,.hs-container-swp .swiper-container-rtl .swiper-button-next:after{content:\'prev\'}.hs-container-swp .swiper-button-next:after,.hs-container-swp .swiper-container-rtl .swiper-button-prev:after{content:\'next\'}.hs-container-swp .swiper-button-next.swiper-button-white,.hs-container-swp .swiper-button-prev.swiper-button-white{--hs-swiper-navigation-color:#ffffff}.hs-container-swp .swiper-button-next.swiper-button-black,.hs-container-swp .swiper-button-prev.swiper-button-black{--hs-swiper-navigation-color:#000000}.hs-container-swp.swiper-button-lock{display:none}.hs-container-swp .swiper-pagination{position:absolute;text-align:center;transition:.3s opacity;transform:translate3d(0,0,0);z-index:10}.hs-container-swp .swiper-pagination.swiper-pagination-hidden{opacity:0}.hs-container-swp .swiper-container-horizontal>.swiper-pagination-bullets,.hs-container-swp .swiper-pagination-custom,.hs-container-swp .swiper-pagination-fraction{bottom:10px;left:0;width:100%}.hs-container-swp .swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.hs-container-swp .swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transform:scale(.33);position:relative}.hs-container-swp .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active{transform:scale(1)}.hs-container-swp .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{transform:scale(1)}.hs-container-swp .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{transform:scale(.66)}.hs-container-swp .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{transform:scale(.33)}.hs-container-swp .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{transform:scale(.66)}.hs-container-swp .swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{transform:scale(.33)}.hs-container-swp .swiper-pagination-bullet{width:8px;height:8px;display:inline-block;border-radius:100%;background:#000;opacity:.2}.hs-container-swp button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;-webkit-appearance:none;-moz-appearance:none;appearance:none}.hs-container-swp .swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.hs-container-swp .swiper-pagination-bullet-active{opacity:1;background:var(--swiper-pagination-color,var(--hs-swiper-theme-color))}.hs-container-swp .swiper-container-vertical>.swiper-pagination-bullets{right:10px;top:50%;transform:translate3d(0,-50%,0)}.hs-container-swp .swiper-container-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{margin:6px 0;display:block}.hs-container-swp .swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;transform:translateY(-50%);width:8px}.hs-container-swp .swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;transition:.2s transform,.2s top}.hs-container-swp .swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 4px}.hs-container-swp .swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;transform:translateX(-50%);white-space:nowrap}.hs-container-swp .swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s left}.hs-container-swp .swiper-container-horizontal.swiper-container-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s right}.hs-container-swp .swiper-pagination-progressbar{background:rgba(0,0,0,.25);position:absolute}.hs-container-swp .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:var(--swiper-pagination-color,var(--hs-swiper-theme-color));position:absolute;left:0;top:0;width:100%;height:100%;transform:scale(0);transform-origin:left top}.hs-container-swp .swiper-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{transform-origin:right top}.hs-container-swp .swiper-container-horizontal>.swiper-pagination-progressbar,.swiper-container-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite{width:100%;height:4px;left:0;top:0}.hs-container-swp .swiper-container-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-container-vertical>.swiper-pagination-progressbar{width:4px;height:100%;left:0;top:0}.hs-container-swp .swiper-pagination-white{--swiper-pagination-color:#ffffff}.hs-container-swp .swiper-pagination-black{--swiper-pagination-color:#000000}.hs-container-swp .swiper-pagination-lock{display:none}.hs-container-swp .swiper-scrollbar{border-radius:10px;position:relative;-ms-touch-action:none;background:rgba(0,0,0,.1)}.hs-container-swp .swiper-container-horizontal>.swiper-scrollbar{position:absolute;left:1%;bottom:3px;z-index:50;height:5px;width:98%}.hs-container-swp .swiper-container-vertical>.swiper-scrollbar{position:absolute;right:3px;top:1%;z-index:50;width:5px;height:98%}.hs-container-swp .swiper-scrollbar-drag{height:100%;width:100%;position:relative;background:rgba(0,0,0,.5);border-radius:10px;left:0;top:0}.hs-container-swp .swiper-scrollbar-cursor-drag{cursor:move}.hs-container-swp .swiper-scrollbar-lock{display:none}.hs-container-swp .swiper-zoom-container{width:100%;height:100%;display:flex;justify-content:center;align-items:center;text-align:center}.hs-container-swp .swiper-zoom-container>canvas,.hs-container-swp .swiper-zoom-container>img,.hs-container-swp .swiper-zoom-container>svg{max-width:100%;max-height:100%;object-fit:contain}.hs-container-swp .swiper-slide-zoomed{cursor:move}.hs-container-swp .swiper-lazy-preloader{width:42px;height:42px;position:absolute;left:50%;top:50%;margin-left:-21px;margin-top:-21px;z-index:10;transform-origin:50%;animation:hs-swiper-preloader-spin 1s infinite linear;box-sizing:border-box;border:4px solid var(--hs-swiper-preloader-color,var(--hs-swiper-theme-color));border-radius:50%;border-top-color:transparent}.hs-container-swp .swiper-lazy-preloader-white{--hs-swiper-preloader-color:#fff}.hs-container-swp .swiper-lazy-preloader-black{--hs-swiper-preloader-color:#000}@keyframes hs-swiper-preloader-spin{100%{transform:rotate(360deg)}}.hs-container-swp .swiper-container .swiper-notification{position:absolute;left:0;top:0;pointer-events:none;opacity:0;z-index:-1000}.hs-container-swp .swiper-container-fade.swiper-container-free-mode .swiper-slide{transition-timing-function:ease-out}.hs-container-swp .swiper-container-fade .swiper-slide{pointer-events:none;transition-property:opacity}.hs-container-swp .swiper-container-fade .swiper-slide .swiper-slide{pointer-events:none}.hs-container-swp .swiper-container-fade .swiper-slide-active,.hs-container-swp .swiper-container-fade .swiper-slide-active .swiper-slide-active{pointer-events:auto}.hs-container-swp .swiper-container-cube{overflow:visible}.hs-container-swp .swiper-container-cube .swiper-slide{pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1;visibility:hidden;transform-origin:0 0;width:100%;height:100%}.hs-container-swp .swiper-container-cube .swiper-slide .swiper-slide{pointer-events:none}.hs-container-swp .swiper-container-cube.swiper-container-rtl .swiper-slide{transform-origin:100% 0}.hs-container-swp .swiper-container-cube .swiper-slide-active,.hs-container-swp .swiper-container-cube .swiper-slide-active .swiper-slide-active{pointer-events:auto}.hs-container-swp .swiper-container-cube .swiper-slide-active,.hs-container-swp .swiper-container-cube .swiper-slide-next,.hs-container-swp .swiper-container-cube .swiper-slide-next+.swiper-slide,.hs-container-swp .swiper-container-cube .swiper-slide-prev{pointer-events:auto;visibility:visible}.hs-container-swp .swiper-container-cube .swiper-slide-shadow-bottom,.hs-container-swp .swiper-container-cube .swiper-slide-shadow-left,.hs-container-swp .swiper-container-cube .swiper-slide-shadow-right,.hs-container-swp .swiper-container-cube .swiper-slide-shadow-top{z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}.hs-container-swp .swiper-container-cube .swiper-cube-shadow{position:absolute;left:0;bottom:0;width:100%;height:100%;background:#000;opacity:.6;-webkit-filter:blur(50px);filter:blur(50px);z-index:0}.hs-container-swp.swiper-container-flip{overflow:visible}.hs-container-swp .swiper-container-flip .swiper-slide{pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1}.hs-container-swp .swiper-container-flip .swiper-slide .swiper-slide{pointer-events:none}.hs-container-swp.swiper-container-flip .swiper-slide-active,.hs-container-swp.swiper-container-flip .swiper-slide-active .swiper-slide-active{pointer-events:auto}.hs-container-swp .swiper-container-flip .swiper-slide-shadow-bottom,.hs-container-swp .swiper-container-flip .swiper-slide-shadow-left,.hs-container-swp .swiper-container-flip .swiper-slide-shadow-right,.hs-container-swp .swiper-container-flip .swiper-slide-shadow-top{z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}\t.hs-popup-cart-sp-load{    \tbox-sizing: border-box !important;    }    body.hs-open-cart:before {    \tbackground: #000;        content: "";        top: 0;        left: 0;        right: 0;        bottom: 0;        position: fixed;\t\tvisibility: inherit !important;\t\topacity: .6;        z-index: 2147483645;    }\tbody.hs-open-cart #privy-container #privy-inner-container .privy-popup-container{    \tz-index: 2147483647;    }    body.hs-open-cart {        overflow: hidden;        position: relative;    }\thtml.hs-open-drawer{        overflow: hidden;    }    .hs-hidden-element {        display: none;    }    .hs-site-cart-popup input {      max-width: 100% !important;    }    .hs--loading i {        margin-bottom: 0px !important;    }\t.hs-popup-cart-sp-load .hs-site-cart-popup {\t\tbackground:' +
                    t.background_color +
                    ";        box-shadow: 0 0 0 1px rgba(39, 44, 48, .05), 0 1px 5px 1px rgba(39, 44, 48, .16);        display: -webkit-box;        display: flex;        display: -webkit-box;        display: flex;        flex-direction: column;        height: 100%;        top: 0;\t\tbottom: 0;        width: 100%;        -webkit-box-orient: vertical;        -webkit-box-direction: normal;        -webkit-transition: 0.4s -webkit-transform;\t   -webkit-overflow-scrolling: touch;        transition: 0.4s -webkit-transform;        transition: 0.4s transform;        transition: 0.4s transform, 0.4s -webkit-transform;\t\tz-index: 999999999999999;    }    .hs-add-discount,.hs-sticky-cart,.hs-content-discounts-calculate-checkout,.hs-content-count-products-clear-all,.hs-cart-note,.hs-drawer-content-checkout {        padding: 0px 30px 0 30px;    }\t.hs-close-popup-cart,.hs-container-swp,.hs-site-cart-popup .hs-dobly-content{\t\tmargin: 0px 30px 0 30px;    }\t.hs-site-cart-popup .hs-dobly-content .doubly-message{\t\tmargin-bottom:20px !important;\t}    .hs-products-stacked {        padding: 0px 30px;    }    .hs-container-stacked .hs-content-product-slide-cart {        padding: 0;        background: transparent;        box-shadow: none;\t\twidth: 100% !important;    }    .hs-content-sub-total-cart {        padding: 0px 20px;    }    .hs-subtotaldiscount-cart {        -ms-flex-order: 2;        order: 2;        padding: 10px 10px 10px 10px;        background: none;        line-height: 0px;    }    .hs-subtotaldiscount-cart span {        color: #807c7c;        font-size: 16px;        font-weight: 600;        line-height: 16px;        text-transform: none;    }    .hs-subtotaldiscount-cart .hs_subtotaldiscount_amount {        color: #807c7c;        margin: 0;        font-weight: 700;        font-size: 16px;        text-transform: uppercase;        text-align: right;        float: right;        line-height: 16px;    }    .hs-subtotaldiscount-cart {        border-bottom: 1px dashed #807c7c;    }    body .hs-subtotaldiscount-cart .hs_subtotaldiscount_amount span {        color: #f00 !important;    }    .hs-container-stacked .hs-products-stacked {        background: " +
                    t.upsell_content_background +
                    ";    }    .hs-frequently-bought {        background: " +
                    t.upsell_title_background +
                    ";        color: " +
                    t.upsell_title_color +
                    ";        padding: 0px;        margin-bottom: 15px;    }    .hs-frequently-bought h2 {\t\tcolor: " +
                    t.upsell_title_color +
                    ";        font-size: 14px;        margin: 0;        text-align: center;        text-transform: initial;        font-weight: 600;\t    letter-spacing: normal;    }    .hs-site-cart-popup svg {\t\tvertical-align: inherit;    }    .hs-remove-item svg g {        fill: #7d7d7d !important;    }\t.hs-remove-item:hover svg g {        fill: #000 !important;    }\t.hs-inc.hs-qtybutton svg g{    \tfill: #7d7d7d !important;    }\t.hs-inc.hs-qtybutton:hover svg g{    \tfill: #000 !important;    }    .hs-products-stacked .swiper-slide .hs-content-product-slide-cart {        padding: 15px 0;        border-bottom: 1px solid " +
                    t.upsell_content_border +
                    ";        margin: 0;        border-radius: 0;    }\t.shopping-cart-content.show { display: none !important; }    .hs-product-link-image, .hs-content-title-price-swiper {        display: inline-block;\t\tcursor:default;        vertical-align: top;    }    .hs-sticky-checkout-bar {        position: fixed;        top: 0;        left: 0;        z-index: 2147483644;        width: 100%;\t\tfont-size: 62.5%;    }    .hs-original-price-total.hs-desktop {        display: inline-block !important;    }    .hs-original-price-total {        margin-left: 10px;    }    .hs-compare-at-price {        text-decoration: line-through;    }\t.hs-change-select-option.hs-hidden-select {\t\tdisplay: none !important;\t}    body .hs-compare-at-price {        display: inline-block !important;    }\t.hs-sticky-checkout-bar.hs-show-element{        visibility: visible !important;        opacity: .95 !important;        transition: opacity 0.2s linear !important;    }\t.grid-product__meta .hs-content-cart-drawer-loop { display: none; }\t.hs-sticky-checkout-bar.hs-hide-element{      \tvisibility: hidden !important;        opacity: 0 !important;        transition: visibility 0s 0.2s, opacity 0.2s linear !important;\t\theight: 0;\t\toverflow: hidden;    }    .hs-title-swiper {        color: #000; display: block;        text-align: center;\t\tline-height: 1;    }\t.hs-sticky-checkout-bar.hs-desktop-top {\t\tbox-shadow: rgba(0, 0, 0, 0.2) 0px -1px 8px;    }\t.hs-sticky-checkout-bar.hs-desktop-top{\t\ttop:" +
                    t.position_offset_desktop +
                    "px;\t\tbottom: inherit;    }\t.hs-sticky-checkout-bar.hs-desktop-bottom{\t\tbottom:" +
                    t.position_offset_desktop +
                    'px;\t\ttop: inherit;    }    .hs-sticky-checkout-bar.hs-desktop-bottom {        box-shadow: rgba(0, 0, 0, 0.2) 0px -1px 8px;    }    .hs-sticky-checkout-bar.hs-mobile-bottom {        box-shadow: rgba(0, 0, 0, 0.2) 0px -1px 8px;    }    .hs-content-image-and-title .hs-image-thumb {        display: flex;        -webkit-box-align: center;        align-items: center;        width: 100%;        max-width: 100%;        flex: 1 1 auto;        overflow: hidden;    }    .hs-content-variant-select-option {        align-items: center;        display: flex;        flex-direction: row;        width: auto;\t\tposition: relative;    }    .hs-content-image-and-title .hs-image-thumb img {\t\tdisplay: inline-block;\t\tvertical-align: middle;        margin-right: 10px;        max-height: 48px;        max-width: 48px;    }    .hs-terms-content a {        font-weight: 600;    }    .hs-terms-content a:hover {        text-decoration: underline;    }    .hs-terms-content {        font-size: 12px;\t\tmargin-bottom: 10px;    }    .hs-terms-content input {        vertical-align: middle;        margin-right: 5px;        -webkit-appearance: checkbox;        height: 15px;        width: 15px;    }\t.hs-terms-content span {    \tvertical-align: middle;\t}\t.hs-select-option-checkout-bar {        -webkit-appearance: none !important;        -moz-appearance: none !important;        appearance: none !important;        background-position: right center !important;        background-image: url("//cdn.shopify.com/s/files/1/0251/1021/6792/t/12/assets/ico-select.svg") !important;        background-repeat: no-repeat !important;        background-position: right 10px center !important;        line-height: 1.2 !important;        padding-right: 28px !important;        text-indent: 0.01px !important;        text-overflow: "" !important;        cursor: pointer !important;        padding-top: 10px !important;        padding-left: 18px !important;        padding-bottom: 10px !important;\t\theight: auto;\t\twidth: 100%;\t\tmargin: 0;    }    .hs-add-to-cart i:before {        speak: none;        text-decoration: inherit;        width: auto;        margin-right: auto;        text-align: center;        font-variant: normal;        text-transform: none;        line-height: initial;    }\t.hs-item-cart-qty i:before {        speak: none;        text-decoration: inherit;        width: auto;        margin-right: auto;        text-align: center;        font-variant: normal;        text-transform: none;        line-height: initial;    }\t.hs--loading i:before {        speak: none;        text-decoration: inherit;        width: auto;        margin-right: auto;        text-align: center;        font-variant: normal;        text-transform: none;        line-height: initial;    }    .hs-sticky-checkout-bar .hs-quick-button-quantity {\t\tcolor: #3d4246 !important;        position: relative !important;        display: inline-block !important;        border-radius: 0 !important;        padding: 5px !important;        width: 60px !important;        height: 41px !important;        min-height: 41px !important;\t\ttop: inherit !important;    \tright: inherit !important;\t\tmax-width: initial;\t\tmargin: 0 !important;\t\toutline: none;    }\t.hs-site-cart-popup .hs-discount-slide-cart-icon {        display: inline-block;        width: 16px !important;        margin-right: 5px;    }    .hs_discount_response.hs_coupon_popup .icon.icon-saletag {        height: 16px;    }    .hs-content-quantity {        vertical-align: middle;        display: flex;        flex-direction: row;    }    .hs-progess-content.hs-hidden-percentages .hs-progress-indicator {        display: none;    }    .hs-progess-content.hs-hidden-percentages {        margin: 0;    }    .hs_discount_response.hs_coupon_popup {        position: relative;        margin: 5px 0px;        padding: 10px;        background-color: #cdf7cd;\t\tcolor: ' +
                    t.cart_color +
                    ";        text-align: center;        font-size: 14px;    }    .hs-content-image-properties img {        max-width: 100px !important;\t\tmargin: 5px 0px;    }    .hs-close-discount-slide-cart {    \tdisplay:inline-block;        margin-left: 10px;    }    .hs_notice__text {        display: inline-block;    }    .hs-close-discount-slide-cart svg {        stroke: #7d7d7d;        width: 14px;        display: inline-block;    }\t.hs-close-discount-slide-cart:hover svg {        stroke: #000;        width: 14px;        display: inline-block;    }    .hs-today-bedding {        margin: 0px 30px 0 30px;    }    .hs-today-bedding h3 {\t\tcolor: #000;        font-size: 16px;\t\tfont-weight: 600;\t\tline-height: 14px;        margin: 0;        padding: 10px 15px 10px 15px;\t\ttext-align: center;    }    .hs_coupon_popup:before {        content: '';        display: block;        position: absolute;        left: 0px;        right: 0px;        bottom: -10px;        transform: rotate(180deg);        width: 100%;        height: 10px;        background: linear-gradient(45deg,transparent 33.333%,#cdf7cd 33.333%,#cdf7cd 66.667%,transparent 66.667%),linear-gradient(-45deg,transparent 33.333%,#cdf7cd 33.333%,#cdf7cd 66.667%,transparent 66.667%);        background-size: 12px 40px;\t}\t.hs_coupon_popup:after {      content: '';      display: block;      position: absolute;      left: 0px;      right: 0px;      top: -10px;      width: 100%;      height: 10px;      background: linear-gradient(45deg,transparent 33.333%,#cdf7cd 33.333%,#cdf7cd 66.667%,transparent 66.667%),linear-gradient(-45deg,transparent 33.333%,#cdf7cd 33.333%,#cdf7cd 66.667%,transparent 66.667%);      background-size: 12px 40px;     }    .hs-checkout-bar-price,.hs-checkout-bar-compare-at-price{        vertical-align: middle;        display: flex;        flex-direction: row;    }    .hs-upsell-add-to-cart i {        font-size: 15px !important;\t\tline-height: 35px;\t\tmargin: 0 !important;    }    .hs-checkout-bar-price .hs-money-price ,.hs-checkout-bar-compare-at-price .hs-money-compare-price {\t\tcolor:" +
                    t.sticky_cart_bar_price_color +
                    ";        margin-left: 10px;    }    .hs-checkout-bar-compare-at-price {        text-decoration: line-through !important;        color:" +
                    t.sticky_cart_bar_compare_price_color +
                    ";    }\t.hs-checkout-bar-compare-at-price .hs-money-compare-price{\t\tcolor:" +
                    t.sticky_cart_bar_compare_price_color +
                    ";    }    .hs-continue-shopping.hs-close {        position: inherit !important;    }    .hs-trust-payment {\t\tdisplay:none;        width: 100%;\t\tmargin-top:10px;\t\ttext-align: center;    }    .hs-trust-payment img {        max-width: 250px;\t\tmax-height: 40px;    }    .hs-content-checkout-bar .hs-content-image-and-title {        vertical-align: middle;        height: 57px;        -webkit-box-align: center;        align-items: center;        -webkit-box-pack: justify;        justify-content: space-between;        display: flex;        flex-direction: row;        flex-wrap: nowrap;        width: auto;        flex: 1 1 auto;        overflow: hidden;\t\tposition: relative;    }\t.hs-cart-drawer-0 .hs-site-cart-popup form.sn-cart .hs-sticky-cart .hs-item-cart-content .hs-item-content-variants .hs-item-cart-description .hs-product-title {\t\tmax-width: none;\t}    .hs-content-image-and-title .hs-image-thumb .hs-btn-checkout-bar {\t\tbackground: " +
                    t.sticky_cart_bar_background_color +
                    ";\t\tdisplay:none;        position: absolute;        right: 0;    }\t.hs-countdown-cart{        background: " +
                    t.countdown_bgcolor +
                    ";        color: " +
                    t.countdown_fontcolor +
                    ";        border: 1px solid " +
                    t.countdown_bordercolor +
                    ";        font-size: " +
                    t.countdown_fontsize +
                    ";        text-align: " +
                    t.countdown_align +
                    ";        font-weight: 600;        padding: 10px 30px;\t\tmargin-bottom: 10px;\t\tline-height: 20px;    }\t.hs-countdown-offer{        background: " +
                    t.all_page_countdown_bgcolor +
                    ";        color: " +
                    t.all_page_countdown_fontcolor +
                    ";        font-size: " +
                    t.all_page_countdown_fontsize +
                    ";        text-align: " +
                    t.all_page_countdown_align +
                    ";        font-weight: bold;    }    .hs-countdown-slide-cart{        color: #504f4f;        font-weight: 400;        background: var(--countdown-timer-background-color, #fff);        padding: 5px 10px;        display: inline-block;        margin: 5px 6px;    }    .hs-countdown-offer-mobile {        margin-left: 10px;    }    .hs-price-per {        display: inline-block;        vertical-align: middle;        padding-left: 4px;        color: #f00;    }    .hs-price-sw {        color: #f00;    }    .hs-content-checkout-bar {\t\tposition: relative;        margin: 0 auto;        width: 100%;        display: flex;        visibility: visible;        -webkit-box-align: center;        align-items: center;        -webkit-box-pack: center;        justify-content: center;        box-sizing: border-box;        flex-flow: row nowrap;        font-size: 18px;        line-height: 18px;        background: " +
                    t.sticky_cart_bar_background_color +
                    ";\t\tpadding-right: 40px;    \tpadding-left: 40px;    }\t.hs--loading {        display: none;    }    .hs-checkout-bar-add-to-cart {\t\tposition:relative;        -moz-user-select: none;        -ms-user-select: none;        -webkit-user-select: none;        user-select: none;        -webkit-appearance: none;        -moz-appearance: none;        appearance: none;        display: inline-block;        width: auto;        text-decoration: none;        text-align: center;        vertical-align: middle;        cursor: pointer;        border: 1px solid transparent;        border-radius: 2px;        padding: 8px 5px;        background-color: " +
                    t.sticky_cart_bar_button_color +
                    ";        color: " +
                    t.sticky_cart_bar_button_text_color +
                    ";        font-style: normal;        font-weight: 600;        text-transform: uppercase;        white-space: normal;        font-size: 14px;        margin-left: 10px;        -webkit-box-pack: center;        justify-content: center;        white-space: nowrap;        user-select: none;        overflow: hidden;\t\tmin-width:120px;    }\t.hs-checkout-bar-add-to-cart[disabled] {\t\topacity:0.5;\t}\t.hs-sticky-bar-add-to-cart-product-title .hs-sticky-bar-product-title{font-family: MercuryDisplayRoman; font-weight: 700;color: " +
                    t.sticky_cart_bar_product_title_color +
                    ";        white-space: nowrap;        text-overflow: ellipsis;\t\twhite-space: nowrap;    }    .hs-loading-btn .hs-add--to--cart {        visibility: hidden;        opacity: 0;    }    .hs-loading-btn .hs--loading {        display: block;        position: absolute;        top: 50%;        left: 50%;        transform: translate(-50%, -50%);    }    .hs-btn-checkout-bar {    \tvertical-align: middle;        display: flex;        flex-direction: row;    }    .hs-content-checkout-bar .hs-change-select-option .hs-select-box-load {        display: inline-block;        margin-left: 10px;        vertical-align: middle;    }    .hs-error-code-discount {        font-size: 11px;        color: red;    }    .hs-content-checkout-bar .hs-change-select-option .hs-select-box-load .hs-select-text {\t\tdisplay:none;        margin-right: 0px;    }    .hs-change-select-option,.hs-image-thumb {        vertical-align: middle;        display: flex;        flex-direction: row;    }    .fa-spin {      -webkit-animation: fa-spin 0.5s infinite linear !important;      animation: fa-spin 0.5s infinite linear !important;    }    .hs-min-money-cart {        width: 100%;        display: block;        text-align: center;        font-weight: 600;        font-size: 16px;    }    .hs-item-cart-image .hs-content-cart-drawer-loop {        display: none;    }\tbody .hs-original-price-total.hs-desktop{    \tdisplay:inline-block;    }    .hs-cart-content-price {        display: inline-block;        vertical-align: top;        position: relative;\t\ttext-align: right;\t\tword-break: break-word;    }    .hs-price-total {        font-size: 14px;    }    #hs_shipping_progress {        width: 100%;        background: " +
                    t.rewards_progress_background_color +
                    ";    }    #hs_shipping_bar {\t\tbackground: " +
                    t.rewards_bar_background_color +
                    ";        height: 15px;    }\t.hs-content-cart-drawer-loop .hs-quick-button-quantity.hs-top-right{\t\tborder: 1px solid " +
                    t.quick_buy_button_background +
                    ";\t}    .hs-discount-app-cart svg {        display: none;        width: 14px !important;        height: 14px !important;        vertical-align: middle;        fill: currentColor;    }    .hs-discount-app-cart {        font-size: 14px;    }    .hs-error-code-discount span {\t\tdisplay:block;        margin-top: 5px;\t\tmargin-bottom: 10px;    }    .hs-content-propertie {        font-size: 12px;    }    .hs-product-content-image-swipper .hs-content-cart-drawer-loop {        display: none !important;    }    .hs-quick-button-quantity.hs-top-left {        position: absolute;        background: #fff;        display: block;        z-index: 3;        margin: 0;        text-align: right;    }\t.hs-content-cart-drawer-loop .hs-quick-button-quantity.hs-top-left{\t\tborder: 1px solid " +
                    t.quick_buy_button_background +
                    ";\t}    .hs-hidden-count-cart{    \tdisplay:none !important;    }    .hs-sticky-cart-cart-drawer {        position: fixed;        " +
                    r +
                    ": " +
                    n +
                    ";        " +
                    i +
                    ": 15px;    }    .hs-item-cart-image .satcb_quick_buy {        display: none !important;    }    .hs-product-review {\t\tcolor:" +
                    t.sticky_cart_bar_product_title_color +
                    ";        font-size: 14px;    }    .hs-product-review .spr-badge {        margin-top: 5px;    }    .hs-sticky-cart-cart-drawer-content {\t\tcolor:" +
                    t.color_cart_widget +
                    ";\t\tbackground: " +
                    t.button_background_color +
                    ";\t\tfont-size:20px;        display: block;        -webkit-border-radius: 30px !important;        -moz-border-radius: 30px !important;        border-radius: 30px !important;        -webkit-box-shadow: 1px 1px 5px grey !important;        -moz-box-shadow: 1px 1px 5px grey !important;        box-shadow: 1px 1px 5px grey !important;        padding: 10px;        width: 30px;        height: 30px;        margin: 0 auto;        line-height: 30px!important;        text-align: center;        position: relative;        box-sizing: content-box !important;        z-index: 1;    }    .hs-sticky-cart-cart-drawer-content i{\t\tcolor:" +
                    t.color_cart_widget +
                    ";\t}    .hs-sticky-cart-cart-drawer-content mark {\t\tbackground-color: #FFFFFF;\t\tcolor: #000000;        -webkit-border-radius: 20px;        -moz-border-radius: 20px;        border-radius: 20px;        border: 2px solid transparent;        width: 20px;        height: 20px;        position: absolute;        top: -5px;        left: -10px;        font-size: 10px !important;        line-height: 20px;        font-weight: 700;        box-sizing: content-box !important;\t\tborder: 2px solid #fff;        padding: 0 !important;    }   .hs-popup-cart-sp-load .hs-site-cart-popup h1 {\t\tfont-size:20px !important;        margin: 0;        font-weight: 600;        color: #000;        text-align:center;\t\tpadding: 0px;\t\tborder: 0px !important;\t\tline-height: 16px;    }\t.hs-item-content-variants { letter-spacing: 0 !important; }    .hs-discount-heading,.hs-note-heading {\t\tcolor: " +
                    t.cart_color +
                    ";        font-size: 14px;        text-align: left;        padding-bottom: 5px;        font-weight: 400;        margin: 0;    }    .hs-cart-note {        margin-top: 15px;    }    .hs-continue-shopping.hs-close {        line-height: normal;        right: auto;        top: auto;    }\t.hs-content-discount-add {        position: relative;    }    .hs-item-content-variants .hs-content-cart-drawer-loop {      display: none !important;    }    button.hs-apply-discount {        position: absolute;        right: 0;        top: 0;        margin: 0;        font-size: 14px;        padding: 10px;        text-transform: capitalize;        font-weight: 500;        width: 30%;        height: 40px;        line-height: 0px;        outline: none;        border: " +
                    t.apply_border_size_button +
                    "px;\t\tborder-style: " +
                    t.apply_border_style_button +
                    ";        background-color: " +
                    t.apply_background_button +
                    ";        border-color: " +
                    t.apply_border_color_button +
                    " !important;        border-radius: 0px " +
                    t.apply_border_radius_button +
                    "px " +
                    t.apply_border_radius_button +
                    "px 0px !important;        color: " +
                    t.apply_color_button +
                    ";        border-left: 0px;    }    button.hs-apply-discount:hover {        background-color: " +
                    t.apply_hover_background_color +
                    ";        border-radius: 0px " +
                    t.apply_border_radius_button +
                    "px " +
                    t.apply_border_radius_button +
                    "px 0px !important;        color: " +
                    t.apply_hover_color +
                    ";    }    button.hs-checkout-purchase {        padding: 10px !important;        line-height: 50px;        height: 50px;        font-size: 18px !important;    }    .hs-cart-ins {\t\tborder: " +
                    t.apply_border_size_button +
                    "px;\t\tborder-style: solid;        width: 100% !important;        font-size: 14px;        height: 40px;        padding: 10px;\t\tborder-color: #000;        margin-bottom: 20px;\t\tbox-sizing: border-box !important;\t\toutline:none;        min-height: 60px;        resize: none;    }    input.hs-discount-code {\t\tborder: " +
                    t.apply_border_size_button +
                    "px;\t\tborder-style: solid;        border-radius: " +
                    t.apply_border_radius_button +
                    "px 0px 0px " +
                    t.apply_border_radius_button +
                    "px;        border-color: " +
                    t.apply_border_color_button +
                    " !important;        box-sizing: border-box !important;\t\toutline: none;        width: 70% !important;        padding: 10px 10px 10px 10px;        font-size: 14px !important;\t\tline-height: 14px;        margin: 0;\t\theight: 40px !important;    }    button.hs-apply-discount .hs--loading i {        width: 50px;        font-size: 14px !important;    }    button.hs-apply-discount.hs-loading .hs-text--apply--discount {        display: none;    }    button.hs-apply-discount.hs-loading .hs--loading {        display: block;    }    .hs-content-price-swiper {        margin: 4px 0;    }    .hs-empty-page-content.hs-text-center p {\t\tcolor: " +
                    t.cart_color +
                    ";        margin: 0;    }    .hs-empty-page-content.hs-text-center .hs-close {        top: 10px;        right: 0px;    }    .hs-container-swp {        position: relative;\t\tmargin-bottom: 10px;    }    .hs-content-empty-cart {        position: absolute;        top: 50%;        left: 50%;        transform: translate(-50%, -50%);    }    .hs-close {        cursor:pointer;        top: -8px;        position: absolute;        right: 0px;\t\tline-height: 0;        background: #0000000d;        padding: 7px;        border-radius: 100%;    }    .hs-site-cart-popup form .XeCartFooterMessage {        margin: 0px !important;    }    .hs-close-popup-cart .hs-close {        line-height: 0px;    }    .hs-popup-cart-sp-load .hs-site-cart-popup .hs-close-popup-cart {        position: relative;        line-height: 0px;        padding: 0px 30px 0px 30px;    }\t.hs-popup-cart-sp-load.active .hs-site-cart-popup {        color: " +
                    t.cart_color +
                    ";        display: block;\t}    .hs-item-cart-qty img {        max-width: 30px !important;    }    .hs-discount-price-total {        font-size: 14px;\t\tmargin-left: 5px;    }    .hs-discount-price-line-through {        text-decoration: line-through;    }\t.hs-site-cart-popup .swiper-button-prev{\t\tbackground-image: none !important;        position: absolute;        top: 50%;        width: 15px;        text-align: center;        height: 30px;        line-height: 30px;        font-size: 16px;        z-index: 2;        color: #000;        margin-top: -20px;        user-select: none;        -webkit-user-drag: none;    }    .hs-site-cart-popup .swiper-button-next {\t\tbackground-image: none !important;        position: absolute;        top: 50%;        width: 15px;        text-align: center;        height: 30px;        line-height: 30px;        font-size: 16px;        z-index: 2;        color: #000;        margin-top: -20px;        user-select: none;        -webkit-user-drag: none;    }    .hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sub-total-cart span {\t\tcolor: #807c7c;        font-size: 16px;        font-weight: 600;        line-height: 16px;        text-transform: none;    }    body .hs-continue-shopping.hs-close {        max-width: 180px;        font-size: 14px;        padding: 8px !important;    }    .hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sub-total-cart .hs_subtotal_amount,.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sub-total-cart .hs_subtotal_amount_discount {\t\tcolor: " +
                    t.product_price_color +
                    ";        margin: 0;        font-weight: 700;\t\tfont-size: 16px;        line-height: 16px;        text-transform: uppercase;\t\ttext-align:right;\t\tfloat: right;\t\tline-height: 16px;    }    .hs-payment-discount .hs_subtotal_amount {        margin-right: 7px !important;        text-decoration: line-through;    }    .hs-sub-total-cart.hs-payment-discount .hs_subtotal_amount_discount {        font-size: 19px !important;    }\t.hs-popup-cart-sp-load .hs-site-cart-popup form{        background: " +
                    t.background_color +
                    ";        width:100%;        position:relative;        margin:0px;\t}\t.hs-popup-cart-sp-load .hs-site-cart-popup .hs-empty-page-content.hs-text-center {        padding: 100px 0px;        font-size: 16px;        margin: 0px 30px;        text-align: center;        position: relative;\t}    .hs-content-cart-drawer-loop i {        margin: 0;    }    .hs-sticky-cart-cart-drawer i {        margin: 0;    }    .hs-shipping-taxes {\t\tfont-size: 14px;    \tpadding: 10px 0;\t\ttext-align:center;    }\t.hs-shopping-cart-icon {\t    color: #000;        position: absolute;        left: 0px;        top: 0px;    }\t.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart{        outline: 0;        width:100%;        box-sizing: border-box !important;        -webkit-overflow-scrolling: auto;\t}\t.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart img {        position:relative;        opacity:1;        border:0px !important;        max-width:100%;\t}\t.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-image {\t\tdisplay: inline-block;    \tvertical-align: top;    \twidth: 15%;\t\ttext-align:center;\t}    .hs-item-content-variants {        display: inline-block;        vertical-align: middle;        width: 100%;\t\tposition: relative;    }    .hs-item-close {\t\tdisplay: inline-block;\t\tvertical-align: middle;      \ttext-align: left;    }    .hs-item-cart-description .hs-item-close {        position: absolute;        right: 0;        top: 0;    }    .hs-remove-item {        cursor:pointer;        font-size: 12px;    }\t.hs-remove-item:hover,hs-clear-all-button:hover {        text-decoration: underline;    }    .hs-content-product-slide-cart .hs-content-cart-drawer-loop {        display: none;    }    .hs-compare-price-sw {        display: inline-block;        vertical-align: middle;\t\tmargin-right:4px;\t\ttext-decoration: line-through;    }    .hs-compare-price-per {        display: inline-block;        vertical-align: middle;        margin-right: 4px;        text-decoration: line-through;    }    .hs-price-sw {        display: inline-block;        vertical-align: middle;    }\t.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-image a {        display: inline-block;        vertical-align:middle;\t}\t.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content .hs-item-cart-image a.hs-remove-item{\t\tdisplay:inline-block;\t\tvertical-align:middle;\t\tcursor:pointer;    \tcolor: #3d4245;\t\tmargin-right:5px;    \tfont-size: 14px;    \tmax-width: 10px;\t}\t.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content .hs-item-cart-image a.hs-remove-item img {\t\twidth: 12px !important;\t\tmin-width: 12px;\t\tborder: 0px !important;\t}\t.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content .hs-item-cart-qty {\t\tvertical-align: middle;\t\twidth: 120px;      \tposition: relative;      \toverflow: hidden;      \tdisplay: inline-flex;        display: -webkit-flex;        display: -moz-flex;        display: -ms-flexbox;        display: -o-flex;        display: flex;        -webkit-flex-direction: row;        -moz-flex-direction: row;        -ms-flex-direction: row;        -o-flex-direction: row;        flex-direction: row;      \t-webkit-box-align: center;      \talign-items: center;\t}\t.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content .hs-item-cart-qty .hs-cart-plus-minus .hs-inc.hs-qtybutton {\t\tborder-top-right-radius: 2px;    \tborder-bottom-right-radius: 2px;\t\tborder: 1px solid #ccc !important;\t\tcolor: #000;\t\tcursor: pointer;      \tdisplay: inline-flex;        display: -webkit-flex;        display: -moz-flex;        display: -ms-flexbox;        display: -o-flex;        display: flex;        -webkit-flex-direction: row;        -moz-flex-direction: row;        -ms-flex-direction: row;        -o-flex-direction: row;        flex-direction: row;        outline: none;        margin: 0px;        line-height: 30px;        font-family: Muli,sans-serif !important;  \t\t-webkit-box-align: center;  \t\talign-items: center;        -webkit-box-pack: center;        width: 30px;        height: 30px;        font-weight: 700;        text-align:center;        background: transparent;\t}\t.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content .hs-item-cart-qty .hs-cart-plus-minus .hs-dec.hs-qtybutton {\t\tborder-top-left-radius: 2px;        border-bottom-left-radius: 2px;\t\tborder: 1px solid #ccc !important;     \tcolor: #000;        cursor: pointer;      \tdisplay: inline-flex;        display: -webkit-flex;        display: -moz-flex;        display: -ms-flexbox;        display: -o-flex;        display: flex;        -webkit-flex-direction: row;        -moz-flex-direction: row;        -ms-flex-direction: row;        -o-flex-direction: row;        flex-direction: row;        outline: none;        margin: 0px;        line-height: 30px;        font-family: Muli,sans-serif !important;  \t\t-webkit-box-align: center;  \t\talign-items: center;        -webkit-box-pack: center;        width: 30px;        height: 30px;        font-weight: 700;        text-align:center;        background: transparent;}    .hs-inc.hs-qtybutton svg {        margin: 0 auto;    }\t.hs-dec.hs-qtybutton svg {\t\tmargin: 0 auto;    }    .hs-cart-plus-minus {        display: -webkit-inline-box;      \tdisplay: inline-flex;        display: -webkit-flex;        display: -moz-flex;        display: -ms-flexbox;        display: -o-flex;        display: flex;        -webkit-flex-direction: row;        -moz-flex-direction: row;        -ms-flex-direction: row;        -o-flex-direction: row;        flex-direction: row;        -webkit-box-align: center;        align-items: center;    }\t.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content .hs-item-cart-qty .hs-cart-plus-minus input {\t\tbox-shadow: none;        text-indent: inherit !important;        box-sizing: border-box !important;        display: -webkit-inline-box;        display: inline-flex;        line-height: 30px !important;        height: 30px !important;        max-height: none;        min-height: 0;        border: none;        background: transparent;        border-top: 1px solid #ccc !important;        border-bottom: 1px solid #ccc !important;        width: 45px !important;        text-align: center;        color: #000;        padding: 0;        border-radius: 0;        min-height: 0 !important;        margin: 0 !important;\t}\t.hs-qtybutton svg{\t\tfill:#7d7d7d;    }\t.hs-qtybutton:hover svg{\t\tfill:#000;    }    .hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sub-total-cart {        -ms-flex-order: 2;\t\torder: 2;        padding: 10px 0px 10px 0px;        background: none;        text-transform: uppercase;\t\tline-height:0px;    }\t.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content .hs-item-cart-description {        display: inline-block;        vertical-align: top;        padding: 0px 0px 0px 15px;        line-height: 14px;        font-size: 14px;        word-break: break-word;        width: 85%;\t\tposition:relative;\t}    .hs-discount-app-cart {        margin-top: 8px;    }\t.hs-popup-cart-sp-load .hs-site-cart-popup a:hover{\t\topacity: 1 !important;    }\t.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content .hs-item-cart-description a{\t\tcolor:" +
                    t.text_color +
                    ";\t\ttext-decoration:none;\t}    .hs-item-cart-description p {        color: " +
                    t.text_color +
                    ";    }    .hs-item-cart-description span.hs-price-total, {\t\tcolor: " +
                    t.product_price_color +
                    ";        display: inline-block;\t\tfont-size:16px;    }\t.hs-original-price-total{\t\tcolor: " +
                    t.product_price_color +
                    ";    }    .hs-price-total.hs-desktop {\t\tcolor: " +
                    t.product_price_color +
                    ";    }    .hs-item-cart-description .hs-variant-title {\t\tdisplay: block;        font-size: 14px;\t\tmargin-top: 5px;    }    .hs-content-product-and-variant-title {\t\tdisplay: block;        font-size: 16px;        margin-right: 20px;\t\tmargin-bottom: 15px;    }\t.hs-product-title {        color: #000;font-weight: 600;    }\t.hs-item-cart-description .hs-content-quantity-price{    \tmargin-top: auto;        display: -webkit-box;      \tdisplay: inline-flex;        display: -webkit-flex;        display: -moz-flex;        display: -ms-flexbox;        display: -o-flex;        display: flex;        -webkit-flex-direction: row;        -moz-flex-direction: row;        -ms-flex-direction: row;        -o-flex-direction: row;        flex-direction: row;        -webkit-box-pack: justify;        justify-content: space-between;        -webkit-box-align: center;        align-items: center;    }\t.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content .hs-item-cart-description a:hover{\t\tcolor:" +
                    t.cart_color +
                    ";\t}    .hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content {\t\tborder-top: 1px solid " +
                    t.cart_border_color +
                    ";\t\tfont-size:0px;        padding: 20px 30px;\t\tposition:relative;    }\t.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content:first-child{\t\tborder-top:0px;    }\t.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-finalize-purchase {\t\twidth:100%;\t\tpadding-bottom:20px;\t\tbox-sizing: border-box !important;\t}    .hs-item-cart-content-quantity.hs-hidden-element {        visibility: hidden;    }\t.hs-upsell-add-to-cart,.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-finalize-purchase .hs-checkout-purchase,.hs-apply-discount {\t\tcolor: " +
                    t.button_color +
                    ";\t\tbackground: " +
                    t.button_background_color +
                    ";\t\tborder-radius: " +
                    t.checkout_border_radius_button +
                    "px;\t\tborder: " +
                    t.checkout_border_size_button +
                    "px;\t\tborder-color: " +
                    t.checkout_border_color_button +
                    ";\t\tborder-style: " +
                    t.checkout_border_style_button +
                    ";\t\tbox-sizing: border-box !important;\t\tbox-shadow: none;\t\tdisplay:inline-block;\t\tfont-weight: 500;\t\tpadding: 10px;\t\ttext-align: center;\t\ttext-decoration: none;        font-size: 16px;\t\twidth: 59%;    \tmargin-right: 2%;\t\tline-height: normal;\t\tmin-width: auto !important;\t\tvertical-align: middle;\t}    .hs-cart-content-price .hs-discount-app-cart span {        display: inline-block !important;    }\t.hs-hidden-by-sku{    \tdisplay: none !important;    }\t.hs-upsell-add-to-cart:hover,.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-finalize-purchase .hs-checkout-purchase:hover,.hs-apply-discount:hover {\t\tbackground: " +
                    t.button_hover_background_color +
                    ";\t\tcolor: " +
                    t.checkout_color_hover_button +
                    ";\t\tborder-color: " +
                    t.checkout_border_color_hover_button +
                    ";\t}    .hs-content-checkout-button {        display: inline-block;        width: 59%;        margin-right: 2%;    }\t.hs-content-checkout-button .hs-checkout-purchase{        width: 100% !important;        margin-right:0px !important;    }    .hs-upsell-add-to-cart {        width: auto !important;        font-size: 12px;        margin: 0;        padding: 0px 20px;\t\ttext-transform:capitalize;\t\toutline: none;\t\tposition:relative;        height: 36px;        line-height: 36px;    }    .hs-site-cart-popup div {        box-sizing: border-box !important;    }    .hs-site-cart-popup form {        box-sizing: border-box !important;    }\t.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-finalize-purchase a.hs-cart-purchase {\t\tcolor: " +
                    t.cart_button_color +
                    ";\t\tbackground: " +
                    t.cart_button_background_color +
                    ";\t\tborder-radius: " +
                    t.cart_border_radius_button +
                    "px;\t\tborder: " +
                    t.cart_border_size_button +
                    "px;\t\tborder-color: " +
                    t.cart_border_color_button +
                    ";\t\tborder-style: " +
                    t.cart_border_style_button +
                    ";\t\tbox-sizing: border-box !important;\t\tdisplay:inline-block !important;\t\tpadding: 10px;\t\ttext-align: center;\t\ttext-decoration: none;        font-size: 16px;\t\tfont-weight: 500;        padding-top: 10px;        padding-bottom: 10px;\t\tline-height: normal;\t\twidth: 39%;\t\tvertical-align: middle;\t}\t.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-finalize-purchase a.hs-cart-purchase:hover {\t\tbackground: " +
                    t.cart_button_hover_background_color +
                    ";\t\tborder-color: " +
                    t.cart_border_color_hover_button +
                    ";\t\tcolor: " +
                    t.cart_color_hover_button +
                    ";\t}    .hs-finalize-purchase .hs-continue-shopping {\t\tcolor: " +
                    t.continue_shopping_color_button +
                    ";\t\tbackground: " +
                    t.continue_shopping_background_button +
                    ";\t\tborder-radius: " +
                    t.continue_shopping_border_radius_button +
                    "px;\t\tborder: " +
                    t.continue_shopping_border_size_button +
                    "px;\t\tborder-color: " +
                    t.continue_shopping_border_color_button +
                    ";\t\tborder-style: " +
                    t.continue_shopping_border_style_button +
                    ";        box-sizing: border-box !important;        font-weight: 600;        padding: 10px;        text-align: center;        text-decoration: none;        font-size: 16px;        width: 100%;        padding: 20px;        margin: 0 auto;        text-align: center;        display: block;        text-align: center;        display: block;\t\tfont-weight: 600;\t\tpadding: 10px !important;    }    .hs-financing {        display: block;        width: 100%;        text-align: center;        padding: 10px;    }\t.hs-container-swp .swiper-button-next:focus,.hs-container-swp .swiper-button-prev:focus {        outline: none;    }\t.hs-container-swp .swiper-button-next:hover,.hs-container-swp .swiper-button-prev:hover {        color: #ccc;    }\t.hs-finalize-purchase .hs-continue-shopping:hover {\t\tbackground: " +
                    t.continue_shopping_background_hover_button +
                    ";\t\tborder-color: " +
                    t.continue_shopping_border_color_hover_button +
                    ";\t\tcolor: " +
                    t.continue_shopping_color_hover_button +
                    ";\t}    .hs-popup-cart-sp-load .hs-site-cart-popup form .hs-finalize-purchase a:last-child{\t\tmargin-bottom:0px;    }\t.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-finalize-purchase a:hover{\t\topacity:1;\t}    .hs-add-to-cart span {        display: block;        background: " +
                    t.quick_buy_button_background +
                    ";\t\tcolor: " +
                    t.quick_buy_button_color +
                    ";        font-size: 20px;        line-height: 35px;        width: 35px;        border-radius: 50%;        height: 35px;\t\topacity:.9;    }    .hs-product-link-image img {        max-width: 100%;    }    .hs-product-content-image-swipper {\t\tdisplay: inline-block;        width: 20%;\t\tvertical-align: middle;    }    .hs-swipper-select-option-add-to-cart {\t\tfont-size: 13px;        padding: 4px 15px 4px 15px;\t\tmargin: 0;\t\twidth: 100%;    }\t.hs-add-to-cart:hover span {    \tbackground: " +
                    t.quick_buy_button_background +
                    ";\t\topacity:1;    }\t.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content .hs-item-cart-qty .hs-cart-plus-minus input:focus {\t\toutline: none;\t}\t.hs-load-ajax-popup-cart,.hs-load-popup-cart-show-products,.hs-load-notify-show {\t\tbackground: rgba(255, 255, 255, 0.50);\t\theight: 100%;\t\tposition: fixed;\t\ttop: 0px;\t\twidth: 100%;\t\tz-index: 1000000;\t}\t.hs-load-notify-show{\t\tz-index: 1000001;\t}\t.hs-site-cart-popup .currency-converter-cart-note{\t\tpadding:10px 30px 0 30px !important;    }\t.hs-message-notify-popup-cart {\t\tbackground: " +
                    t.background_color +
                    ";\t\tcolor: " +
                    t.cart_color +
                    ";\t\tbox-shadow: 0 0 0 1px rgba(39, 44, 48, .05), 0 1px 5px 1px rgba(39, 44, 48, .16);\t\tmin-width: 740px;\t\tmargin: 0 auto;\t\tpadding: 40px 20px;\t\tposition: fixed;\t\ttop: 50%;\t\tleft: 50%;\t\ttransform: translate(-50%, -50%);\t\tz-index: 2147483647;\t}    .hs-mg-price {        margin-top: 5px;    }\t.hs-message-notify-popup-cart .hs-remove-notify {\t\twidth: 12px;\t\tdisplay: block;\t\tposition: absolute;\t\ttop: 20px;\t\tright: 20px;\t}\t.hs-message-notify-popup-cart p{\t\tmargin:0px;\t\ttext-align:center;\t\tfont-weight: 600;\t}\t.hs-load-popup-cart-show-products {\t\tz-index: 100;\t}    .hs-container-swp .swiper-container-horizontal>.swiper-pagination-bullets, .hs-container-swp .swiper-pagination-custom, .hs-container-swp .swiper-pagination-fraction {        bottom: 0px;    }    .hs-container-swp .swiper-pagination-bullet-active, .swiper-pagination-clickable .swiper-pagination-bullet {        background: #fff;        border: 2px solid rgba(0,0,0,0.5);    }\t.hs-btn-checkout-bar .hs-checkout-bar-price, .hs-btn-checkout-bar .hs-checkout-bar-compare-at-price{\t\tline-height: 39px;\t}\t.hs-load-ajax-popup-cart svg {\t\tposition: absolute;\t\ttop: 50%;\t\tleft: 50%;\t\ttransform: translate(-50%, -50%);\t\tmax-width: 50px;\t}\t.hs-load-ajax-popup-cart svg circle {\t\tstroke: " +
                    t.load_color +
                    ";\t}    .hs-compare-active {        color: #f00;    }\t.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content .hs-item-cart-qty .hs-cart-plus-minus .transparent-qty {\t\tposition: absolute;\t\twidth: 100%;\t\theight: 100%;\t\tbackground: rgba(255, 255, 255, 0);\t}    .hs-button-100-w {        width: 100% !important;        margin: 0px !important;    }\tbutton.btn.product-form__cart-submit_popup_cart {\t  width: 100%;\t  margin: 10px 0px;\t}    .hs-content-cart-drawer-loop {        position: relative;        z-index: 4;        width: 100%;\t\tdisplay: block;    }    .hs-select-text {        font-size: 12px;    }    .hs-site-cart-popup form.sn-cart {        width: 100%;        z-index: 999999999999999;        -webkit-transition: 0.4s -webkit-transform;        transition: 0.4s -webkit-transform;        transition: 0.4s transform;        transition: 0.4s transform, 0.4s -webkit-transform;        display: -webkit-box;        display: flex;        -webkit-box-orient: vertical;        -webkit-box-direction: normal;        flex-direction: column;\t\tpadding-top: 20px;\t\theight: 100%;\t\toverflow-y: scroll;\t\t-webkit-overflow-scrolling: touch;    }    .hs-container-mg-top-up {        width: 100%;        margin-top: auto;        position: relative;        padding: 0px;    }    .hs-add-discount {\t\tborder-top: 1px solid " +
                    t.cart_border_color +
                    ';        padding: 20px 30px;    }    .hs-content-cart-drawer-loop .hs-select-box-load select {        width: 100%;        padding-top: 10px;        padding-left: 18px;        padding-bottom: 10px;        -webkit-appearance: none;        -moz-appearance: none;        appearance: none;        background-position: right center;        background-image: url(//cdn.shopify.com/s/files/1/3067/1988/t/10/assets/ico-select.svg?44545);        background-repeat: no-repeat;        background-position: right 10px center;        line-height: 1.2;        padding-right: 28px;        text-indent: 0.01px;        text-overflow: "";        cursor: pointer;        padding-top: 8px;        padding-left: 15px;        padding-bottom: 8px;    }\t.hs-content-cart-drawer-loop select:last-child {\t\tmargin-bottom: 0px\t\tmargin-top: 0px\t}    .hs-count-products-cart {        font-size: 14px;    }    .hs-content-count-products-clear-all .hs-content-count {        padding: 0px 0px 15px 0px;        position: relative;    }    .hs-content-count-products-clear-all .hs-content-count.hs-border-announcement {        border-bottom: 1px solid ' +
                    t.cart_border_color +
                    ";    }    .hs-clear-all-button {\t\tcolor: " +
                    t.cart_color +
                    ";        font-size: 14px;        float: right;\t\ttext-decoration: none;    }    .hs-clear-all-button:hover {\t\tcolor: " +
                    t.cart_color +
                    " !important;    }    .hs-close svg {\t\tfill:#7d7d7d !important;    }\t.hs-close:hover svg {\t\tfill:#000 !important;    }    .hs-product-label {        position: absolute;        z-index: 1;        background: #d2354f;        padding: 0 4px 0 8px;        color: #fff;        font-weight: 500;        font-size: 11px;        line-height: 20px;        white-space: nowrap;    }    .hs-right-arrow {        position: absolute;        top: 0;        right: -9px;        border-left: 9px solid #d2354f;        border-top: 10px solid transparent;        border-bottom: 10px solid transparent;    }    .hs-flag-content {        position: absolute;        top: 0;        left: 0;    }    .hs-text-free-shipping {        font-size: 14px;        width: 100%;        display: block;        text-align: center;\t\tmargin-top: 30px;    }    .hs-remove-item svg {        fill: #7d7d7d !important;    }\t.hs-remove-item:hover svg {        fill: #000 !important;    }    .hs-item-cart-content.hs-product-31918571880546 {      display: none !important;    }\tbutton.product-form__cart-submit_popup_cart {\t\tcolor: " +
                    t.add_to_cart_button_color +
                    ";\t\tbackground: " +
                    t.add_to_cart_button_background +
                    ";\t\tdisplay: " +
                    HsCartDrawer.display_addtocart +
                    " !important;\t\twidth: 100%;\t\tline-height: 1.4;\t\tpadding-left: 5px;\t\tpadding-right: 5px;\t\twhite-space: normal;\t\tpadding: 10px 18px;\t\tborder: 0px;\t\tmargin-top:10px;\t\ttext-transform:uppercase;\t}\tbutton.product-form__cart-submit_popup_cart:active {\t\tcolor: " +
                    t.add_to_cart_button_color +
                    ";\t\tbackground: " +
                    t.add_to_cart_button_hover_background +
                    ";\t}\tbutton.product-form__cart-submit_popup_cart:focus {\t\tcolor: " +
                    t.add_to_cart_button_color +
                    ";\t\tbackground: " +
                    t.add_to_cart_button_hover_background +
                    ";\t}\tbutton.product-form__cart-submit_popup_cart:focus-within {\t\tcolor: " +
                    t.add_to_cart_button_color +
                    ";\t\tbackground: " +
                    t.add_to_cart_button_hover_background +
                    ";\t}\tbutton.product-form__cart-submit_popup_cart:hover {\t\tcolor: " +
                    t.add_to_cart_button_color +
                    ";\t\tbackground: " +
                    t.add_to_cart_button_hover_background +
                    ";\t}\tbutton.product-form__cart-submit_popup_cart:visited {\t\tcolor: " +
                    t.add_to_cart_button_color +
                    ";\t\tbackground: " +
                    t.add_to_cart_button_hover_background +
                    ";\t}\tbutton.product-form__cart-submit_popup_cart[disabled] {\t    color: " +
                    t.add_to_cart_button_color +
                    ";\t\tbackground: " +
                    t.add_to_cart_button_background +
                    ";\t\tcursor: default;\t\topacity: 0.5;\t}\tbutton.product-form__cart-submit_popup_cart:focus {\t \toutline: none;\t} .hs-add-to-cart.hs-top-right {        border: 0px;        position: absolute;        top: 4px;        right: 4px;        z-index: 4;        line-height: 0px;        padding: 0px;        margin: 0px;        outline: none;        background: transparent;        border-radius: 50%;\t\tdisplay: inline-block;\t\twidth: auto;    }\t.hs-success-code-discount{\t\tposition: relative;    }    .hs-success-code-discount .hs--content--warning {\t\tborder: 1px solid #d3e7f5;        border-color: #f0e4bc;        background-color: #fff8de;        position: relative;        display: table;        opacity: 1;        padding: 15px;        padding-right: 30px;        border-radius: 4px;\t    margin-bottom: 15px;        color: #545454;        -webkit-transition: opacity 0.5s ease-in-out;        transition: opacity 0.5s ease-in-out;    }    .hs-success-code-discount .hs-close-discount-slide-cart.hs---warging {        position: absolute;        top: 15px;        right: 15px;    }    .hs--content--warning .notice__text {        display: table-cell;        width: 100%;\t\tvertical-align: top;    }    .hs---warning---icon {        margin-top: -0.14286em;        margin-right: 0.71429em;        color: #b88600;    }    .hs---warning---icon svg {        fill: #b88600 !important;    }    .hs--content--warning p {        margin: 0;    }    .hs-add-to-cart.hs-top-left {        border: 0px;        position: absolute;        top: 4px;        left: 4px;        z-index: 4;        line-height: 0px;        padding: 0px;        margin: 0px;        outline: none;        background: transparent;        border-radius: 50%;\t\tdisplay: inline-block;\t\twidth: auto;    }\t.hs-sticky-cart{\t\t-webkit-overflow-scrolling: auto;    }    .hs-sticky-cart::-webkit-scrollbar-track    {        -webkit-box-shadow: inset 0 0 8px rgba(0,0,0,0.1);        background-color: #f5f6f7;    }    .hs-sticky-cart::-webkit-scrollbar    {        width: 8px;        background-color: #c1c1c1;    }    .hs-sticky-cart::-webkit-scrollbar-thumb    {        background-color: #c1c1c1;    }\t.hs-combobox-option-variant{\t\t-webkit-overflow-scrolling: auto;    }    .hs-combobox-option-variant::-webkit-scrollbar-track    {        -webkit-box-shadow: inset 0 0 8px rgba(0,0,0,0.1);        background-color: #f5f6f7;    }    .hs-combobox-option-variant::-webkit-scrollbar    {        width: 8px;        background-color: #c1c1c1;    }    .hs-combobox-option-variant::-webkit-scrollbar-thumb    {        background-color: #c1c1c1;    }    .hs-dobly-content {        display: none;    }    .hs-loading {        width: 100%;        height: 30px;        line-height: 30px;        text-align: center;    }    .hs-mobile{    \tdisplay:none !important;    }\t.fa-2x {\t\tfont-size: 1.5em !important;\t}    .hs-desktop{    \tdisplay:inline-block !important;    }    .hs-combobox-option-variant {\t\tdisplay:none;        position: absolute;        top: 45px;        right: 4px;        z-index: 100;        width: 90%;        font-size: 13px;        overflow: hidden;\t\toverflow-y: auto;        list-style: none;        text-align: center;\t\topacity:.9;\t\tmargin:0px;    }\t.hs-combobox-option-variant:hover {\t\topacity:1;\t}\t.hs-combobox-option-variant.active {\t\tdisplay:block !important;\t}    .hs-combobox-option-variant li {        background: #eee;        color: #000;        padding: 5px;        margin: 0;        border-bottom: 1px solid #ddd;        line-height: 1;\t\tcursor: pointer;    }\t.hs-combobox-option-variant li:hover {\t\topacity:.9;\t}\t.hs-change-select-option .hs-select-box-load:first-child{\t\tmargin-left: 0px;    }\t.hs-item-cart-content-quantity {\t\tdisplay: inline-block;\t\twidth: auto;\t\tvertical-align: middle;\t}    .hs_subtotaldiscount_amount {        text-decoration: line-through;    }    .hs-full-bar-button {        margin-left: 10px;    }\t.hs-full-bar-button .hs-checkout-bar-add-to-cart {\t\tmargin: 0;\t\twidth: 100%;\t}\t.hs-change-select-option {\t\tpadding-right: 10px;\t}\t.hs-sticky-bar-add-to-cart-product-title {\t\tdisplay: inline-block;\t\tvertical-align: middle;\t\ttext-overflow: ellipsis;\t\twhite-space: nowrap;\t}\t.hs-sticky-checkout-bar.hs-sticky---bar---1 {\t\tz-index: 2147483646;\t}    .hs-content-product-slide-cart {\t\tfont-size:14px;        background: #f2f2f2;        padding: 15px;        border-radius: 0px;   \t\twidth: 99%;\t\tmargin-bottom:5px;\t\ttext-align: left;\t\tposition:relative;    }    .hs-limit-mattress {        font-size: 10px;    }    .hs-upsell-add {\t\twidth: 40%;        display: inline-block;        vertical-align: middle;\t\ttext-align: right;    }    .hs-site-cart-popup .hs-sticky-cart {        padding: 0;    }\t.hs-product-content-image-swipper{\t\tpadding-right: 10px;    }    .hs-title-swiper {\t\tfont-weight: 600;        text-align: left;    }    .hs-content-price-swiper {        display: inline-block;        vertical-align: middle;        width: 100%;    }\t.hs-variants-swipper{\t    display: inline-block;        vertical-align: middle;        width: 60%;    }\t.hs-variants-swipper.hs-hidden-element{\t\tdisplay:none;    }\t.hs-upsell-add-to-cart svg {        margin-right: 5px;    }    .hs-content-title-price-swiper {        width: 80%;        display:inline-block;        vertical-align: middle;    }\t.hs-drawer-checkout{\t\tbackground: #fff;\t\tbox-sizing: border-box !important;\t\tbottom: 0;\t\tdisplay: block;\t\tz-index: 100000;        position: " +
                    HsCartDrawer.position_slide_cart +
                    ";\t}\t.hs-drawer-content-checkout{\t\tpadding-top: 10px;\t\tdisplay: block;    \twidth: 100%;    }\t.hs-progess-content{        margin: 0 auto 25px;        position: relative;        width: 100%;    }    .hs-progess-content .hs-progress-indicator {\t\tcolor:" +
                    t.rewards_bar_color +
                    ';\t\tfont-size: 12px;\t\tfont-weight: 700;        position: absolute;        top: 100%;        text-transform: uppercase;        text-align: center;    }    .hs-progess-content .hs-progress-indicator:before {        display: block;        height: 5px;        width: 2px;        background: #ccc;        margin: 0 auto;        content: "";    }    .hs-container-swp .swiper-slide.swiper-slide-active {        width: 100% !important;    }    .hs-progess-content .hs-progress-indicator:first-of-type {        left: 1px;        transform: translateX(-50%);    }    .hs-progess-content .hs-progress-indicator:nth-of-type(2) {        left: 25%;        transform: translateX(-50%);    }    .hs-progess-content .hs-progress-indicator:nth-of-type(3) {        left: 50%;        transform: translateX(-50%);    }    .hs-progess-content .hs-progress-indicator:nth-of-type(4) {        left: 75%;        transform: translateX(-50%);    }    .hs-progess-content .hs-progress-indicator:nth-of-type(5) {\t\tright: 1px;    \ttransform: translateX(50%);    }\t.hs-popup-cart-sp-load.hs-cart-drawer-0{    \tdisplay:none;    }    .hs-open-cart .hs-popup-cart-sp-load.hs-cart-drawer-0 {        display: block;        position: fixed;        top: 6% !important;        bottom: 6%;        height: 88%;        left: 50%;        max-width: 800px;        width: auto;        -webkit-transform: translateX(-50%);        -moz-transform: translateX(-50%);        -ms-transform: translateX(-50%);        -o-transform: translateX(-50%);        transform: translateX(-50%);    }\t.hs-content-count-products-clear-all{\t\tline-height:0px;    \tpadding: 20px 30px 0px 30px;    }    .hs-content-cart-drawer-loop .hs-quick-button-quantity.hs-top-right {        position: absolute;        background: #fff;        width: 85px;        height: 35px;        min-height: 35px;        top: 4px;        right: 4px;        display: block;        z-index: 3;        border-radius: 17px;        padding: 7px 40px 7px 5px;        margin: 0;        text-align: right;        color: #a0a0a0;    }    .hs-content-cart-drawer-loop .hs-quick-button-quantity.hs-top-left {        position: absolute;        background: #fff;        width: 85px;        height: 35px;        min-height: 35px;        top: 4px;        left: 4px;        display: block;        z-index: 3;        border-radius: 17px;        padding: 7px 5px 7px 40px;        margin: 0;        text-align: right;        color: #a0a0a0;    }\t@media (max-width: 1600px) {      .hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-image{\t\t  width: 20%;      }      .hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content .hs-item-cart-description {          width: 80%;      }      .hs-content-product-slide-cart {          width: 99%;      }      .hs-product-content-image-swipper {          width: 20%;      }    }\t@media (max-width: 769px) {        .hs-btn-checkout-bar .hs-checkout-bar-price .hs-money-price {            margin: 0;            margin-right: 10px;        }        .hs-change-select-option {            padding-right: 0px;        }        .hs-full-bar-button.hs-bar-button-mobile button {            margin: 8px 0;        }        .hs-full-bar-button {            align-items: center;            display: none;            flex-direction: row;            width: 100%;\t\t\tmargin-left:0px;        }\t\t.hs-sticky-checkout-bar.hs-sticky---bar---1 {\t\t\tz-index: 2147483644;\t\t}\t\t.hs-popup-cart-sp-load .hs-site-cart-popup {\t\t\theight: 100%;\t\t}\t\t.hs-popup-cart-sp-load.hs-cart-drawer-1 {\t\t\tdisplay:none;\t\t\twidth: 100%;\t\t\theight: 100%;\t\t\tleft: 0px !important;\t\t\tright: auto !important;\t\t\ttop: 0px !important;\t\t}\t\t.hs-popup-cart-sp-load.hs-cart-drawer-1 .hs-drawer-checkout {\t\t\twidth: 100%;\t\t\tz-index: 10;\t\t}\t\t.hs-popup-cart-sp-load.hs-cart-drawer-1.active {\t\t\tdisplay:block;\t\t}\t\t.hs-change-select-option.hs-hidden-select-option {\t\t\tdisplay: none !important;\t\t}\t\t.hs-content-quantity.hs-hidden-quantity {\t\t\tdisplay: none !important;\t\t}\t\t.hs-content-checkout-bar .hs-change-select-option .hs-select-box-load {\t\t\tmin-width: 120px;\t\t}\t\t.hs-content-checkout-bar .hs-change-select-option .hs-select-box-load.hs-load-select-box-bar-1 {\t\t\twidth: 100%;\t\t}\t\t.hs-content-checkout-bar .hs-change-select-option .hs-select-box-load.hs-load-select-box-bar-2 {\t\t\twidth: 50%;\t\t}\t\t.hs-content-checkout-bar .hs-change-select-option .hs-select-box-load.hs-load-select-box-bar-3 {\t\t\twidth: 33.333%;\t\t}\t\t.hs-content-variant-select-option .hs-change-select-option {\t\t\twidth: 100%;\t\t}\t\t.hs-content-variant-select-option .hs-change-select-option.hs-hidden-quantity {\t\t\twidth: 100%;\t\t\tpadding-right: 0px;\t\t}\t\t.hs-sticky-bar-add-to-cart-product-title {\t\t\tmax-width: calc(100% - 200px);\t\t}\t\t.hs-content-image-and-title.hs-bar-hidden-button .hs-image-thumb .hs-btn-checkout-bar .hs-checkout-bar-add-to-cart {\t\t\tdisplay: none !important;\t\t}\t\t.hs-full-bar-button.hs-bar-button-mobile {\t\t\tdisplay: flex !important;\t\t}\t\t.hs-content-variant-select-option .hs-content-quantity {\t\t\tdisplay: none;\t\t}\t\t.hs-content-variant-select-option .hs-content-quantity.hs-hidden-select-option {\t\t\twidth: 100%;\t\t}\t\t.hs-content-checkout-bar .hs-content-variant-select-option .hs-content-quantity .hs-quick-button-quantity {\t\t\twidth: 100% !important;\t\t}\t\t.hs-content-variant-select-option .hs-checkout-bar-compare-at-price, .hs-content-variant-select-option .hs-checkout-bar-price{\t\t\tdisplay:none !important;\t\t}\t\t.hs-message-notify-popup-cart{\t\t\tmin-width: auto;\t\t\twidth: 80%;\t\t}        .hs-content-checkout-bar{\t\t\tpadding-right: 22px;    \t\tpadding-left: 22px;        }\t\t.hs-content-image-and-title .hs-image-thumb .hs-btn-checkout-bar {        \tvertical-align: middle;            display: flex;            flex-direction: row-reverse;            width: 25%;    \t}\t\t.hs-content-variant-select-option .hs-btn-checkout-bar {            display: none !important;        }        .hs-content-checkout-bar{            width: 100%;            display: flex;            visibility: visible;            -webkit-box-align: center;            align-items: center;            -webkit-box-pack: justify;            justify-content: space-between;            box-sizing: border-box;            flex-flow: row wrap;        }        .hs-content-variant-select-option{            align-items: center;            display: flex;            flex-direction: row;            width: 100%;        }        .hs-sticky-checkout-bar.hs-mobile-top{            top:' +
                    t.position_offset_mobile +
                    "px;\t\t\tbottom: inherit;        }        .hs-sticky-checkout-bar.hs-mobile-bottom{            bottom:" +
                    t.position_offset_mobile +
                    "px;          \ttop: inherit;        }.hs-upsell-add-to-cart{background:#165570 !important}.hs-upsell-add-to-cart:hover{background:#60808E !important}button.product-form__cart-submit_popup_cart {\t\t\tcolor: " +
                    t.add_to_cart_button_color +
                    ";\t\t\tbackground: " +
                    t.add_to_cart_button_background +
                    ";\t\t\twidth: 100%;\t\t\tline-height: 1.4;\t\t\tpadding-left: 0px;\t\t\tpadding-right: 0px;\t\t\twhite-space: normal;\t\t\tpadding: 10px 10px;\t\t\tborder: 0px;\t\t\tmargin-top: 10px;\t\t\ttext-transform: uppercase;\t\t}\t\t.hs-popup-cart-sp-load {\t\t\tz-index: 2147483647 !important;\t\t}\t}\t@media (max-width: 600px) { .hs-popup-cart-sp-load .hs-site-cart-popup form .hs-finalize-purchase {  padding-bottom: 10px !important;  }         .hs-content-image-and-title .hs-image-thumb .hs-btn-checkout-bar {            width: 35%;        }\t\t.hs-countdown-offer-mobile {            display: block;            margin: 0 auto;        }\t\t.hs-content-checkout-bar .hs-change-select-option .hs-select-box-load {\t\t\tmin-width: 100px;\t\t}        .hs-popup-cart-sp-load.hs-cart-drawer-1 {            left: auto !important;        }\t\t.hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-image a {    \t\tdisplay: inline-block;    \t\tvertical-align: middle;\t\t}\t\t.hs-content-checkout-bar .hs-change-select-option .hs-select-box-load {\t\t\tmin-width: 80px;\t\t}\t\t.hs-popup-cart-sp-load.hs-cart-drawer-1.hs-mobile-content-cart{\t\t\twidth: 100% !important;    \t}\t}\t@media (max-width: 480px) {      .hs-swipper-select-option-add-to-cart {          width: 90%;      }      .hs-upsell-add-to-cart {          padding: 0px 15px;      }      .hs-original-price-total {          margin-left: 0px;      }      .hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content .hs-item-cart-description {          line-height: 14px;          font-size: 14px;      }      .hs-announcement,.hs-countdown-cart {          font-size: 14px;      }      input.hs-discount-code {          width: 60% !important;      }      button.hs-apply-discount {          width: 40%;  \t  }  \t  .hs-close-popup-cart h1{  \t\tfont-size: 16px;        margin: 0px;        line-height: 0px;      }      .hs-popup-cart-sp-load .hs-site-cart-popup h1 {      \tfont-size: 16px !important;      }\t  .hs-drawer-checkout{\t\tposition: sticky;      }    .hs-popup-cart-sp-load{        width: 90% !important;        min-width: auto;        max-width: initial;        height: 100%;        right: -90% !important;      }      .hs-item-close { margin-top: 5px; }      .hs-content-image-and-title .hs-image-thumb .hs-btn-checkout-bar {          width: 40%;      }\t}\t@media (max-width: 400px) {      .hs-content-product-and-variant-title {          display: block;          margin-right: 0px;      }      .hs-content-product-and-variant-title {          font-size: 14px;      }      .hs-item-cart-description .hs-variant-title {          font-size: 12px;      }\t  .hs-content-product-and-variant-title {\t\t  margin-right: 10px;      }      .hs-content-image-and-title .hs-image-thumb .hs-btn-checkout-bar {          width: 45%;      }\t}    @media (max-width: 380px) {\t  .hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content .hs-item-cart-qty .hs-cart-plus-minus input{\t\t  width: 30px !important;      }      .hs-popup-cart-sp-load .hs-site-cart-popup form .hs-sticky-cart .hs-item-cart-content .hs-item-cart-qty {          width: 90px;      }    }p.affirm-as-low-as { text-align: center; } form.sn-cart::-webkit-scrollbar{width: 5px;} form.sn-cart::-webkit-scrollbar-thumb{background: rgb(0 0 0 / 30%);border-radius: 20px;  } form.sn-cart::-webkit-scrollbar-track{background: rgb(0,0,0,0.2);}\t\t .hs-item-cart-content.hs-is-loading:before {\t content: '';\t box-sizing: border-box;\t position: absolute;\t top: 50%;\t left: 50%;\t width: 30px;\t height: 30px;\t  margin-top: -15px;\t margin-left: -15px;\t border-radius: 50%;\t border: 1px solid #ccc;\t border-top-color: #000;\t -webkit-animation: spinner .6s linear infinite;\t animation: spin .6s linear infinite;\t z-index: 98;\t} .hs-item-cart-content.hs-is-loading:after{\t content: '';\t display: block;\t top: 0;\t left: 0;\t right: 0;\t bottom: 0;\ background: #ffffff;\t  position: absolute;\t z-index: 97;\t opacity: 0.8;\t} @-webkit-keyframes spin { from { -webkit-transform: rotate(0deg); transform: rotate(0deg);  }  to {    -webkit-transform: rotate(359deg); transform: rotate(359deg); }} @keyframes spin { from { -webkit-transform: rotate(0deg);transform: rotate(0deg);} to { -webkit-transform: rotate(359deg); transform: rotate(359deg); }"),
                e("head").append('<style type="text/css">' + HsCartDrawer.css + "</style>");
          e("head").append(`<style type="text/css">
            .hs-site-cart-popup .hs-cart-input-lbl{\
              padding: 0 !important;\
              margin: 0 !important;\
              background: none !important;\
              opacity:0 !important;\
              position: absolute !important;\
            }\
            .hs-sub-total-cart {\
                display: flex;\
                align-items: center;\
                width: 100%;\
                justify-content: center;\
            }\
            .hs-sl-total {\
                flex: 1;\
            }\
            .hs-drawer-content-checkout .terms-of-services--price {
                font-size: 11px !important;
            }
            .hs-sl-content-p-t {\
                display: flex;\
                align-items: center;\
                justify-content: right;\
                gap: 5px;\
            }\
            span.hs-sticky-cart-cart-drawer-content {\
              display: flex;\
              justify-content: center;\
            }\
            .hs-upsell-popup-content-box{\
                padding: 50px 25px 25px 25px;
                background: #fff;\
            }\
            .hs-upsell-popup-heading, .hs-upsell-popup-title, .hs-upsell-popup-subheading, .hs-upsell-popup-section-button{\
                text-align: center;\
            }\
            .hs-upsell-popup-heading{\
              padding-left: 0px !important;\
              padding-right: 0px !important;\
              padding-top: 0px !important;\
              padding-bottom: 0px !important;\
              margin-left: 0px !important;\
              margin-right: 0px !important;\
              margin-top: 0px !important;\
              margin-bottom: 0px !important;\
            }\
            .hs-upsell-popup-heading h4 {\
                color: #60808E;\
            }\
            .hs-upsell-popup-title{\
                padding-top: 15px !important;\
                padding-bottom: 15px !important;\
            }\
            .hs-upsell-popup-subheading{\
                padding-top: 0px !important;
                padding-bottom: 15px !important;
                margin-left: 0px !important;
                margin-right: 0px !important;
                margin-top: 0px !important;
                margin-bottom: 0px !important;
            }\
            
            .hs-upsell-popup-subheading p {\
                font-size: 16px;\
                font-family: DM Sans, sans-serif;\
                font-weight: 700;\
                color: #000000;\
            }\
            .hs-upsell-popup-heading h4, .hs-upsell-popup-title h1{\
                margin: 0 !important;\
            }\
            .hs-upsell-popup-heading h4{\
                font-size: 16px;
                font-family: DM Sans, sans-serif;
            }\
            .hs-upsell-popup-close{\
              all: initial !important;\
              background: rgba(242,245,249,0.01) !important;\
              display: block !important;\
              position: absolute !important;\
              right: 10px !important;\
              top: 10px !important;\
              padding: 5px !important;\
              line-height: 0 !important;\
              border-radius: 100% !important;\
              cursor: pointer !important;\
            }\
            .hs-upsell-popup-close svg{\
              width: 21px !important;\
              height: 21px !important;\
            }\
            .hs-upsell-popup-section-items-layout{\
                padding-right: 0px !important;
                padding-top: 0px !important;
                padding-bottom: 15px !important;
                margin-right: 0px !important;
                margin-top: 0px !important;
                margin-bottom: -10px !important;
                position: relative;
                display: block;
            }\
            .hs-upsell-popup-section-items .hs-upsell-popup-item{\
                padding: 5px !important;\
                margin-bottom: 5px !important;\
            }\
            .hs-upsell-popup-section-items .hs-upsell-popup-item .hs-upsell-popup-item-inner{\
                padding: 5px !important;\
                border-style: solid!important;\
                border-left-width: 1.5px !important;\
                border-right-width: 1.5px !important;\
                border-bottom-width: 1.5px !important;\
                border-top-width: 1.5px !important;\
                border-color: #D7D7D7!important;\
                border-radius: 4px !important;\
            }\
            .hs-upsell-popup-item:before,.hs-upsell-popup-item-product:before {
                content: " ";\
                display: table;\
                box-sizing: inherit;\
            }
            .hs-upsell-popup-item:after,.hs-upsell-popup-item-product:after {
                clear: both;\
                content: " ";\
                display: table;\
            }
            .hs-upsell-popup-item-product-info{\
                padding: 20px 30px;\
            }\
            .hs-upsell-popup-item-product-image{\
                box-sizing: border-box;\
                width: calc(0% + 400px) !important;\
                float: left;\
                text-align: center;\
            }\
            .hs-upsell-popup-item-product-info{\
                box-sizing: border-box;\
                width: calc(100% - 400px) !important;\
                float: left;\
            }\
            .hs-upsell-popup-item-product-title, .hs-upsell-popup-item-product-prices,.hs-upsell-popup-item-product-outer{\
                text-align: left !important;\
                margin-right: auto !important;\
            }\
            .hs-upsell-popup-item-product-image img{\
                object-fit: cover;\
                height: 200px !important;\
                width: 400px;\
            }\
            .hs-upsell-popup-item-product-title p {\
                font-size: 28px !important;
                line-height: 1.5em;
                color: #000;
                font-weight: 800;
                font-family: MercuryDisplayRoman;
            }\
            .hs-upsell-popup-item-product-prices {\
                margin-bottom: 10px;\
            }\
            .hs-upsell-popup-item-product-prices .hs-upsell-popup-item-compare-price {\
                margin-right: 5px;\
                display: inline-block !important;
                font-family: 'GothamLight';
                font-weight: 600 !important;
                font-size: 20px !important;
                line-height: 20px !important;
                color: #888;
                text-decoration: line-through;
            }\
            .hs-upsell-popup-item-product-prices .hs-upsell-popup-item-price {\
                display: inline-block !important;
                font-family: 'GothamMedium';
                font-size: 20px !important;
                line-height: 20px !important;
                color: #888;
                font-weight: 500!important;
                color: red!important;
            }\
            .hs-upsell-popup-item-product-outer{\
                display: inline-block;\
                min-width: 100% !important;\
            }\
            .hs-upsell-popup-item-product-variants {\
                min-height: 0px;\
                max-width: initial;\
            }\
            .hs-upsell-popup-item-product-variants select {\
                display: inline !important;\
                font-style: normal !important;\
                width: 100% !important;\
                max-width: 100% !important;\
                min-width: initial !important;\
                -webkit-font-smoothing: antialiased !important;\
                -moz-osx-font-smoothing: grayscale !important;\
                color: #2F2F2F !important;\
                outline-color: transparent;\
                outline-style: none;\
                background: #FFF;\
                font-weight: 500 !important;\
                border: 1px solid #DBDBDB !important;\
                -webkit-box-sizing: border-box !important;\
                -moz-box-sizing: border-box !important;\
                box-sizing: border-box !important;\
                box-shadow: none !important;\
                height: initial !important;\
                position: initial !important;\
                overflow: initial !important;\
                vertical-align: top !important;\
                padding: 11px 0px 9px 10px !important;
                font-size: 15px !important;
                margin: 0px !important;
                margin-bottom: 10px !important;
            }\
            .hs-upsell-popup-item-button.hs-upsell-popup-button {\
                text-align: center !important;\
                width: 100% !important;\
                min-width: 100% !important;\
            }\
            .hs-upsell-popup-button{\
                background: #60808E;\
                color: #fff;\
                border-style: none;\
                border-color: #60808E;\
                border-radius: 4px;\
                display: inline-block;\
                padding: 10px 15px;\
                touch-action: manipulation;\
                -webkit-box-sizing: border-box;\
                outline-color: transparent;\
                outline-style: none;\
                -moz-box-sizing: border-box;\
                box-sizing: border-box;\
                min-width: 100px;\
                cursor: pointer;\
                margin: 0px !important;\
                text-transform: none !important;\
                letter-spacing: initial !important;\
                height: initial !important;\
                border: initial;\
                border-style: solid;\
                border-width: 2px;\
                border-color: transparent;\
                border-radius: 4px;\
            }\
            .hs-upsell-popup-button.hs-upsell-popup-item-soldOut{\
                opacity: 0.5 !important;\
                cursor: auto;\
            }\
            .hs-upsell-popup-button p{\
                font-weight: 600;\
                font-size: 14px;\
            }\
            @media (max-width: 599px){
                .hs-upsell-popup-section-items-layout{\
                    padding-right: 10px !important;\
                }\
                .hs-upsell-popup-item-product-image {\
                    max-width: 100%;\
                    width: 100% !important;\
                }\
                .hs-upsell-popup-item-product-info{\
                    width: 100% !important;
                    padding: 10px 0;
                }\
            }
			</style>`);
        },
        IEdetection: function (t, e) {
            var a = window.navigator.userAgent,
                i = a.indexOf("MSIE ");
            if (i > 0) return "IE " + parseInt(a.substring(i + 5, a.indexOf(".", i)), 10);
            if (a.indexOf("Trident/") > 0) {
                var r = a.indexOf("rv:");
                return "IE " + parseInt(a.substring(r + 3, a.indexOf(".", r)), 10);
            }
            var n = a.indexOf("Edge/");
            return n > 0 ? "IE " + parseInt(a.substring(n + 5, a.indexOf(".", n)), 10) : "Not IE";
        },
        plusMin: function (data, $) {
            $(".hs-cart-plus-minus").each(function (t) {
                $(this).html(
                    '<div class="hs-dec hs-qtybutton"><svg xmlns="http://www.w3.org/2000/svg" width="10px" viewBox="0 -192 469.33333 469"><path d="m437.332031.167969h-405.332031c-17.664062 0-32 14.335937-32 32v21.332031c0 17.664062 14.335938 32 32 32h405.332031c17.664063 0 32-14.335938 32-32v-21.332031c0-17.664063-14.335937-32-32-32zm0 0"></path></svg></div><input type="text" value="' +
                        $(this).data("quantity") +
                        '" id="' +
                        $(this).data("id") +
                        '" data-id="' +
                        $(this).data("id") +
                        '" data-key="' +
                        $(this).data("key") +
                        '" data-father="' +
                        $(this).data("father") +
                        '" data-random="' +
                        $(this).data("random") +
                        '" data-fathervariantid="' +
                        $(this).data("fathervariantid") +
                        '" data-childrenvariantid="' +
                        $(this).data("childrenvariantid") +
                        '" data-line="' +
                        $(this).data("line") +
                        '">'+
                  		'<label for="'+
                  		$(this).data("id") +
                  		'" class="hs-cart-input-lbl">'+
                  		$(this).data("quantity")+
                  		' </label>'+
                  		'<div class="hs-inc hs-qtybutton"><svg xmlns="http://www.w3.org/2000/svg" width="10px" version="1.1" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve"> <g> <g> <path d="M465.064,207.566l0.028,0H284.436V27.25c0-14.84-12.016-27.248-26.856-27.248h-23.116    c-14.836,0-26.904,12.408-26.904,27.248v180.316H26.908c-14.832,0-26.908,12-26.908,26.844v23.248    c0,14.832,12.072,26.78,26.908,26.78h180.656v180.968c0,14.832,12.064,26.592,26.904,26.592h23.116    c14.84,0,26.856-11.764,26.856-26.592V284.438h180.624c14.84,0,26.936-11.952,26.936-26.78V234.41    C492,219.566,479.904,207.566,465.064,207.566z"></path> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></div>'
                );
            });

                $(".hs-qtybutton").unbind("click"),
                $(".hs-qtybutton").click(function (e) {

                    // Extend — dispatch event to refresh ajax side cart
                    setTimeout(function() {
                        window.dispatchEvent(new Event('refreshAjaxSideCart'))
                    }, 1000)
                    // Extend — end code

                    var arr_variants = [],
                        concatVariant = "",
                        $button = $(this),
                        load = "",
                        newVal = 0,
                        parent = $button.closest(".hs-item-cart-qty"),
                        oldValue = $button.closest(".hs-item-cart-qty").find("input").val(),
                        id = $button.closest(".hs-item-cart-qty").find("input").data("id"),
                        line = $button.closest(".hs-item-cart-qty").find("input").data("line"),
                        father = $button.closest(".hs-item-cart-qty").find("input").data("father"),
                        key = $button.closest(".hs-item-cart-qty").find("input").data("key"),
                        random = $button.closest(".hs-item-cart-qty").find("input").data("random"),
                        fathervariantid = $button.closest(".hs-item-cart-qty").find("input").data("fathervariantid"),
                        childrenvariantid = $button.closest(".hs-item-cart-qty").find("input").data("childrenvariantid");
                  		var hs_item_cart_content_quantity =  !!$button[0].closest('.hs-item-cart-content-quantity') ? $button[0].closest('.hs-item-cart-content-quantity') : '';
                        var hs_item_cart_content =  !!$button[0].closest('.hs-item-cart-content') ? $button[0].closest('.hs-item-cart-content') : '';
                        if(!!hs_item_cart_content_quantity.classList.contains('hs-hidden-element'))
                        {
                          return false;
                        }
                        if(!!hs_item_cart_content)
                        {
                          hs_item_cart_content.classList.add('hs-is-loading');
                        }
                        if ($button.hasClass('hs-inc')) {
                          newVal = parseFloat(oldValue) + 1;
                        } else {
                          // Don't allow decrementing below zero
                          if (oldValue > 0) {
                            newVal = parseFloat(oldValue) - 1;
                          } else {
                            newVal = 0;
                          }
                        };
                    (load =
                        '<div class="hs-cart-plus-minus" data-quantity="' +
                        newVal +
                        '" data-id="' +
                        id +
                        '" data-key="' +
                        key +
                        '" data-father="' +
                        father +
                        '" data-random="' +
                        random +
                        '" data-fathervariantid="' +
                        fathervariantid +
                        '" data-childrenvariantid="' +
                        childrenvariantid +
                        '" data-line="' +
                        line +
                        '"><div class="hs-dec hs-qtybutton"><svg xmlns="http://www.w3.org/2000/svg" width="10px" viewBox="0 -192 469.33333 469"><path d="m437.332031.167969h-405.332031c-17.664062 0-32 14.335937-32 32v21.332031c0 17.664062 14.335938 32 32 32h405.332031c17.664063 0 32-14.335938 32-32v-21.332031c0-17.664063-14.335937-32-32-32zm0 0"></path></svg></div><input type="text" value="' +
                        newVal +
                        '" data-id="' +
                        id +
                        '" data-key="' +
                        key +
                        '" data-father="' +
                        father +
                        '" data-random="' +
                        random +
                        '" data-fathervariantid="' +
                        fathervariantid +
                        '" data-childrenvariantid="' +
                        childrenvariantid +
                        '" data-line="' +
                        line +
                        '"><div class="hs-inc hs-qtybutton"><svg xmlns="http://www.w3.org/2000/svg" width="10px" version="1.1" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve"> <g> <g> <path d="M465.064,207.566l0.028,0H284.436V27.25c0-14.84-12.016-27.248-26.856-27.248h-23.116    c-14.836,0-26.904,12.408-26.904,27.248v180.316H26.908c-14.832,0-26.908,12-26.908,26.844v23.248    c0,14.832,12.072,26.78,26.908,26.78h180.656v180.968c0,14.832,12.064,26.592,26.904,26.592h23.116    c14.84,0,26.856-11.764,26.856-26.592V284.438h180.624c14.84,0,26.936-11.952,26.936-26.78V234.41    C492,219.566,479.904,207.566,465.064,207.566z"></path> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></div></div>'),
                      $button.parent().find("input").val(newVal);
                    var concatVariant = "'" + key + "':'" + newVal + "'",
                        keychildren = "",
                        concatVariantext = "";
                    (concatVariant = JSON.stringify(eval("({" + concatVariant + "})"))),
                        (concatVariant = JSON.parse(concatVariant)),
                        (arr_variants = { updates: concatVariant }),
                        1 == father &&
                            (fathervariantid &&
                                childrenvariantid &&
                                (isNaN(childrenvariantid)
                                    ? ((childrenvariantid = childrenvariantid.split(",")),
                                      $.each(childrenvariantid, function (t, e) {
                                          null != (keychildren = $(".hs-relation-" + e + "-" + random).data("key")) && (concatVariantext = concatVariantext.concat("'" + keychildren + "':'" + newVal + "',"));
                                      }))
                                    : ((keychildren = $(".hs-relation-" + childrenvariantid + "-" + random).data("key")), null != keychildren && (concatVariantext = "'" + keychildren + "':'" + newVal + "',")),
                                (concatVariant = concatVariantext + "'" + key + "':'" + newVal + "'"),
                                (concatVariant = JSON.stringify(eval("({" + concatVariant + "})"))),
                                (concatVariant = JSON.parse(concatVariant))),
                            (arr_variants = { updates: concatVariant })),
                        HsCartDrawer.onloadAjaxCart(parent, load, arr_variants, line, newVal, data, $);
                });
        },
        removeItemCart: function (data, $) {
            var arr = [],
                arr_variants = [],
                concatVariant = "";
            $(".hs-remove-item").unbind("click"),
                $(".hs-remove-item").click(function (e) {
                    var $button = $(this),
                        id = $button.data("id"),
                        key = $button.data("key"),
                        father = $button.data("father"),
                        random = $button.data("random"),
                        fathervariantid = $button.data("fathervariantid"),
                        childrenvariantid = $button.data("childrenvariantid"),
                        line = $button.data("line"),
                        qty = 0,
                        load = '<div class="hs-loading"><span><i class="fa fa-refresh fa-spin fa-2x fa-fw"></i></span></div>',
                        parent = $button;
                    //$button.closest(".hs-item-cart-content").remove();
                    var concatVariant = "'" + key + "':'" + qty + "'",
                        keychildren = "",
                        concatVariantext = "";
                    (concatVariant = JSON.stringify(eval("({" + concatVariant + "})"))),
                        (concatVariant = JSON.parse(concatVariant)),
                        (arr_variants = { updates: concatVariant }),
                        1 == father &&
                            (fathervariantid &&
                                childrenvariantid &&
                                (isNaN(childrenvariantid)
                                    ? ((childrenvariantid = childrenvariantid.split(",")),
                                      $.each(childrenvariantid, function (t, e) {
                                          null != (keychildren = $(".hs-relation-" + e + "-" + random).data("key")) && (concatVariantext = concatVariantext.concat("'" + keychildren + "':'" + qty + "',"));
                                      }))
                                    : ((keychildren = $(".hs-relation-" + childrenvariantid + "-" + random).data("key")), null != keychildren && (concatVariantext = "'" + keychildren + "':'" + qty + "',")),
                                (concatVariant = concatVariantext + "'" + key + "':'" + qty + "'"),
                                (concatVariant = JSON.stringify(eval("({" + concatVariant + "})"))),
                                (concatVariant = JSON.parse(concatVariant))),
                            (arr_variants = { updates: concatVariant })),
                        HsCartDrawer.onloadAjaxCart(parent, load, arr_variants, line, qty, data, $);

                    // Extend — dispatch event to refresh ajax side cart
                    setTimeout(function() {
                        window.dispatchEvent(new Event('refreshAjaxSideCart'))
                    },1000)
                    // Extend — end code


                });
        },
        UpdateNote: function (t, e, a) {
            a.ajax({ type: "POST", url: "/cart/update.js", dataType: "json", async: !0, data: { note: t }, success: function (t) {}, error: function (t, e, a) {}, complete: function (t) {} });
        },
        changeQuantityCart: function (data, $) {
            $(".hs-item-cart-qty .hs-cart-plus-minus input").unbind("keyup"),
                $(".hs-item-cart-qty .hs-cart-plus-minus input").keyup(function (e) {
                    e.preventDefault(), (this.value = this.value.replace(/[^0-9\.]/g, ""));
                    var where = $(this),
                        value = this.value;
              var hs_item_cart_content_quantity =  !!where[0].closest('.hs-item-cart-content-quantity') ? where[0].closest('.hs-item-cart-content-quantity') : '';
              if(!!hs_item_cart_content_quantity.classList.contains('hs-hidden-element'))
              {
                return false;
              }
                      var hs_item_cart_content =  !!$(".hs-item-" + where.data("id"))[0].closest('.hs-item-cart-content') ?$(".hs-item-" + where.data("id"))[0].closest('.hs-item-cart-content') : '';
                      if(!!hs_item_cart_content)
                      {
                        hs_item_cart_content.classList.add('hs-is-loading');
                      }             
                    delay(function () {
                        //"" === value && (value = 1), where.closest(".hs-item-cart-qty").html('<div class="hs-loading"><span><i class="fa fa-refresh fa-spin fa-2x fa-fw"></i></span></div>');
                       if(value === '')
                       {
                         value = 1;
                       };
                        var arr_variants = [],
                            concatVariant = "",
                            id = where.data("id"),
                            key = where.data("key"),
                            father = where.data("father"),
                            random = where.data("random"),
                            fathervariantid = where.data("fathervariantid"),
                            childrenvariantid = where.data("childrenvariantid"),
                            line = where.data("line"),
                            qty = value,
                            load =
                                '<div class="hs-cart-plus-minus" data-quantity="' +
                                value +
                                '" data-id="' +
                                id +
                                '" data-key="' +
                                key +
                                '" data-father="' +
                                father +
                                '" data-random="' +
                                random +
                                '" data-fathervariantid="' +
                                fathervariantid +
                                '" data-childrenvariantid="' +
                                childrenvariantid +
                                '" data-line="' +
                                line +
                                '"><div class="hs-dec hs-qtybutton"><svg xmlns="http://www.w3.org/2000/svg" width="10px" viewBox="0 -192 469.33333 469"><path d="m437.332031.167969h-405.332031c-17.664062 0-32 14.335937-32 32v21.332031c0 17.664062 14.335938 32 32 32h405.332031c17.664063 0 32-14.335938 32-32v-21.332031c0-17.664063-14.335937-32-32-32zm0 0"></path></svg></div><input type="text" value="' +
                                value +
                                '" data-id="' +
                                id +
                                '" data-line="' +
                                line +
                                '"><div class="hs-inc hs-qtybutton"><svg xmlns="http://www.w3.org/2000/svg" width="10px" version="1.1" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve"> <g> <g> <path d="M465.064,207.566l0.028,0H284.436V27.25c0-14.84-12.016-27.248-26.856-27.248h-23.116    c-14.836,0-26.904,12.408-26.904,27.248v180.316H26.908c-14.832,0-26.908,12-26.908,26.844v23.248    c0,14.832,12.072,26.78,26.908,26.78h180.656v180.968c0,14.832,12.064,26.592,26.904,26.592h23.116    c14.84,0,26.856-11.764,26.856-26.592V284.438h180.624c14.84,0,26.936-11.952,26.936-26.78V234.41    C492,219.566,479.904,207.566,465.064,207.566z"></path> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></div></div>',
                            parent = $(".hs-item-" + id),
                            concatVariant = "'" + key + "':'" + qty + "'",
                            keychildren = "",
                            concatVariantext = "";
                        (concatVariant = JSON.stringify(eval("({" + concatVariant + "})"))),
                            (concatVariant = JSON.parse(concatVariant)),
                            (arr_variants = { updates: concatVariant }),
                            1 == father &&
                                (fathervariantid &&
                                    childrenvariantid &&
                                    (isNaN(childrenvariantid)
                                        ? ((childrenvariantid = childrenvariantid.split(",")),
                                          $.each(childrenvariantid, function (t, e) {
                                              null != (keychildren = $(".hs-relation-" + e + "-" + random).data("key")) && (concatVariantext = concatVariantext.concat("'" + keychildren + "':'" + qty + "',"));
                                          }))
                                        : ((keychildren = $(".hs-relation-" + childrenvariantid + "-" + random).data("key")), null != keychildren && (concatVariantext = "'" + keychildren + "':'" + qty + "',")),
                                    (concatVariant = concatVariantext + "'" + key + "':'" + qty + "'"),
                                    (concatVariant = JSON.stringify(eval("({" + concatVariant + "})"))),
                                    (concatVariant = JSON.parse(concatVariant))),
                                (arr_variants = { updates: concatVariant })),
                            HsCartDrawer.onloadAjaxCart(parent, load, arr_variants, line, qty, data, $);
                    }, 500);
                }),
                $("textarea.hs-cart-ins").unbind("keyup"),
                $("textarea.hs-cart-ins").keyup(function (t) {
                    t.preventDefault(), $(this);
                    var e = this.value;
                    delay(function () {
                        HsCartDrawer.UpdateNote(e, data, $);
                    }, 400);
                });
        },
        onloadAjaxCart: function (t, e, a, i, r, n, s) {
            HsCartDrawer.notifyHide(n, s),
                s.ajax({
                    type: "POST",
                    url: "/cart/update.js",
                    dataType: "json",
                    async: !0,
                    data: a,
                    success: function (t) {
                        void 0 !== window.BOLD && void 0 !== window.BOLD.common && void 0 !== window.BOLD.common.cartDoctor && (t = window.BOLD.common.cartDoctor.fix(t)), t && HsCartDrawer.getCart2(1, 0, n, s);
                    },
                    error: function (t, e, a) {},
                    complete: function (t) {
                        HsCartDrawer.removeItemCart(n, s), HsCartDrawer.positionPopup(n, s), HsCartDrawer.hideCartPopup(n, s), HsCartDrawer.changeQuantityCart(n, s), HsCartDrawer.clearALL(n, s);
                    },
                });
        },
        onloadHtml: function (t, e, a, i) {
            t.html(e);
        },
        getCart: function (t, e, a, i) {
            var r = new Date().getTime();
            if (!parseInt(a.enable_app)) return !1;
            HsCartDrawer.notifyHide(a, i),
                i.ajax({
                    type: "GET",
                    url: `${window.location.origin}/cart?view=plush&range=` + r,
                    async: !0,
                    success: function (e) {
                        (e = JSON.parse(e)),
                            void 0 !== window.BOLD && void 0 !== window.BOLD.common && void 0 !== window.BOLD.common.cartDoctor && (e = window.BOLD.common.cartDoctor.fix(e)),
                            HsCartDrawer.removeRecycle(e, a, i),
                            HsCartDrawer.cart(e, a, i),
                            HsCartDrawer.countCart(e, a, i),
                            HsCartDrawer.priceCart(e, a, i),
                            HsCartDrawer.currencyConverter(a, i),
                            t > 0 && HsCartDrawer.showCartPopup(a, i),
                            HsCartDrawer.hideCartPopup(a, i);
                    },
                    error: function (t) {},
                    complete: function () {
                        HsCartDrawer.plusMin(a, i),
                            HsCartDrawer.removeItemCart(a, i),
                            HsCartDrawer.positionPopup(a, i),
                            HsCartDrawer.hideCartPopup(a, i),
                            HsCartDrawer.changeQuantityCart(a, i),
                            HsCartDrawer.clearALL(a, i),
                            HsCartDrawer.resizeDesktopAndMobile(a, i),
                            HsCartDrawer.startDiscount(a, i),
                            HsCartDrawer.swiperHSCart(a, i),
                            HsCartDrawer.upsellVariants(a, i),
                            HsCartDrawer.addToCartFreeShipping(a, i);
                    },
                });
        },
        getCart2: function (t, e, a, i) {
          var r = new Date().getTime(),s={};
            if (!parseInt(a.enable_app)) return !1;
            HsCartDrawer.notifyHide(a, i),
                i.ajax({
                    type: "GET",
                    url: `${window.location.origin}/cart?view=plush&range=` + r,
                    async: !0,
                    success: function (e) {
                        (e = JSON.parse(e)),
                          	s=e;
                            void 0 !== window.BOLD && void 0 !== window.BOLD.common && void 0 !== window.BOLD.common.cartDoctor && (e = window.BOLD.common.cartDoctor.fix(e)),
                            HsCartDrawer.removeRecycle(e, a, i),
                            HsCartDrawer.cart2(e, a, i),
                            HsCartDrawer.countCart(e, a, i),
                            HsCartDrawer.priceCart(e, a, i),
                            HsCartDrawer.currencyConverter(a, i),
                            t > 0 && HsCartDrawer.showCartPopup(a, i),
                            HsCartDrawer.hideCartPopup(a, i);
                            try {
                              void 0 !== window.HSSLIDECART &&
                              void 0 !== window.HSSLIDECART.variantsUpsell &&
                              void 0 !== window.HSSLIDECART.variantsUpsell.json &&
                              upsellAdditional(e, window.HSSLIDECART.variantsUpsell.json, HsCartDrawer.json, i);
                            } catch (error) {
                              console.log(error)
                            }
                      
                    },
                    error: function (t) {},
                    complete: function () {
                        console.log("getCart2 complete")
                      s.items.length < 1 && i('.hs-close').trigger('click'),
                        	HsCartDrawer.plusMin(a, i),
                            HsCartDrawer.removeItemCart(a, i),
                            HsCartDrawer.positionPopup(a, i),
                            HsCartDrawer.hideCartPopup(a, i),
                            HsCartDrawer.changeQuantityCart(a, i),
                            HsCartDrawer.clearALL(a, i),
                            HsCartDrawer.resizeDesktopAndMobile(a, i),
                            HsCartDrawer.upsellVariants(a, i),
                            HsCartDrawer.startDiscount(a, i),
                            HsCartDrawer.addToCartFreeShipping(a, i);
                    },
                });
        },
        liveConnect: function (t, e, a) {
            (window.liQ = window.liQ || []), window.liQ.push({ event: "addToCart", email: "", items: t });
        },
        removeRecycle: function (response, data, $) {
            if ((sessionStorage.removeItem("hsShipHasAdd"), response)) {
                var myJSON = JSON.stringify(response);
                if (myJSON.indexOf(31918571880546) > -1) {
                    var json_value = "({ updates: {31918571880546:0} })";
                    (json_value = JSON.stringify(eval(json_value))),
                        $.ajax({
                            type: "POST",
                            url: "/cart/update.js",
                            contentType: "application/json; charset=utf-8",
                            dataType: "json",
                            async: !0,
                            data: json_value,
                            success: function (t) {
                                HsCartDrawer.getCart2(0, 0, data, $);
                            },
                            error: function (t, e, a) {},
                            complete: function (t) {},
                        });
                }
            }
        },
        swiperHSCart: function (t, e) {
            if (!parseInt(t.enable_slide_cart)) return !1;
            if (parseInt(t.upsell_mode)) return !1;
            var a = parseInt(t.count_slide_cart_products);
            a > 1 && (a = 1),
                new Swiper(".hs-container-swp .swiper-container", {
                    slidesPerView: a,
                    spaceBetween: 10,
                    loop: !0,
                    autoHeight: !0,
                    shortSwipes: !1,
                    sliderDrag: !1,
                    allowTouchMove: !1,
                    longSwipesRatio: 0.5,
                    navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
                }),
                HsCartDrawer.paginationHover(t, e);
        },
        paginationHover: function (t, e) {
            e(".hs-container-swp .swiper-pagination-bullet").hover(function () {
                e(this).click();
            });
        },
        ajaxCart: function (t, e, a, i, r) {
            var n = r(".hs-sticky-cart .hs-item-cart-content").length;
            HsCartDrawer.notifyHide(i, r),
                r.ajax({
                    type: "POST",
                    url: `${window.location.origin}/cart/add.js?v=${(new Date).getTime()}`,
                    dataType: "json",
                    async: !0,
                    data: e,
                    success: function (e) {
                        console.log("maybe maybe maybe")
                        return parseInt(i.status)
                            ? "no-redirect" !== i.quick_buy_button_clicked
                                ? ((window.location.href = "/" + i.quick_buy_button_clicked), !1)
                                : void (
                                      e &&
                                      (n > 0 ? HsCartDrawer.getCart2(1, 0, i, r) : HsCartDrawer.getCart(1, 0, i, r),
                                      0 == t ? HsCartDrawer.removeDisabledButton(1, a, i, r) : (HsCartDrawer.changeButton(a, i, r), HsCartDrawer.removeDisabledButton(1, a, i, r)))
                                  )
                            : ((window.location.href = "/cart"), !1);
                    },
                    error: function (t, e, n) {
                        var s = r.parseJSON(t.responseText);
                        HsCartDrawer.changeButton(a, i, r),
                            s &&
                                (setTimeout(function () {
                                    422 == s.status && (HsCartDrawer.openCart(i, r), alert(s.description, i, r), HsCartDrawer.closeCart(i, r), HsCartDrawer.hideCartPopup(i, r));
                                }, 500),
                                HsCartDrawer.removeDisabledButton(0, a, i, r));
                    },
                    complete: function (t) {
                        HsCartDrawer.hideCartPopup(i, r), HsCartDrawer.changeQuantityCart(i, r), HsCartDrawer.clearALL(i, r);
                    },
                });
        },
        closeCart: function (t, e) {
            e("html").removeClass("hs-open-drawer"), e("body").removeClass("hs-open-cart");
        },
        openCart: function (t, e) {
            e("html").addClass("hs-open-drawer"), e("body").addClass("hs-open-cart");
        },
        ajaxBarCart: function (t, e, a, i, r) {
            HsCartDrawer.notifyHide(i, r),
                r.ajax({
                    type: "POST",
                    url: `${window.location.origin}/cart/add.js?v=${(new Date).getTime()}`,
                    dataType: "json",
                    async: !0,
                    data: e,
                    success: function (e) {
                        console.log("ajaxBarCart success")
                        return parseInt(i.status)
                            ? "no-redirect" !== i.sticky_cart_bar_skip_button
                                ? ((window.location.href = "/" + i.sticky_cart_bar_skip_button), !1)
                                : void (e && (HsCartDrawer.getCart(1, 0, i, r), 0 == t ? HsCartDrawer.removeDisabledButton(1, a, i, r) : HsCartDrawer.changeButton(a, i, r)))
                            : ((window.location.href = "/cart"), !1);
                    },
                    error: function (t, e, n) {
                        var s = r.parseJSON(t.responseText);
                        s &&
                            (setTimeout(function () {
                                422 == s.status && (HsCartDrawer.openCart(i, r), alert(s.description, i, r), HsCartDrawer.closeCart(i, r), HsCartDrawer.hideCartPopup(i, r));
                            }, 500),
                            HsCartDrawer.changeButton(a, i, r));
                    },
                    complete: function (t) {
                        HsCartDrawer.hideCartPopup(i, r), HsCartDrawer.changeQuantityCart(i, r), HsCartDrawer.clearALL(i, r);
                    },
                });
        },
        ajaxProductCart: function (t, e, a, i) {
            var r = i(".hs-sticky-cart .hs-item-cart-content").length;
            console.log("what the heck")
            e.addClass("btn--loading"),
                HsCartDrawer.notifyHide(a, i),
                i.ajax({
                    type: "POST",
                    url: `${window.location.origin}/cart/add.js?v=${(new Date).getTime()}`,
                    dataType: "json",
                    async: !0,
                    data: t,
                    success: function (t) {
                        console.log("what about this")
                        if (!parseInt(a.status)) return (window.location.href = "/cart"), !1;
                        t && (r > 0 ? HsCartDrawer.getCart2(1, 0, a, i) : HsCartDrawer.getCart(1, 0, a, i)), HsCartDrawer.changeAddButton(e, a, i);

                    },
                    error: function (t, r, n) {
                        console.log("what about this error")
                        var s = i.parseJSON(t.responseText);
                        s &&
                            setTimeout(function () {
                                422 == s.status && (HsCartDrawer.openCart(a, i), alert(s.description, a, i), HsCartDrawer.closeCart(a, i), HsCartDrawer.hideCartPopup(a, i));
                            }, 500),
                            HsCartDrawer.changeAddButton(e, a, i);
                    },
                    complete: function (t) {
                        console.log("what about this complete")
                        HsCartDrawer.hideCartPopup(a, i), HsCartDrawer.changeQuantityCart(a, i), HsCartDrawer.clearALL(a, i), HsCartDrawer.changeAddButton(e, a, i);
                    },
                });
        },
        changeAddButton: function (t, e, a) {
            var i = a(
                'button[type="submit"][name="add"],input[type="submit"][name="add"],form[action="/cart/add"] input[type="submit"],.product-form-submit-wrap input.button,#AddToCart,button.ProductForm__AddToCart,form[action="/cart/add"] button[type="submit"]'
            );
            i.removeAttr("disabled"), i.removeClass("disabled"), i.removeClass("active"), i.removeClass("btn--loading");
        },
        ajaxProductCartUpsell: function (t, e, a, i) {
            HsCartDrawer.notifyHide(a, i),
                i.ajax({
                    type: "POST",
                    url: `${window.location.origin}/cart/add.js?v=${(new Date).getTime()}`,
                    dataType: "json",
                    async: !0,
                    data: t,
                    success: function (t) {
                        console.log("UPSELL YES MORe MONEY")
                        if (!parseInt(a.status)) return (window.location.href = "/cart"), !1;
                        t && HsCartDrawer.getCart2(1, 0, a, i);

                    },
                    error: function (t, e, r) {
                        var n = i.parseJSON(t.responseText);
                        n &&
                            setTimeout(function () {
                                422 == n.status && (HsCartDrawer.openCart(a, i), alert(n.description, a, i), HsCartDrawer.closeCart(a, i), HsCartDrawer.hideCartPopup(a, i));
                            }, 500);
                        console.log("UPSELL YES MORe MONEY error")
                    },
                    complete: function (t) {
                        HsCartDrawer.hideCartPopup(a, i), HsCartDrawer.changeQuantityCart(a, i), HsCartDrawer.changeButton(e, a, i), HsCartDrawer.clearALL(a, i);
                    },
                });
        },
        countCart: function (t, e, a) {
            a("#CartCount").find("span").eq(0).html(t.item_count),
                a(".num-items-in-cart").find(".number").length > 0 ? a(".num-items-in-cart").find(".number").html(t.item_count) : a(".num-items-in-cart .block-cart").html("Cart (" + t.item_count + ")"),
                a("#cartCount").html("( " + t.item_count + " )"),
                a(".count-style.bigcounter").html(t.item_count),
                a("span#CartCount").html(t.item_count),
                a(".CartCount").html(t.item_count),
                a(".tt-badge-cart").html(t.item_count),
                a("a[href*=cart] span.cart-count").html(t.item_count),
                a("a[href*=cart] .cart_count").html(t.item_count),
                a("a[href*=cart] em").html(t.item_count),
                a(".cart-count, #cart-count a:first, #gocart p a, #cart .checkout em, .item-count, #CartCount span").html(t.item_count),
                a(".cart-summary .cart-count").html(
                    '<span class="cart-count__text">Cart (' +
                        t.item_count +
                        ')</span> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-shopping-bag"><title>Cart</title><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg>'
                ),
                a(".cart-count.cart-summary").html(
                    '<span class="cart-count__text">(' +
                        t.item_count +
                        ')</span> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-shopping-bag"><title>Cart</title><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg>'
                ),
                a(".hs-count-cart").html(t.item_count),
                0 == t.item_count &&
                    (a(".hs-popup-cart-sp-load .hs-site-cart-popup").html(
                        '<div class="hs-empty-page-content hs-text-center"><div class="hs-content-empty-cart">' +
                            HsCartDrawer.empty_cart +
                            "<p>" +
                            e.no_result_text +
                            '</p></div><span class="hs-close"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 329.26933 329" width="15px" height="15px"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"></path></svg></span></div>'
                    ),
                    e.style),
                0 == t.item_count && 1 == e.stickycart_hide_if_empty ? a(".hs-sticky-cart-cart-drawer").addClass("hs-hidden-count-cart") : a(".hs-sticky-cart-cart-drawer").removeClass("hs-hidden-count-cart");
        },
        vat: function (t, e, a) {
            if (parseInt(e.enable_price_vat)) {
                var i = e.price_vat;
                0 == i && (i = 1), (t *= parseFloat(i));
            }
            return t;
        },
        priceCart: function (t, e, a) {
            var i = "",
                r = t.total_price,
                n = "",
                s = "",
                o = "",
                l = "",
                c = "",
                d = "",
                s = !!parseInt(e.show_clear_all,10) ? '<a href="javascript:void(0);" class="hs-clear-all-button">' + e.text_clear_all + '</a>' : '',
                p = 100 * parseFloat(e.from_free_shipping),
                h = 0;
            (r = HsCartDrawer.vat(r, e, a)),
                (i = 1 == t.item_count ? t.item_count + " " + e.text_products_singular : t.item_count + " " + e.text_products_plural),
                (h = t.total_price / p),
                (h *= 100),
                (d = p - (d = t.total_price)),
                (d = HsCartDrawer.vat(d, e, a)),
                (d = hsonslidecart.Currency.formatMoney(d, e.money_format)),
                (c = '<div class="hs-text-free-shipping">' + e.text_away_from_free_shipping.replace("{{ price }}", d) + "</div>"),
                h >= 100 && ((h = 100), (c = '<div class="hs-text-free-shipping">' + e.text_congrats_free_shipping + "</div>")),
                (l = '<div class="hs-announcement">' + e.announcement_module + "</div>").indexOf("{{ price }}") > -1 &&
                    ((c = ""), (l = l.replace("{{ price }}", d)), h >= 100 && (l = '<div class="hs-announcement">' + e.text_congrats_free_shipping + "</div>")),
                parseInt(e.enable_announcement) || ((l = ""), (n = " hs-border-announcement")),
                parseInt(e.enable_countdown_cart) && (n = ""),
                parseInt(e.rewards_show_percentages) || (s = " hs-hidden-percentages"),
                a("#hs-total-price-global").val(r),
                a(".hs_subtotal_amount").html(hsonslidecart.Currency.formatMoney(r, e.money_format)),
                a(".hs-sticky-cart-cart-drawer-content mark").html(t.item_count),
                (i = '<div class="hs-content-count' + n + '"><span class="hs-count-products-cart">' + i + '</span>'+s+"</div>"),
                (o =
                    '<div class="hs-rewards-content"><div class="hs-progess-content' +
                    s +
                    '"><div id="hs_shipping_progress"><div id="hs_shipping_bar" style="width:' +
                    h +
                    '%;"></div></div><span class="hs-progress-indicator">0%</span><span class="hs-progress-indicator">25%</span><span class="hs-progress-indicator">50%</span><span class="hs-progress-indicator">75%</span><span class="hs-progress-indicator">100%</span></div>' +
                    c +
                    "</div>"),
                parseInt(e.enable_rewards) || (o = ""),
                a(".hs-content-count-products-clear-all").html(i),
                a(".hs-announcement-module").html(l),
                a(".hs-content-discounts-calculate-checkout").html('<div class="hs-shipping-taxes">' + e.text_shipping + "</div>" + o),
                a(".CartCost").length > 0 && a(".CartCost").html(hsonslidecart.Currency.formatMoney(r, e.money_format)),
                a(".shopping-cart__total").length > 0 && a(".shopping-cart__total").html(hsonslidecart.Currency.formatMoney(r, e.money_format));
        },
        formatMoneyCurrency: function (t) {
            return (t = (t / 100).toFixed(2)).replace(",", "");
        },
        cart: function (t, e, a) {
            var i,
                r = t.total_price,
                n = [],
                s = 0,
                o = (JSON.stringify(t), []),
                l = 0,
                c = 0,
                d = "",
                p = "",
                h = "",
                u = "",
                m = parseFloat(t.total_price),
                f = "",
                g = "",
                b = "",
                w = 100 * (w = parseFloat(e.minimum_order)),
                v = "",
                y = t.note,
                _ = "",
                x = "",
                k = "",
                C = "",
                S = "",
                T = "",
                E = "",
                D = "",
                z = "",
                A = "",
                M = "",
                O = "",
                H = "",
                I = 0,
                P = "",
                L = "",
                B = "",
                $ = "",
                q = "",
                R = "",
                N = "",
                Y = "",
                X = "",
                V = "",
                G = "",
                j = 0,
                F = "",
                U = 0,
                W = 0,
                Z = t.total_price;
            a("li.btn__cart a[href*=cart]").html(
                '<span class="icon" aria-hidden="true">' +
                    t.item_count +
                    '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" width="22" height="27" viewBox="0 0 22 27" enable-background="new 0 0 22 27" xml:space="preserve"><path fill="#010101" d="M17.1 6.6V6.3C17.1 2.8 14.2 0 10.7 0S4.4 2.8 4.4 6.3v0.4H0V27h21.2V6.6H17.1zM6.3 6.3c0-2.4 2-4.3 4.4-4.3s4.4 2 4.4 4.3v0.4H6.3V6.3zM19 8.8v16H2.2V8.8"></path></svg></span><span class="text">' +
                    e.shopping_cart_text +
                    "</span>"
            ),
                a.each(t.items, function (t, i) {
                  var xyz = i.product_title === 'Organic Bedding Bundle' ? '<span class="hs-product-title">' + i.product_title +'</span>' : '<a href="' +i.url +'" class="hs-product-title">' + i.product_title +'</a>';
                  var nbv = i.product_title === 'Organic Bedding Bundle' ? '<img class="hs-cart-image" src="' + i.image + '" alt="' +i.product_title +'">' : '<a href="' +i.url +'"><img class="hs-cart-image" src="' +i.image +'" alt="' +i.product_title +'"></a>';
                    (I += 1),
                        "HSSLIDE_HIDDEN_PRODUCT" === i.product_type && o.push(i.id),
                        null == i.variant_title && (i.variant_title = ""),
                        null == i.image ? (i.image = "https://cdn.shopify.com/s/files/1/3067/1988/t/11/assets/hs-no-image.gif") : (i.image = i.image),
                        (M = ""),
                        (H = ""),
                        i.discounts &&
                            a.each(i.discounts, function (t, a) {
                                "" !== a.title && !(a.title.includes('tontine')) &&
                                    ((l = a.amount),
                                    (H = a.amount),
                                    (H = hsonslidecart.Currency.formatMoney(H, e.money_format)),
                                    (M = M.concat(
                                        '<span class="hs-discount-app-cart hs-desktop"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-saletag"><path d="M10 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0-3H7a1 1 0 0 0-.71.29l-6 6a1 1 0 0 0 0 1.42l4 4a1 1 0 0 0 1.42 0c.19-.2 5.8-5.81 6-6A1 1 0 0 0 12 5V2a2 2 0 0 0-2-2z" fill="#231F20"></path></svg> ' +
                                            a.title +
                                            "  (-" +
                                            H +
                                            ")</span>"
                                    )));
                            }),
                        i.compare_at_price &&
                            ("" === M
                                ? ((u = " hs-compare-active"),
                                  (h = parseInt(i.quantity) * i.compare_at_price),
                                  (j = h),
                                  (s += h),
                                  (h = '<span class="hs-compare-at-price">' + hsonslidecart.Currency.formatMoney(h, e.money_format) + "</span>"))
                                : ((h = ""), (p = parseInt(i.quantity) * l), (s += p)));
                    var c = "",
                        d = "",
                        m = "",
                        w = "",
                        v = "";
                    i.properties &&
                        ((C = ""),
                        a.each(i.properties, function (t, e) {
                            "string" == typeof t &&
                                "_" !== t.charAt(0) &&
                                (t.indexOf("uploader") > -1 && (e = '<div class="hs-content-image-properties"><img src="' + e + '" class="hs-uploader-image-properties" /></div>'),
                                "" !== e && (C = C.concat('<div class="hs-content-propertie"><span class="hs-propertie">' + t + ": </span>" + e + "</div>"))),
                                HsCartDrawer.isArray(e) && ("_father" == e[0] && (c = e[1]), "_random" == e[0] && (d = e[1]), "_variant_id_father" == e[0] && (m = e[1]), "_variant_id_child" == e[0] && (w = e[1]));
                        }),
                        (C = '<div class="hs-propertie-content">' + C + "</div>")),
                        0 == e.show_property && (C = ""),
                        (S = HsCartDrawer.vat(i.price, e, a)),
                        (T = i.discounted_price),
                        (E = HsCartDrawer.vat(i.line_price, e, a)),
                        (D = HsCartDrawer.vat(i.total_price, e, a)),
                        (L = ""),
                        (B = ""),
                        1 == e.show_total_per_variant &&
                            (i.total_discount > 0 &&
                                ((L = " hs-discount-price-line-through"),
                                (B = '<span class="hs-discount-price-total hs-variant-' + i.id + '-discount-price-total hs-desktop">' + hsonslidecart.Currency.formatMoney(T, e.money_format) + "</span>")),
                            (P = '<span class="hs-price-total hs-variant-' + i.id + "-price-total" + L + ' hs-desktop">' + hsonslidecart.Currency.formatMoney(S, e.money_format) + "</span>")),
                        1 == e.show_total_quantity_products &&
                            ("" !== P && ((b = '<span class="hs-quantity-original-price">x' + i.quantity + " </span>"), (g = " hs-mg-price")),
                            (N = '<span class="hs-original-price-total hs-variant-' + i.id + "-original-price-total hs-desktop" + g + u + '">' + b + hsonslidecart.Currency.formatMoney(E, e.money_format) + "</span>")),
                        c && 0 == c && (v = " hs-hidden-element"),
                        (U += parseFloat(E)),
                        (W += parseFloat(j)),
                        c
                            ? c && (0 == (c = parseInt(c)) ? ((W -= U), (F = '<div class="hs-increase-compare-at-price">You Saved ' + hsonslidecart.Currency.formatMoney(W, e.money_format) + "</div>"), (U = 0), (W = 0)) : (F = ""))
                            : ((U = 0), (W = 0), (F = "")),
                        (f = '<span class="hs-financing">Financing Options Available at Checkout</span><p class="affirm-as-low-as" data-page-type="cart" data-amount="' + r + '"></p>'),
                        (q = q.concat(
                            '<div class="hs-item-cart-content hs-product-' +
                                i.id +
                                '"><div class="hs-item-content-variants"><div class="hs-item-cart-image">'+nbv+'</div><div class="hs-item-cart-description"><div class="hs-item-close"><span class="hs-remove-item hs-relation-' +
                                i.id +
                                "-" +
                                d +
                                '" data-id="' +
                                i.id +
                                '" data-key="' +
                                i.key +
                                '" data-father="' +
                                c +
                                '" data-random="' +
                                d +
                                '" data-fathervariantid="' +
                                m +
                                '" data-childrenvariantid="' +
                                w +
                                '" data-line="' +
                                I +
                                '"><svg xmlns="http://www.w3.org/2000/svg" width="10px" height="10px" version="1.1" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve"> <g> <g> <path d="M300.188,246L484.14,62.04c5.06-5.064,7.852-11.82,7.86-19.024c0-7.208-2.792-13.972-7.86-19.028L468.02,7.872    c-5.068-5.076-11.824-7.856-19.036-7.856c-7.2,0-13.956,2.78-19.024,7.856L246.008,191.82L62.048,7.872    c-5.06-5.076-11.82-7.856-19.028-7.856c-7.2,0-13.96,2.78-19.02,7.856L7.872,23.988c-10.496,10.496-10.496,27.568,0,38.052    L191.828,246L7.872,429.952c-5.064,5.072-7.852,11.828-7.852,19.032c0,7.204,2.788,13.96,7.852,19.028l16.124,16.116    c5.06,5.072,11.824,7.856,19.02,7.856c7.208,0,13.968-2.784,19.028-7.856l183.96-183.952l183.952,183.952    c5.068,5.072,11.824,7.856,19.024,7.856h0.008c7.204,0,13.96-2.784,19.028-7.856l16.12-16.116    c5.06-5.064,7.852-11.824,7.852-19.028c0-7.204-2.792-13.96-7.852-19.028L300.188,246z"/> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></span></div>\t\t\t\t\t<div class="hs-content-product-and-variant-title">'+xyz+'<span class="hs-variant-title">' +
                                i.variant_title +
                                "</span>                      " +
                                C +
                                '\t\t\t\t    </div>                    <div class="hs-content-quantity-price">                      <span class="hs-price-total hs-variant-' +
                                i.id +
                                '-price-total hs-mobile">                          ' +
                                hsonslidecart.Currency.formatMoney(S, e.money_format) +
                                '                      </span>                      <div class="hs-item-cart-content-quantity' +
                                v +
                                '">                          <div class="hs-item-cart-qty hs-item-' +
                                i.id +
                                '">                              <div class="hs-cart-plus-minus" data-quantity="' +
                                i.quantity +
                                '" data-id="' +
                                i.id +
                                '" data-key="' +
                                i.key +
                                '" data-father="' +
                                c +
                                '" data-random="' +
                                d +
                                '" data-fathervariantid="' +
                                m +
                                '" data-childrenvariantid="' +
                                w +
                                '" data-line="' +
                                I +
                                '"></div>                          </div>                      </div>                      <div class="hs-cart-content-price">\t\t\t\t\t\t' +
                                P +
                                "\t\t\t\t\t\t" +
                                h +
                                "                        " +
                                B +
                                "                        " +
                                N +
                                "                        " +
                                M +
                                "                      " +
                                F +
                                "</div>\t\t\t\t\t</div>                  </div>\t\t\t\t</div>\t\t\t</div>"
                        )),
                        n.push({ id: i.id, price: HsCartDrawer.formatMoneyCurrency(i.line_price), quantity: i.quantity, currency: "USD" });
                }),
                (Z = (c = s) - Z),
                (Z = '<div class="hs-total-save">You Saved ' + hsonslidecart.Currency.formatMoney(Z, e.money_format) + "!</div>"),
                (c = hsonslidecart.Currency.formatMoney(c, e.money_format)),
                s > 0 && (d = '        \t<div class="hs-subtotaldiscount-cart">\t\t\t\t<span>Total</span>\t\t\t\t<span class="hs_subtotaldiscount_amount">' + c + "</span>            </div>"),
                null == y && (y = ""),
                (0 != e.status_text_cart && 0 != e.status_text_checkout) || (Y = " hs-button-100-w"),
                1 == e.status_text_cart && (R = '<a href="/cart" class="hs-cart-purchase' + Y + '">' + e.text_cart + "</a>"),
                1 == e.status_text_checkout && (X = '<div class="hs-content-checkout-button' + Y + '"><button name="checkout" type="submit" class="hs-checkout-purchase' + Y + '">' + e.text_checkout + "</button></div>"),
                w > 0 &&
                    m < w &&
                    ((w = hsonslidecart.Currency.formatMoney(w, e.money_format)),
                    (X = e.tex_minimum_order.replace("{{ money }}", w)),
                    (X = a(".hs-content-checkout-button").length > 0 ? '<div class="hs-min-money-cart">' + X + "</div>" : '<div class="hs-content-checkout-button' + Y + '"><div class="hs-min-money-cart">' + X + "</div></div>")),
                1 == e.show_discount &&
                    ((v = HsCartDrawer.readCookie("hscodediscount")),
                    (V =
                        '<div class="hs-add-discount"><div class="hs-success-code-discount"></div><label class="hs-discount-heading">' +
                        e.text_discount +
                        '</label><div class="hs-content-discount-add"><input type="text" class="hs-discount-code" placeholder="' +
                        e.text_discount_code +
                        '" value="' +
                        v +
                        '" name="hsdiscount" autocomplete="off"><button type="button" class="hs-apply-discount"><span class="hs-text--apply--discount">' +
                        e.text_apply +
                        '</span><span class="hs--loading"><i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw margin-bottom"></i></span></button></div><div class="hs-error-code-discount"></div></div>')),
                1 == e.show_note &&
                    (G =
                        '<div class="hs-cart-note"><label class="hs-note-heading">' +
                        e.text_note +
                        '</label><textarea class="hs-cart-ins" placeholder="' +
                        e.text_instructions +
                        '" name="note" autocomplete="off">' +
                        y +
                        "</textarea></div>"),
                1 == e.status_text_continue_shopping && ($ = '<a class="hs-continue-shopping hs-close" href="/collections/all">' + e.text_continue_shopping + "</a>"),
                parseInt(e.enable_slide_cart) &&
                    e.slide_cart_products &&
                    (HsCartDrawer.arr_free_shipping_products.length > 0 &&
                        a.each(HsCartDrawer.arr_free_shipping_products, function (t, i) {
                            if (void 0 !== i.error) return !1;
                            (A = ""),
                                a.each(i.variants, function (t, e) {
                                    A = A.concat(
                                        '<option value="' +
                                            e.id +
                                            '" title="' +
                                            e.title +
                                            '" data-id="' +
                                            i.id +
                                            '" data-price="' +
                                            e.price +
                                            '" data-sku="' +
                                            e.sku +
                                            '" data-available="' +
                                            e.available +
                                            '" data-barcode="' +
                                            e.barcode +
                                            '" data-featuredimage="' +
                                            i.featured_image +
                                            '" data-inventorymanagement="' +
                                            e.inventory_management +
                                            '" data-compareatprice="' +
                                            e.compare_at_price +
                                            '" data-variantid="' +
                                            e.id +
                                            '">' +
                                            e.title +
                                            "</option>"
                                    );
                                }),
                                (k = ""),
                                1 == i.variants.length && (k = " hs-hidden-element"),
                                (A = '<select class="hs-swipper-option-parent-' + i.id + " hs-swipper-select-option-add-to-cart" + k + '" data-id="' + i.id + '">' + A + "</select>");
                            var r = i.variants[0].price,
                                n = i.variants[0].compare_at_price;
                            n > r ? ((n = HsCartDrawer.vat(n, e, a)), (n = '<div class="hs-compare-price-sw">' + (n = hsonslidecart.Currency.formatMoney(n, e.money_format)) + "</div>")) : (n = ""),
                                (r = HsCartDrawer.vat(r, e, a)),
                                (r = '<div class="hs-price-sw">' + hsonslidecart.Currency.formatMoney(r, e.money_format) + "</div>"),
                                (O = O.concat(
                                    '<div class="swiper-slide"><div class="hs-content-product-slide-cart"><div class="hs-product-content-image-swipper"><a href="javascript:void(0);" class="hs-product-link-image"><img src="' +
                                        HsCartDrawer.resizeSrc(i.featured_image, "x65") +
                                        '" /></a></div><div class="hs-content-title-price-swiper"><div class="hs-title-swiper">' +
                                        i.title +
                                        '</div><div class="hs-content-price-swiper">' +
                                        n +
                                        r +
                                        '<div class="hs-price-per">(FREE)</div></div><div class="hs-variants-swipper' +
                                        k +
                                        '">' +
                                        A +
                                        '</div><div class="hs-upsell-add"><button type="button" class="hs-upsell-add-to-cart"><span class="hs-add--to--cart">' +
                                        e.text_add +
                                        '</span><span class="hs--loading"><i class="fa fa-circle-o-notch fa-spin fa-1x fa-fw margin-bottom"></i></span></button></div></div></div></div>'
                                ));
                        }),
                    (O = parseInt(e.upsell_mode)
                        ? '<div class="hs-container-stacked"><div class="hs-frequently-bought"><h2>' + e.upsell_title + '</h2></div><div class="hs-products-stacked">' + O + "</div></div>"
                        : '<div class="hs-today-bedding hs-hidden-by-sku"><h3>Independence Day Sale: FREE Organic Sheets!</h3></div><div class="hs-container-swp hs-hidden-by-sku"><div class="swiper-container"><div class="swiper-wrapper hs-swiper-content-free-shipping">' +
                          O +
                          '</div><div class="swiper-pagination"></div></div><div class="swiper-button-next"></div><div class="swiper-button-prev"></div><p class="hs-limit-mattress">* Limit: 1 Free Sheet Set per Mattress</p></div>')),
                (_ = (_ = e.time_remaining).replace("{{time_remaining}}", "<span id='hs_countdown_cart_plus'>" + e.how_many_minutes_cart_reservation + ":00</span>")),
                parseInt(e.enable_countdown_cart) && (x = '<div class="hs-countdown-cart">' + _ + "</div>"),
                (z =
                    '<div class="hs-terms-content"><input type="checkbox" id="hs_front_check_agreed"><span>' +
                    e.text_agreed +
                    ' <a href="' +
                    e.link_terms_and_conditions +
                    '" target="_blank">' +
                    e.text_terms_and_conditions +
                    "</a></span></div>"),
                parseInt(e.show_terms_and_conditions) || (z = ""),
                (i =
                    '<div class="hs-content-discounts-calculate-checkout"></div><div class="hs-sticky-cart">' +
                    q +
                    Z +
                    '</div><div class="hs-container-mg-top-up"></div><div class="hs-business-days"><p>Most mattresses ship within 5-7 business days<img alt="Business Days" src="https://cdn.shopify.com/s/files/1/0061/7195/1202/files/free_shipping.png"></p></div><div class="hs-business-label-checkout"><p>Delivery options available at checkout</p></div>' +
                    V +
                    O +
                    G +
                    '<div class="hs-dobly-content"><div class="doubly-message"></div></div><div class="hs-drawer-checkout"><div class="hs-content-sub-total-cart">' +
                    d +
                    '</div><div class="hs-drawer-content-checkout">\t\t<div class="hs-content-total-cart">          <div class="hs-sub-total-cart">              <span class="hs-sl-total">' +
                    e.text_subtotal +
                    '</span>             <span class="hs-sl-content-p-t"> <span class="terms-of-services--price"> <a target="_blank" href="/pages/terms-of-service/terms#:~:text=in%20such%20cases.-,4.%20Product%20Pricing%20Disclosure,-We%20are%20committed" > Pricing Details </a> </span><span class="hs_subtotal_amount_discount"></span>              <span class="hs_subtotal_amount">' +
                    hsonslidecart.Currency.formatMoney(D, e.money_format) +
                    '</span></span>              <input type="hidden" value="' +
                    D +
                    '" id="hs-total-price-global" />          </div>\t\t  <div class="hs-terms-and-conditions">' +
                    z +
                    '</div>        </div>        <div class="hs-finalize-purchase">        ' +
                    X +
                    R +
                    f +
                    $ +
                    '\t\t<div class="hs-trust-payment"><img src="https://cdn.shopify.com/s/files/1/1009/6916/t/2/assets/trust-payment.png"></div>        </div>        </div></div>'),
                0 == t.item_count
                    ? a(".hs-popup-cart-sp-load .hs-site-cart-popup").html('<div class="hs-empty-page-content hs-text-center"><div class="hs-content-empty-cart">' + HsCartDrawer.empty_cart + "<p>" + e.no_result_text + "</p></div></div>")
                    : a(".hs-popup-cart-sp-load .hs-site-cart-popup").html(
                          '<form action="/cart" method="post" novalidate class="sn-cart"><div class="hs-close-popup-cart"><span class="hs-shopping-cart-icon"><i class="fa ' +
                              e.stickycart_icon +
                              '" aria-hidden="true"></i></span><h1>' +
                              e.shopping_cart_text +
                              '</h1><span class="hs-close"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 329.26933 329" width="15px" height="15px"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/></svg></span></div><div class="hs-content-count-products-clear-all"></div>' +
                              x +
                              '<div class="hs-banner-best-bedding"><img src="https://cdn.shopify.com/s/files/1/0061/7195/1202/t/55/assets/banner-560px.png"></div><div class="hs-announcement-module"></div>' +
                              i +
                              "</form>"
                      );
            try {
                0 == a(".hs-finalize-purchase .affirm-ala-price").length && affirm.ui.refresh();
            } catch (e) {}
            try {
              void 0 !== window.HSSLIDECART &&
                    void 0 !== window.HSSLIDECART.variantsUpsell &&
                    void 0 !== window.HSSLIDECART.variantsUpsell.json &&
                      upsellAdditional(t, window.HSSLIDECART.variantsUpsell.json, HsCartDrawer.json, a);
              
            } catch (error) {
              console.log(error)
            }
        },
        startTimer: function (t, e, a, i) {
            var r,
                n,
                s = t,
                o = 1;
            setInterval(function () {
                (e = i("#hs_countdown_cart_plus")),
                    (o = e.length),
                    (r = parseInt(s / 60, 10)),
                    (n = parseInt(s % 60, 10)),
                    (r = r < 10 ? "0" + r : r),
                    (n = n < 10 ? "0" + n : n),
                    e.html(r + ":" + n),
                    0 == o && (s = -1),
                    --s < 0 && (-1 == s && parseInt(a.countdown_expires_clear_cart) && HsCartDrawer.ajaxClearAll(a, i), (s = t), i(".hs-countdown-cart").html(a.countdown_expires));
            }, 1e3);
        },
        iniTimer: function (t, e) {
            var a = (a = 60 * parseInt(t.how_many_minutes_cart_reservation)) - 1,
                i = e("#hs_countdown_cart_plus");
            HsCartDrawer.startTimer(a, i, t, e);
        },
        isArray: function (t) {
            return "[object Array]" === toString.call(t);
        },
        cart2: function (t, e, a) {
            var i = [],
                r = 0,
                n = (JSON.stringify(t), []),
                s = 0,
                o = 0,
                l = "",
                c = "",
                d = "",
                p = "",
                h = parseFloat(t.total_price),
                u = "",
                m = "",
                f = 100 * (f = parseFloat(e.minimum_order)),
                g = "",
                b = t.note,
                w = "",
                v = "",
                y = "",
                _ = "",
                x = "",
                k = 0,
                C = "",
                S = "",
                T = "",
                E = "",
                D = "",
                z = "",
                A = "",
                M = 0,
                O = "",
                H = 0,
                I = 0,
                P = t.total_price;
            a("li.btn__cart a[href*=cart]").html(
                '<span class="icon" aria-hidden="true">' +
                    t.item_count +
                    '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0" y="0" width="22" height="27" viewBox="0 0 22 27" enable-background="new 0 0 22 27" xml:space="preserve"><path fill="#010101" d="M17.1 6.6V6.3C17.1 2.8 14.2 0 10.7 0S4.4 2.8 4.4 6.3v0.4H0V27h21.2V6.6H17.1zM6.3 6.3c0-2.4 2-4.3 4.4-4.3s4.4 2 4.4 4.3v0.4H6.3V6.3zM19 8.8v16H2.2V8.8"></path></svg></span><span class="text">' +
                    e.shopping_cart_text +
                    "</span>"
            ),
                a.each(t.items, function (t, o) {
                    (k += 1),
                        null == o.variant_title && (o.variant_title = ""),
                        "HSSLIDE_HIDDEN_PRODUCT" === o.product_type && n.push(o.id),
                        null == o.image ? (o.image = "https://cdn.shopify.com/s/files/1/3067/1988/t/11/assets/hs-no-image.gif") : (o.image = o.image),
                        (g = ""),
                        (x = ""),
                        o.discounts &&
                            a.each(o.discounts, function (t, a) {
                                "" !== a.title && !(a.title.includes('tontine')) &&
                                    ((s = a.amount),
                                    (x = a.amount),
                                    (x = hsonslidecart.Currency.formatMoney(x, e.money_format)),
                                    (g = g.concat(
                                        '<span class="hs-discount-app-cart hs-desktop"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-saletag"><path d="M10 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0-3H7a1 1 0 0 0-.71.29l-6 6a1 1 0 0 0 0 1.42l4 4a1 1 0 0 0 1.42 0c.19-.2 5.8-5.81 6-6A1 1 0 0 0 12 5V2a2 2 0 0 0-2-2z" fill="#231F20"></path></svg> ' +
                                            a.title +
                                            "  (-" +
                                            x +
                                            ")</span>"
                                    )));
                            }),
                        o.compare_at_price &&
                            ("" === g
                                ? ((p = " hs-compare-active"),
                                  (d = parseInt(o.quantity) * o.compare_at_price),
                                  (M = d),
                                  (r += d),
                                  (d = '<span class="hs-compare-at-price">' + hsonslidecart.Currency.formatMoney(d, e.money_format) + "</span>"))
                                : ((d = ""), (c = parseInt(o.quantity) * s), (r += c))),
                        (v = HsCartDrawer.vat(o.price, e, a)),
                        (y = o.discounted_price),
                        (_ = HsCartDrawer.vat(o.line_price, e, a)),
                        HsCartDrawer.vat(o.total_price, e, a),
                        (S = ""),
                        (T = ""),
                        1 == e.show_total_per_variant &&
                            (o.total_discount > 0 &&
                                ((S = " hs-discount-price-line-through"),
                                (T = '<span class="hs-discount-price-total hs-variant-' + o.id + '-discount-price-total hs-desktop">' + hsonslidecart.Currency.formatMoney(y, e.money_format) + "</span>")),
                            (C = '<span class="hs-price-total hs-variant-' + o.id + "-price-total" + S + ' hs-desktop"> ' + hsonslidecart.Currency.formatMoney(v, e.money_format) + "</span>"));
                    var l = "",
                        h = "",
                        f = "",
                        z = "",
                        A = "";
                    o.properties &&
                        ((w = ""),
                        a.each(o.properties, function (t, e) {
                            "string" == typeof t &&
                                "_" !== t.charAt(0) &&
                                (t.indexOf("uploader") > -1 && (e = '<div class="hs-content-image-properties"><img src="' + e + '" class="hs-uploader-image-properties" /></div>'),
                                "" !== e && (w = w.concat('<div class="hs-content-propertie"><span class="hs-propertie">' + t + ": </span>" + e + "</div>"))),
                                HsCartDrawer.isArray(e) && ("_father" == e[0] && (l = e[1]), "_random" == e[0] && (h = e[1]), "_variant_id_father" == e[0] && (f = e[1]), "_variant_id_child" == e[0] && (z = e[1]));
                        }),
                        (w = '<div class="hs-propertie-content">' + w + "</div>")),
                        0 == e.show_property && (w = ""),
                        1 == e.show_total_quantity_products &&
                            ("" !== C && ((m = '<span class="hs-quantity-original-price">x' + o.quantity + " </span>"), (u = " hs-mg-price")),
                            (D = '<span class="hs-original-price-total hs-variant-' + o.id + "-original-price-total hs-desktop" + u + p + '">' + m + hsonslidecart.Currency.formatMoney(_, e.money_format) + "</span>")),
                        null == b && (b = ""),
                        l && 0 == l && (A = " hs-hidden-element"),
                        (H += parseFloat(_)),
                        (I += parseFloat(M)),
                        l
                            ? l && (0 == (l = parseInt(l)) ? ((I -= H), (O = '<div class="hs-increase-compare-at-price">You Saved ' + hsonslidecart.Currency.formatMoney(I, e.money_format) + "</div>"), (H = 0), (I = 0)) : (O = ""))
                            : ((H = 0), (I = 0), (O = "")),
                        (E = E.concat(
                            '<div class="hs-item-cart-content hs-product-' +
                                o.id +
                                '">\t\t\t\t<div class="hs-item-content-variants">\t\t\t\t<div class="hs-item-cart-image">\t\t\t\t\t<a href="' +
                                o.url +
                                '"><img class="hs-cart-image" src="' +
                                o.image +
                                '" alt="' +
                                o.product_title +
                                '"></a>\t\t\t\t</div>\t\t\t\t<div class="hs-item-cart-description">\t\t\t\t\t<div class="hs-item-close"><a href="javascript:void(0);" class="hs-remove-item hs-relation-' +
                                o.id +
                                "-" +
                                h +
                                '" data-id="' +
                                o.id +
                                '" data-key="' +
                                o.key +
                                '" data-father="' +
                                l +
                                '" data-random="' +
                                h +
                                '" data-fathervariantid="' +
                                f +
                                '" data-childrenvariantid="' +
                                z +
                                '" data-line="' +
                                k +
                                '"><svg xmlns="http://www.w3.org/2000/svg" width="10px" height="10px" version="1.1" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve"> <g> <g> <path d="M300.188,246L484.14,62.04c5.06-5.064,7.852-11.82,7.86-19.024c0-7.208-2.792-13.972-7.86-19.028L468.02,7.872    c-5.068-5.076-11.824-7.856-19.036-7.856c-7.2,0-13.956,2.78-19.024,7.856L246.008,191.82L62.048,7.872    c-5.06-5.076-11.82-7.856-19.028-7.856c-7.2,0-13.96,2.78-19.02,7.856L7.872,23.988c-10.496,10.496-10.496,27.568,0,38.052    L191.828,246L7.872,429.952c-5.064,5.072-7.852,11.828-7.852,19.032c0,7.204,2.788,13.96,7.852,19.028l16.124,16.116    c5.06,5.072,11.824,7.856,19.02,7.856c7.208,0,13.968-2.784,19.028-7.856l183.96-183.952l183.952,183.952    c5.068,5.072,11.824,7.856,19.024,7.856h0.008c7.204,0,13.96-2.784,19.028-7.856l16.12-16.116    c5.06-5.064,7.852-11.824,7.852-19.028c0-7.204-2.792-13.96-7.852-19.028L300.188,246z"/> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></a></div>\t\t\t\t\t<div class="hs-content-product-and-variant-title">                      <a href="' +
                                o.url +
                                '" class="hs-product-title">                          ' +
                                o.product_title +
                                '                      </a>                      <span class="hs-variant-title">' +
                                o.variant_title +
                                "</span>                      " +
                                w +
                                '\t\t\t\t    </div>                    <div class="hs-content-quantity-price">                      <span class="hs-price-total hs-variant-' +
                                o.id +
                                '-price-total hs-mobile">                          ' +
                                hsonslidecart.Currency.formatMoney(v, e.money_format) +
                                '                      </span>                      <div class="hs-item-cart-content-quantity' +
                                A +
                                '">                          <div class="hs-item-cart-qty hs-item-' +
                                o.id +
                                '">                              <div class="hs-cart-plus-minus" data-quantity="' +
                                o.quantity +
                                '" data-id="' +
                                o.id +
                                '" data-key="' +
                                o.key +
                                '" data-father="' +
                                l +
                                '" data-random="' +
                                h +
                                '" data-fathervariantid="' +
                                f +
                                '" data-childrenvariantid="' +
                                z +
                                '" data-line="' +
                                k +
                                '"></div>                          </div>                      </div>                      <div class="hs-cart-content-price">\t\t\t\t\t\t' +
                                C +
                                "\t\t\t\t\t\t" +
                                d +
                                "                        " +
                                T +
                                "                        " +
                                D +
                                "                        " +
                                g +
                                "                      " +
                                O +
                                "</div>\t\t\t\t\t</div>                  </div>\t\t\t\t</div>\t\t\t</div>"
                        )),
                        i.push({ id: o.id, price: HsCartDrawer.formatMoneyCurrency(o.line_price), quantity: o.quantity, currency: "USD" });
                }),
                HsCartDrawer.liveConnect(i, e, a),
                (P = (o = r) - P),
                (P = '<div class="hs-total-save">You Saved ' + hsonslidecart.Currency.formatMoney(P, e.money_format) + "!</div>"),
                (o = hsonslidecart.Currency.formatMoney(o, e.money_format)),
                r > 0 && (l = '        \t<div class="hs-subtotaldiscount-cart">\t\t\t\t<span>Total</span>\t\t\t\t<span class="hs_subtotaldiscount_amount">' + o + "</span>            </div>"),
                (0 != e.status_text_cart && 0 != e.status_text_checkout) || (z = " hs-button-100-w"),
                1 == e.status_text_cart && e.text_cart,
                1 == e.status_text_checkout && (A = '<button name="checkout" type="submit" class="hs-checkout-purchase' + z + '">' + e.text_checkout + "</button>"),
                f > 0 &&
                    h < f &&
                    ((f = hsonslidecart.Currency.formatMoney(f, e.money_format)),
                    (A = e.tex_minimum_order.replace("{{ money }}", f)),
                    (A = a(".hs-content-checkout-button").length > 0 ? '<div class="hs-min-money-cart">' + A + "</div>" : '<div class="hs-content-checkout-button' + z + '"><div class="hs-min-money-cart">' + A + "</div></div>")),
                1 == e.show_discount && e.text_discount,
                1 == e.show_note && e.text_instructions,
                1 == e.status_text_continue_shopping && e.text_continue_shopping,
                a(".hs-content-checkout-button").html(A),
                a(".hs-content-sub-total-cart").html(l),
                0 == t.item_count
                    ? a(".hs-popup-cart-sp-load .hs-site-cart-popup").html('<div class="hs-empty-page-content hs-text-center"><div class="hs-content-empty-cart">' + HsCartDrawer.empty_cart + "<p>" + e.no_result_text + "</p></div></div>")
                    : a(".hs-sticky-cart").html(E + P);
        },
        removeAllBonus: function (arr_hidden_variants, data, $) {
            var quantity = 0,
                json_value = "",
                text = "";
            arr_hidden_variants.length > 0 &&
                ($.each(arr_hidden_variants, function (t, e) {
                    text = text.concat('"' + e + '":"' + quantity + '",');
                }),
                (json_value = "({ updates: {" + text + "} })"),
                (json_value = JSON.stringify(eval(json_value))),
                $.ajax({
                    type: "POST",
                    url: "/cart/update.js",
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    async: !0,
                    data: json_value,
                    success: function (t) {
                        HsCartDrawer.getCart2(1, 0, data, $);
                    },
                    error: function (t, e, a) {},
                    complete: function (t) {},
                }));
        },
        resizeSrc: function (t, e) {
            try {
                if ("original" == e) return t;
                var a = t.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
                return a[1] + "_" + e + "." + a[2];
            } catch (e) {
                return t;
            }
        },
        showCartPopup: function (t, e) {
            1 != t.style && HsCartDrawer.openCart(t, e), e(".hs-load-popup-cart-show-products").show(), e(".hs-popup-cart-sp-load").addClass("active");
        },
        hideCartPopup: function (t, e) {
            e(".hs-open-cart").unbind("click"),
                e(".hs-open-cart").click(function (a) {
                    HsCartDrawer.closeCart(t, e),
                        e(".hs-popup-cart-sp-load").removeClass("active"),
                        e(".hs-load-popup-cart-show-products").hide(),
                        e(".hs-popup-cart-sp-load.hs-desktop-content-cart").hasClass("active") || e(".hs-message-notify-popup-cart").hide(),
                        e(HsCartDrawer.openSlideCart).removeClass("hs-open-cart-url"),
                        e(HsCartDrawer.openSlideCart).removeClass("hs-open-cart-url-2");
                }),
                e(".hs-close").unbind("click"),
                e(".hs-close").click(function (a) {
                    a.preventDefault(),
                        HsCartDrawer.closeCart(t, e),
                        e(".hs-popup-cart-sp-load").removeClass("active"),
                        e(".hs-load-popup-cart-show-products").hide(),
                        e(HsCartDrawer.openSlideCart).removeClass("hs-open-cart-url"),
                        e(HsCartDrawer.openSlideCart).removeClass("hs-open-cart-url-2");
                }),
                e(".hs-load-popup-cart-show-products").unbind("click"),
                e(".hs-load-popup-cart-show-products").click(function (a) {
                    a.preventDefault(),
                        HsCartDrawer.closeCart(t, e),
                        e(".hs-popup-cart-sp-load").removeClass("active"),
                        e(this).hide(),
                        e(HsCartDrawer.openSlideCart).removeClass("hs-open-cart-url"),
                        e(HsCartDrawer.openSlideCart).removeClass("hs-open-cart-url-2");
                }),
                e(".hs-message-notify-popup-cart .hs-remove-notify").unbind("click"),
                e(".hs-message-notify-popup-cart .hs-remove-notify").click(function (a) {
                    a.preventDefault(),
                        e(".hs-message-notify-popup-cart").hide(),
                        e(".hs-popup-cart-sp-load.hs-desktop-content-cart").hasClass("active") || HsCartDrawer.closeCart(t, e),
                        e(HsCartDrawer.openSlideCart).removeClass("hs-open-cart-url"),
                        e(HsCartDrawer.openSlideCart).removeClass("hs-open-cart-url-2");
                }),
                e(".hs-popup-cart-sp-load,.hs-message-notify-popup-cart").unbind("click"),
                e(".hs-popup-cart-sp-load,.hs-message-notify-popup-cart").click(function (t) {
                    t.stopPropagation();
                }),
                e(".hs-checkout-purchase").unbind("click"),
                e(".hs-checkout-purchase").click(function (a) {
                    a.stopImmediatePropagation(), a.preventDefault();
                    var i = e(this),
                        r = e("#hs_front_check_agreed"),
                        n = e("input.hs-discount-code"),
                        s = e("input.hs-cart-ins"),
                        o = n.val(),
                        l = s.val();
                    if ((0 == n.length && (o = ""), r.length > 0 && !r.is(":checked"))) return alert(t.text_message_terms_and_conditions), !1;
                    HsCartDrawer.UpdateAjaxCart(1, o, l, t, e, i);
                }),
                e(".hs-cart-purchase").unbind("click"),
                e(".hs-cart-purchase").click(function (a) {
                    a.stopImmediatePropagation(), a.preventDefault();
                    var i = e(this),
                        r = (e("input.hs-discount-code"), e("input.hs-cart-ins")),
                        n = r.val();
                    return 0 == r.length ? ((window.location.href = "/cart"), !1) : "" === n ? ((window.location.href = "/cart"), !1) : void HsCartDrawer.UpdateAjaxCart(0, null, n, t, e, i);
                });
        },
        UpdateAjaxCart: function (t, e, a, i, r, n) {
            r.ajax({
                type: "POST",
                url: "/cart/update.js",
                dataType: "json",
                async: !0,
                data: { note: a },
                success: function (a) {
                    var i = JSON.stringify(a);
                    if ((void 0 !== window.BOLD && void 0 !== window.BOLD.common && void 0 !== window.BOLD.common.cartDoctor && ((a = window.BOLD.common.cartDoctor.fix(a)), r("#hs-checkout-bold").trigger("click")), a))
                        if (0 == t) window.location.href = "/cart";
                        else if (i.indexOf("shipping_interval_frequency") > -1) {
                            do {
                                var n = (document.cookie.match("(^|; )cart=([^;]*)") || 0)[2];
                            } while (null == n);
                            var s = HsCartDrawer.shopifyUrl,
                                o = "";
                            r("#hs_subscriptions_customer_id").length > 0 && (o = "&customer_id=" + r("#hs_subscriptions_customer_id").val() + "&customer_email=" + r("#hs_subscriptions_customer_email").val());
                            try {
                                var l = ga.getAll()[0].get("linkerParam");
                            } catch (t) {
                                l = "";
                            }
                            var c = "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=" + s + "&cart_token=" + n + "&" + l + o + "&discount=" + e;
                            window.location.href = c;
                        } else "" !== e && (e = "?discount=" + e), (window.location.href = "/checkout" + e);
                },
                error: function (t, e, a) {},
                complete: function (t) {},
            });
        },
        contentPopup: function (t, e) {
            if (1 == t.enable_app) {
                var a = e(".hs-popup-cart-sp-load"),
                    i = "",
                    r = "",
                    n = window.location.href,
                    s = parseInt(t.style),
                    o = "",
                    l = "",
                    c = 1;
                if (a.length > 0) return !1;
                if (
                    (0 == s && ((o = " hs-cart-drawer-0"), (l = ' id="hs-cart-drawer-by-shopify-0"')),
                    1 == s && ((o = " hs-cart-drawer-1"), (l = ' id="hs-cart-drawer-by-shopify-1"')),
                    2 == s && ((o = " hs-cart-drawer-2"), (l = ' id="hs-cart-drawer-by-shopify-2"')),
                    n.indexOf("/cart") > -1 && 1 == t.stickycart_hide_cart_page && (c = 0),
                    1 == t.stickycart_hide_if_empty && (r = " hs-hidden-count-cart"),
                    1 == t.animatedHover && (i = " animated bounceIn"),
                    c > 0)
                ) {
                    if (
                        (1 == t.status_widget &&
                            e("body").append(
                                '<div class="hs-sticky-cart-cart-drawer' +
                                    i +
                                    r +
                                    '"><a href="/cart"><span class="hs-sticky-cart-cart-drawer-content" style="background-color:' +
                                    t.background_cart_widget +
                                    ";color:" +
                                    t.color_cart_widget +
                                    ';"><mark style="background-color:' +
                                    t.background_count_widget +
                                    ";color:" +
                                    t.color_count_widget +
                                    ';">0</mark><svg style="width: 22.5px;" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="shopping-cart" class="svg-inline--fa fa-shopping-cart fa-w-18" role="img" viewBox="0 0 576 512"><path fill="currentColor" d="M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"/></svg></span></a></div>'
                            ),
                        !parseInt(t.status))
                    )
                        return HsCartDrawer.getCart(0, [], t, e), !1;
                        var upsell_popup = `<div id="hs-popup-upsell-overlay" class="hs-upsell-popup-overlay" style="display: none; position: fixed; top: 0px; left: 0px; width: 100%; height: 100%; overflow-y: auto; z-index:8888888889; opacity: 0; background: rgba(15, 21, 33, 0.89);">
                                <div class="hs-upsell-popup-overlay-box" style="position: absolute; margin: 4% auto; cursor: initial; z-index: 8888888889; left: 0px; right: 0px; max-width: 1000px;">
                                    <div class="hs-upsell-popup-container">
                                        <div class="hs-upsell-popup-content-box">
                                            <div class="hs-upsell-popup-content">
                                                <div class="hs-upsell-popup-heading">
                                                    <h4>BONUS OFFER</h4>
                                                </div>
                                                <div class="hs-upsell-popup-title">
                                                    <h1>Recommended item for your cart</h1>
                                                </div>
                                                <div class="hs-upsell-popup-subheading">
                                                    <p>You might also like... </p>
                                                </div>
                                                <div class="hs-upsell-popup-section-items-layout">
                                                    <div class="hs-upsell-popup-section-items">
                                                    </div>
                                                    <div class="hs-upsell-popup-section-button">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="hs-upsell-popup-close">
                                            <svg class="hs-close-popup-upsell" fill="#676f84" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z"></path></svg>
                                        </div>
                                    </div>
                                </div>
                    </div>`
                    //e("body").append('<div class="hs-popup-cart-sp-load' + o + '"' + l + '><div class="hs-site-cart-popup"></div></div><div class="hs-message-notify-popup-cart" style="display: none;"></div>'),
                    e("body").append(`<div class="hs-popup-cart-sp-load ${o} " ${l}><div class="hs-site-cart-popup"></div></div><div class="hs-message-notify-popup-cart" style="display: none;"></div>${upsell_popup}`),
                        0 == t.enable_event &&
                            (e(HsCartDrawer.openSlideCart).unbind("click"),
                            e(HsCartDrawer.openSlideCart).click(function (a) {
                                a.stopImmediatePropagation(), a.stopPropagation(), a.preventDefault(), HsCartDrawer.openCartDrawerClick(e(this), t, e);
                            }),
                            HsCartDrawer.getCart(0, [], t, e));
                }
            }
        },
        redirectCart: function (t, e) {
            window.location.href = "/cart";
        },
        openCartDrawerClick: function (t, e, a) {

            // Extend - dispatch event on cart open
            setTimeout(function() {
                window.dispatchEvent(new Event('refreshAjaxSideCart'))
            },1000)
            // Extend – end code

            var i = e.stickycart_takes_user_to,
                r = t.hasClass("hs-open-cart-url");
            return 2 == i
                ? ((window.location.href = "/cart"), !1)
                : 3 == i
                ? ((window.location.href = "/checkout"), !1)
                : (r || (r = t.hasClass("hs-open-cart-url-2")),
                  a(HsCartDrawer.openSlideCart).removeClass("hs-open-cart-url"),
                  a(HsCartDrawer.openSlideCart).removeClass("hs-open-cart-url-2"),
                  r
                      ? (HsCartDrawer.closeCart(e, a), a(".hs-popup-cart-sp-load").removeClass("active"), a(".hs-popup-cart-sp-load").removeClass("active"), a(".hs-load-popup-cart-show-products").hide(), HsCartDrawer.hideCartPopup(e, a))
                      : (t.addClass("hs-open-cart-url"), HsCartDrawer.positionPopup(e, a), HsCartDrawer.showCartPopup(e, a)),
                  HsCartDrawer.notifyShow(e, a),
                  void HsCartDrawer.hideCartPopup(e, a));
        },
        openCartDrawer: function (t, e) {
            setTimeout(function() {
                window.dispatchEvent(new Event('refreshAjaxSideCart'))
            },1000)
            HsCartDrawer.showCartPopup(t, e), HsCartDrawer.getCart(0, [], t, e);
        },
        positionPopup: function (t, e) {
            if (0 == parseInt(t.style)) return !1;
            if (2 == parseInt(t.style)) return !1;
            var a = e('.hs-sticky-cart-cart-drawer a[href="/cart"].hs-open-cart-url');
            0 == a.length && (a = e('header a[href="/cart"],.cart-wrap')).length > 1 && (a = a.eq(1)), 0 == a.length && (a = e("header .Header__Icon"));
            var i = e(window).scrollTop(),
                r = 460,
                n = e("body").width(),
                s = a.offset(),
                o = a.outerHeight(),
                l = a.outerWidth();
            l > r && (r = l);
            var c = s.top + o,
                d = s.left + l,
                p = s.left,
                h = s.left + 460 - n;
            (p -= h = h > 0 ? s.left + r - d : 0),
                (p *= 1),
                (c *= 1),
                n < (r *= 1) && ((p = 10), (r = 1 * (n - 20))),
                (c -= i),
                e(".hs-popup-cart-sp-load").css("left", p + "px"),
                e(".hs-popup-cart-sp-load").css("top", c + "px"),
                e(window).scroll(function () {
                    var t = e('.hs-sticky-cart-cart-drawer a[href="/cart"].hs-open-cart-url');
                    0 == t.length && (t = e('header a[href="/cart"],.cart-wrap')).length > 1 && (t = t.eq(1)), 0 == t.length && (t = e("header .Header__Icon"));
                    var a = e(window).scrollTop(),
                        i = 460,
                        r = e("body").width(),
                        n = t.offset(),
                        s = t.outerHeight(),
                        o = t.outerWidth();
                    o > i && (i = o);
                    var l = n.top + s,
                        c = n.left + o,
                        d = n.left,
                        p = n.left + 460 - r;
                    (d -= p = p > 0 ? n.left + i - c : 0), (d *= 1), (l *= 1), r < (i *= 1) && ((d = 10), (i = 1 * (r - 20))), (l -= a), e(".hs-popup-cart-sp-load").css("left", d + "px"), e(".hs-popup-cart-sp-load").css("top", l + "px");
                });
        },
        notify: function (t, e, a) {
            HsCartDrawer.notifyShow(e, a),
                a(".hs-message-notify-popup-cart").html(
                    "<p>" +
                        t +
                        '</p><a href="javascript:void(0);" class="hs-remove-notify"><svg width="12px" xmlns="http://www.w3.org/2000/svg" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 500 500" enable-background="new 0 0 500 500" xml:space="preserve"> <g> <rect x="230.626" y="-48.852" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -103.7603 250.4999)" stroke-width="1.2421" stroke-miterlimit="10" width="39.749" height="598.703"></rect> <rect x="230.626" y="-48.852" transform="matrix(-0.7071 -0.7071 0.7071 -0.7071 250.5026 604.7603)" stroke-width="1.2421" stroke-miterlimit="10" width="39.748" height="598.703"></rect></g></svg></a>'
                );
        },
        notifyShow: function (t, e) {
            e(".hs-load-notify-show").show();
        },
        notifyHide: function (t, e) {
            e(".hs-load-notify-show").hide();
        },
        addToCart: function (data, $) {
            if (1 == data.enable_event) return !1;
            (HsCartDrawer.params = []),
                $(
                    'button[type="submit"][name="add"],input[type="submit"][name="add"],form[action="/cart/add"] input[type="submit"],.product-form-submit-wrap input.button,#AddToCart,button.ProductForm__AddToCart,form[action="/cart/add"] button[type="submit"]'
                ).unbind("click"),
                $(
                    'button[type="submit"][name="add"],input[type="submit"][name="add"],form[action="/cart/add"] input[type="submit"],.product-form-submit-wrap input.button,#AddToCart,button.ProductForm__AddToCart,form[action="/cart/add"] button[type="submit"]'
                ).on('click',function (e,qt) {

                    e.preventDefault();

                    let where = $(this);
                    void 0 !== window.HSSLIDECART &&
                    void 0 !== window.HSSLIDECART.variantsUpsell &&
                    void 0 !== window.HSSLIDECART.variantsUpsell.json ?
                      thisAdd(where,qt,'')//!$('.hs-upsell-popup-content-box').hasClass( "hs-open-popup-upsell" ) ? upsellVariants(where) : thisAdd(where,qt,'')
                     :
                     thisAdd(where,qt,'');
                    
                    function upsellVariants(where,qt){
                      var element = where.closest("form").find('select[name="id"]'),
                      variantchildren = "",
                      variantHandle = "",
                      variantid = element.val();
                      var thisObject = window.HSSLIDECART.variantsUpsell.json.filter(producto => producto.variant_id_father === variantid);
                      if(thisObject.length > 0){
                        const combined_elements = [];
                        thisObject.forEach(function(obj){
                          var thisFilter = combined_elements.filter(producto => producto.variant_handle_child === obj.variant_handle_child);
                          if(thisFilter.length <= 0){
                            combined_elements.push(obj)
                          }else{
                            const index = combined_elements.findIndex(elemento => elemento.variant_handle_child === obj.variant_handle_child);
                            combined_elements[index].variant_id_child = [combined_elements[index].variant_id_child,obj.variant_id_child];
                          }
                        });
                        if(combined_elements.length > 0){
                            $('.hs-upsell-popup-close').on('click',function (e) {
                                $('#hs-popup-upsell-overlay').css("display", "none");
                                $('#hs-popup-upsell-overlay').css("opacity", "0");
                                $('.hs-upsell-popup-content-box').addClass( "hs-open-popup-upsell" );
                                thisAdd(where,qt,'');
                            })
                            var count = 0,count_errors = 0,items_per_view=0,content_items='',image_item='',arr_prods_var_popup_upsell=[];
                            combined_elements.forEach(function(element){
                                $.getJSON(window.Shopify.routes.root + `products/${element.variant_handle_child}.js`, function (product) {
                                    if (product) {
                                        var image_item = product.featured_image;
                                        var selected_variants = combined_elements.filter(thisElement => thisElement.variant_handle_child === product.handle);
                                        var select_options = '';
                                        if (product.variants.length > 0) {
                                            arr_prods_var_popup_upsell = [...arr_prods_var_popup_upsell, ...product.variants];
                                            product.variants.forEach(function (n) {
                                                if (selected_variants.length > 0) {
                                                    if (selected_variants[0].variant_id_child.toString().indexOf(n.id) > -1) {
                                                        select_options += '<option value="' + n.id + '">' + n.title + '</option>';
                                                    }
                                                } else {
                                                    select_options += '<option value="' + n.id + '">' + n.title + '</option>';
                                                };
                                            });
                                        };
                                        if (image_item === null) {
                                            image_item = 'https://cdn.shopify.com/s/files/1/3067/1988/t/11/assets/hs-no-image.gif';
                                        };
                                        content_items += `
                                    <div class="hs-upsell-popup-item">
                                        <div class="hs-upsell-popup-item-inner">
                                            <div class="hs-upsell-popup-item-product">
                                                <div class="hs-upsell-popup-item-product-image">
                                                    <img src="${image_item}" loading="lazy">
                                                </div>
                                                <div class="hs-upsell-popup-item-product-info">
                                                    <div class="hs-upsell-popup-item-product-title">
                                                        <p>${product.title}</p>
                                                    </div>
                                                    <div class="hs-upsell-popup-item-product-prices">

                                                    </div>
                                                    <div class="hs-upsell-popup-item-product-outer">
                                                        <div class="hs-upsell-popup-item-product-variants">
                                                            <select class="hs-upsell-popup-item-product-variants-opt">${select_options}</select>
                                                        </div>
                                                        <div class="hs-upsell-popup-item-product-button">
                                                            <div class="hs-upsell-popup-item-button hs-upsell-popup-button"><p>Add To Cart</p></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                   `;
                                    };
                                }).done(function () {
                                }).fail(function () {
                                    count_errors++;
                                    console.log("error");
                                }).always(function () {
                                    count++;
                                    if(count == combined_elements.length){
                                        if (content_items !== '') {
                                            $('.hs-upsell-popup-section-items').html(content_items);
                                            $('.hs-upsell-popup-section-button').html(`<div class="hs-upsellpopup-add-all hs-upsell-popup-button"><p>Add All To Cart</p></div>`);

                                            $('.hs-upsell-popup-item-product-variants-opt').on('change', function (e) {
                                                var thisParentInfo = $(this).closest('.hs-upsell-popup-item-product-info');
                                                var thisParent = thisParentInfo.closest('.hs-upsell-popup-item-product');
                                                var item_selected = arr_prods_var_popup_upsell.filter(variant => variant.id + "" === $(this).children("option:selected").val())[0]
                                                var compare_price = item_selected.compare_at_price > item_selected.price ? hsonslidecart.Currency.formatMoney(item_selected.compare_at_price, data.money_format) : '';
                                                var price = hsonslidecart.Currency.formatMoney(item_selected.price, data.money_format);
                                                thisParentInfo.find(".hs-upsell-popup-item-product-title").html(`<p>${item_selected.name}</p>`);
                                                thisParentInfo.find(".hs-upsell-popup-item-product-prices").html(`<p><strike><span class="hs-upsell-popup-item-compare-price">${compare_price}</span></strike><span class="hs-upsell-popup-item-price">${price}</span></p>`);
                                                item_selected.featured_image !== null && thisParent[0].querySelector("img").setAttribute("src", `${item_selected.featured_image.src}`)
                                                if (!item_selected.available) {
                                                    thisParentInfo.find(".hs-upsell-popup-item-button").addClass("hs-upsell-popup-item-soldOut");
                                                    thisParentInfo.find(".hs-upsell-popup-item-button").html('<p>Sold Out</p>')
                                                } else {
                                                    thisParentInfo.find(".hs-upsell-popup-item-button").removeClass("hs-upsell-popup-item-soldOut");
                                                    thisParentInfo.find(".hs-upsell-popup-item-button").html('<p>Add To Cart</p>')
                                                }
                                            });

                                            $('.hs-upsell-popup-item-button').on('click', function (e) {
                                                if ($(this).hasClass('hs-upsell-popup-item-soldOut')) {
                                                    return false;
                                                };
                                                var thisParent = $(this).closest('.hs-upsell-popup-item-product-info');
                                                var data = {
                                                    id: thisParent.find(".hs-upsell-popup-item-product-variants-opt").children("option:selected").val(),
                                                    quantity: 1
                                                };
                                                $.ajax({
                                                    url: window.Shopify.routes.root + "cart/add.js?upsell_popup=true",
                                                    type: "POST",
                                                    data: data,
                                                    cache: !1,
                                                    dataType: "json",
                                                    success: function (t) { },
                                                    error: function (error) {
                                                        console.log(error);
                                                    },
                                                    complete: function () {
                                                    },
                                                });
                                                /* $(this)[0].setAttribute("data-add", "1") ; */
                                                $(this).html(`<p>View Cart</p>`);
                                                $(this).unbind();
                                                $(this).on('click', function (e) {
                                                    $('.hs-upsell-popup-close').trigger('click');
                                                });
                                                /* validateButton(); */
                                            });
                                            $('.hs-upsellpopup-add-all').on('click', function (e) {
                                                var items = document.querySelectorAll('.hs-upsell-popup-item-product-variants-opt').length > 0 ? document.querySelectorAll('.hs-upsell-popup-item-product-variants-opt') : [];
                                                if (items.length > 0) {
                                                    let productVariantIds = [];
                                                    items.forEach(function (select) {
                                                        productVariantIds.push({
                                                            id: select.value,
                                                            quantity: 1,
                                                        });
                                                    });
                                                    $.ajax({
                                                        url: window.Shopify.routes.root + `cart/add.js?upsell_popup=true`,
                                                        type: "POST",
                                                        data: {
                                                            items: productVariantIds,
                                                        },
                                                        cache: !1,
                                                        dataType: "json",
                                                        success: function (t) { },
                                                        error: function (error) {
                                                            console.log(error);
                                                        },
                                                        complete: function () {
                                                        },
                                                    });
                                                    /* $(this)[0].setAttribute("data-addAll", "1") ; */
                                                    $(this).html(`<p>View Cart</p>`);
                                                    $(this).unbind();
                                                    $(this).on('click', function (e) {
                                                        $('.hs-upsell-popup-close').trigger('click');
                                                    });
                                                    /* validateButton(); */
                                                };
                                            });

                                            /* function validateButton(){
                                                var btns_without_soldOut = $('.hs-upsell-popup-item-button:not(.hs-upsell-popup-item-soldOut)').length;
                                                var btns_add_all = $('.hs-upsellpopup-add-all[data-addAll="1"]').length;
                                                var btns_add = $('.hs-upsell-popup-item-button[data-add="1"]').length;
                                                if(btns_add == btns_without_soldOut){
                                                    $('.hs-upsellpopup-add-all').html('<p>View Cart</p>')
                                                };
                                                if(btns_add_all > 0){
                                                    btns_without_soldOut.html('<p>View Cart</p>')
                                                }
                                            }; */
                                            $('.hs-upsell-popup-item-product-variants-opt').trigger("change");
                                            $('#hs-popup-upsell-overlay').css("display", "block");
                                            $('#hs-popup-upsell-overlay').css("opacity", "1");
                                        };
                                    };
                                    if(count_errors == combined_elements.length){
                                        thisAdd(where,qt,'');
                                    };
                                });
                            });
                        }else{
                            thisAdd(where,qt,'');
                        }
                      }else{
                        thisAdd(where,qt,'');
                      };
                    };
                    /* *************** */
                    function thisAdd(where,qt,new_concat = ''){
                      
                    if (typeof qt === 'undefined') {
                      if (HsCartDrawer.qtyAddToCartBar.click == true) {
                        qt = HsCartDrawer.qtyAddToCartBar.qty;
                      };
                    };
                    
                    var d = new Date(),
                    random = d.getTime(),
                    arrProperties = [],
                    additional_variant = $("#hs-additional-variant"),
                    special_offers = $(".ks-addon-variant-id"),
                    element_additional = $(".swatch.choose-cotton-cover").find(".swatch-element"),
                    concatProperties = "",
                    concatVariantParent = "",
                    elementForm = where.closest("form"),
                    element = where.closest("form").find('select[name="id"]'),
                    variantid = element.val(),
                    qty = typeof qt !== 'undefined' ? parseInt(qt, 10) : where.closest("form").find('input[name="quantity"]'),
                    quantity = 1;

                    let myProductJson = {};
                    let elementSwitcher = document.querySelectorAll('.hs-sl-mui-switch-input').length > 0 ? document.querySelector('.hs-sl-mui-switch-input') : 0;
                    
                    if (
                    (elementForm.serializeArray() &&
                    ($.each(elementForm.serializeArray(), function (t, e) {
                      e.name.indexOf("properties[") > -1 && ((e.name = e.name.replace("properties[", "")), (e.name = e.name.replace("]", "")), (concatProperties = concatProperties.concat("'" + e.name + "':'" + e.value + "',"))),
                          "id" == e.name && (variantid = e.value),
                          variantid || (variantid = where.attr("data-add-id")),
                          "quantity" == e.name && (quantity = typeof qt !== 'undefined' ? qt : e.value);
                    }),
                      concatProperties && ((concatProperties = concatProperties.slice(0, -1)), (concatProperties = JSON.stringify(eval("({" + concatProperties + "})"))), (concatProperties = JSON.parse(concatProperties)))),
                    $(".spb-fileupload").find('input[name="file"]').length > 0 && "" === $(".spb-fileupload").find('input[name="file"]').val())
                    )
                    return !1;
                    $("header a[href*=cart]").addClass("hs-open-cart-url-2"), (variantid = parseFloat(variantid));
                    var concatVariant = "",
                    variantchildren = "",
                    variantchildrenKS = "";
                    if (special_offers.length > 0) {
                    var i = $('.ks-grouped-product.selected').find('.ks-addon-variant-id').val();
                    if (i !== '') {
                    variantchildrenKS = i;
                      
                    if (i.indexOf('-') > 0) {
                      var variants = i.split('-');
                      variants.forEach(function (w) {
                          variantchildren = variantchildren.concat(w + ",");
                          concatVariant = concatVariant.concat(
                              "{'id':'" + w + "','quantity':'" + quantity + "',properties:{'_father':0,_random:'" + random + "','_variant_id_father':'" + variantid + "','_variant_id_child':'" + w + "'}},"
                          );
                      })
                    } else {
                      variantchildren = i;
                      concatVariant = concatVariant.concat(
                          "{'id':'" + i + "','quantity':'" + quantity + "',properties:{'_father':0,_random:'" + random + "','_variant_id_father':'" + variantid + "','_variant_id_child':'" + i + "'}},"
                      );
                    };
                    };
                    };
                      
                    if (variantchildrenKS === '') {
                    void 0 !== window.HSSLIDECART &&
                    void 0 !== window.HSSLIDECART.variants &&
                    void 0 !== window.HSSLIDECART.variants.json &&
                    $.each(window.HSSLIDECART.variants.json, function (t, e) {
                      var a = e.variant_id_father,
                          i = e.variant_id_child;
                      a == variantid &&
                          ((variantchildren = variantchildren.concat(i + ",")),
                              (concatVariant = concatVariant.concat(
                                  "{'id':'" + i + "','quantity':'" + quantity + "',properties:{'_father':0,_random:'" + random + "','_variant_id_father':'" + variantid + "','_variant_id_child':'" + i + "'}},"
                              )));
                    });
                    };
                    
                    HsCartDrawer.params = { items: [{ id: variantid, quantity: quantity, properties: concatProperties }] };
                    additional_variant.length > 0 &&
                    "Yes" === element_additional.find("input:checked").val() &&
                    additional_variant.val() &&
                    (HsCartDrawer.params = {
                    items: [
                      { id: additional_variant.val(), quantity: quantity },
                      { id: variantid, quantity: quantity },
                    ],
                    }),
                    
                    concatVariant &&
                    ((variantchildren = variantchildren.slice(0, -1)),
                    (variantchildren = '"' + variantchildren + '"'),
                    (concatVariantParent = "{'id':" + variantid + ",'quantity':" + quantity + ",properties:{'_father':1,_random:" + random + ",'_variant_id_father':" + variantid + ",'_variant_id_child':" + variantchildren + "}}"),
                    (concatVariant += concatVariantParent),
                    (concatVariant = JSON.stringify(eval("[" + concatVariant + "]"))),
                    (concatVariant = JSON.parse(concatVariant)),
                    (HsCartDrawer.params = { items: concatVariant })),
                    concatProperties && (
                    concatVariant.length > 0 && (
                      concatVariant.forEach(function (thisVar) {
                          typeof thisVar.properties !== 'undefined' && (
                              typeof thisVar.properties._variant_id_child !== 'undefined' && (
                                  typeof thisVar.properties._variant_id_child !== 'undefined' && (
                                      thisVar.properties._variant_id_child.indexOf(',') > -1 && (
                                          thisVar.properties = { ...thisVar.properties, ...concatProperties }
                                      )
                                  )
                              )
                          )
                      })
                    )
                    );
                    
                    if(!!elementSwitcher)
                    {
                      if(elementSwitcher.getAttribute('checked') !== null) {
                        let elementProductJson = document.querySelectorAll('.hs-sl-product-json').length > 0 ? document.querySelector('.hs-sl-product-json') : 0; 
                        if(!!elementProductJson)
                        {
                          myProductJson = JSON.parse(elementProductJson.value);
                          if(myProductJson.error !== undefined)
                          {
                            myProductJson = {};
                          }
                        }
                      }
                    }
                      
                    let myJson = HsCartDrawer.captureJson(myProductJson,quantity,variantid),concatVariant2 = "";
                    if(!!myJson)
                    {
                      concatVariant2 = JSON.stringify(eval("[" + myJson + "]"));
                      concatVariant2 = JSON.parse(concatVariant2);
                      HsCartDrawer.params = { items: concatVariant2 };
                    }else{
                      HsCartDrawer.params = { items: [{id:variantid,quantity:quantity}] };
                      additional_variant.length > 0 &&
                      "Yes" === element_additional.find("input:checked").val() &&
                      additional_variant.val() &&
                      (HsCartDrawer.params = {
                      items: [
                        { id: additional_variant.val(), quantity: quantity },
                        { id: variantid, quantity: quantity },
                      ],
                      });
                    }
                    //concatProperties && (HsCartDrawer.params = { id: variantid, quantity: quantity, properties: concatProperties }),
                    HsCartDrawer.ajaxProductCart(HsCartDrawer.params, where, data, $);
                    HsCartDrawer.qtyAddToCartBar = { "click": false, "qty": 1 };

                        console.log("PLEASSEEEE")

                    /*
                    if(typeof window.factors !== 'undefined')
                    {
                    if(window.location.search.indexOf('utm_medium=questionnaire')>-1)
                    {
                    var name ='';
                    if(typeof window.item !== 'undefined')
                    {
                    if(typeof window.item.Name !== 'undefined')
                    {
                      name = window.item.Name;
                    };
                    };
                    if(name === '')
                    {
                      name = !!document.querySelector('title') ? document.querySelector('title').innerHTML.trim() : '';
                    };
                    if(name !== '')
                    {
                        factors.track('Product added to cart', {'productName': name});
                    };
                    };
                    }; */
                    };
                }),
                $('form[action="/cart/add"]').find('[name="quantity"]').unbind("change"),
                $('form[action="/cart/add"]').find('[name="quantity"]').change(function (t) {
                  t.preventDefault();
                  var e = $(this).val();
                  $('form[action="/cart/add"]').find('[name="quantity"]').length > 0 && $('form[action="/cart/add"]').find('[name="quantity"]').eq(1).val(e);
                });                
        },
        captureJson: function(myProductJson,quantity,variantid){
          var concatVariant = "", d = new Date(),random = d.getTime();
          
          if(Object.keys(myProductJson).length > 0)
          {
            if(Object.keys(window.MYHSSLCART.product).length > 0)
            {
              window.MYHSSLCART.product.variants.forEach(function (variant) {
                if(variantid == variant.id)
                {

                  myProductJson.variants.forEach(function (value) {
                    if(value.option1 == variant.option1)
                    {
                      concatVariant = concatVariant.concat(
                          "{'id':'" + value.id + "','quantity':'" + quantity + "',properties:{'_father':0,_random:'" + random + "','_variant_id_father':'" + variantid + "','_variant_id_child':'" + value.id + "'}},{'id':'" + variantid + "','quantity':'" + quantity + "',properties:{'_father':1,_random:'" + random + "','_variant_id_father':'" + variantid + "','_variant_id_child':'" + value.id + "'}},"
                      );
                    }
                  });
                }
              });
            }
          }
          return concatVariant;
        },
        replaceSymbol: function (t) {
            return (t = (t = t.toLowerCase()).replace(/\s/g, "-")).replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, "-");
        },
        removeDisabledButton: function (t, e, a, i) {
            setTimeout(function () {
                1 == t && e.html('<span><i class="fa fa-check"></i></span>'),
                    setTimeout(function () {
                        e.removeAttr("disabled"), e.html('<span><i class="fa ' + a.quickbuybutton_icon + '"></i></span>'), e.removeClass("hs-loading-cart");
                    }, 500);
            }, 200);
        },
        changeButton: function (t, e, a) {
            setTimeout(function () {
                t.removeClass("hs-loading-btn");
            }, 200);
        },
        showApp: function (t, e) {
            e(".content-popup-cart-product-form").show(), e(".product-form__cart-submit_popup_cart").show(), e(".wrapper.wrapper--margins .pagination.text-center").css("margin-top", "50px");
        },
        resizeDesktopAndMobile: function (t, e) {
                                  var sticky_cart_bar_mobile_show_devices = parseInt(t.sticky_cart_bar_mobile_show_devices),
                                  sticky_cart_bar_mobile_hide_add_to_cart = parseInt(t.sticky_cart_bar_mobile_hide_add_to_cart),
                                  sticky_cart_bar_mobile_show_full_width = parseInt(t.sticky_cart_bar_mobile_show_full_width),
                                  sticky_cart_bar_mobile_show_product_image = parseInt(t.sticky_cart_bar_mobile_show_product_image),
                                  sticky_cart_bar_mobile_show_product_title = parseInt(t.sticky_cart_bar_mobile_show_product_title),
                                  sticky_cart_bar_mobile_show_review_stars = parseInt(t.sticky_cart_bar_mobile_show_review_stars),
                                  sticky_cart_bar_mobile_show_variant_select = parseInt(t.sticky_cart_bar_mobile_show_variant_select),
                                  sticky_cart_bar_mobile_show_quantity_select = parseInt(t.sticky_cart_bar_mobile_show_quantity_select),
                                  sticky_cart_bar_mobile_show_price = parseInt(t.sticky_cart_bar_mobile_show_price),
                                  sticky_cart_bar_mobile_show_compare_price = parseInt(t.sticky_cart_bar_mobile_show_compare_price),
                                  sticky_cart_bar_desktop_show_devices = parseInt(t.sticky_cart_bar_desktop_show_devices),/////////////////////
                                  sticky_cart_bar_desktop_hide_add_to_cart = parseInt(t.sticky_cart_bar_desktop_hide_add_to_cart),
                                  sticky_cart_bar_desktop_show_product_image = parseInt(t.sticky_cart_bar_desktop_show_product_image),
                                  sticky_cart_bar_desktop_show_product_title = parseInt(t.sticky_cart_bar_desktop_show_product_title),
                                  sticky_cart_bar_desktop_show_review_stars = parseInt(t.sticky_cart_bar_desktop_show_review_stars),
                                  sticky_cart_bar_desktop_show_variant_select = parseInt(t.sticky_cart_bar_desktop_show_variant_select),
                                  sticky_cart_bar_desktop_show_quantity_select = parseInt(t.sticky_cart_bar_desktop_show_quantity_select),
                                  sticky_cart_bar_desktop_show_price = parseInt(t.sticky_cart_bar_desktop_show_price),
                                  sticky_cart_bar_desktop_show_compare_price = parseInt(t.sticky_cart_bar_desktop_show_compare_price);



                                  var hs_content_checkout_bar = !!document.querySelector('.hs-content-checkout-bar') ? document.querySelector('.hs-content-checkout-bar') : '';
                                  if(!!hs_content_checkout_bar){
                                  if(window.innerWidth < 769)
                                  {
                                  hs_content_checkout_bar.classList.remove('hs-hidden-header');
                                  /* if(!sticky_cart_bar_mobile_show_product_image){
          if(!sticky_cart_bar_mobile_show_product_title){
            if(!sticky_cart_bar_mobile_show_variant_select){
              if(!sticky_cart_bar_mobile_show_quantity_select){
                if(!sticky_cart_bar_mobile_show_price)
                {
                  if(!sticky_cart_bar_mobile_show_compare_price){
                    hs_content_checkout_bar.classList.add('hs-hidden-header');
                    var hs_content_variants = !!document.querySelector('.hs-content-variant-select-option') ? document.querySelector('.hs-content-variant-select-option') : '';
                    if(!!hs_content_variants)
                    {
                      hs_content_variants.style.display = "none";
                    }
                  }
                }
              }
            }
          }
        } */
                                  hs_content_checkout_bar.classList.remove('hs-hidden-header');
                                  if(!sticky_cart_bar_mobile_show_variant_select)
                                  {
                                  hs_content_checkout_bar.classList.add('hs-hidden-header');
                                  var hs_content_variants = !!document.querySelector('.hs-content-variant-select-option') ? document.querySelector('.hs-content-variant-select-option') : '';
                                  if(!!hs_content_variants)
                                  {
                                  hs_content_variants.style.display = "none";
                                  }
                                  }
                                  var hs_checkout_bar = !!document.querySelector('.hs-sticky-checkout-bar') ? document.querySelector('.hs-sticky-checkout-bar') : '';
                                  if(!!hs_checkout_bar){
                                  var sticky_cart_bar_desktop_position = 'hs-desktop-top';
                                  if(e.position_offset_desktop == 1)
                                  {
                                  sticky_cart_bar_desktop_position = 'hs-desktop-bottom';
                                  };

                                  var sticky_cart_bar_mobile_position = 'hs-mobile-top';
                                  if(e.position_offset_mobile == 1)
                                  {
                                  sticky_cart_bar_mobile_position = 'hs-mobile-bottom';
                                  }
                                  hs_checkout_bar.classList.add(sticky_cart_bar_mobile_position);
                                  hs_checkout_bar.classList.remove(sticky_cart_bar_desktop_position);
                                  }


                                  /*if(!stickycart_devices_status)
        {
          $('.hs-content-checkout-bar .hs-sticky-cart-cart-drawer').hide();
        }else{
          $('.hs-content-checkout-bar .hs-sticky-cart-cart-drawer').show();
        }
        if(!show_on_tablets_and_mobile_devices_quick_buy_button)
        {
          $('.hs-content-checkout-bar .hs-content-cart-drawer-loop').hide();
        }else{
          $('.hs-content-checkout-bar .hs-content-cart-drawer-loop').show();
        }*/

                                  var hs_content = !!document.querySelector('.hs-content-checkout-bar') ? document.querySelector('.hs-content-checkout-bar') : '';
                                  if(!!hs_content){
                                  if(!sticky_cart_bar_mobile_show_devices)
                                  {
                                  hs_content.style.display = 'none';
                                  }
                                  else
                                  {
                                  hs_content.style.display = 'block';
                                  }

                                  };

                                  var hs_product_price_container = !!document.querySelector('.hs-content-checkout-bar .hs-bar-content-title .hs-product-price-container') ? document.querySelector('.hs-content-checkout-bar .hs-bar-content-title .hs-product-price-container') : '';
                                  if(!!hs_product_price_container)
                                  {
                                  if(!!sticky_cart_bar_mobile_show_compare_price || !!sticky_cart_bar_mobile_show_price )
                                  {
                                  hs_product_price_container.style.display="flex";
                                  };
                                  var mobile_compare_price= document.querySelectorAll('.hs-content-checkout-bar .hs-product-price-container .hs-checkout-bar-compare-at-price').length > 0 ? document.querySelectorAll('.hs-content-checkout-bar .hs-product-price-container .hs-checkout-bar-compare-at-price') : [];
                          if(mobile_compare_price.length > 0){
                          if(!sticky_cart_bar_mobile_show_compare_price){
                          mobile_compare_price.forEach(function(val){
                          val.style.display="none";
                        });
            }else{
                        mobile_compare_price.forEach(function(val){
              val.style.display="block";
            });
        }
};

var mobile_price= document.querySelectorAll('.hs-content-checkout-bar .hs-product-price-container .hs-checkout-bar-price').length > 0 ? document.querySelectorAll('.hs-content-checkout-bar .hs-product-price-container .hs-checkout-bar-price') : [];
if(mobile_price.length > 0){
  if(!sticky_cart_bar_mobile_show_price){
    mobile_price.forEach(function(val){
      val.style.display="none";
    });
  }else{
    mobile_price.forEach(function(val){
      val.style.display="block";
    });
  }
};
}

/* var mobile_quantity = document.querySelectorAll('.hs-content-checkout-bar .hs-content-quantity').length > 0 ? document.querySelectorAll('.hs-content-checkout-bar .hs-content-quantity') : [];
        if(mobile_quantity.length > 0){
          if(!sticky_cart_bar_mobile_show_quantity_select){
            mobile_quantity.forEach(function(val){
              val.style.display="none";
            });
          }else{
            mobile_quantity.forEach(function(val){
              val.style.display="block";
            });
          }
        }; */

var mobile_variant = document.querySelector('.hs-content-checkout-bar') ? document.querySelector('.hs-content-checkout-bar') : '';
if(!!mobile_variant){
  var box_load = mobile_variant.querySelectorAll('.hs-select-box-load').length > 0 ? mobile_variant.querySelectorAll('.hs-select-box-load') : [];
  if(!sticky_cart_bar_mobile_show_variant_select){
    mobile_variant.classList.add('hs-hidden-select');
    if(box_load.length > 0){
      box_load.forEach(function(val){
        val.style.display="none";
      });
    }
  }else{
    mobile_variant.classList.remove('hs-hidden-select');
    if(box_load.length > 0){
      box_load.forEach(function(val){
        val.style.display="block";
      });
    }
  };

  mobile_variant.classList.remove('hs-hidden-select');
  var hs_select_box_bar = !!document.querySelector('.hs-load-select-box-bar-1') ? document.querySelector('.hs-load-select-box-bar-1') : '';
  var hs_option_checkout_bar = !!hs_select_box_bar ? hs_select_box_bar.querySelector('.hs-select-option-checkout-bar')  : '';
  var hs_select = !!hs_option_checkout_bar ? hs_option_checkout_bar.querySelector('[value="Default Title"]') : '';
  if(!!hs_select){
    mobile_variant.classList.add('hs-hidden-select');
  }
};

/* if(!sticky_cart_bar_mobile_show_variant_select && !sticky_cart_bar_mobile_show_quantity_select){
          if(!!document.querySelector('.hs-content-variant-select-option')){
            document.querySelector('.hs-content-variant-select-option').style.setProperty('display', 'none', 'important');
          };
          if(!!document.querySelector('.hs-content-checkout-bar'))
          {
            if(!!document.querySelector('.hs-content-checkout-bar .hs-content-image-and-title'))
            {
              if(!!document.querySelector('.hs-content-checkout-bar .hs-content-image-and-title .hs-content-quantity-resize'))
              {
                document.querySelector('.hs-content-checkout-bar .hs-content-image-and-title .hs-content-quantity-resize').style.setProperty('display', 'block', 'important');
              }
            }
          }
        }; */

var mobile_review_stars = !!document.querySelector('.hs-content-checkout-bar .hs-product-review') ? document.querySelector('.hs-content-checkout-bar .hs-product-review') : '';
if(!!mobile_review_stars){
  if(!sticky_cart_bar_mobile_show_review_stars){
    mobile_review_stars.style.display="none";
  }else{
    mobile_review_stars.style.display="block";
  }
};

var mobile_title = !!document.querySelector('.hs-content-checkout-bar .hs-sticky-bar-product-title') ? document.querySelector('.hs-content-checkout-bar .hs-sticky-bar-product-title') : '';
var hs_variant = !!hs_content_checkout_bar ? hs_content_checkout_bar.querySelector('.hs-content-variant-select-option') : '';
var btn_checkout_bar = !!hs_variant ? hs_variant.querySelector('.hs-btn-checkout-bar') : '';


if(!!mobile_title){
  if(!sticky_cart_bar_mobile_show_product_title){
    mobile_title.style.display="none";
    if(!!btn_checkout_bar){
      btn_checkout_bar.style.display="block";
    }

  }else{
    mobile_title.style.display="block";
    if(!!btn_checkout_bar){
      btn_checkout_bar.style.display="none";
    }
  }
};

var mobile_featured_image = !!document.querySelector('.hs-content-checkout-bar .hs-image-thumb .hs-bar-featured-image') ? document.querySelector('.hs-content-checkout-bar .hs-image-thumb .hs-bar-featured-image') : '';
if(!!mobile_featured_image){
  if(!sticky_cart_bar_mobile_show_product_image){
    mobile_featured_image.style.display="none";
  }else{
    mobile_featured_image.style.display="block";
  }
};

var mobile_addtocart = !!document.querySelector('.hs-content-checkout-bar .hs-checkout-bar-add-to-cart') ? document.querySelector('.hs-content-checkout-bar .hs-checkout-bar-add-to-cart') : '';
if(!!mobile_addtocart){
  if(!!sticky_cart_bar_mobile_hide_add_to_cart){
    mobile_addtocart.style.display="none";
  }else{
    mobile_addtocart.style.display="block";
  }
}

/* var content_img = !!document.querySelector('.hs-content-image-and-title') ? document.querySelector('.hs-content-image-and-title') : '';
        if(!!content_img)
        {
          if(!sticky_cart_bar_mobile_show_product_image && !sticky_cart_bar_mobile_show_product_title && !sticky_cart_bar_mobile_show_review_stars)
          {
            content_img.style.display="none";
          }
          else{
            content_img.style.display="flex";
          }
        }; */

var content_img = !!document.querySelector('.hs-content-image-and-title') ? document.querySelector('.hs-content-image-and-title') : '';
if(!!content_img)
{
  if(!!sticky_cart_bar_mobile_show_product_image || !!sticky_cart_bar_mobile_show_product_title || !!sticky_cart_bar_mobile_show_review_stars || !!sticky_cart_bar_mobile_show_price || !!sticky_cart_bar_mobile_show_compare_price)
  {
    content_img.style.display="flex";
  }
  else{
    content_img.style.display="none";
  }
};

if(!sticky_cart_bar_mobile_hide_add_to_cart && !sticky_cart_bar_mobile_show_product_image && !sticky_cart_bar_mobile_show_product_title && !sticky_cart_bar_mobile_show_review_stars && !sticky_cart_bar_mobile_show_variant_select && !sticky_cart_bar_mobile_show_price && ! sticky_cart_bar_mobile_show_compare_price)
{
  var a = !!document.querySelector('.hs-content-checkout-bar') ? document.querySelector('.hs-content-checkout-bar') : '';
  if(!!a)
  {
    a.classList.add('quantityButton')
  }
};

}else{
  var hs_checkout_bar = !!document.querySelector('.hs-sticky-checkout-bar') ? document.querySelector('.hs-sticky-checkout-bar') : '';
  if(!!hs_checkout_bar){
    var sticky_cart_bar_mobile_position = 'hs-mobile-top';
    if(t.position_offset_mobile == 1)
    {
      sticky_cart_bar_mobile_position = 'hs-mobile-bottom';
    }
    var sticky_cart_bar_desktop_position = 'hs-desktop-top';
    if(t.position_offset_desktop == 1)
    {
      sticky_cart_bar_desktop_position = 'hs-desktop-bottom';
    };
    hs_checkout_bar.classList.add(sticky_cart_bar_desktop_position);
    hs_checkout_bar.classList.remove(sticky_cart_bar_mobile_position);
  }

  var checkout_bar = !!document.querySelector('.hs-content-checkout-bar') ? document.querySelector('.hs-content-checkout-bar') :'';
  if(!!checkout_bar){
    checkout_bar.classList.remove('hs-hidden-header');
  }

  /*if(!stickycart_show_desktop)
        {
          $('.hs-content-checkout-bar .hs-sticky-cart-cart-drawer').hide();
        }else{
          $('.hs-content-checkout-bar .hs-sticky-cart-cart-drawer').show();
        }
        if(!show_on_desktop_computers_quick_buy_button)
        {
          $('.hs-content-checkout-bar .hs-content-cart-drawer-loop').hide();
        }else{
          $('.hs-content-checkout-bar .hs-content-cart-drawer-loop').show();
        }
		 */

  var hs_content = !!document.querySelector('.hs-content-checkout-bar') ? document.querySelector('.hs-content-checkout-bar') : '';
  if(!!hs_content){
    if(!!sticky_cart_bar_desktop_show_devices)
    {
      hs_content.style.display = 'flex';
    }
    else
    {
      hs_content.style.display = 'none';
    }
  };

  if(!!checkout_bar){
    checkout_bar.classList.remove('hs-hidden-select');
    var hs_select_box_bar = !!document.querySelector('.hs-load-select-box-bar-1') ? document.querySelector('.hs-load-select-box-bar-1') : '';
    var hs_option_checkout_bar = !!hs_select_box_bar ? hs_select_box_bar.querySelector('.hs-select-option-checkout-bar')  : '';
    var hs_select = !!hs_option_checkout_bar ? hs_option_checkout_bar.querySelector('[value="Default Title"]') : '';
    if(!!hs_select){
      checkout_bar.classList.add('hs-hidden-select');
    }
  };

  var content_img = !!document.querySelector('.hs-content-image-and-title') ? document.querySelector('.hs-content-image-and-title') : '';
  if(!!content_img)
  {
    if(!!sticky_cart_bar_desktop_show_product_image || !!sticky_cart_bar_desktop_show_product_title || !!sticky_cart_bar_desktop_show_review_stars)
    {
      content_img.style.display="flex";
    };
  };

  var desktop_featured_image = !!document.querySelector('.hs-content-checkout-bar .hs-image-thumb .hs-bar-featured-image') ? document.querySelector('.hs-content-checkout-bar .hs-image-thumb .hs-bar-featured-image') :''
  if(!!desktop_featured_image){
    if(!sticky_cart_bar_desktop_show_product_image){
      desktop_featured_image.style.display="none";
    }else{
      desktop_featured_image.style.display="block";
    }
  };

  var desktop_title = !!document.querySelector('.hs-content-checkout-bar .hs-sticky-bar-product-title') ? document.querySelector('.hs-content-checkout-bar .hs-sticky-bar-product-title') :''
  if(!!desktop_title){
    if(!sticky_cart_bar_desktop_show_product_title){
      desktop_title.style.display="none";
    }else{
      desktop_title.style.display="block";
    }
  };

  /*var desktop_review_stars = !!document.querySelector('.hs-content-checkout-bar .hs-product-review') ? document.querySelector('.hs-content-checkout-bar .hs-product-review') :''
  if(!!desktop_review_stars){
    if(!sticky_cart_bar_desktop_show_review_stars){
      desktop_review_stars.style.display="none";
    }else{
      desktop_review_stars.style.display="block";
    }
  };*/

  var desktop_variant = document.querySelectorAll('.hs-content-checkout-bar .hs-select-box-load').length > 0 ? document.querySelectorAll('.hs-content-checkout-bar .hs-select-box-load') : [];
  if(desktop_variant.length > 0){
    if(!sticky_cart_bar_desktop_show_variant_select){
      desktop_variant.forEach(function(val){
        val.style.display="none";
      });
    }else{
      desktop_variant.forEach(function(val){
        val.style.display="block";
      });
    }
  };

  var desktop_compare_price= document.querySelectorAll('.hs-content-checkout-bar .hs-checkout-bar-compare-at-price').length > 0 ? document.querySelectorAll('.hs-content-checkout-bar .hs-checkout-bar-compare-at-price') : [];
  if(desktop_compare_price.length > 0){
    if(!sticky_cart_bar_desktop_show_compare_price){
      desktop_compare_price.forEach(function(val){
        val.style.display="none";
      });
    }else{
      desktop_compare_price.forEach(function(val){
        val.style.display="block";
      });
    }
  };

  var desktop_price= document.querySelectorAll('.hs-content-checkout-bar .hs-checkout-bar-price').length > 0 ? document.querySelectorAll('.hs-content-checkout-bar .hs-checkout-bar-price') : [];
  if(desktop_price.length > 0){
    if(!sticky_cart_bar_desktop_show_price){
      desktop_price.forEach(function(val){
        val.style.display="none";
      });
    }else{
      desktop_price.forEach(function(val){
        val.style.display="block";
      });
    }
  };

  var desktop_quantity = document.querySelectorAll('.hs-content-checkout-bar .hs-change-select-option .hs-content-quantity').length > 0 ? document.querySelectorAll('.hs-content-checkout-bar .hs-change-select-option .hs-content-quantity') : [];
  if(desktop_quantity.length > 0){
    if(!sticky_cart_bar_desktop_show_quantity_select){
      desktop_quantity.forEach(function(val){
        val.style.display="none";
      });
    }else{
      desktop_quantity.forEach(function(val){
        val.style.display="block";
      });
    }
  };

  if(!!sticky_cart_bar_desktop_show_variant_select || !!sticky_cart_bar_desktop_show_quantity_select || !!sticky_cart_bar_desktop_show_price || !!sticky_cart_bar_desktop_show_compare_price)
  {
    var hs_content_selection = !!document.querySelector('.hs-content-variant-select-option') ? document.querySelector('.hs-content-variant-select-option') : '';
    if(!!hs_content_selection)
    {
      hs_content_selection.style.display= 'flex';
    }
  };

  /* if(!sticky_cart_bar_mobile_show_variant_select && !!sticky_cart_bar_mobile_show_quantity_select){
          if(!!document.querySelector('.hs-content-variant-select-option')){
            document.querySelector('.hs-content-variant-select-option').style.setProperty('display', 'flex', 'important');
          };
          if(!!document.querySelector('.hs-content-checkout-bar'))
          {
            if(!!document.querySelector('.hs-content-checkout-bar .hs-content-image-and-title'))
            {
              if(!!document.querySelector('.hs-content-checkout-bar .hs-content-image-and-title .hs-content-quantity-resize'))
              {
                document.querySelector('.hs-content-checkout-bar .hs-content-image-and-title .hs-content-quantity-resize').style.setProperty('display', 'none', 'important');
              }
            }
          }
        }; */

  var hs_product_price_container = !!document.querySelector('.hs-content-checkout-bar .hs-bar-content-title .hs-product-price-container') ? document.querySelector('.hs-content-checkout-bar .hs-bar-content-title .hs-product-price-container') : '';
  if(!!hs_product_price_container)
  {
    hs_product_price_container.style.display="none";
  };

  var desktop_addtocart = !!document.querySelector('.hs-content-checkout-bar .hs-checkout-bar-add-to-cart') ? document.querySelector('.hs-content-checkout-bar .hs-checkout-bar-add-to-cart') :''
  if(!!desktop_addtocart){
    if(!!sticky_cart_bar_desktop_hide_add_to_cart){
      desktop_addtocart.style.display="none";
    }else{
      desktop_addtocart.style.display="block";
    }
  };
}
}
        },
        resize: function (t, e) {
            e(window).width() < 600
                ? (e(".hs-popup-cart-sp-load").removeClass("hs-desktop-content-cart"), e(".hs-popup-cart-sp-load").addClass("hs-mobile-content-cart"))
                : (e(".hs-popup-cart-sp-load").removeClass("hs-mobile-content-cart"), e(".hs-popup-cart-sp-load").addClass("hs-desktop-content-cart")),
                e(window).resize(function () {
                    delay(function () {
                        HsCartDrawer.positionPopup(t, e), HsCartDrawer.mobileCart(e(this), t, e), HsCartDrawer.HideCart(t, e), HsCartDrawer.mgTop(t, e), HsCartDrawer.swiperHSCart(t, e), HsCartDrawer.upsellVariants(t, e);
                    }, 200);
                });
        },
        HideCart: function (t, e) {
            e(".hs-popup-cart-sp-load.hs-cart-drawer-1.hs-desktop-content-cart").removeClass("active");
        },
        mobileCart: function (t, e, a) {
            t.width() < 600
                ? (a(".hs-popup-cart-sp-load").removeClass("hs-desktop-content-cart"), a(".hs-popup-cart-sp-load").addClass("hs-mobile-content-cart"))
                : (a(".hs-popup-cart-sp-load").removeClass("hs-mobile-content-cart"), a(".hs-popup-cart-sp-load").addClass("hs-desktop-content-cart"));
        },
        getParameterByName: function (t, e) {
            e || (e = window.location.href), (t = t.replace(/[\[\]]/g, "\\$&"));
            var a = new RegExp("[?&]" + t + "(=([^&#]*)|&|#|$)").exec(e);
            return a ? (a[2] ? decodeURIComponent(a[2].replace(/\+/g, "+")) : "") : null;
        },
        clearALL: function (t, e) {
            e(".hs-clear-all-button").unbind("click"),
                e(".hs-clear-all-button").click(function (a) {
                    a.preventDefault(), HsCartDrawer.ajaxClearAll(t, e);
                });
        },
        ajaxClearAll: function (t, e) {
            e.ajax({
                type: "POST",
                url: "/cart/clear.js",
                dataType: "json",
                async: !0,
                success: function (a) {
                    void 0 !== window.BOLD && void 0 !== window.BOLD.common && void 0 !== window.BOLD.common.cartDoctor && (a = window.BOLD.common.cartDoctor.fix(a)),
                        a &&
                            (e(".hs-popup-cart-sp-load .hs-site-cart-popup").html(
                                '<div class="hs-empty-page-content hs-text-center"><div class="hs-content-empty-cart">' +
                                    HsCartDrawer.empty_cart +
                                    "<p>" +
                                    t.no_result_text +
                                    '</p></div><span class="hs-close"><svg width="12px" height="12px" xml:space="preserve" enable-background="new 0 0 500 500" viewBox="0 0 500 500" y="0px" x="0px" id="Layer_1" version="1.1" xmlns="http://www.w3.org/2000/svg"> <g> <rect x="230.626" y="-48.852" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -103.7603 250.4999)" stroke-width="1.2421" stroke-miterlimit="10" width="39.749" height="598.703"></rect> <rect x="230.626" y="-48.852" transform="matrix(-0.7071 -0.7071 0.7071 -0.7071 250.5026 604.7603)"  stroke-width="1.2421" stroke-miterlimit="10" width="39.748" height="598.703"></rect> </g></svg></span></div>'
                            ),
                            t.style,
                            HsCartDrawer.removeCart(t, e),
                            HsCartDrawer.countCart(a, t, e),
                            HsCartDrawer.priceCart(a, t, e),
                            e(HsCartDrawer.openSlideCart).removeClass("hs-open-cart-url"),
                            e(HsCartDrawer.openSlideCart).removeClass("hs-open-cart-url-2"));
                },
                error: function (t) {},
                complete: function (a) {
                    HsCartDrawer.plusMin(t, e), HsCartDrawer.removeItemCart(t, e), HsCartDrawer.positionPopup(t, e), HsCartDrawer.hideCartPopup(t, e), HsCartDrawer.changeQuantityCart(t, e), HsCartDrawer.clearALL(t, e);
                },
            });
        },
        removeCart: function (t, e) {
            e(".hs-popup-cart-sp-load").removeClass("active"), HsCartDrawer.closeCart(t, e);
        },
        addComboboxCollections: function (t, e) {
            if ("undefined" != typeof HsCartDrawerCollection) {
                var a = HsCartDrawerCollection.HsJson(),
                    i = "",
                    r = "",
                    n = "",
                    s = "",
                    o = "",
                    l = "",
                    c = "",
                    d = [],
                    p = [],
                    h = [],
                    u = [],
                    m = [],
                    f = [],
                    g = [],
                    b = "",
                    w = "",
                    v = "",
                    y = "",
                    _ = "";
                a &&
                    (e.each(a, function (a, x) {
                        x.options,
                            (d = x.variants),
                            (y = ""),
                            (_ = ""),
                            (m = []),
                            (f = []),
                            (g = []),
                            e.each(d, function (t, a) {
                                (b = ""),
                                    (w = ""),
                                    (v = ""),
                                    e.each(a.options, function (t, e) {
                                        0 == t && (b = e), 1 == t && (w = e), 2 == t && (v = e);
                                    }),
                                    b.length > 0 && m.push(b),
                                    w.length > 0 && f.push(w),
                                    v.length > 0 && g.push(v),
                                    (y = y.concat(
                                        '<option value="' +
                                            a.title +
                                            '" title="' +
                                            a.title +
                                            '" data-id="' +
                                            x.id +
                                            '" data-price="' +
                                            a.price +
                                            '" data-sku="' +
                                            a.sku +
                                            '" data-available="' +
                                            a.available +
                                            '" data-barcode="' +
                                            a.barcode +
                                            '" data-featuredimage="' +
                                            x.featured_image +
                                            '" data-inventorymanagement="' +
                                            a.inventory_management +
                                            '" data-compareatprice="' +
                                            a.compare_at_price +
                                            '" data-variantid="' +
                                            a.id +
                                            '">' +
                                            a.title +
                                            "</option>"
                                    )),
                                    (_ = _.concat('<li data-id="' + x.id + '" data-vid="' + a.id + '"><span>' + a.title + "</li></span>"));
                            }),
                            (o = ""),
                            (l = ""),
                            (c = ""),
                            (_ = '<ul class="hs-combobox-option-variant hs-combobox-option-variant-' + x.id + '">' + _ + "</ul>"),
                            (r =
                                '<input type="number" class="satcb_qb_quantity satcb_qb_quantity_top_right" name="satcb_qb_quantity" value="1" min="1" style="position: absolute; background: #fff; width: 85px; height: 35px; min-height: 35px; top: 4px; left: 4px; display: block; z-index: 3; border-radius: 17px; padding: 7px 5px 7px 40px; margin: 0; text-align: center; border: 1px solid #eee; color: #a0a0a0;">'),
                            (n = '<button type="button" class="hs-add-to-cart hs-button-cart-' + x.id + ' animated bounceIn" data-id="' + x.id + '"><span><i class="fa ' + t.quickbuybutton_icon + '"></i></span></button>'),
                            (s = '<div class="hs-flag-content hs-flag-' + x.id + '" style="display:none;"></div>'),
                            (y = '<select class="hs-option-parent-' + x.id + ' hs-select-option-add-to-cart" data-id="' + x.id + '" name="none" style="display:none;">' + y + "</select>"),
                            (p = m.filter(function (t, e) {
                                if (m.indexOf(t) == e) return t;
                            })),
                            (h = f.filter(function (t, e) {
                                if (f.indexOf(t) == e) return t;
                            })),
                            (u = g.filter(function (t, e) {
                                if (g.indexOf(t) == e) return t;
                            })),
                            p.length > 0 &&
                                (e.each(p, function (t, e) {
                                    o = o.concat('<option value="' + e + '" data-id="' + x.id + '">' + e + "</option>");
                                }),
                                (o = '<div class="hs-select-box-load"><span class="hs-select-text">' + x.options[0] + '</span><select class="hs-option-' + x.id + '-0 hs-select-option" name="none">' + o + "</select></div>")),
                            h.length > 0 &&
                                (e.each(h, function (t, e) {
                                    l = l.concat('<option value="' + e + '" data-id="' + x.id + '">' + e + "</option>");
                                }),
                                (l = '<div class="hs-select-box-load"><span class="hs-select-text">' + x.options[1] + '</span><select class="hs-option-' + x.id + '-1 hs-select-option" name="none">' + l + "</select></div>")),
                            u.length > 0 &&
                                (e.each(u, function (t, e) {
                                    c = c.concat('<option value="' + e + '" data-id="' + x.id + '">' + e + "</option>");
                                }),
                                (c = '<div class="hs-select-box-load"><span class="hs-select-text">' + x.options[2] + '</span><select class="hs-option-' + x.id + '-2 hs-select-option" name="none">' + c + "</select></div>")),
                            0 == t.show_quantity_selector_buy_button && (r = ""),
                            (i = '<div class="hs-change-select-option" style="display:none;">' + o + l + c + "</div>" + y),
                            e(".hs-product-cart-drawer-" + x.id).html(i),
                            e(".hs-product-cart-drawer-" + x.id)
                                .parent("div")
                                .css("position", "relative"),
                            e(".hs-product-cart-drawer-" + x.id)
                                .parent("div")
                                .append(n + r + s + _);
                    }),
                    HsCartDrawer.changeVariants(t, e),
                    HsCartDrawer.onLoadVariants(t, e));
            }
        },
        captureVariants: function (t, e, a) {
            var i = [];
            return (
                HsCartDrawer.arr_variants &&
                    (a.each(HsCartDrawer.arr_variants, function (e, a) {
                        t === a.title && i.push(a);
                    }),
                    (i = i[0])),
                i
            );
        },
        callBackVariant: function (t, e, a) {
            var i = window.location.href;
            if (!t) return a(".hs-checkout-bar-add-to-cart").html(e.text_unavailable), a(".hs-checkout-bar-add-to-cart").attr("disabled", "disabled"), !1;
            var r = t.id,
                n = t.available,
                s = t.price,
                o = t.compare_at_price,
                l = "";
              const elementCoverList = document.querySelectorAll('.hs-option-cotton-cover');
              if (elementCoverList.length > 0) {
                const price = parseFloat(elementCoverList[0].querySelector('option[value="Yes"]').getAttribute('data-price'));
                const compare_price = parseFloat(elementCoverList[0].querySelector('option[value="Yes"]').getAttribute('data-compare-price'));
                var value = elementCoverList[0].value;
                if(value === 'Yes')
                {
                  s = s + price;
                  o = o + compare_price;
                }
              }
            a("select.hs-select-variants-bar").val(r).change(),
                a(".hs-checkout-bar-compare-at-price").html(""),
                a(".hs-checkout-bar-price").html(""),
                o &&
                    o > s &&
                    ((l = " hs-compare-price-active"), (o = HsCartDrawer.vat(o, e, a)), a(".hs-checkout-bar-compare-at-price").html('<s class="hs-money-compare-price">' + hsonslidecart.Currency.formatMoney(o, e.money_format) + "</s>")),
                s && ((s = HsCartDrawer.vat(s, e, a)), a(".hs-checkout-bar-price").html('<span class="hs-money-price' + l + '">' + hsonslidecart.Currency.formatMoney(s, e.money_format) + "</span>")),
                n
                    ? ((i = HsCartDrawer.removeParam("variant", i)),
                      (i = HsCartDrawer.URL_add_parameter(i, "variant", r)),
                      window.history.pushState({}, "keywords", i),
                      a(".hs-checkout-bar-add-to-cart").removeAttr("disabled"),
                      a(".hs-checkout-bar-add-to-cart").html('<span class="hs-add--to--cart">' + e.text_add_to_cart + '</span><span class="hs--loading"><i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw margin-bottom"></i></span>'))
                    : (a(".hs-checkout-bar-add-to-cart").attr("disabled", "disabled"),
                      a(".hs-checkout-bar-add-to-cart").html(e.text_stock),
                      (i = HsCartDrawer.removeParam("variant", i)),
                      (i = HsCartDrawer.URL_add_parameter(i, "variant", r)),
                      window.history.pushState({}, "keywords", i));
        },
        upsellVariants: function (t, e) {
            e(".hs-swipper-select-option-add-to-cart").unbind("change"),
                e(".hs-swipper-select-option-add-to-cart").change(function (a) {
                    a.preventDefault();
                    var i = hsonslidecart.Currency.formatMoney(e(this).find("option:selected").data("price"), t.money_format),
                        r = hsonslidecart.Currency.formatMoney(e(this).find("option:selected").data("compareatprice"), t.money_format),
                        n = e(this).find("option:selected").data("available");
                    e(this).closest(".hs-content-product-slide-cart").find(".hs-upsell-add").find(".hs-upsell-add-to-cart").removeAttr("disabled"),
                        n
                            ? (e(this).closest(".hs-content-product-slide-cart").find(".hs-upsell-add").find(".hs-upsell-add-to-cart").find(".hs-add--to--cart").html(t.text_add),
                              e(this).closest(".hs-content-title-price-swiper").find(".hs-price-sw").html(i),
                              e(this).closest(".hs-content-title-price-swiper").find(".hs-compare-price-sw").html(r))
                            : (e(this).closest(".hs-content-product-slide-cart").find(".hs-upsell-add").find(".hs-upsell-add-to-cart").prop("disabled", !0),
                              e(this).closest(".hs-content-product-slide-cart").find(".hs-upsell-add").find(".hs-upsell-add-to-cart").find(".hs-add--to--cart").html(t.text_stock),
                              e(this).closest(".hs-content-title-price-swiper").find(".hs-price-sw").html(i),
                              e(this).closest(".hs-content-title-price-swiper").find(".hs-compare-price-sw").html(r));
                });
        },
        changeVariantsCheckoutBar: function (t, e) {
          /*CART BAR ---> Click title scroll to top */
          var cart_bar_product_title = !!document.querySelector('.hs-sticky-bar-product-title') ? document.querySelector('.hs-sticky-bar-product-title') : '';
          if(!!cart_bar_product_title){
            cart_bar_product_title.addEventListener("click", function(e) {
              e.preventDefault();
              /* console.log('changeVariantsCheckoutBar cart_bar_product_title') */
              window.scroll({
                top: 0,
                behavior: 'smooth'
              });

            });
          };
          
          var a = "";
          var selectOpt = document.querySelectorAll('.hs-select-option-checkout-bar').length > 0 ? document.querySelectorAll('.hs-select-option-checkout-bar') : [];
          setTimeout(function(){
            e('form[action="/cart/add"]').find("select").length > 0 &&
                e('form[action="/cart/add"]')
                    .find(".swatch")
            .each(function (i) {
              e(this).find('.swatch-element').each(function(p){
                var b =e(this).find('input');
                b.each(function(x){
                  "id" !== e(this).attr("name") &&
                    e(this).change(function (i) {
                    e(this).val();
                    var r = "",
                        n = [];
                    e('form[action="/cart/add"]')
                    .find("select")
                    .each(function (t) {

                      var a = e(this),
                          i = a.val(),
                          s = a.attr("name");
                      "id" !== s && "quantity" !== s && "none" !== s && null != i && (n.push(i), (r = r.concat(i + " / ")));
                    }),
                      r && (r = r.slice(0, -3)),
                      n.length > 0 &&
                      (e.each(n, function (t, a) {
                      e(".hs-content-variant-select-option").find(".hs-change-select-option").find(".hs-select-box-load").eq(t).find("select.hs-select-option-checkout-bar").val(escape(a));
                    }),
                       (a = HsCartDrawer.captureVariants(r, t, e)),
                       HsCartDrawer.callBackVariant(a, t, e));
                  });
                })

              })
            })
            
            var cart_bar_forms = document.querySelectorAll('form[action="/cart/add"],[data-product-blocks]').length > 0 ? document.querySelectorAll('form[action="/cart/add"],[data-product-blocks]') : [];
            if(cart_bar_forms.length > 0){
              cart_bar_forms.forEach(function(cart_bar_form){
                var cart_bar_select = cart_bar_form.querySelectorAll('select').length > 0 ? cart_bar_form.querySelectorAll('select') : [] ;
                if(cart_bar_select.length > 0){
                  cart_bar_select.forEach(function(vals,i){
                    e(".hs-content-variant-select-option").find(".hs-change-select-option").find(".hs-select-box-load").eq(i).find("select.hs-select-option-checkout-bar").val(escape(vals.value));
                    var ev = new Event("change", {"bubbles":true, "cancelable":false});
                    vals.dispatchEvent(ev);
                  });
                };
              });
            };
        }, 2500);

          
          e(".hs-select-option-checkout-bar").unbind("change");
          /*e(".hs-select-option-checkout-bar").change(function (a) {
                    a.preventDefault(), e(this).find("option:selected").data("id");
                    var i,
                        r = e(this).val(),
                        n = "",
                        s = [];
                    e(".hs-content-variant-select-option")
                        .find(".hs-change-select-option")
                        .find(".hs-select-box-load")
                        .each(function (t) {
                            (n = n.concat(unescape(e(this).find("select").val() + " / "))), s.push(unescape(e(this).find("select").val()));
                        }),
                        n && (n = n.slice(0, -3)),
                        e('form[action="/cart/add"]').find("select").length > 0 &&
                            e('form[action="/cart/add"]')
                                .find(".swatch")
                                .each(function (t) {
                                  e(this).find('.swatch-element').each(function(p){
                                    var b =e(this).find('input');
                                    b.each(function(x){
                                      console.log(r)
                                      console.log(s[x])
                                      if ("id" !== e(this).attr("name") && r == s[x]) {
                                        console.log(e(this))
                                        var a = e(this).attr("id");
                                        e(this).val(s[t]);
                                        var i = document.getElementById(a),
                                            n = document.createEvent("HTMLEvents");
                                        n.initEvent("change", !1, !0), e(this)[0].dispatchEvent(n);
                                      }
                                    })
                                  })
                                }),
                        (i = HsCartDrawer.captureVariants(n, t, e)),
                        HsCartDrawer.callBackVariant(i, t, e);
                }),*/
            
            
          //selectOpt.length>0&&selectOpt.forEach(function(a){a.classList.contains("hs-event-static")||(a.classList.add("hs-event-static"),a.addEventListener("change",function(e){e.preventDefault(),a.querySelector("option:checked").dataset.id,unescape(a.value);var b="",f=[],c=document.querySelector(".hs-content-variant-select-option").querySelector(".hs-change-select-option").querySelectorAll(".hs-select-box-load").length>0?document.querySelector(".hs-content-variant-select-option").querySelector(".hs-change-select-option").querySelectorAll(".hs-select-box-load"):[];c.length>0&&c.forEach(function(c){var a=unescape(c.querySelector("select").value);b=b.concat(a+" / "),f.push(a)}),b&&(b=b.slice(0,-3));var d=document.querySelectorAll('form[action="/cart/add"],[data-product-blocks]').length>0?document.querySelectorAll('form[action="/cart/add"],[data-product-blocks]'):[];d.length>0&&d.forEach(function(a){var b=a.querySelectorAll(".swatch").length>0?a.querySelectorAll(".swatch"):"";b.length>0&&b.forEach(function(a,c){var b=a.querySelectorAll(".swatch-element").length>0?a.querySelectorAll(".swatch-element"):[];b.length>0&&b.forEach(function(b){var a=b.querySelector("input")?b.querySelector("input"):"";if(a&&a.value===f[c]){console.log()var d=new Event("change",{bubbles:!0,cancelable:!1});a.dispatchEvent(d)}})})})}))})
          selectOpt.length > 0 && selectOpt.forEach(function(a) {
            a.classList.contains("hs-event-static") || (a.classList.add("hs-event-static"), a.addEventListener("change", function(e) {
              var $where = this;
              e.preventDefault();
                //a.querySelector("option:checked").dataset.id, unescape(a.value);
              var id = a.querySelector("option:checked").dataset.id, value = unescape(a.value);
				var element = document.querySelector(`form[action="/cart/add"] .swatch .swatch-element input[value="${value}"]`);
                  var d = new Event("change", {
                    bubbles: !0,
                    cancelable: !1
                  });
                  element.dispatchEvent(d)
              /*var d = document.querySelectorAll('form[action="/cart/add"],[data-product-blocks]').length > 0 ? document.querySelectorAll('form[action="/cart/add"],[data-product-blocks]') : [];
              d.length > 0 && d.forEach(function(a) {
                var b = a.querySelectorAll(".swatch").length > 0 ? a.querySelectorAll(".swatch") : "";
                b.length > 0 && b.forEach(function(a, c) {
                  var b = a.querySelectorAll(".swatch-element").length > 0 ? a.querySelectorAll(".swatch-element") : [];
                  b.length > 0 && b.forEach(function(b) {
                    var a = b.querySelector("input") ? b.querySelector("input") : "";
                    if (a.value === f[c]) {
                      var d = new Event("change", {
                        bubbles: !0,
                        cancelable: !1
                      });
                      a.dispatchEvent(d)
                    }
                  })
                })
              })*/
            }))
          })
                
          e('form[action="/cart/add"]').find('select[name="id"]').trigger("change"),
                e(".hs-checkout-bar-add-to-cart").click(function (a) {
                    a.preventDefault();
                    var i = e(this),
                        r = e('form[action="/cart/add"] input[name="id"]'),
                        n = e('form[action="/cart/add"] select[name="id"]').val(),
                        s = e(".hs-content-quantity input.hs-quick-button-quantity"),
                        j = e('form[action="/cart/add"] button[name="add"]').first(),
                        o = e('.hs-content-checkout-bar .hs-content-variant-select-option .hs---quantity input').val();
            
            			HsCartDrawer.qtyAddToCartBar = {"click":true,qty:o};
                        
                        j[0].click();
                        //j.first()[0].click();
            			//j.trigger('click',o);
                    /*s.length > 0 && (o = s.val()),
                        r.length > 0 && (n = r.val()),
                        n || (n = e(this).closest(".hs-content-checkout-bar").find(".hs-content-variant-select-option").find("select.hs-select-variants-bar").val()),
                        i.addClass("hs-loading-btn"),
                        (o = parseInt(o)),
                        e("header a[href*=cart]").addClass("hs-open-cart-url-2"),
                        (HsCartDrawer.params = { id: n, quantity: o }),
                        HsCartDrawer.ajaxBarCart(1, HsCartDrawer.params, i, t, e);*/
                });
            var i = t.sticky_cart_bar_mobile_show_scroll,v = t.sticky_cart_bar_desktop_show_scroll,r = 80;
            /*e(window).width() < 770 && 0 == i && (r = 0),
                e(".hs-sticky-checkout-bar").addClass("hs-hide-element"),
                e(".hs-sticky-checkout-bar").removeClass("hs-show-element"),
                e(window).scrollTop() >= r && (e(".hs-sticky-checkout-bar").removeClass("hs-hide-element"), e(".hs-sticky-checkout-bar").addClass("hs-show-element")),
                e(window).scroll(function () {
                (r = 80),
                  e(window).width() < 770 && 0 == i && (r = 0),
                  e(".hs-sticky-checkout-bar").addClass("hs-hide-element"),
                  e(".hs-sticky-checkout-bar").removeClass("hs-show-element"),
                  e(this).scrollTop() >= r && (e(".hs-sticky-checkout-bar").removeClass("hs-hide-element"), e(".hs-sticky-checkout-bar").addClass("hs-show-element"));
              })*/
            
                function isScrolledIntoView(elem){
                  elem = !!document.querySelector(elem) ? document.querySelector(elem) : '';
                  if(!!elem)
                  {
                    var elementOffsetHeight = elem.offsetHeight;
                    let offsetTop = 0;
                    while(elem) {
                      offsetTop += elem.offsetTop;
                      elem = elem.offsetParent;
                    }
                    var docViewTop =  window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
                    var docViewBottom = docViewTop + window.innerHeight;
                    var elemTop = offsetTop
                    var elemBottom = elemTop + elementOffsetHeight;
                    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
                  }
                };
                function scrollAndresize(sticky_cart_bar_mobile_show_scroll,sticky_cart_bar_desktop_show_scroll,aTop,hs_checkout_bar){
                  var windowScroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                  var check = false;
                  if(document.location.pathname === "/"){
                    check=true;
                  }
                  if(!!hs_checkout_bar){
                    if(window.innerWidth < 770)
                    {
                      if(parseInt(sticky_cart_bar_mobile_show_scroll))
                      {
                        if(!check)
                        {
                          var atc_visibility = isScrolledIntoView('form[data-zp-link-type="checkout"] button[data-zp-link-type="checkout"],[action$="/cart/add"] [type="submit"], [action$="/cart/add.js"] [type="submit"], [action$="/cart/add"] [name="add"], [action$="/cart/add.js"] [name="add"], [action$="/cart/add"] .shg-btn, [action$="/cart/add.js"] .shg-btn, [data-action="add-to-cart"], [action$="/cart/add"] .btn-addtocart, [action$="/cart/add.js"] .btn-addtocart,[action$="/cart/add.js"] .addtocart-js,[action$="/cart/add"] .addtocart-js,[action$="/cart/add"] .tt-btn-addtocart,[action$="/cart/add"] .addtocart-item-js,[action$="/cart/add.js"] .tt-btn-addtocart,[action$="/cart/add.js"] .addtocart-item-js, .addCart,button.add-to-cart-btn,.add-to-cart.btn,button.add_to_cart_btn_cls.fly_addtocart,button.quick-add-btn[data-id]')
                          if(!!atc_visibility)
                          {
                            hs_checkout_bar.classList.add('hs-hide-element');
                            hs_checkout_bar.classList.remove('hs-show-element');
                          }else{
                            if(windowScroll < 1)
                            {
                              hs_checkout_bar.classList.add('hs-hide-element');
                              hs_checkout_bar.classList.remove('hs-show-element');
                            }
                            else if(windowScroll >=aTop){
                              hs_checkout_bar.classList.remove('hs-hide-element');
                              hs_checkout_bar.classList.add('hs-show-element');
                            }
                          }
                        }
                      }else{
                        hs_checkout_bar.classList.add('hs-hide-element');
                        hs_checkout_bar.classList.remove('hs-show-element');
                        if(windowScroll >=aTop){
                          hs_checkout_bar.classList.remove('hs-hide-element');
                          hs_checkout_bar.classList.add('hs-show-element');
                        }
                      }
                    }
                    else{
                      if(parseInt(sticky_cart_bar_desktop_show_scroll))
                      {
                        if(!check)
                        {
                          var atc_visibility = isScrolledIntoView('form[data-zp-link-type="checkout"] button[data-zp-link-type="checkout"],[action$="/cart/add"] [type="submit"], [action$="/cart/add.js"] [type="submit"], [action$="/cart/add"] [name="add"], [action$="/cart/add.js"] [name="add"], [action$="/cart/add"] .shg-btn, [action$="/cart/add.js"] .shg-btn, [data-action="add-to-cart"], [action$="/cart/add"] .btn-addtocart, [action$="/cart/add.js"] .btn-addtocart,[action$="/cart/add.js"] .addtocart-js,[action$="/cart/add"] .addtocart-js,[action$="/cart/add"] .tt-btn-addtocart,[action$="/cart/add"] .addtocart-item-js,[action$="/cart/add.js"] .tt-btn-addtocart,[action$="/cart/add.js"] .addtocart-item-js, .addCart,button.add-to-cart-btn,.add-to-cart.btn,button.add_to_cart_btn_cls.fly_addtocart,button.quick-add-btn[data-id]')
                          if(!!atc_visibility)
                          {
                            hs_checkout_bar.classList.add('hs-hide-element');
                            hs_checkout_bar.classList.remove('hs-show-element');
                          }else{
                            if(windowScroll < 1)
                            {
                              hs_checkout_bar.classList.add('hs-hide-element');
                              hs_checkout_bar.classList.remove('hs-show-element');
                            }
                            else if(windowScroll >=aTop){
                              hs_checkout_bar.classList.remove('hs-hide-element');
                              hs_checkout_bar.classList.add('hs-show-element');
                            }
                          }
                        }
                      }else{
                        hs_checkout_bar.classList.add('hs-hide-element');
                        hs_checkout_bar.classList.remove('hs-show-element');
                        if(windowScroll >=aTop){
                          hs_checkout_bar.classList.remove('hs-hide-element');
                          hs_checkout_bar.classList.add('hs-show-element');
                        }
                      }
                    }
                  };
                };
          
                var sticky_cart_bar_mobile_show_scroll = parseInt(i);
          		var sticky_cart_bar_desktop_show_scroll = parseInt(v);
                var aTop = r;
                var hs_checkout_bar = !!document.querySelector('.hs-sticky-checkout-bar') ? document.querySelector('.hs-sticky-checkout-bar') : '';
                var windowScroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
          
                window.addEventListener('scroll', function(e) {
                  scrollAndresize(sticky_cart_bar_mobile_show_scroll,sticky_cart_bar_desktop_show_scroll,aTop,hs_checkout_bar);
                },{passive: true});
          
                e(window).resize(function () {
                   /* (r = 80),
                        e(this).width() < 770 && 0 == i && (r = 0),
                        e(".hs-sticky-checkout-bar").addClass("hs-hide-element"),
                        e(".hs-sticky-checkout-bar").removeClass("hs-show-element"),
                        e(this).scrollTop() >= r && (e(".hs-sticky-checkout-bar").removeClass("hs-hide-element"), e(".hs-sticky-checkout-bar").addClass("hs-show-element"));
                */
                  scrollAndresize(sticky_cart_bar_mobile_show_scroll,sticky_cart_bar_desktop_show_scroll,aTop,hs_checkout_bar);
                }),
                e('form[action="/cart/add"]').find("select").length > 0 &&
                    e('form[action="/cart/add"]')
                        .find("select")
                        .each(function (t) {
                            var a = e(this).attr("name");
                            "id" !== a && "quantity" !== a && e(this).change();
                        });
          var qty=0<document.querySelectorAll(".hs---qty").length?document.querySelectorAll(".hs---qty"):[],inputQty=0<document.querySelectorAll("input.hs-quick-button-quantity2").length?document.querySelectorAll("input.hs-quick-button-quantity2"):[];0<qty.length&&qty.forEach(function(u){u.addEventListener("click",function(t){var e=0,n=u.closest(".hs---buttons_added").querySelector("input").value,e=u.classList.contains("hs---plus")?parseFloat(n)+1:1<n?parseFloat(n)-1:1;0<inputQty.length&&inputQty.forEach(function(t){t.value=e})})});
          var elementProductSelectVariants = !!document.getElementById("product-selectors") ? document.getElementById("product-selectors") : '';
          if(!!elementProductSelectVariants)
          {
            var myVariant = HsCartDrawer.captureVariantsIds(elementProductSelectVariants.value,t,e);
            HsCartDrawer.callBackVariant(myVariant,t,e);
          }
        },
        captureVariantsIds:function(id,data,$){
          var arr = [];
          if(HsCartDrawer.arr_variants)
          {
            $.each(HsCartDrawer.arr_variants, function( index, value ) {
    			if(id == value.id)
                {
                  arr.push(value);
                }
            });
            arr = arr[0];
          }
          return arr;
        },
        URL_add_parameter: function (t, e, a) {
            var i = {},
                r = document.createElement("a");
            r.href = t;
            for (var n = r.search.split(/\?|&/), s = 0; s < n.length; s++)
                if (n[s]) {
                    var o = n[s].split("=");
                    i[o[0]] = o[1];
                }
            i[e] = a;
            var l = [];
            return (
                Object.keys(i).forEach(function (t) {
                    l.push(t + "=" + i[t]);
                }),
                (r.search = "?" + l.join("&")),
                r.href
            );
        },
        removeParam: function (t, e) {
            var a = e.split("?")[0],
                i = [],
                r = -1 !== e.indexOf("?") ? e.split("?")[1] : "";
            if ("" !== r) {
                for (var n = (i = r.split("&")).length - 1; n >= 0; n -= 1) i[n].split("=")[0] === t && i.splice(n, 1);
                a = a + "?" + i.join("&");
            }
            return a;
        },
        changeVariants: function (t, e) {
            e(".hs-select-option").unbind("change"),
                e(".hs-select-option").change(function (t) {
                    t.preventDefault();
                    var a = e(this).find("option:selected").data("id"),
                        i = "";
                    e(".hs-product-cart-drawer-" + a)
                        .find(".hs-change-select-option")
                        .find(".hs-select-box-load")
                        .each(function (t) {
                            i = i.concat(e(this).find("select").val() + " / ");
                        }),
                        i && (i = i.slice(0, -3)),
                        e(".hs-option-parent-" + a)
                            .val(i)
                            .trigger("change");
                }),
                e(".hs-select-option-add-to-cart").unbind("change"),
                e(".hs-select-option-add-to-cart").change(function (a) {
                    a.preventDefault();
                    var i = e(this).find("option:selected"),
                        r = e(this).data("id"),
                        n = (i.data("variantid"), i.data("available"));
                    e(".hs-button-cart-" + r).removeAttr("disabled"),
                        e(".hs-flag-" + r).html(""),
                        0 == n && e(".hs-flag-" + r).html('<div class="hs-product-label hs-top-left" style="background: #9E9E9E;"><span class="hs-right-arrow" style="border-left-color: #9E9E9E;"></span>' + t.text_stock + "</div>"),
                        void 0 === n &&
                            (e(".hs-button-cart-" + r).attr("disabled", "disabled"),
                            e(".hs-flag-" + r).html('<div class="hs-product-label hs-top-left" style="background: #9E9E9E;"><span class="hs-right-arrow" style="border-left-color: #9E9E9E;"></span>' + t.text_unavailable + "</div>"));
                }),
                e(".hs-quick-button-quantity").unbind("click"),
                e(".hs-quick-button-quantity").click(function (t) {
                    t.preventDefault();
                }),
                e(".hs-add-to-cart").unbind("click"),
                e(".hs-add-to-cart").click(function (a) {
                    a.preventDefault();
                    var i = e(this).data("id"),
                        r = 160,
                        n = e(this),
                        s = e(this).closest(".hs-product-cart-drawer-" + i),
                        o = s.parent("div"),
                        l = e(".hs-option-parent-" + i),
                        c = e(".hs-combobox-option-variant"),
                        d = e(".hs-combobox-option-variant-" + i),
                        p = "",
                        h = 1;
                    if ((a = e(".hs-combobox-option-variant-" + i + ".active")).length > 0) return d.removeClass("active"), !1;
                    o.length > 0 && (r = o.height() - 45),
                        s.find(".hs-quick-button-quantity").length > 0 && (h = s.find(".hs-quick-button-quantity").val()),
                        e("header a[href*=cart]").addClass("hs-open-cart-url-2"),
                        (h = parseInt(h)),
                        d.height(r),
                        c.removeClass("active"),
                        e(this).addClass("hs-loading-cart"),
                        e(this).html('<span><i class="fa fa-refresh fa-spin fa-1x fa-fw"></i></span>'),
                        1 == e(this).parent(".hs-content-cart-drawer-loop").find(".hs-select-option-add-to-cart").find("option").length
                            ? ((p = l.find("option:selected").data("variantid")), (HsCartDrawer.params = { id: p, quantity: h }), HsCartDrawer.ajaxCart(1, HsCartDrawer.params, n, t, e))
                            : setTimeout(function () {
                                  n.html('<span><i class="fa ' + t.quickbuybutton_icon + '"></i></span>'), d.addClass("active");
                              }, 200);
                }),
                e(".hs-combobox-option-variant").find("li").unbind("click"),
                e(".hs-combobox-option-variant")
                    .find("li")
                    .click(function (a) {
                        a.preventDefault();
                        var i = e(this).data("id"),
                            r = e(this).data("vid"),
                            n = e(".hs-product-cart-drawer-" + i),
                            s = e(".hs-button-cart-" + i),
                            o = 1;
                        e(".hs-combobox-option-variant-" + i).removeClass("active"),
                            s.addClass("hs-loading-cart"),
                            s.html('<span><i class="fa fa-refresh fa-spin fa-1x fa-fw"></i></span>'),
                            n.find(".hs-quick-button-quantity").length > 0 && (o = n.find(".hs-quick-button-quantity").val()),
                            (o = parseInt(o)),
                            (HsCartDrawer.params = { id: r, quantity: o }),
                            HsCartDrawer.ajaxCart(0, HsCartDrawer.params, s, t, e);
                    });
        },
        onLoadVariants: function (t, e) {
            e(".hs-select-option-add-to-cart").change();
        },
        quickBuyByttonByCollections: function (t, e) {
            var a = window.location.href;
            if (!parseInt(t.enable_app)) return !1;
            if (a.indexOf("/cart") > -1) return !1;
            if (0 == t.enable_quick_buy_button) return !1;
            var i = [],
                r = "";
            if (
                ((a = ""),
                e("a").each(function (t) {
                    e(this),
                        void 0 !== (a = e(this).attr("href")) &&
                            a.indexOf("/products/") > -1 &&
                            ((r = (r = a.split("/products/"))[1]).indexOf("?") > -1 && (r = (r = r.split("?"))[0]),
                            r.indexOf("#") > -1 && (r = (r = r.split("#"))[0]),
                            (r = decodeURIComponent(r)),
                            (r = decodeURIComponent(r)),
                            (r = decodeURIComponent(r)),
                            i.push(r));
                }),
                i)
            ) {
                i = (i = i.unique()).chunk_inefficient2(20);
                var n = "";
                e.each(i, function (a, i) {
                    (n = ""),
                        e.each(i, function (t, e) {
                            n = n.concat(e + "|");
                        }),
                        HsCartDrawer.addBuyButton(n, t, e);
                });
            }
        },
        isJson: function (t) {
            t = "string" != typeof t ? JSON.stringify(t) : t;
            try {
                t = JSON.parse(t);
            } catch (t) {
                return !1;
            }
            return "object" == typeof t && null !== t;
        },
        addBuyButton: function (t, e, a) {
            if (t) {
                var i = "",
                    r = "",
                    n = "";
                (t = t.slice(0, -1)),
                    a.ajax({
                        type: "GET",
                        data: { q: t, view: "hs-products" },
                        url: "/search",
                        contentType: "application/json",
                        beforeSend: function () {},
                        success: function (t) {
                            if (1 == HsCartDrawer.isJson(t)) {
                                var s = JSON.parse(t);
                                a("a").each(function (t) {
                                    (n = a(this)),
                                        void 0 !== (r = a(this).attr("href")) &&
                                            r.indexOf("/products/") > -1 &&
                                            ((i = (i = r.split("/products/"))[1]).indexOf("?") > -1 && (i = (i = i.split("?"))[0]),
                                            i.indexOf("#") > -1 && (i = (i = i.split("#"))[0]),
                                            (i = decodeURIComponent(i)),
                                            (i = decodeURIComponent(i)),
                                            (i = decodeURIComponent(i)),
                                            HsCartDrawer.fromCreateVariants(n, i, s, e, a));
                                });
                            }
                        },
                        error: function (t) {},
                        complete: function () {
                            HsCartDrawer.resizeDesktopAndMobile(e, a);
                        },
                    });
            }
        },
        fromCreateVariants: function (t, e, a, i, r) {
            var n = 1,
                s = "",
                o = "",
                l = "",
                c = "",
                d = "",
                p = "",
                h = "",
                u = [],
                m = [],
                f = [],
                g = [],
                b = [],
                w = [],
                v = [],
                y = "",
                _ = "",
                x = "",
                k = "",
                C = "";
            r.each(a, function (a, S) {
                e == S.handle &&
                    (r(".hs-product-cart-drawer-" + S.id),
                    S.options,
                    (u = S.variants),
                    (k = ""),
                    (C = ""),
                    (b = []),
                    (w = []),
                    (v = []),
                    (n = 1),
                    r.each(u, function (t, e) {
                        (y = ""),
                            (_ = ""),
                            (x = ""),
                            (n = e.options.length),
                            r.each(e.options, function (t, e) {
                                0 == t && (y = e), 1 == t && (_ = e), 2 == t && (x = e);
                            }),
                            y.length > 0 && b.push(y),
                            _.length > 0 && w.push(_),
                            x.length > 0 && v.push(x),
                            (k = k.concat(
                                '<option value="' +
                                    e.title +
                                    '" title="' +
                                    e.title +
                                    '" data-id="' +
                                    S.id +
                                    '" data-price="' +
                                    e.price +
                                    '" data-sku="' +
                                    e.sku +
                                    '" data-available="' +
                                    e.available +
                                    '" data-barcode="' +
                                    e.barcode +
                                    '" data-featuredimage="' +
                                    S.featured_image +
                                    '" data-inventorymanagement="' +
                                    e.inventory_management +
                                    '" data-compareatprice="' +
                                    e.compare_at_price +
                                    '" data-variantid="' +
                                    e.id +
                                    '">' +
                                    e.title +
                                    "</option>"
                            )),
                            (C = C.concat('<li data-id="' + S.id + '" data-vid="' + e.id + '"><span>' + e.title + "</li></span>"));
                    }),
                    (d = ""),
                    (p = ""),
                    (h = ""),
                    (C = '<ul class="hs-combobox-option-variant hs-combobox-option-variant-' + S.id + '">' + C + "</ul>"),
                    (o = '<input type="number" class="hs-quick-button-quantity ' + i.quick_buy_button_position + '" name="hs-quick-button-quantity" value="1" min="1">'),
                    (l =
                        '<button type="button" class="hs-add-to-cart hs-button-cart-' +
                        S.id +
                        " " +
                        i.quick_buy_button_position +
                        ' animated bounceIn" data-id="' +
                        S.id +
                        '"><span><i class="fa ' +
                        i.quickbuybutton_icon +
                        '"></i></span></button>'),
                    (c = '<div class="hs-flag-content hs-flag-' + S.id + '" style="display:none;"></div>'),
                    (k = '<select class="hs-option-parent-' + S.id + ' hs-select-option-add-to-cart" name="none" data-id="' + S.id + '" style="display:none;">' + k + "</select>"),
                    (m = b.filter(function (t, e) {
                        if (b.indexOf(t) == e) return t;
                    })),
                    (f = w.filter(function (t, e) {
                        if (w.indexOf(t) == e) return t;
                    })),
                    (g = v.filter(function (t, e) {
                        if (v.indexOf(t) == e) return t;
                    })),
                    m.length > 0 &&
                        (r.each(m, function (t, e) {
                            d = d.concat('<option value="' + e + '" data-id="' + S.id + '">' + e + "</option>");
                        }),
                        (d =
                            '<div class="hs-select-box-load hs-load-select-box-bar-' +
                            n +
                            '"><span class="hs-select-text">' +
                            S.options[0] +
                            '</span><select class="hs-option-' +
                            S.id +
                            '-0 hs-select-option" name="none">' +
                            d +
                            "</select></div>")),
                    f.length > 0 &&
                        (r.each(f, function (t, e) {
                            p = p.concat('<option value="' + e + '" data-id="' + S.id + '">' + e + "</option>");
                        }),
                        (p =
                            '<div class="hs-select-box-load hs-load-select-box-bar-' +
                            n +
                            '"><span class="hs-select-text">' +
                            S.options[1] +
                            '</span><select class="hs-option-' +
                            S.id +
                            '-1 hs-select-option" name="none">' +
                            p +
                            "</select></div>")),
                    g.length > 0 &&
                        (r.each(g, function (t, e) {
                            h = h.concat('<option value="' + e + '" data-id="' + S.id + '">' + e + "</option>");
                        }),
                        (h =
                            '<div class="hs-select-box-load hs-load-select-box-bar-' +
                            n +
                            '"><span class="hs-select-text">' +
                            S.options[2] +
                            '</span><select class="hs-option-' +
                            S.id +
                            '-2 hs-select-option" name="none">' +
                            h +
                            "</select></div>")),
                    0 == i.show_quantity_selector_buy_button && (o = ""),
                    (s = '<div class="hs-change-select-option" style="display:none;">' + d + p + h + "</div>" + k),
                    t.parent().find("img").length > 0 &&
                        (t.prepend('<div class="hs-product-cart-drawer-' + S.id + ' hs-content-cart-drawer-loop"></div>'),
                        r(".hs-product-cart-drawer-" + S.id).html(s),
                        r(".hs-product-cart-drawer-" + S.id).css("position", "relative"),
                        r(".hs-product-cart-drawer-" + S.id).append(o + l + c + C)));
            }),
                HsCartDrawer.changeVariants(i, r),
                HsCartDrawer.onLoadVariants(i, r);
        },
        animatedHover: function (t, e) {
            1 == t.animatedHover &&
                e(".hs-sticky-cart-cart-drawer").hover(function () {
                    var t = e(this);
                    t.find("mark").hasClass("animated") ||
                        (t.find("mark").addClass("swing"),
                        t.find("mark").addClass("animated"),
                        setTimeout(function () {
                            t.find("mark").removeClass("swing"), t.find("mark").removeClass("animated");
                        }, 1e3));
                });
        },
        startAnimatedQuickBuyButton: function (t, e) {
            if (0 == t.enable_cart_animator) return !1;
            if ("none" === t.quick_buy_button_animation) return !1;
            var a = e(".hs-add-to-cart");
            setTimeout(function () {
                a.removeClass("animated"),
                    a.removeClass("bounceIn"),
                    a.removeClass("bounce"),
                    a.removeClass("flash"),
                    a.removeClass("pulse"),
                    a.removeClass("rubberBand"),
                    a.removeClass("shake"),
                    a.removeClass("swing"),
                    a.removeClass("tada"),
                    a.removeClass("wobble"),
                    a.removeClass("jello");
            }, 1e3),
                setTimeout(function () {
                    a.addClass("animated"), a.addClass(t.quick_buy_button_animation), HsCartDrawer.startAnimatedQuickBuyButton(t, e);
                }, 3e3);
        },
        startAnimatedCheckout: function (t, e) {
            if (0 == t.enable_cart_animator) return !1;
            if ("none" === t.checkout_button_animation) return !1;
            var a = e('.hs-checkout-purchase,button[type="submit"][name="checkout"],input[type="submit"][name="checkout"]');
            setTimeout(function () {
                a.removeClass("animated"),
                    a.removeClass("bounceIn"),
                    a.removeClass("bounce"),
                    a.removeClass("flash"),
                    a.removeClass("pulse"),
                    a.removeClass("rubberBand"),
                    a.removeClass("shake"),
                    a.removeClass("swing"),
                    a.removeClass("tada"),
                    a.removeClass("wobble"),
                    a.removeClass("jello");
            }, 1e3),
                setTimeout(function () {
                    a.addClass("animated"), a.addClass(t.checkout_button_animation), HsCartDrawer.startAnimatedCheckout(t, e);
                }, 3e3);
        },
        startAnimatedAddToCart: function (t, e) {
            if (0 == t.enable_cart_animator) return !1;
            if ("none" === t.add_to_cart_button_animation) return !1;
            var a = e('button[type="submit"][name="add"]');
            setTimeout(function () {
                a.removeClass("animated"),
                    a.removeClass("bounceIn"),
                    a.removeClass("bounce"),
                    a.removeClass("flash"),
                    a.removeClass("pulse"),
                    a.removeClass("rubberBand"),
                    a.removeClass("shake"),
                    a.removeClass("swing"),
                    a.removeClass("tada"),
                    a.removeClass("wobble"),
                    a.removeClass("jello");
            }, 1e3),
                setTimeout(function () {
                    a.addClass("animated"), a.addClass(t.add_to_cart_button_animation), HsCartDrawer.startAnimatedAddToCart(t, e);
                }, 3e3);
        },
        startAnimatedStickyBarButton: function (t, e) {
            if (0 == t.enable_cart_animator) return !1;
            if ("none" === t.sticky_bar_button_animation) return !1;
            var a = e(".hs-checkout-bar-add-to-cart");
            setTimeout(function () {
                a.removeClass("animated"),
                    a.removeClass("bounceIn"),
                    a.removeClass("bounce"),
                    a.removeClass("flash"),
                    a.removeClass("pulse"),
                    a.removeClass("rubberBand"),
                    a.removeClass("shake"),
                    a.removeClass("swing"),
                    a.removeClass("tada"),
                    a.removeClass("wobble"),
                    a.removeClass("jello");
            }, 1e3),
                setTimeout(function () {
                    a.addClass("animated"), a.addClass(t.sticky_bar_button_animation), HsCartDrawer.startAnimatedStickyBarButton(t, e);
                }, 3e3);
        },
        InitStickyCheckoutBar: function (t, e) {
            if (!parseInt(t.enable_sticky_cart_bar)) return !1;
            var a = window.location.href,
                i = "";
          HsCartDrawer.cssCartBar(t);
            void 0 !== a &&
                a.indexOf("/products/") > -1 &&
                ((i = (i = a.split("/products/"))[1]).indexOf("?") > -1 && (i = (i = i.split("?"))[0]),
                i.indexOf("#") > -1 && (i = (i = i.split("#"))[0]),
                (i = decodeURIComponent(i)),
                (i = decodeURIComponent(i)),
                (i = decodeURIComponent(i))),
                i &&
                    e.ajax({
                        type: "GET",
                        data: { q: i, view: "hs-products" },
                        url: "/search",
                        contentType: "application/json",
                        beforeSend: function () {},
                        success: function (a) {
                            if (1 == HsCartDrawer.isJson(a)) {
                                var i = JSON.parse(a);
                                i && ((HsCartDrawer.arr_variants = i[0].variants), HsCartDrawer.stickyCheckoutBar(i, t, e));
                            }
                        },
                        error: function (t) {},
                        complete: function () {
                            HsCartDrawer.resizeDesktopAndMobile(t, e), HsCartDrawer.productReview(t, e);
                        },
                    });
        },
        loadSvg:function(){
                      return `<svg class="hs-icon-loading" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
          <path fill="#fff" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
          <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s" from="0 50 50" to="360 50 50" repeatCount="indefinite"></animateTransform>
          </path>
          </svg>`;
          },
        cssCartBar:function(e){
                var contentCssCartBar = `
header{\
z-index:100 !important;\
}\
.ajax-success-modal, .loading-modal {\
    display: none !important;\
}\
.hs-content-checkout-bar .hs-change-select-option .hs-select-box-load.hs-load-select-box-bar-3:nth-last-child(-n+1){
margin-left:0px !important;
}

.hs-sticky-checkout-bar.hs-mobile-bottom {\
box-shadow: rgba(0, 0, 0, 0.2) 0px -1px 8px !important;\
}\
.hs-sticky-checkout-bar.hs-mobile-top {\
box-shadow: rgba(0, 0, 0, 0.2) 0px -1px 8px !important;\
}\
.hs-sticky-checkout-bar.hs-desktop-top {\
box-shadow: rgba(0, 0, 0, 0.2) 0px -1px 8px !important;\
}\
.hs-sticky-checkout-bar.hs-desktop-top{\
top:${e.position_offset_desktop}px !important;\
bottom: inherit !important;\
}\
.hs-sticky-checkout-bar.hs-show-element{\
visibility: hidden !important;\
transition: all .7s !important;\
}\
.hs-sticky-checkout-bar.hs-hide-element{\
visibility: visible !important;\
z-index : 0 !important;\
transition: all .7s !important;\
}\
.hs-sticky-checkout-bar.hs-sticky-bar.hs-hide-element {\
z-index: -1 !important;\
}\
.hs-sticky-checkout-bar {\
position: fixed !important;\
top: 0 !important;\
left: 0 !important;\
z-index: 99 !important;\
width: 100% !important;\
}\
.hs-content-checkout-bar {\
box-sizing: border-box !important;\
margin: 0 auto !important;\
width: 100% !important;\
font-size: 18px !important;\
line-height: 18px !important;\
background: ${e.sticky_cart_bar_background_color} !important;\
padding-right: 10px !important;\
padding-left: 10px !important;\
display: flex !important;\
display: -webkit-flex !important;\
-webkit-box-align: center !important;\
align-items: center !important;\
-webkit-box-pack: justify !important;\
}\
.hs-sticky-checkout-bar.hs-show-element{\
visibility: visible !important;\
opacity: 1 !important;\
}\
.hs-content-checkout-bar .hs-select-box-load .hs-select-text {\
display: none !important;\
}\
.hs-content-checkout-bar .hs-content-image-and-title {\
vertical-align: middle !important;\
height: 57px !important;\
-webkit-box-align: center !important;\
align-items: center !important;\
-webkit-box-pack: justify !important;\
justify-content: space-between !important;\
display: flex !important;\
display: -webkit-flex !important;\
flex-direction: row !important;\
flex-wrap: nowrap !important;\
width: auto !important;\
flex: 1 1 auto !important;\
overflow: hidden !important;\
position: relative !important;\
height: auto !important;\
margin-top: 0px !important;\
}\
.hs-content-checkout-bar.hs-hidden-header .hs-content-image-and-title {\
display: none !important;\
}\
.hs-content-checkout-bar .hs-image-thumb {\
display: flex !important;\
display: -webkit-flex !important;\
-webkit-box-align: center !important;\
align-items: center !important;\
max-width: 100% !important;\
flex: 1 1 auto !important;\
overflow: hidden !important;\
}\
.hs-desktop-top .hs-content-checkout-bar .hs-thumb-and-title, .hs-desktop-bottom .hs-content-checkout-bar .hs-thumb-and-title {\
margin-bottom: 0px !important;\
}\
.hs-content-checkout-bar .hs-thumb-and-title {\
-webkit-box-pack: justify !important;\
display: flex !important;\
display: -webkit-flex !important;\
-webkit-box-align: center !important;\
align-items: center !important;\
margin-right: 10px !important;\
//margin-bottom: 0px !important;\
width: auto !important;\
flex: 1 1 auto !important;\
overflow: hidden !important;\
}\
.hs-content-checkout-bar .hs-bar-content-image {\
line-height: 0 !important;\
}\
.hs-content-checkout-bar .hs-bar-content-title {\
display: flex !important;\
display: -webkit-flex !important;\
width: calc(100% - 60px) !important;\
flex-direction: column !important;\
line-height: 1.4 !important;\
}\
.hs-content-checkout-bar .hs-bar-content-title a {\
text-decoration:none !important;\
}\
.hs-sticky-bar-add-to-cart-product-title .hs-sticky-bar-product-title{\
color: ${e.sticky_cart_bar_product_title_color} !important;\
cursor: pointer !important;\
white-space: nowrap !important;\
text-overflow: ellipsis !important;\
overflow: hidden !important;\
}\
.hs-content-checkout-bar .hs-product-review {\
color: ${e.sticky_cart_bar_product_title_color};\
font-size: 14px !important;\
white-space: nowrap !important;\
text-overflow: ellipsis !important;\
overflow: hidden !important;\
}\
.hs-content-checkout-bar .hs-select-option-checkout-bar {\
font-family: GothamLight;
font-size: 14px;
-webkit-appearance: none !important;\
-moz-appearance: none !important;\
appearance: none !important;\
background-position: right center !important;\
background-image: url("//cdn.shopify.com/s/files/1/0251/1021/6792/t/12/assets/ico-select.svg") !important;\
background-repeat: no-repeat !important;\
background-position: right 10px center !important;\
padding-right: 28px !important;\
text-indent: 0.01px !important;\
text-overflow: "" !important;\
cursor: pointer !important;\
padding-top: 0px !important;\
padding-left: 18px !important;\
padding-bottom: 0px !important;\
height: 35px !important;\
min-height: 35px !important;\
margin: 0 !important;\
appearance: none !important;\
width: 100% !important;\
text-overflow: ellipsis !important;\
box-shadow: none !important;\
outline: none !important;\
outline-offset: inherit !important;\
}\
.hs-content-checkout-bar .hs-bar-content-price {\
display: none !important;\
-webkit-box-align: center !important;\
align-items: center !important;\
-webkit-box-pack: justify !important;\
justify-content: space-between !important;\
}\
.hs-content-checkout-bar.hs-hidden-select .hs-select-box-load,.hs-content-checkout-bar .hs-hidden-quantity-mobile {\
display: none !important;\
}\
.hs---quantity.hs---buttons_added {\
display: flex !important;\
text-align: left !important;\
position: relative !important;\
white-space: nowrap !important;\
vertical-align: top !important;\
line-height: 0 !important;\
}\
.hs---quantity.hs---buttons_added .hs---minus {\
border-right: 0 !important;\
}\
.hs---quantity.hs---buttons_added .hs---minus,.hs---quantity.hs---buttons_added .hs---plus {\
display: inline-flex !important;\
align-items: center !important;\
justify-content: center !important;\
padding: 0px 8px !important;\
background-color: #ffffff !important;\
border-radius: 0px !important;\
border: 1px solid #949494 !important;\
height: 41px !important;\
line-height: 41px !important;\
min-height: auto !important;\
cursor: pointer !important;\
font-size: inherit !important;\
box-sizing: border-box !important;\
box-shadow: none !important;\
outline: none !important;\
letter-spacing: 0 !important;\
width:27px !important;\
}\
.hs---quantity.hs---buttons_added input {\
display: inline-block;\
margin: 0 !important;\
vertical-align: top !important;\
box-shadow: none !important;\
}\
.hs---quantity .hs-quick-button-quantity2 {\
color: #000 !important;\
width: 40px !important;\
height: 35px !important;\
padding: 0px !important;\
text-align: center !important;\
background-color: #fff !important;\
border: 0px !important;\
border-top: 1px solid #949494 !important;\
border-bottom: 1px solid #949494 !important;\
border-radius: 0 !important;\
outline: none !important;\
min-height: auto !important;\
}\
.hs---quantity.hs---buttons_added .hs---minus,.hs---quantity.hs---buttons_added .hs---plus {\
display: inline-flex !important;\
align-items: center !important;\
justify-content: center !important;\
padding: 0px 8px !important;\
background-color: #ffffff !important;\
border-radius: 0px !important;\
border: 1px solid #949494 !important;\
height: 35px !important;\
line-height: 41px !important;\
min-height: auto !important;\
cursor: pointer !important;\
font-size: inherit !important;\
box-sizing: border-box !important;\
box-shadow: none !important;\
outline: none !important;\
letter-spacing: 0 !important;\
}\
.hs---quantity.hs---buttons_added .hs---minus {\
border-right: 0 !important;\
}\
.hs---quantity.hs---buttons_added .hs---plus {\
border-left: 0 !important;\
}\
.hs---quantity.hs---buttons_added svg {\
width: auto !important;\
height: auto !important;\
vertical-align: unset !important;\
}\
.hs---minus svg,.hs---plus svg {\
fill: #7d7d7d !important;\
}\
.hs-checkout-bar-price,.hs-checkout-bar-compare-at-price{\
vertical-align: middle !important;\
display: flex !important;\
display: -webkit-flex !important;\
flex-direction: row !important;\
white-space: nowrap !important;\
}\
.hs-checkout-bar-price .hs-money-price{\
color:${e.sticky_cart_bar_price_color} !important;\
margin-left: 10px !important;\
}\
.hs-checkout-bar-compare-at-price {\
text-decoration: line-through !important;\
color:${e.sticky_cart_bar_compare_price_color} !important;\
}\
.hs-content-variant-select-option .hs-checkout-bar-compare-at-price .hs-money-compare-price {\
margin-left: 10px !important;\
}\ 
.hs-content-checkout-bar .hs-content-variant-select-option {\
margin-bottom: 0rem !important;\
display: flex !important;\
display: -webkit-flex !important;\
flex-direction: row !important;\
margin-left: 0px !important;\
width: auto !important;\
-webkit-box-align: center !important;\
align-items: center !important;\
-webkit-box-pack: justify !important;\
}\
.hs-content-checkout-bar .hs-change-select-option {\
position: relative !important;\
margin-bottom: 0rem !important;\
display: flex !important;\
display: -webkit-flex !important;\
flex-direction: row !important;\
margin-left: 0px !important;\
width: auto !important;\
}\
.hs-content-checkout-bar .hs-select-box-load {\
position: relative !important;\
display: flex !important;\
display: -webkit-flex !important;\
-webkit-box-align: center !important;\
align-items: center !important;\
max-width: 140px !important;\
min-width: 110px !important;\
padding-right: 5px!important ;\
flex: 1 1 auto !important ;\
margin-left: 0px !important;
}\
.hs-content-checkout-bar .hs-full-bar-button {\
line-height: 41px;\
margin-left: 10px !important;\
}\
.hs-content-checkout-bar .hs-full-bar-button .hs-checkout-bar-add-to-cart {\
box-sizing: border-box;\
margin: 0 ;\
width: 100%;\
max-width: 100%;\
height: 40px;\

box-shadow:none;\
}\
.hs-content-checkout-bar .hs-checkout-bar-add-to-cart[disabled="disabled"] {\
cursor:default !important;\
}\
.hs-checkout-bar-add-to-cart, .hs-checkout-bar-add-to-cart:focus, .hs-checkout-bar-add-to-cart:active, .hs-checkout-bar-add-to-cart:hover {\
position:relative !important;\
-moz-user-select: none !important;\
-ms-user-select: none !important;\
-webkit-user-select: none !important;\
user-select: none !important;\
-webkit-appearance: none !important;\
-moz-appearance: none !important;\
appearance: none !important;\
display: inline-block !important;\
width: auto !important !important;\
text-decoration: none !important;\
text-align: center !important;\
vertical-align: middle !important;\
cursor: pointer !important;\
border: 1px solid transparent !important;\
border-radius: 4px !important;\
padding: 8px 15px !important;\
background-color: ${e.sticky_cart_bar_button_color} !important;\
color: ${e.sticky_cart_bar_button_text_color} !important;\
font-style: normal !important;\
white-space: normal !important;\
font-size: 14px !important;\
line-height: 14px !important;\
/*margin-left: 10px !important;\*/
-webkit-box-pack: center !important;\
justify-content: center !important;\
white-space: nowrap !important;\
user-select: none !important;\
overflow: hidden !important ;\
min-width:120px !important;\
}\
.hs-checkout-bar-add-to-cart:hover {\
background-color: #60808E !important;\
}\
.hs-checkout-bar-add-to-cart span,.hs-checkout-bar-add-to-cart:focus > span,.hs-checkout-bar-add-to-cart:active > span, .hs-checkout-bar-add-to-cart:hover > span{\
color: ${e.sticky_cart_bar_button_text_color} !important;\
font-style: normal !important;\
font-size: 14px !important;\
white-space: nowrap !important;\
}\
.hs--loading {\
display: none;\
}\
.hs-content-checkout-bar .hs-image-thumb {\
display: flex !important;\
display: -webkit-flex !important;\
-webkit-box-align: center !important;\
align-items: center !important;\
max-width: 100% !important;\
flex: 1 1 auto !important;\
overflow: hidden !important;\
}\
.hs-sticky-checkout-bar.hs-desktop-bottom {\
bottom:${e.position_offset_desktop}px !important;\
top: auto !important;\
}\
.hs-sticky-checkout-bar.hs-desktop-top {\
box-shadow: rgba(0, 0, 0, 0.2) 0px -1px 8px !important;\
}\
.hs-sticky-checkout-bar.hs-desktop-bottom {\
box-shadow: rgba(0, 0, 0, 0.2) 0px -1px 8px !important;\
}\
.hs-sticky-checkout-bar.hs-mobile-bottom {\
box-shadow: rgba(0, 0, 0, 0.2) 0px -1px 8px !important;\
}\
.hs-sticky-checkout-bar.hs-sticky-checkout-bar-6919672365231.hs-mobile-top.hs-sticky-bar.hs-show-element {\
box-shadow: rgba(0, 0, 0, 0.2) 0px -1px 8px !important;\
}\
.hs-content-checkout-bar .hs-content-image-and-title .hs-image-thumb img {\
margin-right: 10px !important;\
max-height: 58px !important;\
max-width: 58px !important;\
}\
.hs-loading-btn{\
position:relative !important;\
}\
.hs-loading-btn .hs-add--to--cart {\
visibility: hidden !important;\
opacity: 0 !important;\
}\
.hs-loading-btn .hs--loading {\
display: flex !important !important;\
display: -webkit-flex !important;\
align-items: center !important;\
justify-content: center !important;\
position: absolute !important;\
top: 50% !important;\
left: 50% !important;\
transform: translate(-50%, -50%) !important;\
width: 100% !important;\
}\
.hs--loading svg{\
width: 50px !important;\
height: 50px !important;\
}\

.hs-cross-sell .hs-swiper-button-next, .hs-cross-sell  .hs-swiper-button-prev {\
position: absolute !important;\
top: 50% !important;\
width: calc(var(--hs-swiper-navigation-size)/ 15 * 27) !important;\
height: var(--hs-swiper-navigation-size) !important;\
margin-top: calc(0px - (var(--hs-swiper-navigation-size)/ 2)) !important;\
z-index: 10 !important;\
cursor: pointer !important;\
display: flex !important;\
align-items: center !important;\
justify-content: center;\
line-height: 1 !important;\
}\
.hs-select-box-load.hs-hidden-select---variants {\
display: none !important;\
}\

.hs-sticky-checkout-bar .hs-full-bar-button .hs-content-quantity\
{\
display:none !important;\
}\

.hs-product-price-container\
{\
display:none !important;\
}\

@media (max-width: 769px){
.hs---quantity.hs---buttons_added .hs---minus, .hs---quantity.hs---buttons_added .hs---plus{\
height: 41px !important;
}\
.hs---quantity .hs-quick-button-quantity2{\
height: 41px !important;
}\
.hs-sticky-checkout-bar .hs-change-select-option .hs-content-quantity\
{\
display:none !important;\
}\
.hs-sticky-checkout-bar .hs-full-bar-button .hs-content-quantity\
{\
display:${!!parseInt(e.sticky_cart_bar_mobile_show_quantity_select) ? 'block' : 'none'} !important;\
margin: 2px 2px 2px 5px !important;\
}\
.hs-sticky-checkout-bar .hs-full-bar-button button\
{\
display: block !important;\
justify-content: center !important;\
margin: 0px 5px 0px 2px !important;\
//animation: 2s ease 0s infinite normal none running carty-labs-sticky-bar-none !important;\
height: 41px !important;\
line-height: 20px !important;\
width: 100% !important;\
position: relative !important;\
font-size: inherit !important;\
font-weight: bold !important;\
box-shadow: none !important;\
white-space: nowrap !important;\
margin: 5px 5px 5px 5px !important !important;\
}\
.hs-content-checkout-bar .hs-select-option-checkout-bar\
{\
height: 35px !important;\
flex: 1 1 150px !important;\
font-size: 11px !important;
}\

.hs-content-checkout-bar{\
font-size: 16px !important;\
line-height: 16px !important;\
-webkit-box-align: center !important;\
align-items: center !important;\
-webkit-box-pack: justify !important;\
justify-content: space-between !important;\
display: flex !important;\
display: -webkit-flex !important;\
flex-direction: row !important;\
padding: 0px !important;\
flex-wrap: wrap !important;\
width: 100% !important;\
flex: 1 1 auto !important;\
overflow: hidden !important;\
}\
.hs-sticky-checkout-bar.hs-mobile-bottom{\
bottom:${e.position_offset_mobile}px;\
top: auto;\
}\
.hs-content-checkout-bar .hs-content-image-and-title {\
width: 100% !important;\
padding: 0px 5px !important;\
}\
.hs-content-checkout-bar .hs-bar-content-price {\
display: none !important;\
}\
.hs-content-checkout-bar .hs-content-variant-select-option {\
-webkit-box-align: center !important;\
align-items: center !important;\
-webkit-box-pack: justify !important;\
justify-content: space-between !important;\
display: flex !important;\
display: -webkit-flex !important;\
flex-direction: row !important;\
flex-wrap: wrap !important;\
width: 100% !important;\
flex: 1 1 auto !important;\
overflow: hidden !important;\
}\
.hs-content-checkout-bar .hs-change-select-option {\
padding: 2px 3px 0px 3px !important;\
width: calc(100% + 1.1rem) !important;\
display: flex !important;\
margin: 2px 2px 0px !important;\
flex: 1 1 100% !important;\
flex-wrap: wrap !important;\
}\

.hs-content-checkout-bar.quantityButton{\
display:flex !important;\
}\
.hs-content-checkout-bar.quantityButton .hs-change-select-option {\
margin-left: 5px !important;
padding:0px;
width: auto !important;\
}\
.hs-content-checkout-bar.quantityButton .hs-content-variant-select-option{\
width: auto !important;\
}\
.hs-content-checkout-bar.quantityButton .hs-full-bar-button{\
width: auto !important;\
margin-rigth: 5px !important;\
}\

.hs-change-select-option {\
padding-right: 0px !important;\
}\
.hs-content-variant-select-option .hs-checkout-bar-compare-at-price, .hs-content-variant-select-option .hs-checkout-bar-price {\
display: none !important;\
}\
.hs-content-checkout-bar .hs-select-box-load {\
position: relative !important;\
display: block !important;\
-webkit-box-align: center !important;\
align-items: center !important;\
max-width: initial !important;\
min-width: 70px !important;\
padding-right: 0px !important;\
}\
.hs-content-checkout-bar .hs-select-box-load {\
margin-bottom: 2px !important;\
}\
.hs-content-checkout-bar .hs-full-bar-button {\
margin-left: 0px !important;\
-webkit-box-align: center !important;\
align-items: center !important;\
-webkit-box-pack: justify !important;\
justify-content: space-between !important;\
display: flex !important;\
display: -webkit-flex !important;\
flex-direction: row !important;\
width: 100% !important;\
flex: 1 1 auto !important;\
overflow: hidden !important;\
}\
.hs-full-bar-button .hs-content-quantity-resize {\
padding-right: 10px !important;\
}\
.hs-full-bar-button {\
align-items: center !important;\
flex-direction: row !important;\
width: 100% !important;\
margin-left:0px !important;\
}\
.hs-content-checkout-bar .hs-checkout-bar-add-to-cart{\
font-size: 16px !important;\
height:52px !important !important;\
}\
.hs-full-bar-button button.hs-checkout-bar-add-to-cart {\
border-radius: 0 !important !important;\
}\
.hs-content-checkout-bar .hs-checkout-bar-add-to-cart{\
font-size: 16px !important;\
height:52px !important !important;\
}\
.hs-sticky-checkout-bar.hs-mobile-top{\
top:${e.position_offset_mobile}px !important;\
bottom: auto !important;\
}\
}
`;
                document.querySelector('head').insertAdjacentHTML('beforeend', '<style type="text/css">'+contentCssCartBar+'</style>');
              },
              printCottonCover: function(){
                  var elementCottonCover = document.querySelectorAll('.choose-cotton-cover').length > 0 ? document.querySelector('.choose-cotton-cover') : 0;
                  var textHeader = '';
                  var value_1 = '';
                  var value_2 = '' ;
                  var value_prices = '';
                  var value_prices_data = 0;
                  var ct = '';
                  if(!!elementCottonCover)
                  {
                    textHeader = elementCottonCover.querySelector('.header').innerText;
                    value_1 = elementCottonCover.querySelectorAll('.swatch-element').length > 0 ? elementCottonCover.querySelectorAll('.swatch-element')[0].getAttribute('data-value') : '';
                    value_2 = elementCottonCover.querySelectorAll('.swatch-element').length > 1 ? elementCottonCover.querySelectorAll('.swatch-element')[1].getAttribute('data-value') : '';
                    value_prices = elementCottonCover.querySelector('.hs-additional-price').innerText;
                    value_prices_data = elementCottonCover.querySelector('.hs-additional-price').getAttribute('data-price');
                    value_prices_compares_data = elementCottonCover.querySelector('.hs-additional-price').getAttribute('data-compare-price');
                    ct = '<div class="hs-select-box-load hs-load-select-box-bar-cotton-cover" style="display: block;"><select class="hs-option-cotton-cover hs-select-option-checkout-bar" name="none"><option value="'+textHeader+'" disabled="">'+textHeader+'</option><option value="'+value_1+'">'+value_1+'</option><option data-price="'+value_prices_data+'" data-compare-price="'+value_prices_compares_data+'" value="'+value_2+'">'+value_2+' '+value_prices+'</option></select></div>';
                  }
                  return ct;
                },
                changeCottonCover: function () {
                const wrap = document.querySelector('.choose-cotton-cover');
                if (!wrap) return;

                // Radios/inputs con name="option-3" dentro del contenedor
                const optionInputs = wrap.querySelectorAll('[name="option-3"]');
                const cottonSelect = document.querySelector('.hs-option-cotton-cover');

                // 1) Cuando el usuario elige un radio/input => sincroniza el select
                if (optionInputs.length && cottonSelect) {
                    optionInputs.forEach(function (input) {
                    if (input.classList.contains('hs-event-static')) return;
                    input.classList.add('hs-event-static');

                    const syncToSelect = function () {
                        const value = input.value;
                        cottonSelect.value = value;

                        // dispara change "real" (bubbles) por compatibilidad
                        cottonSelect.dispatchEvent(new Event('change', { bubbles: true }));
                    };

                    // mejor escuchar change (click a veces no cambia el valor aún)
                    input.addEventListener('change', syncToSelect);
                    input.addEventListener('click', syncToSelect);
                    });
                }

                // 2) Cuando cambia el select => activa el radio correspondiente
                // Nota: si tienes MÁS de un select, cambia querySelector por querySelectorAll y recorre.
                if (cottonSelect && !cottonSelect.classList.contains('hs-event-static')) {
                    cottonSelect.classList.add('hs-event-static');

                    cottonSelect.addEventListener('change', function (e) {
                    const selectedValue = String(e.target.value || '').trim().toLowerCase();
                    if (!selectedValue) return;

                    // Evita armar ".<valor>" como selector (puede romperse con espacios/símbolos)
                    // Mejor: buscar el input cuyo value coincida.
                    const targetInput = Array.from(optionInputs).find(function (inp) {
                        return String(inp.value || '').trim().toLowerCase() === selectedValue;
                    });

                    if (!targetInput) return;

                    // Si existe label asociado, lo clickas; si no, click al input.
                    const id = targetInput.getAttribute('id');
                    const label = id ? wrap.querySelector('label[for="' + CSS.escape(id) + '"]') : null;

                    if (label) {
                        label.click();
                    } else {
                        targetInput.click();
                    }
                    });
                }
                },
                stickyCheckoutBar: function (t, e, a) {
                  var ct = HsCartDrawer.printCottonCover();
                  var count_options = 1,
                    review = '',
                    hs_price = '',
                    compare_price_active = '',
                    sticky_cart_bar_desktop_position = ' hs-desktop-top',
                    sticky_cart_bar_mobile_position = ' hs-mobile-top',
                    title = '',
                    content = '',
                    price = '',
                    count_variants = 0,
                    hidden_variant = '',
                    compare_at_price = '',
                    content_compare_at_price = '<div class="hs-checkout-bar-compare-at-price"></div>',
                    checkoutBar = '',
                    featured_image = '',
                    quantity = '',
                    button = '',
                    flag = '',
                    filterText1 = '',
                    filterText2 = '',
                    filterText3 = '',
                    options = [],
                    variants = [],
                    filteredArr1 = [],
                    filteredArr2 = [],
                    filteredArr3 = [],
                    opt1 = [],
                    opt2 = [],
                    opt3 = [],
                    option1 = '',
                    option2 = '',
                    option3 = '',
                    selectParent = '',
                    selectVariant = '';

                    1 == parseInt(e.sticky_cart_bar_desktop_position, 10) &&
                    (sticky_cart_bar_desktop_position = ' hs-desktop-bottom');

                    1 == parseInt(e.sticky_cart_bar_mobile_position, 10) &&
                    (sticky_cart_bar_mobile_position = ' hs-mobile-bottom');

                    t.forEach(function (t) {
                    var i = `<div class="hs-sticky-checkout-bar hs-sticky-checkout-bar-${t.id} ${sticky_cart_bar_desktop_position} ${sticky_cart_bar_mobile_position} hs-sticky-bar" style="visibility: hidden;opacity: 0;"></div>`;

                    document.querySelector('body').insertAdjacentHTML('beforeend', i);

                    checkoutBar = document.querySelector(`.hs-sticky-checkout-bar-${t.id}`);
                    title = t.title;
                    price = t.price;
                    compare_at_price = t.compare_at_price;
                    featured_image = HsCartDrawer.imageResize(t.featured_image, 'x100');
                    options = t.options;
                    variants = t.variants;

                    selectParent = '';
                    selectVariant = '';
                    compare_price_active = '';

                    opt1 = [];
                    opt2 = [];
                    opt3 = [];

                    count_options = 1;
                    count_variants = variants.length;

                    variants.forEach(function (e, i) {
                        option1 = '';
                        option2 = '';
                        option3 = '';

                        count_options = e.options.length;

                        e.options.forEach(function (t, e) {
                        0 == e && (option1 = t);
                        1 == e && (option2 = t);
                        2 == e && (option3 = t);
                        });

                        option1.length > 0 && opt1.push(option1);
                        option2.length > 0 && opt2.push(option2);
                        option3.length > 0 && opt3.push(option3);

                        selectParent = selectParent.concat(
                        '<option value="' +
                            e.id +
                            '" data-id="' +
                            t.id +
                            '" title="' +
                            e.title +
                            '" data-price="' +
                            e.price +
                            '" data-sku="' +
                            e.sku +
                            '" data-available="' +
                            e.available +
                            '" data-barcode="' +
                            e.barcode +
                            '" data-featuredimage="' +
                            t.featured_image +
                            '" data-inventorymanagement="' +
                            e.inventory_management +
                            '" data-compareatprice="' +
                            e.compare_at_price +
                            '">' +
                            e.title +
                            '</option>'
                        );

                        selectVariant = selectVariant.concat(
                        '<li data-id="' +
                            t.id +
                            '" data-vid="' +
                            e.id +
                            '"><span>' +
                            e.title +
                            '</li></span>'
                        );
                    });

                    filterText1 = '';
                    filterText2 = '';
                    filterText3 = '';

                    selectParent =
                        '<select class="hs-select-variants-bar" style="display:none;">' +
                        selectParent +
                        '</select>';

                    selectVariant =
                        '<ul class="hs-combobox-option-variant hs-combobox-option-variant-' +
                        t.id +
                        '">' +
                        selectVariant +
                        '</ul>';

                    quantity =
                        '<div class="hs---quantity hs---buttons_added"><div class="hs---minus hs---qty"><svg xmlns="http://www.w3.org/2000/svg" width="10px" height="10px" viewBox="0 -192 469.33333 469"><path d="m437.332031.167969h-405.332031c-17.664062 0-32 14.335937-32 32v21.332031c0 17.664062 14.335938 32 32 32h405.332031c17.664063 0 32-14.335938 32-32v-21.332031c0-17.664063-14.335937-32-32-32zm0 0"></path></svg></div><input type="text" step="1" name="hs-quick-button-quantity2" value="1" title="Qty" class="hs-quick-button-quantity2" size="4" pattern="" inputmode=""><div class="hs---plus hs---qty"><svg xmlns="http://www.w3.org/2000/svg" width="10px" height="10px" version="1.1" x="0px" y="0px" viewBox="0 0 492 492" style="enable-background:new 0 0 492 492;" xml:space="preserve"> <g> <g> <path d="M465.064,207.566l0.028,0H284.436V27.25c0-14.84-12.016-27.248-26.856-27.248h-23.116 c-14.836,0-26.904,12.408-26.904,27.248v180.316H26.908c-14.832,0-26.908,12-26.908,26.844v23.248 c0,14.832,12.072,26.78,26.908,26.78h180.656v180.968c0,14.832,12.064,26.592,26.904,26.592h23.116 c14.84,0,26.856-11.764,26.856-26.592V284.438h180.624c14.84,0,26.936-11.952,26.936-26.78V234.41 C492,219.566,479.904,207.566,465.064,207.566z"></path> </g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></div></div>';

                    button =
                        '<button type="button" class="hs-add-to-cart hs-button-cart-' +
                        t.id +
                        ' ' +
                        e.quick_buy_button_position +
                        ' hs-animated HsbounceIn" data-id="' +
                        t.id +
                        '"><span>' +
                        HsCartDrawer.quick_buyIcon +
                        '</span></button>';

                    flag = '<div class="hs-flag-content hs-flag-' + t.id + '" style="display:none;"></div>';

                    filteredArr1 = opt1.filter(function (t, e) {
                        if (opt1.indexOf(t) == e) return t;
                    });

                    filteredArr2 = opt2.filter(function (t, e) {
                        if (opt2.indexOf(t) == e) return t;
                    });

                    filteredArr3 = opt3.filter(function (t, e) {
                        if (opt3.indexOf(t) == e) return t;
                    });

                    if (filteredArr1.length > 0) {
                        hidden_variant = '';

                        filteredArr1.forEach(function (e, i) {
                        1 == count_variants && 'Default Title' == e && (hidden_variant = ' hs-hidden-select---variants');

                        filterText1 = filterText1.concat(
                            '<option value="' + escape(e) + '" data-id="' + t.id + '">' + e + '</option>'
                        );
                        });

                        filterText1 =
                        '<div class="hs-select-box-load' +
                        hidden_variant +
                        ' hs-load-select-box-bar-' +
                        count_options +
                        '"><span class="hs-select-text">' +
                        t.options[0] +
                        '</span><select class="hs-option-' +
                        t.id +
                        '-0 hs-select-option-checkout-bar" name="none"><option value="' +
                        escape(t.options[0]) +
                        '" disabled>' +
                        t.options[0] +
                        '</option>' +
                        filterText1 +
                        '</select></div>';
                    }

                    if (filteredArr2.length > 0) {
                        filteredArr2.forEach(function (e, i) {
                        filterText2 = filterText2.concat(
                            '<option value="' + escape(e) + '" data-id="' + t.id + '">' + e + '</option>'
                        );
                        });

                        filterText2 =
                        '<div class="hs-select-box-load hs-load-select-box-bar-' +
                        count_options +
                        '"><span class="hs-select-text">' +
                        t.options[1] +
                        '</span><select class="hs-option-' +
                        t.id +
                        '-1 hs-select-option-checkout-bar" name="none"><option value="' +
                        escape(t.options[1]) +
                        '" disabled>' +
                        t.options[1] +
                        '</option>' +
                        filterText2 +
                        '</select></div>';
                    }

                    if (filteredArr3.length > 0) {
                        filteredArr3.forEach(function (e, i) {
                        filterText3 = filterText3.concat(
                            '<option value="' + escape(e) + '" data-id="' + t.id + '">' + e + '</option>'
                        );
                        });

                        filterText3 =
                        '<div class="hs-select-box-load hs-load-select-box-bar-' +
                        count_options +
                        '"><span class="hs-select-text">' +
                        t.options[2] +
                        '</span><select class="hs-option-' +
                        t.id +
                        '-2 hs-select-option-checkout-bar" name="none"><option value="' +
                        escape(t.options[2]) +
                        '" disabled>' +
                        t.options[2] +
                        '</option>' +
                        filterText3 +
                        '</select></div>';
                    }

                    if (compare_at_price > price) {
                        compare_price_active = ' hs-compare-price-active';

                        content_compare_at_price =
                        '<div class="hs-checkout-bar-compare-at-price"><s class="hs-money-compare-price">' +
                        hsonslidecart.Currency.formatMoney(compare_at_price, e.money_format) +
                        '</s></div>';
                    }

                    hs_price =
                        '<div class="hs-checkout-bar-price"><span class="hs-money-price' +
                        compare_price_active +
                        '">' +
                        hsonslidecart.Currency.formatMoney(price, e.money_format) +
                        '</span></div>';

                        const yotpoWidget = document.querySelector(
                            '.yotpo-widget-instance[data-yotpo-product-id]'
                        );

                        let yotpoProductId = t.id;

                        if (yotpoWidget) {
                            const customProductId = yotpoWidget.getAttribute('data-yotpo-product-id');

                            if (customProductId) {
                                yotpoProductId = customProductId;
                            }
                        }

                    null == featured_image &&
                        (featured_image =
                        'https://cdn.shopify.com/s/files/1/0251/1021/6792/t/12/assets/hs-no-image_thumb.gif');

                    review =
                        ' <div class="star_ratings_bar_bb"><div class="yotpo bottomLine" data-product-id="' +
                        yotpoProductId +
                        '"></div></div>';

                    content =
                        '<div class="hs-content-image-and-title">\t\t<div class="hs-image-thumb"> <div class="hs-thumb-and-title"> <div class="hs-bar-content-image"> <img class="hs-bar-featured-image" src="' +
                        featured_image +
                        '" alt="' +
                        t.title +
                        '" /> </div> <div class="hs-bar-content-title"> <span class="hs-sticky-bar-add-to-cart-product-title"> <div class="hs-sticky-bar-product-title">' +
                        title +
                        '</div> <div class="hs-product-review">' +
                        review +
                        '</div> <div class="hs-product-price-container" style="display: none; flex-direction: row;"> ' +
                        content_compare_at_price +
                        hs_price +
                        ' </div> </span> </div> </div> </div>\t\t<div class="hs-content-quantity-resize" style="display:none;">' +
                        quantity +
                        '</div> <div class="hs-bar-content-price"><div class="hs-hidden-quantity-mobile"><div class="hs-content-quantity">' +
                        quantity +
                        '</div></div>' +
                        content_compare_at_price +
                        hs_price +
                        '</div> </div> <div class="hs-content-variant-select-option"> <div class="hs-change-select-option"> ' +
                        filterText1 +
                        filterText2 +
                        filterText3 +
                        ct +
                        ' <div class="hs-content-quantity">' +
                        quantity +
                        '</div> </div> ' +
                        content_compare_at_price +
                        hs_price +
                        selectParent +
                        ' </div> <div class="hs-full-bar-button"> <div class="hs-content-quantity">' +
                        quantity +
                        '</div> <button type="button" class="hs-checkout-bar-add-to-cart btn"> <span class="hs-add--to--cart">' +
                        e.text_add_to_cart +
                        '</span> <span class="hs--loading">' +
                        HsCartDrawer.loadSvg() +
                        '</span> </button> </div><div class=\'hs-sl-content-btn-cart\'><button type=\'button\' class=\'hs-sl-btn hs-sl-btn--secondary hs-sl-btn--return-to-cart\' onclick=\'hsSlReturnToVariants()\'> SELECT SIZE </button></div>';

                    checkoutBar.innerHTML =
                        '<div class="hs-content-checkout-bar' + hidden_variant + '">' + content + '</div>';

                        if (
    typeof yotpoWidgetsContainer !== 'undefined' &&
    typeof yotpoWidgetsContainer.initWidgets === 'function'
) {
    yotpoWidgetsContainer.initWidgets();
}

                    });
                  HsCartDrawer.changeVariantsCheckoutBar(e,a)
                  HsCartDrawer.changeCottonCover();
                },
        imageResize: function (t, e) {
            try {
                if ("original" == e) return t;
                var a = t.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
                return a[1] + "_" + e + "." + a[2];
            } catch (e) {
                return t;
            }
        },
        createCpokie: function (t, e, a) {
            return (expires = new Date()), expires.setTime(expires.getTime() + 24 * a * 60 * 60 * 1e3), (cookie = t + "=" + e + ";expires=" + expires.toUTCString() + ";path=/"), (document.cookie = cookie);
        },
        readCookie: function (t) {
            return (keyValue = document.cookie.match("(^|;) ?" + t + "=([^;]*)(;|$)")), keyValue ? keyValue[2] : "";
        },
        setCookie: function (t, e, a) {
            var i = new Date();
            i.setTime(i.getTime() + 24 * a * 60 * 60 * 1e3);
            var r = "expires=" + i.toGMTString();
            document.cookie = t + "=" + e + "; " + r + ";path=/";
        },
        deleteCookie: function (t) {
            return (expires = new Date()), expires.setTime(expires.getTime() + -864e5), (cookie = t + "=;expires=" + expires.toUTCString() + ";path=/"), (document.cookie = cookie);
        },
        addCart: function (t, e, a) {
            a.ajax({
                url: "//stickycart.heysenior.com/ajaxcart/add?shop=" + HsCartDrawer.shopifyUrl,
                type: "POST",
                data: { result: t },
                cache: !1,
                dataType: "json",
                success: function (t) {},
                error: function (t) {},
                complete: function () {},
            });
        },
        productReview: function (t, e) {
            "undefined" != typeof SPR &&
                SPR.loadjQuery(function () {
                    return (
                        SPR.$.ajaxSetup({ cache: !1 }),
                        SPR.loadjQueryExtentions(SPR.$),
                        SPR.$(document).ready(function () {
                            return SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges();
                        })
                    );
                });
        },
        initproductReview: function () {
            "undefined" != typeof SPR &&
                (SPR.loadStylesheet(),
                SPR.loadjQuery(function () {
                    return (
                        SPR.$.ajaxSetup({ cache: !1 }),
                        SPR.loadjQueryExtentions(SPR.$),
                        SPR.$(document).ready(function () {
                            return SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges();
                        })
                    );
                }));
        },
        startDiscount: function (t, e) {
            var a = HsCartDrawer.readCookie("hscodediscount");
            e("button.hs-apply-discount").unbind("click"),
                e("button.hs-apply-discount").click(function (a) {
                    a.preventDefault();
                    var i = e("input.hs-discount-code").val();
                    if ((e(this).addClass("hs-loading"), HsCartDrawer.deleteCookie("hscodediscount"), "" === i)) return HsCartDrawer.errorDiscount(t, e), !1;
                    e.ajax({
                        url: "/checkout?discount=" + i,
                        dataType: "html",
                        success: function (a) {
                            if (a) {
                                e(a).find(".total-line-table__tbody .total-line .total-line__price .order-summary__emphasis").html(),
                                    e(a).find(".total-line-table__tbody .total-line .total-line__name>span").html(),
                                    e(a).find(".total-line__price.payment-due .payment-due__price").attr("data-checkout-payment-due-target");
                                var r = e(a).find(".total-line--reduction .total-line__price").find(".order-summary__emphasis").attr("data-checkout-discount-amount-target"),
                                    n = e("#hs-total-price-global").val(),
                                    s = e(a).find("#error-for-reduction_code").length,
                                    o = e(a).find(".notice--warning"),
                                    l = e(a).find("#error-for-reduction_code"),
                                    c = "",
                                    d = t.text_discount_checkout,
                                    p = (e(a).find(".total-line--subtotal .total-line__price .order-summary__emphasis").html(), e(a).find(".total-line__price.payment-due .payment-due__price").html());
                                if (0 == l.length && o.length > 0)
                                    return (
                                        e(".hs-success-code-discount").html(
                                            '<div class="hs--content--warning"><div class="hs---warning---icon"><svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 22" style=" "><path d="M15.286 2.386l7.91 13.857C25.01 19.423 23.65 22 20.16 22H3.84C.35 22-1.01 19.427.805 16.243l7.91-13.857c1.815-3.178 4.754-3.185 6.57 0zm-1.737.992c-1.05-1.838-2.05-1.837-3.1 0L2.54 17.235C1.468 19.122 1.93 20 3.84 20h16.32c1.91 0 2.374-.88 1.298-2.765l-7.91-13.857zM12 6.5c.552 0 1 .448 1 1V12c0 .552-.448 1-1 1s-1-.448-1-1V7.5c0-.552.448-1 1-1zm-1.5 10c0-.828.666-1.5 1.5-1.5.828 0 1.5.666 1.5 1.5 0 .828-.666 1.5-1.5 1.5-.828 0-1.5-.666-1.5-1.5z"></path></svg></div>' +
                                                o.find(".notice__content").html() +
                                                '<a href="javascript:void(0)" class="hs-close-discount-slide-cart hs---warging"><svg xmlns="http://www.w3.org/2000/svg" width="14px" height="14px" viewBox="0 0 13 13"><path d="M1.5 1.5l10.05 10.05M11.5 1.5L1.45 11.55" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round"></path></svg></a></div>'
                                        ),
                                        e("button.hs-apply-discount").removeClass("hs-loading"),
                                        HsCartDrawer.createCpokie("hscodediscount", i, 365),
                                        HsCartDrawer.closeCouponCheckout(t, e),
                                        !1
                                    );
                                0 == s
                                    ? ((p = HsCartDrawer.convertPrice(p, t, e)),
                                      (r = parseFloat(r)),
                                      (c = (n = parseFloat(n)) - (p = parseFloat(p))),
                                      (c = hsonslidecart.Currency.formatMoney(c, t.money_format)),
                                      HsCartDrawer.createCpokie("hscodediscount", i, 365),
                                      e(".hs-sub-total-cart").addClass("hs-payment-discount"),
                                      (p = hsonslidecart.Currency.formatMoney(p, t.money_format)),
                                      e(".hs_subtotal_amount_discount").html(p),
                                      (d = d.replace("{{ money }}", '<span class="hs_af_money">' + c + "</span>")),
                                      e(".hs-success-code-discount").html(
                                          '<p class="hs_discount_response hs_coupon_popup"><svg class="hs-discount-slide-cart-icon" width="16px" height="16px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55"></path><path d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path></svg><span class="hs_notice__text">' +
                                              d +
                                              '</span><a href="javascript:void(0)" class="hs-close-discount-slide-cart"><svg xmlns="http://www.w3.org/2000/svg" width="14px" height="14px" viewBox="0 0 13 13"><path d="M1.5 1.5l10.05 10.05M11.5 1.5L1.45 11.55" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round"></path></svg></a></p>'
                                      ),
                                      HsCartDrawer.currencyConverter(t, e))
                                    : HsCartDrawer.errorDiscount(t, e),
                                    e("button.hs-apply-discount").removeClass("hs-loading");
                            } else e("button.hs-apply-discount").removeClass("hs-loading");
                            HsCartDrawer.closeCouponCheckout(t, e);
                        },
                        error: function (t) {
                            t && "error" == t.statusText && (window.location.href = "/checkout?discount=" + i);
                        },
                        complete: function () {},
                    });
                }),
                "" !== a && e("button.hs-apply-discount").trigger("click");
        },
        convertPrice: function (t, e, a) {
            return t && (t = (t = t.replace(/[^a-zA-Z0-9]/g, "")).replace(/[^0-9]/g, "")), t;
        },
        closeCouponCheckout: function (t, e) {
            e(".hs-close-discount-slide-cart").unbind("click"),
                e(".hs-close-discount-slide-cart").click(function (t) {
                    t.preventDefault(), HsCartDrawer.deleteCookie("hscodediscount"), e("input.hs-discount-code").val(""), e("button.hs-apply-discount").trigger("click");
                });
        },
        addToCartFreeShipping: function (t, e) {
            e(".hs-upsell-add-to-cart").unbind("click"),
                e(".hs-upsell-add-to-cart").click(function (a) {
                    var i = e(this),
                        r = e(this).closest(".hs-content-title-price-swiper").find(".hs-swipper-select-option-add-to-cart").val();
                    i.addClass("hs-loading-btn"), (HsCartDrawer.params = { id: r, quantity: 1 }), HsCartDrawer.ajaxProductCartUpsell(HsCartDrawer.params, i, t, e);
                });
        },
        errorDiscount: function (t, e) {
            e("button.hs-apply-discount").removeClass("hs-loading"),
                e(".hs-sub-total-cart").removeClass("hs-payment-discount"),
                e(".hs-error-code-discount").html("<span>" + t.text_validate_coupon + "</span>"),
                e(".hs-success-code-discount").html(""),
                e(".hs_subtotal_amount_discount").html(""),
                setTimeout(function () {
                    e(".hs-error-code-discount").html("");
                }, 2e3);
        },
        updateSlideCart: function () {
            HsCartDrawer.getCart(0, [], HsCartDrawer.json, HsCartDrawer.query);
        },
        getSlideCart: function () {
            HsCartDrawer.getCart(1, [], HsCartDrawer.json, HsCartDrawer.query);
        },
        getQuickBuyBytton: function () {
            HsCartDrawer.quickBuyByttonByCollections(HsCartDrawer.json, HsCartDrawer.query);
        },
        currencyConverter: function (t, e) {
            e(".currency-switcher").length > 0 &&
                (e(".currency-switcher").click(function (t) {
                    t.stopPropagation();
                }),
                e(".currency-switcher").find("ul.list").find("li.selected").trigger("click", ["foo", "bar"]),
                e(".currency-switcher").removeClass("open"),
                e(".currency-switcher").unbind("click")),
                e(".pick_currency").length > 0 &&
                    (e(".pick_currency").click(function (t) {
                        t.stopPropagation();
                    }),
                    e(".pick_currency").find(".nice-select").find("ul.list").find("li.selected").trigger("click", ["foo", "bar"]),
                    e(".pick_currency").find(".nice-select").removeClass("open"),
                    e(".pick_currency").unbind("click")),
                e("select.currencies").length > 0 && e(".top_bar [data-currency-converter]").change();
        },
        offerCoupon: function (t, e) {
            if (!parseInt(t.all_page_enable_countdown_cart)) return !1;
            var a = "",
                i = "";
            (i = (i = t.all_page_time_remaining).replace("{{ COUNTDOWN }}", "<span class='hs-countdown-offer-mobile'><span id='hs_countdown_offer_plus'></span></span>")),
                parseInt(t.all_page_enable_countdown_cart) && (a = '<div style="padding:5px 20px;width:100%;position:fixed;top:0px;left:0px;z-index:2147483644;" class="hs-countdown-offer">' + i + "</div>"),
                "" !== a &&
                    (e("body").append(a),
                    e(document).ready(function () {
                        HsCartDrawer.mgTop(t, e);
                    })),
                HsCartDrawer.iniTimerOffer(t, e);
        },
        mgTop: function (t, e) {
            if (parseInt(t.all_page_enable_countdown_cart)) {
                var a = e(".hs-countdown-offer").height();
                (a += 10), (a += "px"), e("body").css("padding-top", a);
            }
        },
        iniTimerOffer: function (t, e) {
            var a = parseInt(t.all_page_how_many_minutes_cart_reservation),
                i = 60 * a;
            HsCartDrawer.countdown(a, i, t, e);
        },
        countdown: function (t, e, a, i) {
            t < 60 && (e = parseInt(sessionStorage.getItem("seconds")) || e),
                (function r() {
                    e--, t < 60 && sessionStorage.setItem("seconds", e);
                    var n = new Date(),
                        s = n.getSeconds(),
                        o = (o = 60 * (o = n.getMinutes())) + s,
                        l = 60 * t;
                    t > 59 && (e = (l -= 1) - o);
                    var c = Math.floor(e / 3600);
                    c = c < 10 ? "0" + c : c;
                    var d = parseInt(e / 60) % 60,
                        p = e % 60,
                        h = " hours",
                        u = " minutes",
                        m = " seconds";
                    1 == c && (h = " hour"),
                        1 == d && (u = " minute"),
                        1 == p && (m = " second"),
                        i("#hs_countdown_offer_plus").html(
                            "<span class='hs-countdown-slide-cart'>" + c + h + "</span><span class='hs-countdown-slide-cart'>" + d + u + "</span><span class='hs-countdown-slide-cart'>" + (p < 10 ? "0" : "") + p + m + "</span>"
                        ),
                        e > 0 ? setTimeout(r, 1e3) : (HsCartDrawer.iniTimerOffer(a, i), parseInt(a.all_page_countdown_expires_clear_cart) && (i(".hs-countdown-offer").html(a.all_page_countdown_expires), i(".hs-countdown-offer").remove()));
                })();
        },
        viewPage: function (t, e) {
            HsCartDrawer.pathname.indexOf("viewcart=true") > -1 && HsCartDrawer.getSlideCart(t, e);
        },
        init: function (t, e) {
            this.addstyle(t, e),
            this.freeShipping(t, e),
            this.contentPopup(t, e),
            this.quickBuyByttonByCollections(t, e),
            this.addToCart(t, e),
            this.showApp(t, e),
            this.resize(t, e),
            this.changeQuantityCart(t, e),
            this.animatedHover(t, e),
            this.startAnimatedQuickBuyButton(t, e),
            this.startAnimatedStickyBarButton(t, e),
            this.startAnimatedCheckout(t, e),
            this.startAnimatedAddToCart(t, e),
            this.initproductReview(t, e),
            this.startDiscount(t, e),
            this.iniTimer(t, e),
            this.offerCoupon(t, e),
            this.InitStickyCheckoutBar(t, e),
            this.viewPage(t, e);
        },
    },
    loadScript = function (t, e) {
        var a = document.createElement("script");
        (a.type = "text/javascript"),
            a.readyState
                ? (a.onreadystatechange = function () {
                      ("loaded" != a.readyState && "complete" != a.readyState) || ((a.onreadystatechange = null), e());
                  })
                : (a.onload = function () {
                      e();
                  }),
            (a.src = t),
            document.getElementsByTagName("head")[0].appendChild(a);
    },
    myAppJavaScript = function (t) {
        HsCartDrawer.query = t;
        HsCartDrawer.globalData = {
            money_format: "${{amount}}",
            sync: "0",
            status: "1",
            text_color: "#000000",
            background_color: "#ffffff",
            hover_text_color: "#000000",
            hover_background_color: "#ffffff",
            border_color: "#ffffff",
            footer_background_color: "#f2f2f2",
            footer_text_color: "#222222",
            button_color: "#ffffff",
            button_background_color: "#0f3a63",
            button_hover_background_color: "#0f3a63",
            cart_button_color: "#ffffff",
            cart_button_background_color: "#42603c",
            cart_button_hover_background_color: "#42603c",
            add_to_cart_status: "1",
            add_to_cart_text: "Add to cart",
            add_to_cart_button_color: "#ffffff",
            add_to_cart_button_background: "#299191",
            add_to_cart_button_hover_background: "#1e7272",
            border_color_variant_option: "#2196f3",
            background_variant_option: "rgba(119,118,135,0.5",
            variants_options_status: "1",
            load_color: "#0b2626",
            text_stock: "Sold out",
            text_unavailable: "Unavailable",
            text_products_singular: "Product",
            text_products_plural: "Products",
            text_subtotal: "Your Total",
            text_checkout: "Checkout",
            status_text_checkout: "1",
            text_cart: "Go to cart",
            text_shipping: "Most orders ship in 2-5 business days",
            text_clear_all: "Clear all",
            text_remove: "Clear",
            text_discount: "Add discount code, will be applied at checkout",
            text_note: "Write a note here",
            text_apply: "Apply",
            text_add: "Add To Cart",
            text_discount_code: "eg. Discount Code",
            text_validate_coupon: "Please Enter Valid Coupon Code.",
            text_instructions: "Special Instructions",
            text_add_to_cart: "Add To Cart",
            text_continue_shopping: "Continue Shopping",
            text_terms_and_conditions: "terms & conditions",
            text_agreed: "I have understood & agreed with your",
            text_congrats_free_shipping: "Congrats, you have got free shipping",
            text_away_from_free_shipping: "You are [price] away from free shipping!",
            text_message_terms_and_conditions: "You must accept the terms and conditions",
            text_discount_checkout: "Discount of {{ money }} applied",
            link_terms_and_conditions: "",
            status_text_cart: "0",
            status_text_continue_shopping: "1",
            continue_shopping_link: "",
            footer_text: "View all result",
            no_result_text: "Continue Shopping",
            max_search_results: "5",
            show_price: "1",
            show_sold_out_products: "1",
            filter_results: "product",
            hide_products_with_tag: "SearchHiddenMyProduct",
            spacing_from_search_box: "10",
            position: "fixed",
            status_swatch: "1",
            status_widget: "0",
            color_count_widget: "#333333",
            background_count_widget: "#ffffff",
            color_cart_widget: "#333333",
            background_cart_widget: "#cccccc",
            toppositionwidget: "20",
            style: "2",
            plan_id: "3",
            max_paginate: "12",
            shopping_cart_text: "REVIEW YOUR CART",
            stickycart_devices_status: "1",
            stickycart_hide_cart_page: "1",
            stickycart_show_desktop: "1",
            stickycart_hide_if_empty: "1",
            stickycart_position: "hs-top-right",
            stickycart_takes_user_to: "1",
            stickycart_icon: "fa-shopping-cart",
            enable_quick_buy_button: "0",
            enable_cart_animator: "0",
            enable_sticky_cart_bar: 1,
            enable_slide_cart: "1",
            enable_rewards: "0",
            enable_price_vat: "0",
            enable_announcement: "1",
            enable_additional_buttons: "0",
            show_on_tablets_and_mobile_devices_quick_buy_button: "1",
            show_quantity_selector_buy_button: "0",
            show_on_desktop_computers_quick_buy_button: "1",
            quick_buy_button_position: "hs-top-right",
            quick_buy_button_clicked: "no-redirect",
            quick_buy_button_background: "#eeeeee",
            quick_buy_button_color: "#000000",
            quick_buy_button_animation: "none",
            quick_buy_button_type: "0",
            checkout_button_animation: "shake",
            add_to_cart_button_animation: "shake",
            sticky_bar_button_animation: "shake",
            quickbuybutton_icon: "fa-cart-plus",
            sticky_cart_bar_button_color: "#165570",
            sticky_cart_bar_button_text_color: "#ffffff",
            sticky_cart_bar_background_color: "#ffffff",
            sticky_cart_bar_product_title_color: "#000000",
            sticky_cart_bar_price_color: "#000000",
            sticky_cart_bar_compare_price_color: "#999999",
            sticky_cart_bar_skip_button: "no-redirect",
            sticky_cart_bar_mobile_show_devices: "1",
            sticky_cart_bar_mobile_show_scroll: "1",
            sticky_cart_bar_mobile_hide_add_to_cart: "0",
            sticky_cart_bar_mobile_show_full_width: "0",
            sticky_cart_bar_mobile_show_product_image: "0",
            sticky_cart_bar_mobile_show_product_title: "0",
            sticky_cart_bar_mobile_show_review_stars: "0",
            sticky_cart_bar_mobile_show_variant_select: "1",
            sticky_cart_bar_mobile_show_quantity_select: "1",
            sticky_cart_bar_mobile_show_price: "1",
            sticky_cart_bar_mobile_show_compare_price: "1",
            sticky_cart_bar_mobile_position: "0",
            sticky_cart_bar_desktop_show_devices: "1",
            sticky_cart_bar_desktop_show_scroll: "1",
            sticky_cart_bar_desktop_hide_add_to_cart: "0",
            sticky_cart_bar_desktop_show_product_image: "1",
            sticky_cart_bar_desktop_show_product_title: "1",
            sticky_cart_bar_desktop_show_review_stars: "0",
            sticky_cart_bar_desktop_show_variant_select: "1",
            sticky_cart_bar_desktop_show_quantity_select: "1",
            sticky_cart_bar_desktop_show_price: "1",
            sticky_cart_bar_desktop_show_compare_price: "1",
            sticky_cart_bar_desktop_position: "0",
            sticky_cart_button_animation: "none",
            show_discount: "0",
            show_note: "0",
            show_total_per_variant: "0",
            show_total_quantity_products: "1",
            show_terms_and_conditions: "0",
            show_property: "0",
            position_offset_mobile: "88",
            position_offset_desktop: "35",
            enable_app: "1",
            product_price_color: "#807c7c",
            cart_color: "#807c7c",
            cart_border_color: "#eeeeee",
            enable_statistics: "1",
            custom_css: "",
            animatedHover: "1",
            checkout_color_hover_button: "#ffffff",
            checkout_border_size_button: "0",
            checkout_border_color_button: "#000000",
            checkout_border_color_hover_button: "#000000",
            checkout_border_radius_button: "2",
            checkout_border_style_button: "none",
            cart_color_hover_button: "#000000",
            cart_border_size_button: "0",
            cart_border_color_button: "#000000",
            cart_border_color_hover_button: "#000000",
            cart_border_radius_button: "2",
            cart_border_style_button: "none",
            continue_shopping_color_button: "#807c7c",
            continue_shopping_background_button: "rgba(255,255,255,1)",
            continue_shopping_border_radius_button: "2",
            continue_shopping_border_style_button: "solid",
            continue_shopping_border_size_button: "1",
            continue_shopping_border_color_button: "#807c7c",
            continue_shopping_color_hover_button: "#807c7c",
            continue_shopping_background_hover_button: "rgba(255,255,255,1)",
            continue_shopping_border_color_hover_button: "#807c7c",
            apply_color_button: "#ffffff",
            apply_background_button: "#000000",
            apply_border_radius_button: "2",
            apply_border_style_button: "solid",
            apply_border_size_button: "1",
            apply_border_color_button: "#000000",
            apply_hover_color: "#ffffff",
            apply_hover_background_color: "#000000",
            apply_border_color_hover_button: "#000000",
            rewards_font_size: "14px",
            rewards_style: "1",
            rewards_progress_background_color: "#f8f8f8",
            rewards_bar_background_color: "#000000",
            rewards_bar_color: "#000000",
            rewards_show_percentages: "1",
            rewards_bar_border_radius: "14px",
            announcement_color: "#fff",
            announcement_background_color: "#648ca4",
            announcement_border_color: "#648ca4",
            announcement_fontsize: "14px",
            announcement_align: "center",
            from_free_shipping: "100.00",
            announcement_module: `<div data-hs-limited-offer-mount data-hs-cart-surface="drawer"></div>`,
            enable_event: "0",
            group_products: "0",
            enable_countdown_cart: "0",
            how_many_minutes_cart_reservation: "60",
            time_remaining: "Your special offer is reserved for {{time_remaining}} minutes!",
            countdown_expires: "Cart reservation expired.",
            countdown_expires_clear_cart: "0",
            countdown_bgcolor: "#fff5d2",
            countdown_bordercolor: "#e3df74",
            countdown_fontcolor: "#2c2c2c",
            countdown_fontsize: "14px",
            countdown_align: "center",
            all_page_enable_countdown_cart: "0",
            all_page_how_many_minutes_cart_reservation: "60",
            all_page_time_remaining: "20% OFF Sale Ends {{ COUNTDOWN }} Code: TAKE20OFF",
            all_page_countdown_expires: "Coupon expired",
            all_page_countdown_expires_clear_cart: "0",
            all_page_countdown_bgcolor: "#fff5d2",
            all_page_countdown_bordercolor: "#e3df74",
            all_page_countdown_fontcolor: "#2c2c2c",
            all_page_countdown_fontsize: "14px",
            all_page_countdown_align: "center",
            upsell_mode: "0",
            upsell_title: "Today's Offer: 50% off Organic Bedding with Purchase!",
            upsell_title_background: "#fff",
            upsell_title_color: "#000",
            upsell_content_background: "#f9f9f9",
            upsell_content_border: "#ffffff",
            upsell_content_color: "#000000",
            slide_cart_checkout_background: "#f9f9f9",
            slide_cart_close_color: "#7d7d7d",
            slide_cart_close_hover_color: "#000000",
            show_products_count: "1",
            show_clear_all: "0",
            show_text_shipping_taxes: "0",
            coupon_background_color: "#cdf7cd",
            coupon_border_color: "#acf0ac",
            coupon_icon_color: "#499949",
            price_vat: "0.00",
            minimum_order: "0.00",
            tex_minimum_order: "Minimum Order {{ money }}",
            redirect_minimum_order: "0",
            enable_default_country: "1",
            enable_shipping_country: "0",
            slide_cart_products: "bonus-organic-cotton-sateen-sheet-set|bonus-organic-cotton-mattress-protector|bonus-organic-shredded-latex-pillow",
            count_slide_cart_products: "3",
        };
      var e = HsCartDrawer.globalData;
      HsCartDrawer.vars = e;
        if (e) {
            if (!parseInt(e.enable_app)) return !1;
            if ("" !== HsCartDrawer.readCookie("cart_currency")) {
                var a = HsCartDrawer.readCookie("cart_currency");
                e.money_format = HsCurrency.moneyFormats[a].money_format;
            }
            (HsCartDrawer.json = e),
                1 == e.status &&
                    (t("a[href=cart],a[href=#cart]").unbind("click"),
                    t("a[href=cart],a[href=#cart]").click(function (t) {
                        t.preventDefault();
                    })),
             HsCartDrawer.init(e, t);
        }
    };
(function() {
  var proxied = window.XMLHttpRequest.prototype.send;
  window.XMLHttpRequest.prototype.send = function() {
    var pointer = this;
    var intervalId = window.setInterval(function(data){
      if(pointer.readyState != 4){
        return;
      }
      var url='';
      if(!!pointer._requestUrl)
      {
        url = pointer._requestUrl;
      };
      if(!!pointer._url)
      {
        url = pointer._url;
      };  
      if(url !== "")
      {
        if(url === "/cart/add.js" || url === window.location.origin+"/cart/add.js")
        {
         /*if(pointer.status == 200)
          {
            console.log(JSON.parse(pointer.responseText));  
          };*/
          HsCartDrawer.getSlideCart();
          var modal =  !!document.querySelector('.ajax-success-modal.modal') ? document.querySelector('.ajax-success-modal.modal') : '';
          if(!!modal)
          {
            var content = !!modal.querySelector('.content') ? modal.querySelector('.content') : '';
            if(!!content)
            {
              var close = !!content.querySelector('.close-modal') ? content.querySelector('.close-modal') : '';
              if(!!close)
              {
                /*var ev = new Event("click", {"bubbles":true, "cancelable":false});
                close.dispatchEvent(ev);*/
              }
            };
          };
        }
      };
      clearInterval(intervalId);
    }, 1);
    return proxied.apply(this, [].slice.call(arguments));
  };
})();                     
loadScript("//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js", function () {
    var t, e;
    (jQuery191 = jQuery.noConflict(!0)),
        (t = this),
        (e = function () {
            "use strict";
            var t =
                    "undefined" == typeof document
                        ? {
                              body: {},
                              addEventListener: function () {},
                              removeEventListener: function () {},
                              activeElement: { blur: function () {}, nodeName: "" },
                              querySelector: function () {
                                  return null;
                              },
                              querySelectorAll: function () {
                                  return [];
                              },
                              getElementById: function () {
                                  return null;
                              },
                              createEvent: function () {
                                  return { initEvent: function () {} };
                              },
                              createElement: function () {
                                  return {
                                      children: [],
                                      childNodes: [],
                                      style: {},
                                      setAttribute: function () {},
                                      getElementsByTagName: function () {
                                          return [];
                                      },
                                  };
                              },
                              location: { hash: "" },
                          }
                        : document,
                e =
                    "undefined" == typeof window
                        ? {
                              document: t,
                              navigator: { userAgent: "" },
                              location: {},
                              history: {},
                              CustomEvent: function () {
                                  return this;
                              },
                              addEventListener: function () {},
                              removeEventListener: function () {},
                              getComputedStyle: function () {
                                  return {
                                      getPropertyValue: function () {
                                          return "";
                                      },
                                  };
                              },
                              Image: function () {},
                              Date: function () {},
                              screen: {},
                              setTimeout: function () {},
                              clearTimeout: function () {},
                          }
                        : window,
                a = function (t) {
                    for (var e = 0; e < t.length; e += 1) this[e] = t[e];
                    return (this.length = t.length), this;
                };
            function i(i, r) {
                var n = [],
                    s = 0;
                if (i && !r && i instanceof a) return i;
                if (i)
                    if ("string" == typeof i) {
                        var o,
                            l,
                            c = i.trim();
                        if (c.indexOf("<") >= 0 && c.indexOf(">") >= 0) {
                            var d = "div";
                            for (
                                0 === c.indexOf("<li") && (d = "ul"),
                                    0 === c.indexOf("<tr") && (d = "tbody"),
                                    (0 !== c.indexOf("<td") && 0 !== c.indexOf("<th")) || (d = "tr"),
                                    0 === c.indexOf("<tbody") && (d = "table"),
                                    0 === c.indexOf("<option") && (d = "select"),
                                    (l = t.createElement(d)).innerHTML = c,
                                    s = 0;
                                s < l.childNodes.length;
                                s += 1
                            )
                                n.push(l.childNodes[s]);
                        } else for (o = r || "#" !== i[0] || i.match(/[ .<>:~]/) ? (r || t).querySelectorAll(i.trim()) : [t.getElementById(i.trim().split("#")[1])], s = 0; s < o.length; s += 1) o[s] && n.push(o[s]);
                    } else if (i.nodeType || i === e || i === t) n.push(i);
                    else if (i.length > 0 && i[0].nodeType) for (s = 0; s < i.length; s += 1) n.push(i[s]);
                return new a(n);
            }
            function r(t) {
                for (var e = [], a = 0; a < t.length; a += 1) -1 === e.indexOf(t[a]) && e.push(t[a]);
                return e;
            }
            (i.fn = a.prototype), (i.Class = a), (i.Dom7 = a);
            var n = {
                addClass: function (t) {
                    if (void 0 === t) return this;
                    for (var e = t.split(" "), a = 0; a < e.length; a += 1) for (var i = 0; i < this.length; i += 1) void 0 !== this[i] && void 0 !== this[i].classList && this[i].classList.add(e[a]);
                    return this;
                },
                removeClass: function (t) {
                    for (var e = t.split(" "), a = 0; a < e.length; a += 1) for (var i = 0; i < this.length; i += 1) void 0 !== this[i] && void 0 !== this[i].classList && this[i].classList.remove(e[a]);
                    return this;
                },
                hasClass: function (t) {
                    return !!this[0] && this[0].classList.contains(t);
                },
                toggleClass: function (t) {
                    for (var e = t.split(" "), a = 0; a < e.length; a += 1) for (var i = 0; i < this.length; i += 1) void 0 !== this[i] && void 0 !== this[i].classList && this[i].classList.toggle(e[a]);
                    return this;
                },
                attr: function (t, e) {
                    var a = arguments;
                    if (1 === arguments.length && "string" == typeof t) return this[0] ? this[0].getAttribute(t) : void 0;
                    for (var i = 0; i < this.length; i += 1)
                        if (2 === a.length) this[i].setAttribute(t, e);
                        else for (var r in t) (this[i][r] = t[r]), this[i].setAttribute(r, t[r]);
                    return this;
                },
                removeAttr: function (t) {
                    for (var e = 0; e < this.length; e += 1) this[e].removeAttribute(t);
                    return this;
                },
                data: function (t, e) {
                    var a;
                    if (void 0 !== e) {
                        for (var i = 0; i < this.length; i += 1) (a = this[i]).dom7ElementDataStorage || (a.dom7ElementDataStorage = {}), (a.dom7ElementDataStorage[t] = e);
                        return this;
                    }
                    if ((a = this[0])) return a.dom7ElementDataStorage && t in a.dom7ElementDataStorage ? a.dom7ElementDataStorage[t] : a.getAttribute("data-" + t) || void 0;
                },
                transform: function (t) {
                    for (var e = 0; e < this.length; e += 1) {
                        var a = this[e].style;
                        (a.webkitTransform = t), (a.transform = t);
                    }
                    return this;
                },
                transition: function (t) {
                    "string" != typeof t && (t += "ms");
                    for (var e = 0; e < this.length; e += 1) {
                        var a = this[e].style;
                        (a.webkitTransitionDuration = t), (a.transitionDuration = t);
                    }
                    return this;
                },
                on: function () {
                    for (var t, e = [], a = arguments.length; a--; ) e[a] = arguments[a];
                    var r = e[0],
                        n = e[1],
                        s = e[2],
                        o = e[3];
                    function l(t) {
                        var e = t.target;
                        if (e) {
                            var a = t.target.dom7EventData || [];
                            if ((a.indexOf(t) < 0 && a.unshift(t), i(e).is(n))) s.apply(e, a);
                            else for (var r = i(e).parents(), o = 0; o < r.length; o += 1) i(r[o]).is(n) && s.apply(r[o], a);
                        }
                    }
                    function c(t) {
                        var e = (t && t.target && t.target.dom7EventData) || [];
                        e.indexOf(t) < 0 && e.unshift(t), s.apply(this, e);
                    }
                    "function" == typeof e[1] && ((r = (t = e)[0]), (s = t[1]), (o = t[2]), (n = void 0)), o || (o = !1);
                    for (var d, p = r.split(" "), h = 0; h < this.length; h += 1) {
                        var u = this[h];
                        if (n)
                            for (d = 0; d < p.length; d += 1) {
                                var m = p[d];
                                u.dom7LiveListeners || (u.dom7LiveListeners = {}), u.dom7LiveListeners[m] || (u.dom7LiveListeners[m] = []), u.dom7LiveListeners[m].push({ listener: s, proxyListener: l }), u.addEventListener(m, l, o);
                            }
                        else
                            for (d = 0; d < p.length; d += 1) {
                                var f = p[d];
                                u.dom7Listeners || (u.dom7Listeners = {}), u.dom7Listeners[f] || (u.dom7Listeners[f] = []), u.dom7Listeners[f].push({ listener: s, proxyListener: c }), u.addEventListener(f, c, o);
                            }
                    }
                    return this;
                },
                off: function () {
                    for (var t, e = [], a = arguments.length; a--; ) e[a] = arguments[a];
                    var i = e[0],
                        r = e[1],
                        n = e[2],
                        s = e[3];
                    "function" == typeof e[1] && ((i = (t = e)[0]), (n = t[1]), (s = t[2]), (r = void 0)), s || (s = !1);
                    for (var o = i.split(" "), l = 0; l < o.length; l += 1)
                        for (var c = o[l], d = 0; d < this.length; d += 1) {
                            var p = this[d],
                                h = void 0;
                            if ((!r && p.dom7Listeners ? (h = p.dom7Listeners[c]) : r && p.dom7LiveListeners && (h = p.dom7LiveListeners[c]), h && h.length))
                                for (var u = h.length - 1; u >= 0; u -= 1) {
                                    var m = h[u];
                                    n && m.listener === n
                                        ? (p.removeEventListener(c, m.proxyListener, s), h.splice(u, 1))
                                        : n && m.listener && m.listener.dom7proxy && m.listener.dom7proxy === n
                                        ? (p.removeEventListener(c, m.proxyListener, s), h.splice(u, 1))
                                        : n || (p.removeEventListener(c, m.proxyListener, s), h.splice(u, 1));
                                }
                        }
                    return this;
                },
                trigger: function () {
                    for (var a = [], i = arguments.length; i--; ) a[i] = arguments[i];
                    for (var r = a[0].split(" "), n = a[1], s = 0; s < r.length; s += 1)
                        for (var o = r[s], l = 0; l < this.length; l += 1) {
                            var c = this[l],
                                d = void 0;
                            try {
                                d = new e.CustomEvent(o, { detail: n, bubbles: !0, cancelable: !0 });
                            } catch (e) {
                                (d = t.createEvent("Event")).initEvent(o, !0, !0), (d.detail = n);
                            }
                            (c.dom7EventData = a.filter(function (t, e) {
                                return e > 0;
                            })),
                                c.dispatchEvent(d),
                                (c.dom7EventData = []),
                                delete c.dom7EventData;
                        }
                    return this;
                },
                transitionEnd: function (t) {
                    var e,
                        a = ["webkitTransitionEnd", "transitionend"],
                        i = this;
                    function r(n) {
                        if (n.target === this) for (t.call(this, n), e = 0; e < a.length; e += 1) i.off(a[e], r);
                    }
                    if (t) for (e = 0; e < a.length; e += 1) i.on(a[e], r);
                    return this;
                },
                outerWidth: function (t) {
                    if (this.length > 0) {
                        if (t) {
                            var e = this.styles();
                            return this[0].offsetWidth + parseFloat(e.getPropertyValue("margin-right")) + parseFloat(e.getPropertyValue("margin-left"));
                        }
                        return this[0].offsetWidth;
                    }
                    return null;
                },
                outerHeight: function (t) {
                    if (this.length > 0) {
                        if (t) {
                            var e = this.styles();
                            return this[0].offsetHeight + parseFloat(e.getPropertyValue("margin-top")) + parseFloat(e.getPropertyValue("margin-bottom"));
                        }
                        return this[0].offsetHeight;
                    }
                    return null;
                },
                offset: function () {
                    if (this.length > 0) {
                        var a = this[0],
                            i = a.getBoundingClientRect(),
                            r = t.body,
                            n = a.clientTop || r.clientTop || 0,
                            s = a.clientLeft || r.clientLeft || 0,
                            o = a === e ? e.scrollY : a.scrollTop,
                            l = a === e ? e.scrollX : a.scrollLeft;
                        return { top: i.top + o - n, left: i.left + l - s };
                    }
                    return null;
                },
                css: function (t, a) {
                    var i;
                    if (1 === arguments.length) {
                        if ("string" != typeof t) {
                            for (i = 0; i < this.length; i += 1) for (var r in t) this[i].style[r] = t[r];
                            return this;
                        }
                        if (this[0]) return e.getComputedStyle(this[0], null).getPropertyValue(t);
                    }
                    if (2 === arguments.length && "string" == typeof t) {
                        for (i = 0; i < this.length; i += 1) this[i].style[t] = a;
                        return this;
                    }
                    return this;
                },
                each: function (t) {
                    if (!t) return this;
                    for (var e = 0; e < this.length; e += 1) if (!1 === t.call(this[e], e, this[e])) return this;
                    return this;
                },
                html: function (t) {
                    if (void 0 === t) return this[0] ? this[0].innerHTML : void 0;
                    for (var e = 0; e < this.length; e += 1) this[e].innerHTML = t;
                    return this;
                },
                text: function (t) {
                    if (void 0 === t) return this[0] ? this[0].textContent.trim() : null;
                    for (var e = 0; e < this.length; e += 1) this[e].textContent = t;
                    return this;
                },
                is: function (r) {
                    var n,
                        s,
                        o = this[0];
                    if (!o || void 0 === r) return !1;
                    if ("string" == typeof r) {
                        if (o.matches) return o.matches(r);
                        if (o.webkitMatchesSelector) return o.webkitMatchesSelector(r);
                        if (o.msMatchesSelector) return o.msMatchesSelector(r);
                        for (n = i(r), s = 0; s < n.length; s += 1) if (n[s] === o) return !0;
                        return !1;
                    }
                    if (r === t) return o === t;
                    if (r === e) return o === e;
                    if (r.nodeType || r instanceof a) {
                        for (n = r.nodeType ? [r] : r, s = 0; s < n.length; s += 1) if (n[s] === o) return !0;
                        return !1;
                    }
                    return !1;
                },
                index: function () {
                    var t,
                        e = this[0];
                    if (e) {
                        for (t = 0; null !== (e = e.previousSibling); ) 1 === e.nodeType && (t += 1);
                        return t;
                    }
                },
                eq: function (t) {
                    if (void 0 === t) return this;
                    var e,
                        i = this.length;
                    return new a(t > i - 1 ? [] : t < 0 ? ((e = i + t) < 0 ? [] : [this[e]]) : [this[t]]);
                },
                append: function () {
                    for (var e, i = [], r = arguments.length; r--; ) i[r] = arguments[r];
                    for (var n = 0; n < i.length; n += 1) {
                        e = i[n];
                        for (var s = 0; s < this.length; s += 1)
                            if ("string" == typeof e) {
                                var o = t.createElement("div");
                                for (o.innerHTML = e; o.firstChild; ) this[s].appendChild(o.firstChild);
                            } else if (e instanceof a) for (var l = 0; l < e.length; l += 1) this[s].appendChild(e[l]);
                            else this[s].appendChild(e);
                    }
                    return this;
                },
                prepend: function (e) {
                    var i, r;
                    for (i = 0; i < this.length; i += 1)
                        if ("string" == typeof e) {
                            var n = t.createElement("div");
                            for (n.innerHTML = e, r = n.childNodes.length - 1; r >= 0; r -= 1) this[i].insertBefore(n.childNodes[r], this[i].childNodes[0]);
                        } else if (e instanceof a) for (r = 0; r < e.length; r += 1) this[i].insertBefore(e[r], this[i].childNodes[0]);
                        else this[i].insertBefore(e, this[i].childNodes[0]);
                    return this;
                },
                next: function (t) {
                    return this.length > 0
                        ? t
                            ? this[0].nextElementSibling && i(this[0].nextElementSibling).is(t)
                                ? new a([this[0].nextElementSibling])
                                : new a([])
                            : this[0].nextElementSibling
                            ? new a([this[0].nextElementSibling])
                            : new a([])
                        : new a([]);
                },
                nextAll: function (t) {
                    var e = [],
                        r = this[0];
                    if (!r) return new a([]);
                    for (; r.nextElementSibling; ) {
                        var n = r.nextElementSibling;
                        t ? i(n).is(t) && e.push(n) : e.push(n), (r = n);
                    }
                    return new a(e);
                },
                prev: function (t) {
                    if (this.length > 0) {
                        var e = this[0];
                        return t ? (e.previousElementSibling && i(e.previousElementSibling).is(t) ? new a([e.previousElementSibling]) : new a([])) : e.previousElementSibling ? new a([e.previousElementSibling]) : new a([]);
                    }
                    return new a([]);
                },
                prevAll: function (t) {
                    var e = [],
                        r = this[0];
                    if (!r) return new a([]);
                    for (; r.previousElementSibling; ) {
                        var n = r.previousElementSibling;
                        t ? i(n).is(t) && e.push(n) : e.push(n), (r = n);
                    }
                    return new a(e);
                },
                parent: function (t) {
                    for (var e = [], a = 0; a < this.length; a += 1) null !== this[a].parentNode && (t ? i(this[a].parentNode).is(t) && e.push(this[a].parentNode) : e.push(this[a].parentNode));
                    return i(r(e));
                },
                parents: function (t) {
                    for (var e = [], a = 0; a < this.length; a += 1) for (var n = this[a].parentNode; n; ) t ? i(n).is(t) && e.push(n) : e.push(n), (n = n.parentNode);
                    return i(r(e));
                },
                closest: function (t) {
                    var e = this;
                    return void 0 === t ? new a([]) : (e.is(t) || (e = e.parents(t).eq(0)), e);
                },
                find: function (t) {
                    for (var e = [], i = 0; i < this.length; i += 1) for (var r = this[i].querySelectorAll(t), n = 0; n < r.length; n += 1) e.push(r[n]);
                    return new a(e);
                },
                children: function (t) {
                    for (var e = [], n = 0; n < this.length; n += 1) for (var s = this[n].childNodes, o = 0; o < s.length; o += 1) t ? 1 === s[o].nodeType && i(s[o]).is(t) && e.push(s[o]) : 1 === s[o].nodeType && e.push(s[o]);
                    return new a(r(e));
                },
                filter: function (t) {
                    for (var e = [], i = 0; i < this.length; i += 1) t.call(this[i], i, this[i]) && e.push(this[i]);
                    return new a(e);
                },
                remove: function () {
                    for (var t = 0; t < this.length; t += 1) this[t].parentNode && this[t].parentNode.removeChild(this[t]);
                    return this;
                },
                add: function () {
                    for (var t = [], e = arguments.length; e--; ) t[e] = arguments[e];
                    var a, r;
                    for (a = 0; a < t.length; a += 1) {
                        var n = i(t[a]);
                        for (r = 0; r < n.length; r += 1) (this[this.length] = n[r]), (this.length += 1);
                    }
                    return this;
                },
                styles: function () {
                    return this[0] ? e.getComputedStyle(this[0], null) : {};
                },
            };
            Object.keys(n).forEach(function (t) {
                i.fn[t] = i.fn[t] || n[t];
            });
            var s = {
                    deleteProps: function (t) {
                        var e = t;
                        Object.keys(e).forEach(function (t) {
                            try {
                                e[t] = null;
                            } catch (t) {}
                            try {
                                delete e[t];
                            } catch (t) {}
                        });
                    },
                    nextTick: function (t, e) {
                        return void 0 === e && (e = 0), setTimeout(t, e);
                    },
                    now: function () {
                        return Date.now();
                    },
                    getTranslate: function (t, a) {
                        var i, r, n;
                        void 0 === a && (a = "x");
                        var s = e.getComputedStyle(t, null);
                        return (
                            e.WebKitCSSMatrix
                                ? ((r = s.transform || s.webkitTransform).split(",").length > 6 &&
                                      (r = r
                                          .split(", ")
                                          .map(function (t) {
                                              return t.replace(",", ".");
                                          })
                                          .join(", ")),
                                  (n = new e.WebKitCSSMatrix("none" === r ? "" : r)))
                                : (i = (n = s.MozTransform || s.OTransform || s.MsTransform || s.msTransform || s.transform || s.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")).toString().split(",")),
                            "x" === a && (r = e.WebKitCSSMatrix ? n.m41 : 16 === i.length ? parseFloat(i[12]) : parseFloat(i[4])),
                            "y" === a && (r = e.WebKitCSSMatrix ? n.m42 : 16 === i.length ? parseFloat(i[13]) : parseFloat(i[5])),
                            r || 0
                        );
                    },
                    parseUrlQuery: function (t) {
                        var a,
                            i,
                            r,
                            n,
                            s = {},
                            o = t || e.location.href;
                        if ("string" == typeof o && o.length)
                            for (
                                n = (i = (o = o.indexOf("?") > -1 ? o.replace(/\S*\?/, "") : "").split("&").filter(function (t) {
                                    return "" !== t;
                                })).length,
                                    a = 0;
                                a < n;
                                a += 1
                            )
                                (r = i[a].replace(/#\S+/g, "").split("=")), (s[decodeURIComponent(r[0])] = void 0 === r[1] ? void 0 : decodeURIComponent(r[1]) || "");
                        return s;
                    },
                    isObject: function (t) {
                        return "object" == typeof t && null !== t && t.constructor && t.constructor === Object;
                    },
                    extend: function () {
                        for (var t = [], e = arguments.length; e--; ) t[e] = arguments[e];
                        for (var a = Object(t[0]), i = 1; i < t.length; i += 1) {
                            var r = t[i];
                            if (null != r)
                                for (var n = Object.keys(Object(r)), o = 0, l = n.length; o < l; o += 1) {
                                    var c = n[o],
                                        d = Object.getOwnPropertyDescriptor(r, c);
                                    void 0 !== d && d.enumerable && (s.isObject(a[c]) && s.isObject(r[c]) ? s.extend(a[c], r[c]) : !s.isObject(a[c]) && s.isObject(r[c]) ? ((a[c] = {}), s.extend(a[c], r[c])) : (a[c] = r[c]));
                                }
                        }
                        return a;
                    },
                },
                o = {
                    touch: (e.Modernizr && !0 === e.Modernizr.touch) || !!(e.navigator.maxTouchPoints > 0 || "ontouchstart" in e || (e.DocumentTouch && t instanceof e.DocumentTouch)),
                    pointerEvents: !!e.PointerEvent && "maxTouchPoints" in e.navigator && e.navigator.maxTouchPoints > 0,
                    observer: "MutationObserver" in e || "WebkitMutationObserver" in e,
                    passiveListener: (function () {
                        var t = !1;
                        try {
                            var a = Object.defineProperty({}, "passive", {
                                get: function () {
                                    t = !0;
                                },
                            });
                            e.addEventListener("testPassiveListener", null, a);
                        } catch (t) {}
                        return t;
                    })(),
                    gestures: "ongesturestart" in e,
                },
                l = function (t) {
                    void 0 === t && (t = {});
                    var e = this;
                    (e.params = t),
                        (e.eventsListeners = {}),
                        e.params &&
                            e.params.on &&
                            Object.keys(e.params.on).forEach(function (t) {
                                e.on(t, e.params.on[t]);
                            });
                },
                c = { components: { configurable: !0 } };
            (l.prototype.on = function (t, e, a) {
                var i = this;
                if ("function" != typeof e) return i;
                var r = a ? "unshift" : "push";
                return (
                    t.split(" ").forEach(function (t) {
                        i.eventsListeners[t] || (i.eventsListeners[t] = []), i.eventsListeners[t][r](e);
                    }),
                    i
                );
            }),
                (l.prototype.once = function (t, e, a) {
                    var i = this;
                    if ("function" != typeof e) return i;
                    function r() {
                        for (var a = [], n = arguments.length; n--; ) a[n] = arguments[n];
                        i.off(t, r), r.f7proxy && delete r.f7proxy, e.apply(i, a);
                    }
                    return (r.f7proxy = e), i.on(t, r, a);
                }),
                (l.prototype.off = function (t, e) {
                    var a = this;
                    return a.eventsListeners
                        ? (t.split(" ").forEach(function (t) {
                              void 0 === e
                                  ? (a.eventsListeners[t] = [])
                                  : a.eventsListeners[t] &&
                                    a.eventsListeners[t].length &&
                                    a.eventsListeners[t].forEach(function (i, r) {
                                        (i === e || (i.f7proxy && i.f7proxy === e)) && a.eventsListeners[t].splice(r, 1);
                                    });
                          }),
                          a)
                        : a;
                }),
                (l.prototype.emit = function () {
                    for (var t = [], e = arguments.length; e--; ) t[e] = arguments[e];
                    var a,
                        i,
                        r,
                        n = this;
                    return n.eventsListeners
                        ? ("string" == typeof t[0] || Array.isArray(t[0]) ? ((a = t[0]), (i = t.slice(1, t.length)), (r = n)) : ((a = t[0].events), (i = t[0].data), (r = t[0].context || n)),
                          (Array.isArray(a) ? a : a.split(" ")).forEach(function (t) {
                              if (n.eventsListeners && n.eventsListeners[t]) {
                                  var e = [];
                                  n.eventsListeners[t].forEach(function (t) {
                                      e.push(t);
                                  }),
                                      e.forEach(function (t) {
                                          t.apply(r, i);
                                      });
                              }
                          }),
                          n)
                        : n;
                }),
                (l.prototype.useModulesParams = function (t) {
                    var e = this;
                    e.modules &&
                        Object.keys(e.modules).forEach(function (a) {
                            var i = e.modules[a];
                            i.params && s.extend(t, i.params);
                        });
                }),
                (l.prototype.useModules = function (t) {
                    void 0 === t && (t = {});
                    var e = this;
                    e.modules &&
                        Object.keys(e.modules).forEach(function (a) {
                            var i = e.modules[a],
                                r = t[a] || {};
                            i.instance &&
                                Object.keys(i.instance).forEach(function (t) {
                                    var a = i.instance[t];
                                    e[t] = "function" == typeof a ? a.bind(e) : a;
                                }),
                                i.on &&
                                    e.on &&
                                    Object.keys(i.on).forEach(function (t) {
                                        e.on(t, i.on[t]);
                                    }),
                                i.create && i.create.bind(e)(r);
                        });
                }),
                (c.components.set = function (t) {
                    this.use && this.use(t);
                }),
                (l.installModule = function (t) {
                    for (var e = [], a = arguments.length - 1; a-- > 0; ) e[a] = arguments[a + 1];
                    var i = this;
                    i.prototype.modules || (i.prototype.modules = {});
                    var r = t.name || Object.keys(i.prototype.modules).length + "_" + s.now();
                    return (
                        (i.prototype.modules[r] = t),
                        t.proto &&
                            Object.keys(t.proto).forEach(function (e) {
                                i.prototype[e] = t.proto[e];
                            }),
                        t.static &&
                            Object.keys(t.static).forEach(function (e) {
                                i[e] = t.static[e];
                            }),
                        t.install && t.install.apply(i, e),
                        i
                    );
                }),
                (l.use = function (t) {
                    for (var e = [], a = arguments.length - 1; a-- > 0; ) e[a] = arguments[a + 1];
                    var i = this;
                    return Array.isArray(t)
                        ? (t.forEach(function (t) {
                              return i.installModule(t);
                          }),
                          i)
                        : i.installModule.apply(i, [t].concat(e));
                }),
                Object.defineProperties(l, c);
            var d,
                p,
                h,
                u,
                m,
                f,
                g,
                b,
                w,
                v,
                y,
                _,
                x,
                k,
                C,
                S = {
                    updateSize: function () {
                        var t,
                            e,
                            a = this.$el;
                        (t = void 0 !== this.params.width ? this.params.width : a[0].clientWidth),
                            (e = void 0 !== this.params.height ? this.params.height : a[0].clientHeight),
                            (0 === t && this.isHorizontal()) ||
                                (0 === e && this.isVertical()) ||
                                ((t = t - parseInt(a.css("padding-left"), 10) - parseInt(a.css("padding-right"), 10)),
                                (e = e - parseInt(a.css("padding-top"), 10) - parseInt(a.css("padding-bottom"), 10)),
                                s.extend(this, { width: t, height: e, size: this.isHorizontal() ? t : e }));
                    },
                    updateSlides: function () {
                        var t = this.params,
                            a = this.$wrapperEl,
                            i = this.size,
                            r = this.rtlTranslate,
                            n = this.wrongRTL,
                            o = this.virtual && t.virtual.enabled,
                            l = o ? this.virtual.slides.length : this.slides.length,
                            c = a.children("." + this.params.slideClass),
                            d = o ? this.virtual.slides.length : c.length,
                            p = [],
                            h = [],
                            u = [];
                        function m(e) {
                            return !t.cssMode || e !== c.length - 1;
                        }
                        var f = t.slidesOffsetBefore;
                        "function" == typeof f && (f = t.slidesOffsetBefore.call(this));
                        var g = t.slidesOffsetAfter;
                        "function" == typeof g && (g = t.slidesOffsetAfter.call(this));
                        var b = this.snapGrid.length,
                            w = this.snapGrid.length,
                            v = t.spaceBetween,
                            y = -f,
                            _ = 0,
                            x = 0;
                        if (void 0 !== i) {
                            var k, C;
                            "string" == typeof v && v.indexOf("%") >= 0 && (v = (parseFloat(v.replace("%", "")) / 100) * i),
                                (this.virtualSize = -v),
                                r ? c.css({ marginLeft: "", marginTop: "" }) : c.css({ marginRight: "", marginBottom: "" }),
                                t.slidesPerColumn > 1 &&
                                    ((k = Math.floor(d / t.slidesPerColumn) === d / this.params.slidesPerColumn ? d : Math.ceil(d / t.slidesPerColumn) * t.slidesPerColumn),
                                    "auto" !== t.slidesPerView && "row" === t.slidesPerColumnFill && (k = Math.max(k, t.slidesPerView * t.slidesPerColumn)));
                            for (var S, T = t.slidesPerColumn, E = k / T, D = Math.floor(d / t.slidesPerColumn), z = 0; z < d; z += 1) {
                                C = 0;
                                var A = c.eq(z);
                                if (t.slidesPerColumn > 1) {
                                    var M = void 0,
                                        O = void 0,
                                        H = void 0;
                                    if ("row" === t.slidesPerColumnFill && t.slidesPerGroup > 1) {
                                        var I = Math.floor(z / (t.slidesPerGroup * t.slidesPerColumn)),
                                            P = z - t.slidesPerColumn * t.slidesPerGroup * I,
                                            L = 0 === I ? t.slidesPerGroup : Math.min(Math.ceil((d - I * T * t.slidesPerGroup) / T), t.slidesPerGroup);
                                        (M = (O = P - (H = Math.floor(P / L)) * L + I * t.slidesPerGroup) + (H * k) / T),
                                            A.css({ "-webkit-box-ordinal-group": M, "-moz-box-ordinal-group": M, "-ms-flex-order": M, "-webkit-order": M, order: M });
                                    } else "column" === t.slidesPerColumnFill ? ((H = z - (O = Math.floor(z / T)) * T), (O > D || (O === D && H === T - 1)) && (H += 1) >= T && ((H = 0), (O += 1))) : (O = z - (H = Math.floor(z / E)) * E);
                                    A.css("margin-" + (this.isHorizontal() ? "top" : "left"), 0 !== H && t.spaceBetween && t.spaceBetween + "px");
                                }
                                if ("none" !== A.css("display")) {
                                    if ("auto" === t.slidesPerView) {
                                        var B = e.getComputedStyle(A[0], null),
                                            $ = A[0].style.transform,
                                            q = A[0].style.webkitTransform;
                                        if (($ && (A[0].style.transform = "none"), q && (A[0].style.webkitTransform = "none"), t.roundLengths)) C = this.isHorizontal() ? A.outerWidth(!0) : A.outerHeight(!0);
                                        else if (this.isHorizontal()) {
                                            var R = parseFloat(B.getPropertyValue("width")),
                                                N = parseFloat(B.getPropertyValue("padding-left")),
                                                Y = parseFloat(B.getPropertyValue("padding-right")),
                                                X = parseFloat(B.getPropertyValue("margin-left")),
                                                V = parseFloat(B.getPropertyValue("margin-right")),
                                                G = B.getPropertyValue("box-sizing");
                                            C = G && "border-box" === G ? R + X + V : R + N + Y + X + V;
                                        } else {
                                            var j = parseFloat(B.getPropertyValue("height")),
                                                F = parseFloat(B.getPropertyValue("padding-top")),
                                                U = parseFloat(B.getPropertyValue("padding-bottom")),
                                                W = parseFloat(B.getPropertyValue("margin-top")),
                                                Z = parseFloat(B.getPropertyValue("margin-bottom")),
                                                K = B.getPropertyValue("box-sizing");
                                            C = K && "border-box" === K ? j + W + Z : j + F + U + W + Z;
                                        }
                                        $ && (A[0].style.transform = $), q && (A[0].style.webkitTransform = q), t.roundLengths && (C = Math.floor(C));
                                    } else (C = (i - (t.slidesPerView - 1) * v) / t.slidesPerView), t.roundLengths && (C = Math.floor(C)), c[z] && (this.isHorizontal() ? (c[z].style.width = C + "px") : (c[z].style.height = C + "px"));
                                    c[z] && (c[z].swiperSlideSize = C),
                                        u.push(C),
                                        t.centeredSlides
                                            ? ((y = y + C / 2 + _ / 2 + v),
                                              0 === _ && 0 !== z && (y = y - i / 2 - v),
                                              0 === z && (y = y - i / 2 - v),
                                              Math.abs(y) < 0.001 && (y = 0),
                                              t.roundLengths && (y = Math.floor(y)),
                                              x % t.slidesPerGroup == 0 && p.push(y),
                                              h.push(y))
                                            : (t.roundLengths && (y = Math.floor(y)), (x - Math.min(this.params.slidesPerGroupSkip, x)) % this.params.slidesPerGroup == 0 && p.push(y), h.push(y), (y = y + C + v)),
                                        (this.virtualSize += C + v),
                                        (_ = C),
                                        (x += 1);
                                }
                            }
                            if (
                                ((this.virtualSize = Math.max(this.virtualSize, i) + g),
                                r && n && ("slide" === t.effect || "coverflow" === t.effect) && a.css({ width: this.virtualSize + t.spaceBetween + "px" }),
                                t.setWrapperSize && (this.isHorizontal() ? a.css({ width: this.virtualSize + t.spaceBetween + "px" }) : a.css({ height: this.virtualSize + t.spaceBetween + "px" })),
                                t.slidesPerColumn > 1 &&
                                    ((this.virtualSize = (C + t.spaceBetween) * k),
                                    (this.virtualSize = Math.ceil(this.virtualSize / t.slidesPerColumn) - t.spaceBetween),
                                    this.isHorizontal() ? a.css({ width: this.virtualSize + t.spaceBetween + "px" }) : a.css({ height: this.virtualSize + t.spaceBetween + "px" }),
                                    t.centeredSlides))
                            ) {
                                S = [];
                                for (var Q = 0; Q < p.length; Q += 1) {
                                    var J = p[Q];
                                    t.roundLengths && (J = Math.floor(J)), p[Q] < this.virtualSize + p[0] && S.push(J);
                                }
                                p = S;
                            }
                            if (!t.centeredSlides) {
                                S = [];
                                for (var tt = 0; tt < p.length; tt += 1) {
                                    var et = p[tt];
                                    t.roundLengths && (et = Math.floor(et)), p[tt] <= this.virtualSize - i && S.push(et);
                                }
                                (p = S), Math.floor(this.virtualSize - i) - Math.floor(p[p.length - 1]) > 1 && p.push(this.virtualSize - i);
                            }
                            if (
                                (0 === p.length && (p = [0]),
                                0 !== t.spaceBetween && (this.isHorizontal() ? (r ? c.filter(m).css({ marginLeft: v + "px" }) : c.filter(m).css({ marginRight: v + "px" })) : c.filter(m).css({ marginBottom: v + "px" })),
                                t.centeredSlides && t.centeredSlidesBounds)
                            ) {
                                var at = 0;
                                u.forEach(function (e) {
                                    at += e + (t.spaceBetween ? t.spaceBetween : 0);
                                });
                                var it = (at -= t.spaceBetween) - i;
                                p = p.map(function (t) {
                                    return t < 0 ? -f : t > it ? it + g : t;
                                });
                            }
                            if (t.centerInsufficientSlides) {
                                var rt = 0;
                                if (
                                    (u.forEach(function (e) {
                                        rt += e + (t.spaceBetween ? t.spaceBetween : 0);
                                    }),
                                    (rt -= t.spaceBetween) < i)
                                ) {
                                    var nt = (i - rt) / 2;
                                    p.forEach(function (t, e) {
                                        p[e] = t - nt;
                                    }),
                                        h.forEach(function (t, e) {
                                            h[e] = t + nt;
                                        });
                                }
                            }
                            s.extend(this, { slides: c, snapGrid: p, slidesGrid: h, slidesSizesGrid: u }),
                                d !== l && this.emit("slidesLengthChange"),
                                p.length !== b && (this.params.watchOverflow && this.checkOverflow(), this.emit("snapGridLengthChange")),
                                h.length !== w && this.emit("slidesGridLengthChange"),
                                (t.watchSlidesProgress || t.watchSlidesVisibility) && this.updateSlidesOffset();
                        }
                    },
                    updateAutoHeight: function (t) {
                        var e,
                            a = [],
                            i = 0;
                        if (("number" == typeof t ? this.setTransition(t) : !0 === t && this.setTransition(this.params.speed), "auto" !== this.params.slidesPerView && this.params.slidesPerView > 1))
                            for (e = 0; e < Math.ceil(this.params.slidesPerView); e += 1) {
                                var r = this.activeIndex + e;
                                if (r > this.slides.length) break;
                                a.push(this.slides.eq(r)[0]);
                            }
                        else a.push(this.slides.eq(this.activeIndex)[0]);
                        for (e = 0; e < a.length; e += 1)
                            if (void 0 !== a[e]) {
                                var n = a[e].offsetHeight;
                                i = n > i ? n : i;
                            }
                        i && this.$wrapperEl.css("height", i + "px");
                    },
                    updateSlidesOffset: function () {
                        for (var t = this.slides, e = 0; e < t.length; e += 1) t[e].swiperSlideOffset = this.isHorizontal() ? t[e].offsetLeft : t[e].offsetTop;
                    },
                    updateSlidesProgress: function (t) {
                        void 0 === t && (t = (this && this.translate) || 0);
                        var e = this.params,
                            a = this.slides,
                            r = this.rtlTranslate;
                        if (0 !== a.length) {
                            void 0 === a[0].swiperSlideOffset && this.updateSlidesOffset();
                            var n = -t;
                            r && (n = t), a.removeClass(e.slideVisibleClass), (this.visibleSlidesIndexes = []), (this.visibleSlides = []);
                            for (var s = 0; s < a.length; s += 1) {
                                var o = a[s],
                                    l = (n + (e.centeredSlides ? this.minTranslate() : 0) - o.swiperSlideOffset) / (o.swiperSlideSize + e.spaceBetween);
                                if (e.watchSlidesVisibility) {
                                    var c = -(n - o.swiperSlideOffset),
                                        d = c + this.slidesSizesGrid[s];
                                    ((c >= 0 && c < this.size - 1) || (d > 1 && d <= this.size) || (c <= 0 && d >= this.size)) && (this.visibleSlides.push(o), this.visibleSlidesIndexes.push(s), a.eq(s).addClass(e.slideVisibleClass));
                                }
                                o.progress = r ? -l : l;
                            }
                            this.visibleSlides = i(this.visibleSlides);
                        }
                    },
                    updateProgress: function (t) {
                        if (void 0 === t) {
                            var e = this.rtlTranslate ? -1 : 1;
                            t = (this && this.translate && this.translate * e) || 0;
                        }
                        var a = this.params,
                            i = this.maxTranslate() - this.minTranslate(),
                            r = this.progress,
                            n = this.isBeginning,
                            o = this.isEnd,
                            l = n,
                            c = o;
                        0 === i ? ((r = 0), (n = !0), (o = !0)) : ((n = (r = (t - this.minTranslate()) / i) <= 0), (o = r >= 1)),
                            s.extend(this, { progress: r, isBeginning: n, isEnd: o }),
                            (a.watchSlidesProgress || a.watchSlidesVisibility) && this.updateSlidesProgress(t),
                            n && !l && this.emit("reachBeginning toEdge"),
                            o && !c && this.emit("reachEnd toEdge"),
                            ((l && !n) || (c && !o)) && this.emit("fromEdge"),
                            this.emit("progress", r);
                    },
                    updateSlidesClasses: function () {
                        var t,
                            e = this.slides,
                            a = this.params,
                            i = this.$wrapperEl,
                            r = this.activeIndex,
                            n = this.realIndex,
                            s = this.virtual && a.virtual.enabled;
                        e.removeClass(a.slideActiveClass + " " + a.slideNextClass + " " + a.slidePrevClass + " " + a.slideDuplicateActiveClass + " " + a.slideDuplicateNextClass + " " + a.slideDuplicatePrevClass),
                            (t = s ? this.$wrapperEl.find("." + a.slideClass + '[data-swiper-slide-index="' + r + '"]') : e.eq(r)).addClass(a.slideActiveClass),
                            a.loop &&
                                (t.hasClass(a.slideDuplicateClass)
                                    ? i.children("." + a.slideClass + ":not(." + a.slideDuplicateClass + ')[data-swiper-slide-index="' + n + '"]').addClass(a.slideDuplicateActiveClass)
                                    : i.children("." + a.slideClass + "." + a.slideDuplicateClass + '[data-swiper-slide-index="' + n + '"]').addClass(a.slideDuplicateActiveClass));
                        var o = t
                            .nextAll("." + a.slideClass)
                            .eq(0)
                            .addClass(a.slideNextClass);
                        a.loop && 0 === o.length && (o = e.eq(0)).addClass(a.slideNextClass);
                        var l = t
                            .prevAll("." + a.slideClass)
                            .eq(0)
                            .addClass(a.slidePrevClass);
                        a.loop && 0 === l.length && (l = e.eq(-1)).addClass(a.slidePrevClass),
                            a.loop &&
                                (o.hasClass(a.slideDuplicateClass)
                                    ? i.children("." + a.slideClass + ":not(." + a.slideDuplicateClass + ')[data-swiper-slide-index="' + o.attr("data-swiper-slide-index") + '"]').addClass(a.slideDuplicateNextClass)
                                    : i.children("." + a.slideClass + "." + a.slideDuplicateClass + '[data-swiper-slide-index="' + o.attr("data-swiper-slide-index") + '"]').addClass(a.slideDuplicateNextClass),
                                l.hasClass(a.slideDuplicateClass)
                                    ? i.children("." + a.slideClass + ":not(." + a.slideDuplicateClass + ')[data-swiper-slide-index="' + l.attr("data-swiper-slide-index") + '"]').addClass(a.slideDuplicatePrevClass)
                                    : i.children("." + a.slideClass + "." + a.slideDuplicateClass + '[data-swiper-slide-index="' + l.attr("data-swiper-slide-index") + '"]').addClass(a.slideDuplicatePrevClass));
                    },
                    updateActiveIndex: function (t) {
                        var e,
                            a = this.rtlTranslate ? this.translate : -this.translate,
                            i = this.slidesGrid,
                            r = this.snapGrid,
                            n = this.params,
                            o = this.activeIndex,
                            l = this.realIndex,
                            c = this.snapIndex,
                            d = t;
                        if (void 0 === d) {
                            for (var p = 0; p < i.length; p += 1) void 0 !== i[p + 1] ? (a >= i[p] && a < i[p + 1] - (i[p + 1] - i[p]) / 2 ? (d = p) : a >= i[p] && a < i[p + 1] && (d = p + 1)) : a >= i[p] && (d = p);
                            n.normalizeSlideIndex && (d < 0 || void 0 === d) && (d = 0);
                        }
                        if (r.indexOf(a) >= 0) e = r.indexOf(a);
                        else {
                            var h = Math.min(n.slidesPerGroupSkip, d);
                            e = h + Math.floor((d - h) / n.slidesPerGroup);
                        }
                        if ((e >= r.length && (e = r.length - 1), d !== o)) {
                            var u = parseInt(this.slides.eq(d).attr("data-swiper-slide-index") || d, 10);
                            s.extend(this, { snapIndex: e, realIndex: u, previousIndex: o, activeIndex: d }),
                                this.emit("activeIndexChange"),
                                this.emit("snapIndexChange"),
                                l !== u && this.emit("realIndexChange"),
                                (this.initialized || this.runCallbacksOnInit) && this.emit("slideChange");
                        } else e !== c && ((this.snapIndex = e), this.emit("snapIndexChange"));
                    },
                    updateClickedSlide: function (t) {
                        var e = this.params,
                            a = i(t.target).closest("." + e.slideClass)[0],
                            r = !1;
                        if (a) for (var n = 0; n < this.slides.length; n += 1) this.slides[n] === a && (r = !0);
                        if (!a || !r) return (this.clickedSlide = void 0), void (this.clickedIndex = void 0);
                        (this.clickedSlide = a),
                            this.virtual && this.params.virtual.enabled ? (this.clickedIndex = parseInt(i(a).attr("data-swiper-slide-index"), 10)) : (this.clickedIndex = i(a).index()),
                            e.slideToClickedSlide && void 0 !== this.clickedIndex && this.clickedIndex !== this.activeIndex && this.slideToClickedSlide();
                    },
                },
                T = {
                    getTranslate: function (t) {
                        void 0 === t && (t = this.isHorizontal() ? "x" : "y");
                        var e = this.params,
                            a = this.rtlTranslate,
                            i = this.translate,
                            r = this.$wrapperEl;
                        if (e.virtualTranslate) return a ? -i : i;
                        if (e.cssMode) return i;
                        var n = s.getTranslate(r[0], t);
                        return a && (n = -n), n || 0;
                    },
                    setTranslate: function (t, e) {
                        var a = this.rtlTranslate,
                            i = this.params,
                            r = this.$wrapperEl,
                            n = this.wrapperEl,
                            s = this.progress,
                            o = 0,
                            l = 0;
                        this.isHorizontal() ? (o = a ? -t : t) : (l = t),
                            i.roundLengths && ((o = Math.floor(o)), (l = Math.floor(l))),
                            i.cssMode ? (n[this.isHorizontal() ? "scrollLeft" : "scrollTop"] = this.isHorizontal() ? -o : -l) : i.virtualTranslate || r.transform("translate3d(" + o + "px, " + l + "px, 0px)"),
                            (this.previousTranslate = this.translate),
                            (this.translate = this.isHorizontal() ? o : l);
                        var c = this.maxTranslate() - this.minTranslate();
                        (0 === c ? 0 : (t - this.minTranslate()) / c) !== s && this.updateProgress(t), this.emit("setTranslate", this.translate, e);
                    },
                    minTranslate: function () {
                        return -this.snapGrid[0];
                    },
                    maxTranslate: function () {
                        return -this.snapGrid[this.snapGrid.length - 1];
                    },
                    translateTo: function (t, e, a, i, r) {
                        var n;
                        void 0 === t && (t = 0), void 0 === e && (e = this.params.speed), void 0 === a && (a = !0), void 0 === i && (i = !0);
                        var s = this,
                            o = s.params,
                            l = s.wrapperEl;
                        if (s.animating && o.preventInteractionOnTransition) return !1;
                        var c,
                            d = s.minTranslate(),
                            p = s.maxTranslate();
                        if (((c = i && t > d ? d : i && t < p ? p : t), s.updateProgress(c), o.cssMode)) {
                            var h = s.isHorizontal();
                            return 0 === e ? (l[h ? "scrollLeft" : "scrollTop"] = -c) : l.scrollTo ? l.scrollTo((((n = {})[h ? "left" : "top"] = -c), (n.behavior = "smooth"), n)) : (l[h ? "scrollLeft" : "scrollTop"] = -c), !0;
                        }
                        return (
                            0 === e
                                ? (s.setTransition(0), s.setTranslate(c), a && (s.emit("beforeTransitionStart", e, r), s.emit("transitionEnd")))
                                : (s.setTransition(e),
                                  s.setTranslate(c),
                                  a && (s.emit("beforeTransitionStart", e, r), s.emit("transitionStart")),
                                  s.animating ||
                                      ((s.animating = !0),
                                      s.onTranslateToWrapperTransitionEnd ||
                                          (s.onTranslateToWrapperTransitionEnd = function (t) {
                                              s &&
                                                  !s.destroyed &&
                                                  t.target === this &&
                                                  (s.$wrapperEl[0].removeEventListener("transitionend", s.onTranslateToWrapperTransitionEnd),
                                                  s.$wrapperEl[0].removeEventListener("webkitTransitionEnd", s.onTranslateToWrapperTransitionEnd),
                                                  (s.onTranslateToWrapperTransitionEnd = null),
                                                  delete s.onTranslateToWrapperTransitionEnd,
                                                  a && s.emit("transitionEnd"));
                                          }),
                                      s.$wrapperEl[0].addEventListener("transitionend", s.onTranslateToWrapperTransitionEnd),
                                      s.$wrapperEl[0].addEventListener("webkitTransitionEnd", s.onTranslateToWrapperTransitionEnd))),
                            !0
                        );
                    },
                },
                E = {
                    slideTo: function (t, e, a, i) {
                        var r;
                        void 0 === t && (t = 0), void 0 === e && (e = this.params.speed), void 0 === a && (a = !0);
                        var n = this,
                            s = t;
                        s < 0 && (s = 0);
                        var o = n.params,
                            l = n.snapGrid,
                            c = n.slidesGrid,
                            d = n.previousIndex,
                            p = n.activeIndex,
                            h = n.rtlTranslate,
                            u = n.wrapperEl;
                        if (n.animating && o.preventInteractionOnTransition) return !1;
                        var m = Math.min(n.params.slidesPerGroupSkip, s),
                            f = m + Math.floor((s - m) / n.params.slidesPerGroup);
                        f >= c.length && (f = c.length - 1), (p || o.initialSlide || 0) === (d || 0) && a && n.emit("beforeSlideChangeStart");
                        var g,
                            b = -l[f];
                        if ((n.updateProgress(b), o.normalizeSlideIndex)) for (var w = 0; w < c.length; w += 1) -Math.floor(100 * b) >= Math.floor(100 * c[w]) && (s = w);
                        if (n.initialized && s !== p) {
                            if (!n.allowSlideNext && b < n.translate && b < n.minTranslate()) return !1;
                            if (!n.allowSlidePrev && b > n.translate && b > n.maxTranslate() && (p || 0) !== s) return !1;
                        }
                        if (((g = s > p ? "next" : s < p ? "prev" : "reset"), (h && -b === n.translate) || (!h && b === n.translate)))
                            return n.updateActiveIndex(s), o.autoHeight && n.updateAutoHeight(), n.updateSlidesClasses(), "slide" !== o.effect && n.setTranslate(b), "reset" !== g && (n.transitionStart(a, g), n.transitionEnd(a, g)), !1;
                        if (o.cssMode) {
                            var v = n.isHorizontal();
                            return 0 === e ? (u[v ? "scrollLeft" : "scrollTop"] = -b) : u.scrollTo ? u.scrollTo((((r = {})[v ? "left" : "top"] = -b), (r.behavior = "smooth"), r)) : (u[v ? "scrollLeft" : "scrollTop"] = -b), !0;
                        }
                        return (
                            0 === e
                                ? (n.setTransition(0), n.setTranslate(b), n.updateActiveIndex(s), n.updateSlidesClasses(), n.emit("beforeTransitionStart", e, i), n.transitionStart(a, g), n.transitionEnd(a, g))
                                : (n.setTransition(e),
                                  n.setTranslate(b),
                                  n.updateActiveIndex(s),
                                  n.updateSlidesClasses(),
                                  n.emit("beforeTransitionStart", e, i),
                                  n.transitionStart(a, g),
                                  n.animating ||
                                      ((n.animating = !0),
                                      n.onSlideToWrapperTransitionEnd ||
                                          (n.onSlideToWrapperTransitionEnd = function (t) {
                                              n &&
                                                  !n.destroyed &&
                                                  t.target === this &&
                                                  (n.$wrapperEl[0].removeEventListener("transitionend", n.onSlideToWrapperTransitionEnd),
                                                  n.$wrapperEl[0].removeEventListener("webkitTransitionEnd", n.onSlideToWrapperTransitionEnd),
                                                  (n.onSlideToWrapperTransitionEnd = null),
                                                  delete n.onSlideToWrapperTransitionEnd,
                                                  n.transitionEnd(a, g));
                                          }),
                                      n.$wrapperEl[0].addEventListener("transitionend", n.onSlideToWrapperTransitionEnd),
                                      n.$wrapperEl[0].addEventListener("webkitTransitionEnd", n.onSlideToWrapperTransitionEnd))),
                            !0
                        );
                    },
                    slideToLoop: function (t, e, a, i) {
                        void 0 === t && (t = 0), void 0 === e && (e = this.params.speed), void 0 === a && (a = !0);
                        var r = t;
                        return this.params.loop && (r += this.loopedSlides), this.slideTo(r, e, a, i);
                    },
                    slideNext: function (t, e, a) {
                        void 0 === t && (t = this.params.speed), void 0 === e && (e = !0);
                        var i = this.params,
                            r = this.animating,
                            n = this.activeIndex < i.slidesPerGroupSkip ? 1 : i.slidesPerGroup;
                        if (i.loop) {
                            if (r) return !1;
                            this.loopFix(), (this._clientLeft = this.$wrapperEl[0].clientLeft);
                        }
                        return this.slideTo(this.activeIndex + n, t, e, a);
                    },
                    slidePrev: function (t, e, a) {
                        void 0 === t && (t = this.params.speed), void 0 === e && (e = !0);
                        var i = this.params,
                            r = this.animating,
                            n = this.snapGrid,
                            s = this.slidesGrid,
                            o = this.rtlTranslate;
                        if (i.loop) {
                            if (r) return !1;
                            this.loopFix(), (this._clientLeft = this.$wrapperEl[0].clientLeft);
                        }
                        function l(t) {
                            return t < 0 ? -Math.floor(Math.abs(t)) : Math.floor(t);
                        }
                        var c,
                            d = l(o ? this.translate : -this.translate),
                            p = n.map(function (t) {
                                return l(t);
                            }),
                            h =
                                (s.map(function (t) {
                                    return l(t);
                                }),
                                n[p.indexOf(d)],
                                n[p.indexOf(d) - 1]);
                        return (
                            void 0 === h &&
                                i.cssMode &&
                                n.forEach(function (t) {
                                    !h && d >= t && (h = t);
                                }),
                            void 0 !== h && (c = s.indexOf(h)) < 0 && (c = this.activeIndex - 1),
                            this.slideTo(c, t, e, a)
                        );
                    },
                    slideReset: function (t, e, a) {
                        return void 0 === t && (t = this.params.speed), void 0 === e && (e = !0), this.slideTo(this.activeIndex, t, e, a);
                    },
                    slideToClosest: function (t, e, a, i) {
                        void 0 === t && (t = this.params.speed), void 0 === e && (e = !0), void 0 === i && (i = 0.5);
                        var r = this.activeIndex,
                            n = Math.min(this.params.slidesPerGroupSkip, r),
                            s = n + Math.floor((r - n) / this.params.slidesPerGroup),
                            o = this.rtlTranslate ? this.translate : -this.translate;
                        if (o >= this.snapGrid[s]) {
                            var l = this.snapGrid[s];
                            o - l > (this.snapGrid[s + 1] - l) * i && (r += this.params.slidesPerGroup);
                        } else {
                            var c = this.snapGrid[s - 1];
                            o - c <= (this.snapGrid[s] - c) * i && (r -= this.params.slidesPerGroup);
                        }
                        return (r = Math.max(r, 0)), (r = Math.min(r, this.slidesGrid.length - 1)), this.slideTo(r, t, e, a);
                    },
                    slideToClickedSlide: function () {
                        var t,
                            e = this,
                            a = e.params,
                            r = e.$wrapperEl,
                            n = "auto" === a.slidesPerView ? e.slidesPerViewDynamic() : a.slidesPerView,
                            o = e.clickedIndex;
                        if (a.loop) {
                            if (e.animating) return;
                            (t = parseInt(i(e.clickedSlide).attr("data-swiper-slide-index"), 10)),
                                a.centeredSlides
                                    ? o < e.loopedSlides - n / 2 || o > e.slides.length - e.loopedSlides + n / 2
                                        ? (e.loopFix(),
                                          (o = r
                                              .children("." + a.slideClass + '[data-swiper-slide-index="' + t + '"]:not(.' + a.slideDuplicateClass + ")")
                                              .eq(0)
                                              .index()),
                                          s.nextTick(function () {
                                              e.slideTo(o);
                                          }))
                                        : e.slideTo(o)
                                    : o > e.slides.length - n
                                    ? (e.loopFix(),
                                      (o = r
                                          .children("." + a.slideClass + '[data-swiper-slide-index="' + t + '"]:not(.' + a.slideDuplicateClass + ")")
                                          .eq(0)
                                          .index()),
                                      s.nextTick(function () {
                                          e.slideTo(o);
                                      }))
                                    : e.slideTo(o);
                        } else e.slideTo(o);
                    },
                },
                D = {
                    loopCreate: function () {
                        var e = this,
                            a = e.params,
                            r = e.$wrapperEl;
                        r.children("." + a.slideClass + "." + a.slideDuplicateClass).remove();
                        var n = r.children("." + a.slideClass);
                        if (a.loopFillGroupWithBlank) {
                            var s = a.slidesPerGroup - (n.length % a.slidesPerGroup);
                            if (s !== a.slidesPerGroup) {
                                for (var o = 0; o < s; o += 1) {
                                    var l = i(t.createElement("div")).addClass(a.slideClass + " " + a.slideBlankClass);
                                    r.append(l);
                                }
                                n = r.children("." + a.slideClass);
                            }
                        }
                        "auto" !== a.slidesPerView || a.loopedSlides || (a.loopedSlides = n.length),
                            (e.loopedSlides = Math.ceil(parseFloat(a.loopedSlides || a.slidesPerView, 10))),
                            (e.loopedSlides += a.loopAdditionalSlides),
                            e.loopedSlides > n.length && (e.loopedSlides = n.length);
                        var c = [],
                            d = [];
                        n.each(function (t, a) {
                            var r = i(a);
                            t < e.loopedSlides && d.push(a), t < n.length && t >= n.length - e.loopedSlides && c.push(a), r.attr("data-swiper-slide-index", t);
                        });
                        for (var p = 0; p < d.length; p += 1) r.append(i(d[p].cloneNode(!0)).addClass(a.slideDuplicateClass));
                        for (var h = c.length - 1; h >= 0; h -= 1) r.prepend(i(c[h].cloneNode(!0)).addClass(a.slideDuplicateClass));
                    },
                    loopFix: function () {
                        this.emit("beforeLoopFix");
                        var t,
                            e = this.activeIndex,
                            a = this.slides,
                            i = this.loopedSlides,
                            r = this.allowSlidePrev,
                            n = this.allowSlideNext,
                            s = this.snapGrid,
                            o = this.rtlTranslate;
                        (this.allowSlidePrev = !0), (this.allowSlideNext = !0);
                        var l = -s[e] - this.getTranslate();
                        e < i
                            ? ((t = a.length - 3 * i + e), (t += i), this.slideTo(t, 0, !1, !0) && 0 !== l && this.setTranslate((o ? -this.translate : this.translate) - l))
                            : e >= a.length - i && ((t = -a.length + e + i), (t += i), this.slideTo(t, 0, !1, !0) && 0 !== l && this.setTranslate((o ? -this.translate : this.translate) - l)),
                            (this.allowSlidePrev = r),
                            (this.allowSlideNext = n),
                            this.emit("loopFix");
                    },
                    loopDestroy: function () {
                        var t = this.$wrapperEl,
                            e = this.params,
                            a = this.slides;
                        t.children("." + e.slideClass + "." + e.slideDuplicateClass + ",." + e.slideClass + "." + e.slideBlankClass).remove(), a.removeAttr("data-swiper-slide-index");
                    },
                },
                z = {
                    setGrabCursor: function (t) {
                        if (!(o.touch || !this.params.simulateTouch || (this.params.watchOverflow && this.isLocked) || this.params.cssMode)) {
                            var e = this.el;
                            (e.style.cursor = "move"), (e.style.cursor = t ? "-webkit-grabbing" : "-webkit-grab"), (e.style.cursor = t ? "-moz-grabbin" : "-moz-grab"), (e.style.cursor = t ? "grabbing" : "grab");
                        }
                    },
                    unsetGrabCursor: function () {
                        o.touch || (this.params.watchOverflow && this.isLocked) || this.params.cssMode || (this.el.style.cursor = "");
                    },
                },
                A = {
                    appendSlide: function (t) {
                        var e = this.$wrapperEl,
                            a = this.params;
                        if ((a.loop && this.loopDestroy(), "object" == typeof t && "length" in t)) for (var i = 0; i < t.length; i += 1) t[i] && e.append(t[i]);
                        else e.append(t);
                        a.loop && this.loopCreate(), (a.observer && o.observer) || this.update();
                    },
                    prependSlide: function (t) {
                        var e = this.params,
                            a = this.$wrapperEl,
                            i = this.activeIndex;
                        e.loop && this.loopDestroy();
                        var r = i + 1;
                        if ("object" == typeof t && "length" in t) {
                            for (var n = 0; n < t.length; n += 1) t[n] && a.prepend(t[n]);
                            r = i + t.length;
                        } else a.prepend(t);
                        e.loop && this.loopCreate(), (e.observer && o.observer) || this.update(), this.slideTo(r, 0, !1);
                    },
                    addSlide: function (t, e) {
                        var a = this.$wrapperEl,
                            i = this.params,
                            r = this.activeIndex;
                        i.loop && ((r -= this.loopedSlides), this.loopDestroy(), (this.slides = a.children("." + i.slideClass)));
                        var n = this.slides.length;
                        if (t <= 0) this.prependSlide(e);
                        else if (t >= n) this.appendSlide(e);
                        else {
                            for (var s = r > t ? r + 1 : r, l = [], c = n - 1; c >= t; c -= 1) {
                                var d = this.slides.eq(c);
                                d.remove(), l.unshift(d);
                            }
                            if ("object" == typeof e && "length" in e) {
                                for (var p = 0; p < e.length; p += 1) e[p] && a.append(e[p]);
                                s = r > t ? r + e.length : r;
                            } else a.append(e);
                            for (var h = 0; h < l.length; h += 1) a.append(l[h]);
                            i.loop && this.loopCreate(), (i.observer && o.observer) || this.update(), i.loop ? this.slideTo(s + this.loopedSlides, 0, !1) : this.slideTo(s, 0, !1);
                        }
                    },
                    removeSlide: function (t) {
                        var e = this.params,
                            a = this.$wrapperEl,
                            i = this.activeIndex;
                        e.loop && ((i -= this.loopedSlides), this.loopDestroy(), (this.slides = a.children("." + e.slideClass)));
                        var r,
                            n = i;
                        if ("object" == typeof t && "length" in t) {
                            for (var s = 0; s < t.length; s += 1) (r = t[s]), this.slides[r] && this.slides.eq(r).remove(), r < n && (n -= 1);
                            n = Math.max(n, 0);
                        } else (r = t), this.slides[r] && this.slides.eq(r).remove(), r < n && (n -= 1), (n = Math.max(n, 0));
                        e.loop && this.loopCreate(), (e.observer && o.observer) || this.update(), e.loop ? this.slideTo(n + this.loopedSlides, 0, !1) : this.slideTo(n, 0, !1);
                    },
                    removeAllSlides: function () {
                        for (var t = [], e = 0; e < this.slides.length; e += 1) t.push(e);
                        this.removeSlide(t);
                    },
                },
                M =
                    ((d = e.navigator.platform),
                    (p = e.navigator.userAgent),
                    (h = {
                        ios: !1,
                        android: !1,
                        androidChrome: !1,
                        desktop: !1,
                        iphone: !1,
                        ipod: !1,
                        ipad: !1,
                        edge: !1,
                        ie: !1,
                        firefox: !1,
                        macos: !1,
                        windows: !1,
                        cordova: !(!e.cordova && !e.phonegap),
                        phonegap: !(!e.cordova && !e.phonegap),
                        electron: !1,
                    }),
                    (u = e.screen.width),
                    (m = e.screen.height),
                    (f = p.match(/(Android);?[\s\/]+([\d.]+)?/)),
                    (g = p.match(/(iPad).*OS\s([\d_]+)/)),
                    (b = p.match(/(iPod)(.*OS\s([\d_]+))?/)),
                    (w = !g && p.match(/(iPhone\sOS|iOS)\s([\d_]+)/)),
                    (v = p.indexOf("MSIE ") >= 0 || p.indexOf("Trident/") >= 0),
                    (y = p.indexOf("Edge/") >= 0),
                    (_ = p.indexOf("Gecko/") >= 0 && p.indexOf("Firefox/") >= 0),
                    (x = "Win32" === d),
                    (k = p.toLowerCase().indexOf("electron") >= 0),
                    (C = "MacIntel" === d),
                    !g && C && o.touch && ((1024 === u && 1366 === m) || (834 === u && 1194 === m) || (834 === u && 1112 === m) || (768 === u && 1024 === m)) && ((g = p.match(/(Version)\/([\d.]+)/)), (C = !1)),
                    (h.ie = v),
                    (h.edge = y),
                    (h.firefox = _),
                    f && !x && ((h.os = "android"), (h.osVersion = f[2]), (h.android = !0), (h.androidChrome = p.toLowerCase().indexOf("chrome") >= 0)),
                    (g || w || b) && ((h.os = "ios"), (h.ios = !0)),
                    w && !b && ((h.osVersion = w[2].replace(/_/g, ".")), (h.iphone = !0)),
                    g && ((h.osVersion = g[2].replace(/_/g, ".")), (h.ipad = !0)),
                    b && ((h.osVersion = b[3] ? b[3].replace(/_/g, ".") : null), (h.ipod = !0)),
                    h.ios && h.osVersion && p.indexOf("Version/") >= 0 && "10" === h.osVersion.split(".")[0] && (h.osVersion = p.toLowerCase().split("version/")[1].split(" ")[0]),
                    (h.webView = !(!(w || g || b) || (!p.match(/.*AppleWebKit(?!.*Safari)/i) && !e.navigator.standalone)) || (e.matchMedia && e.matchMedia("(display-mode: standalone)").matches)),
                    (h.webview = h.webView),
                    (h.standalone = h.webView),
                    (h.desktop = !(h.ios || h.android) || k),
                    h.desktop && ((h.electron = k), (h.macos = C), (h.windows = x), h.macos && (h.os = "macos"), h.windows && (h.os = "windows")),
                    (h.pixelRatio = e.devicePixelRatio || 1),
                    h);
            function O(a) {
                var r = this.touchEventsData,
                    n = this.params,
                    o = this.touches;
                if (!this.animating || !n.preventInteractionOnTransition) {
                    var l = a;
                    l.originalEvent && (l = l.originalEvent);
                    var c = i(l.target);
                    if (
                        ("wrapper" !== n.touchEventsTarget || c.closest(this.wrapperEl).length) &&
                        ((r.isTouchEvent = "touchstart" === l.type), (r.isTouchEvent || !("which" in l) || 3 !== l.which) && !((!r.isTouchEvent && "button" in l && l.button > 0) || (r.isTouched && r.isMoved)))
                    )
                        if (n.noSwiping && c.closest(n.noSwipingSelector ? n.noSwipingSelector : "." + n.noSwipingClass)[0]) this.allowClick = !0;
                        else if (!n.swipeHandler || c.closest(n.swipeHandler)[0]) {
                            (o.currentX = "touchstart" === l.type ? l.targetTouches[0].pageX : l.pageX), (o.currentY = "touchstart" === l.type ? l.targetTouches[0].pageY : l.pageY);
                            var d = o.currentX,
                                p = o.currentY,
                                h = n.edgeSwipeDetection || n.iOSEdgeSwipeDetection,
                                u = n.edgeSwipeThreshold || n.iOSEdgeSwipeThreshold;
                            if (!h || !(d <= u || d >= e.screen.width - u)) {
                                if (
                                    (s.extend(r, { isTouched: !0, isMoved: !1, allowTouchCallbacks: !0, isScrolling: void 0, startMoving: void 0 }),
                                    (o.startX = d),
                                    (o.startY = p),
                                    (r.touchStartTime = s.now()),
                                    (this.allowClick = !0),
                                    this.updateSize(),
                                    (this.swipeDirection = void 0),
                                    n.threshold > 0 && (r.allowThresholdMove = !1),
                                    "touchstart" !== l.type)
                                ) {
                                    var m = !0;
                                    c.is(r.formElements) && (m = !1), t.activeElement && i(t.activeElement).is(r.formElements) && t.activeElement !== c[0] && t.activeElement.blur();
                                    var f = m && this.allowTouchMove && n.touchStartPreventDefault;
                                    (n.touchStartForcePreventDefault || f) && l.preventDefault();
                                }
                                this.emit("touchStart", l);
                            }
                        }
                }
            }
            function H(e) {
                var a = this.touchEventsData,
                    r = this.params,
                    n = this.touches,
                    o = this.rtlTranslate,
                    l = e;
                if ((l.originalEvent && (l = l.originalEvent), a.isTouched)) {
                    if (!a.isTouchEvent || "mousemove" !== l.type) {
                        var c = "touchmove" === l.type && l.targetTouches && (l.targetTouches[0] || l.changedTouches[0]),
                            d = "touchmove" === l.type ? c.pageX : l.pageX,
                            p = "touchmove" === l.type ? c.pageY : l.pageY;
                        if (l.preventedByNestedSwiper) return (n.startX = d), void (n.startY = p);
                        if (!this.allowTouchMove) return (this.allowClick = !1), void (a.isTouched && (s.extend(n, { startX: d, startY: p, currentX: d, currentY: p }), (a.touchStartTime = s.now())));
                        if (a.isTouchEvent && r.touchReleaseOnEdges && !r.loop)
                            if (this.isVertical()) {
                                if ((p < n.startY && this.translate <= this.maxTranslate()) || (p > n.startY && this.translate >= this.minTranslate())) return (a.isTouched = !1), void (a.isMoved = !1);
                            } else if ((d < n.startX && this.translate <= this.maxTranslate()) || (d > n.startX && this.translate >= this.minTranslate())) return;
                        if (a.isTouchEvent && t.activeElement && l.target === t.activeElement && i(l.target).is(a.formElements)) return (a.isMoved = !0), void (this.allowClick = !1);
                        if ((a.allowTouchCallbacks && this.emit("touchMove", l), !(l.targetTouches && l.targetTouches.length > 1))) {
                            (n.currentX = d), (n.currentY = p);
                            var h,
                                u = n.currentX - n.startX,
                                m = n.currentY - n.startY;
                            if (!(this.params.threshold && Math.sqrt(Math.pow(u, 2) + Math.pow(m, 2)) < this.params.threshold))
                                if (
                                    (void 0 === a.isScrolling &&
                                        ((this.isHorizontal() && n.currentY === n.startY) || (this.isVertical() && n.currentX === n.startX)
                                            ? (a.isScrolling = !1)
                                            : u * u + m * m >= 25 && ((h = (180 * Math.atan2(Math.abs(m), Math.abs(u))) / Math.PI), (a.isScrolling = this.isHorizontal() ? h > r.touchAngle : 90 - h > r.touchAngle))),
                                    a.isScrolling && this.emit("touchMoveOpposite", l),
                                    void 0 === a.startMoving && ((n.currentX === n.startX && n.currentY === n.startY) || (a.startMoving = !0)),
                                    a.isScrolling)
                                )
                                    a.isTouched = !1;
                                else if (a.startMoving) {
                                    (this.allowClick = !1),
                                        r.cssMode || l.preventDefault(),
                                        r.touchMoveStopPropagation && !r.nested && l.stopPropagation(),
                                        a.isMoved ||
                                            (r.loop && this.loopFix(),
                                            (a.startTranslate = this.getTranslate()),
                                            this.setTransition(0),
                                            this.animating && this.$wrapperEl.trigger("webkitTransitionEnd transitionend"),
                                            (a.allowMomentumBounce = !1),
                                            !r.grabCursor || (!0 !== this.allowSlideNext && !0 !== this.allowSlidePrev) || this.setGrabCursor(!0),
                                            this.emit("sliderFirstMove", l)),
                                        this.emit("sliderMove", l),
                                        (a.isMoved = !0);
                                    var f = this.isHorizontal() ? u : m;
                                    (n.diff = f), (f *= r.touchRatio), o && (f = -f), (this.swipeDirection = f > 0 ? "prev" : "next"), (a.currentTranslate = f + a.startTranslate);
                                    var g = !0,
                                        b = r.resistanceRatio;
                                    if (
                                        (r.touchReleaseOnEdges && (b = 0),
                                        f > 0 && a.currentTranslate > this.minTranslate()
                                            ? ((g = !1), r.resistance && (a.currentTranslate = this.minTranslate() - 1 + Math.pow(-this.minTranslate() + a.startTranslate + f, b)))
                                            : f < 0 && a.currentTranslate < this.maxTranslate() && ((g = !1), r.resistance && (a.currentTranslate = this.maxTranslate() + 1 - Math.pow(this.maxTranslate() - a.startTranslate - f, b))),
                                        g && (l.preventedByNestedSwiper = !0),
                                        !this.allowSlideNext && "next" === this.swipeDirection && a.currentTranslate < a.startTranslate && (a.currentTranslate = a.startTranslate),
                                        !this.allowSlidePrev && "prev" === this.swipeDirection && a.currentTranslate > a.startTranslate && (a.currentTranslate = a.startTranslate),
                                        r.threshold > 0)
                                    ) {
                                        if (!(Math.abs(f) > r.threshold || a.allowThresholdMove)) return void (a.currentTranslate = a.startTranslate);
                                        if (!a.allowThresholdMove)
                                            return (
                                                (a.allowThresholdMove = !0),
                                                (n.startX = n.currentX),
                                                (n.startY = n.currentY),
                                                (a.currentTranslate = a.startTranslate),
                                                void (n.diff = this.isHorizontal() ? n.currentX - n.startX : n.currentY - n.startY)
                                            );
                                    }
                                    r.followFinger &&
                                        !r.cssMode &&
                                        ((r.freeMode || r.watchSlidesProgress || r.watchSlidesVisibility) && (this.updateActiveIndex(), this.updateSlidesClasses()),
                                        r.freeMode &&
                                            (0 === a.velocities.length && a.velocities.push({ position: n[this.isHorizontal() ? "startX" : "startY"], time: a.touchStartTime }),
                                            a.velocities.push({ position: n[this.isHorizontal() ? "currentX" : "currentY"], time: s.now() })),
                                        this.updateProgress(a.currentTranslate),
                                        this.setTranslate(a.currentTranslate));
                                }
                        }
                    }
                } else a.startMoving && a.isScrolling && this.emit("touchMoveOpposite", l);
            }
            function I(t) {
                var e = this,
                    a = e.touchEventsData,
                    i = e.params,
                    r = e.touches,
                    n = e.rtlTranslate,
                    o = e.$wrapperEl,
                    l = e.slidesGrid,
                    c = e.snapGrid,
                    d = t;
                if ((d.originalEvent && (d = d.originalEvent), a.allowTouchCallbacks && e.emit("touchEnd", d), (a.allowTouchCallbacks = !1), !a.isTouched))
                    return a.isMoved && i.grabCursor && e.setGrabCursor(!1), (a.isMoved = !1), void (a.startMoving = !1);
                i.grabCursor && a.isMoved && a.isTouched && (!0 === e.allowSlideNext || !0 === e.allowSlidePrev) && e.setGrabCursor(!1);
                var p,
                    h = s.now(),
                    u = h - a.touchStartTime;
                if (
                    (e.allowClick && (e.updateClickedSlide(d), e.emit("tap click", d), u < 300 && h - a.lastClickTime < 300 && e.emit("doubleTap doubleClick", d)),
                    (a.lastClickTime = s.now()),
                    s.nextTick(function () {
                        e.destroyed || (e.allowClick = !0);
                    }),
                    !a.isTouched || !a.isMoved || !e.swipeDirection || 0 === r.diff || a.currentTranslate === a.startTranslate)
                )
                    return (a.isTouched = !1), (a.isMoved = !1), void (a.startMoving = !1);
                if (((a.isTouched = !1), (a.isMoved = !1), (a.startMoving = !1), (p = i.followFinger ? (n ? e.translate : -e.translate) : -a.currentTranslate), !i.cssMode))
                    if (i.freeMode) {
                        if (p < -e.minTranslate()) return void e.slideTo(e.activeIndex);
                        if (p > -e.maxTranslate()) return void (e.slides.length < c.length ? e.slideTo(c.length - 1) : e.slideTo(e.slides.length - 1));
                        if (i.freeModeMomentum) {
                            if (a.velocities.length > 1) {
                                var m = a.velocities.pop(),
                                    f = a.velocities.pop(),
                                    g = m.position - f.position,
                                    b = m.time - f.time;
                                (e.velocity = g / b), (e.velocity /= 2), Math.abs(e.velocity) < i.freeModeMinimumVelocity && (e.velocity = 0), (b > 150 || s.now() - m.time > 300) && (e.velocity = 0);
                            } else e.velocity = 0;
                            (e.velocity *= i.freeModeMomentumVelocityRatio), (a.velocities.length = 0);
                            var w = 1e3 * i.freeModeMomentumRatio,
                                v = e.velocity * w,
                                y = e.translate + v;
                            n && (y = -y);
                            var _,
                                x,
                                k = !1,
                                C = 20 * Math.abs(e.velocity) * i.freeModeMomentumBounceRatio;
                            if (y < e.maxTranslate())
                                i.freeModeMomentumBounce ? (y + e.maxTranslate() < -C && (y = e.maxTranslate() - C), (_ = e.maxTranslate()), (k = !0), (a.allowMomentumBounce = !0)) : (y = e.maxTranslate()),
                                    i.loop && i.centeredSlides && (x = !0);
                            else if (y > e.minTranslate())
                                i.freeModeMomentumBounce ? (y - e.minTranslate() > C && (y = e.minTranslate() + C), (_ = e.minTranslate()), (k = !0), (a.allowMomentumBounce = !0)) : (y = e.minTranslate()),
                                    i.loop && i.centeredSlides && (x = !0);
                            else if (i.freeModeSticky) {
                                for (var S, T = 0; T < c.length; T += 1)
                                    if (c[T] > -y) {
                                        S = T;
                                        break;
                                    }
                                y = -(y = Math.abs(c[S] - y) < Math.abs(c[S - 1] - y) || "next" === e.swipeDirection ? c[S] : c[S - 1]);
                            }
                            if (
                                (x &&
                                    e.once("transitionEnd", function () {
                                        e.loopFix();
                                    }),
                                0 !== e.velocity)
                            ) {
                                if (((w = n ? Math.abs((-y - e.translate) / e.velocity) : Math.abs((y - e.translate) / e.velocity)), i.freeModeSticky)) {
                                    var E = Math.abs((n ? -y : y) - e.translate),
                                        D = e.slidesSizesGrid[e.activeIndex];
                                    w = E < D ? i.speed : E < 2 * D ? 1.5 * i.speed : 2.5 * i.speed;
                                }
                            } else if (i.freeModeSticky) return void e.slideToClosest();
                            i.freeModeMomentumBounce && k
                                ? (e.updateProgress(_),
                                  e.setTransition(w),
                                  e.setTranslate(y),
                                  e.transitionStart(!0, e.swipeDirection),
                                  (e.animating = !0),
                                  o.transitionEnd(function () {
                                      e &&
                                          !e.destroyed &&
                                          a.allowMomentumBounce &&
                                          (e.emit("momentumBounce"),
                                          e.setTransition(i.speed),
                                          e.setTranslate(_),
                                          o.transitionEnd(function () {
                                              e && !e.destroyed && e.transitionEnd();
                                          }));
                                  }))
                                : e.velocity
                                ? (e.updateProgress(y),
                                  e.setTransition(w),
                                  e.setTranslate(y),
                                  e.transitionStart(!0, e.swipeDirection),
                                  e.animating ||
                                      ((e.animating = !0),
                                      o.transitionEnd(function () {
                                          e && !e.destroyed && e.transitionEnd();
                                      })))
                                : e.updateProgress(y),
                                e.updateActiveIndex(),
                                e.updateSlidesClasses();
                        } else if (i.freeModeSticky) return void e.slideToClosest();
                        (!i.freeModeMomentum || u >= i.longSwipesMs) && (e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses());
                    } else {
                        for (var z = 0, A = e.slidesSizesGrid[0], M = 0; M < l.length; M += M < i.slidesPerGroupSkip ? 1 : i.slidesPerGroup) {
                            var O = M < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
                            void 0 !== l[M + O] ? p >= l[M] && p < l[M + O] && ((z = M), (A = l[M + O] - l[M])) : p >= l[M] && ((z = M), (A = l[l.length - 1] - l[l.length - 2]));
                        }
                        var H = (p - l[z]) / A,
                            I = z < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
                        if (u > i.longSwipesMs) {
                            if (!i.longSwipes) return void e.slideTo(e.activeIndex);
                            "next" === e.swipeDirection && (H >= i.longSwipesRatio ? e.slideTo(z + I) : e.slideTo(z)), "prev" === e.swipeDirection && (H > 1 - i.longSwipesRatio ? e.slideTo(z + I) : e.slideTo(z));
                        } else {
                            if (!i.shortSwipes) return void e.slideTo(e.activeIndex);
                            !e.navigation || (d.target !== e.navigation.nextEl && d.target !== e.navigation.prevEl)
                                ? ("next" === e.swipeDirection && e.slideTo(z + I), "prev" === e.swipeDirection && e.slideTo(z))
                                : d.target === e.navigation.nextEl
                                ? e.slideTo(z + I)
                                : e.slideTo(z);
                        }
                    }
            }
            function P() {
                var t = this.params,
                    e = this.el;
                if (!e || 0 !== e.offsetWidth) {
                    t.breakpoints && this.setBreakpoint();
                    var a = this.allowSlideNext,
                        i = this.allowSlidePrev,
                        r = this.snapGrid;
                    (this.allowSlideNext = !0),
                        (this.allowSlidePrev = !0),
                        this.updateSize(),
                        this.updateSlides(),
                        this.updateSlidesClasses(),
                        ("auto" === t.slidesPerView || t.slidesPerView > 1) && this.isEnd && !this.params.centeredSlides ? this.slideTo(this.slides.length - 1, 0, !1, !0) : this.slideTo(this.activeIndex, 0, !1, !0),
                        this.autoplay && this.autoplay.running && this.autoplay.paused && this.autoplay.run(),
                        (this.allowSlidePrev = i),
                        (this.allowSlideNext = a),
                        this.params.watchOverflow && r !== this.snapGrid && this.checkOverflow();
                }
            }
            var L = !1;
            function B() {}
            var $ = {
                    init: !0,
                    direction: "horizontal",
                    touchEventsTarget: "container",
                    initialSlide: 0,
                    speed: 300,
                    cssMode: !1,
                    updateOnWindowResize: !0,
                    preventInteractionOnTransition: !1,
                    edgeSwipeDetection: !1,
                    edgeSwipeThreshold: 20,
                    freeMode: !1,
                    freeModeMomentum: !0,
                    freeModeMomentumRatio: 1,
                    freeModeMomentumBounce: !0,
                    freeModeMomentumBounceRatio: 1,
                    freeModeMomentumVelocityRatio: 1,
                    freeModeSticky: !1,
                    freeModeMinimumVelocity: 0.02,
                    autoHeight: !1,
                    setWrapperSize: !1,
                    virtualTranslate: !1,
                    effect: "slide",
                    breakpoints: void 0,
                    spaceBetween: 0,
                    slidesPerView: 1,
                    slidesPerColumn: 1,
                    slidesPerColumnFill: "column",
                    slidesPerGroup: 1,
                    slidesPerGroupSkip: 0,
                    centeredSlides: !1,
                    centeredSlidesBounds: !1,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    normalizeSlideIndex: !0,
                    centerInsufficientSlides: !1,
                    watchOverflow: !1,
                    roundLengths: !1,
                    touchRatio: 1,
                    touchAngle: 45,
                    simulateTouch: !0,
                    shortSwipes: !0,
                    longSwipes: !0,
                    longSwipesRatio: 0.5,
                    longSwipesMs: 300,
                    followFinger: !0,
                    allowTouchMove: !0,
                    threshold: 0,
                    touchMoveStopPropagation: !1,
                    touchStartPreventDefault: !0,
                    touchStartForcePreventDefault: !1,
                    touchReleaseOnEdges: !1,
                    uniqueNavElements: !0,
                    resistance: !0,
                    resistanceRatio: 0.85,
                    watchSlidesProgress: !1,
                    watchSlidesVisibility: !1,
                    grabCursor: !1,
                    preventClicks: !0,
                    preventClicksPropagation: !0,
                    slideToClickedSlide: !1,
                    preloadImages: !0,
                    updateOnImagesReady: !0,
                    loop: !1,
                    loopAdditionalSlides: 0,
                    loopedSlides: null,
                    loopFillGroupWithBlank: !1,
                    allowSlidePrev: !0,
                    allowSlideNext: !0,
                    swipeHandler: null,
                    noSwiping: !0,
                    noSwipingClass: "swiper-no-swiping",
                    noSwipingSelector: null,
                    passiveListeners: !0,
                    containerModifierClass: "swiper-container-",
                    slideClass: "swiper-slide",
                    slideBlankClass: "swiper-slide-invisible-blank",
                    slideActiveClass: "swiper-slide-active",
                    slideDuplicateActiveClass: "swiper-slide-duplicate-active",
                    slideVisibleClass: "swiper-slide-visible",
                    slideDuplicateClass: "swiper-slide-duplicate",
                    slideNextClass: "swiper-slide-next",
                    slideDuplicateNextClass: "swiper-slide-duplicate-next",
                    slidePrevClass: "swiper-slide-prev",
                    slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
                    wrapperClass: "swiper-wrapper",
                    runCallbacksOnInit: !0,
                },
                q = {
                    update: S,
                    translate: T,
                    transition: {
                        setTransition: function (t, e) {
                            this.params.cssMode || this.$wrapperEl.transition(t), this.emit("setTransition", t, e);
                        },
                        transitionStart: function (t, e) {
                            void 0 === t && (t = !0);
                            var a = this.activeIndex,
                                i = this.params,
                                r = this.previousIndex;
                            if (!i.cssMode) {
                                i.autoHeight && this.updateAutoHeight();
                                var n = e;
                                if ((n || (n = a > r ? "next" : a < r ? "prev" : "reset"), this.emit("transitionStart"), t && a !== r)) {
                                    if ("reset" === n) return void this.emit("slideResetTransitionStart");
                                    this.emit("slideChangeTransitionStart"), "next" === n ? this.emit("slideNextTransitionStart") : this.emit("slidePrevTransitionStart");
                                }
                            }
                        },
                        transitionEnd: function (t, e) {
                            void 0 === t && (t = !0);
                            var a = this.activeIndex,
                                i = this.previousIndex,
                                r = this.params;
                            if (((this.animating = !1), !r.cssMode)) {
                                this.setTransition(0);
                                var n = e;
                                if ((n || (n = a > i ? "next" : a < i ? "prev" : "reset"), this.emit("transitionEnd"), t && a !== i)) {
                                    if ("reset" === n) return void this.emit("slideResetTransitionEnd");
                                    this.emit("slideChangeTransitionEnd"), "next" === n ? this.emit("slideNextTransitionEnd") : this.emit("slidePrevTransitionEnd");
                                }
                            }
                        },
                    },
                    slide: E,
                    loop: D,
                    grabCursor: z,
                    manipulation: A,
                    events: {
                        attachEvents: function () {
                            var e = this.params,
                                a = this.touchEvents,
                                i = this.el,
                                r = this.wrapperEl;
                            (this.onTouchStart = O.bind(this)),
                                (this.onTouchMove = H.bind(this)),
                                (this.onTouchEnd = I.bind(this)),
                                e.cssMode &&
                                    (this.onScroll = function () {
                                        var t = this.wrapperEl;
                                        (this.previousTranslate = this.translate),
                                            (this.translate = this.isHorizontal() ? -t.scrollLeft : -t.scrollTop),
                                            -0 === this.translate && (this.translate = 0),
                                            this.updateActiveIndex(),
                                            this.updateSlidesClasses();
                                        var e = this.maxTranslate() - this.minTranslate();
                                        (0 === e ? 0 : (this.translate - this.minTranslate()) / e) !== this.progress && this.updateProgress(this.translate), this.emit("setTranslate", this.translate, !1);
                                    }.bind(this)),
                                (this.onClick = function (t) {
                                    this.allowClick || (this.params.preventClicks && t.preventDefault(), this.params.preventClicksPropagation && this.animating && (t.stopPropagation(), t.stopImmediatePropagation()));
                                }.bind(this));
                            var n = !!e.nested;
                            if (!o.touch && o.pointerEvents) i.addEventListener(a.start, this.onTouchStart, !1), t.addEventListener(a.move, this.onTouchMove, n), t.addEventListener(a.end, this.onTouchEnd, !1);
                            else {
                                if (o.touch) {
                                    var s = !("touchstart" !== a.start || !o.passiveListener || !e.passiveListeners) && { passive: !0, capture: !1 };
                                    i.addEventListener(a.start, this.onTouchStart, s),
                                        i.addEventListener(a.move, this.onTouchMove, o.passiveListener ? { passive: !1, capture: n } : n),
                                        i.addEventListener(a.end, this.onTouchEnd, s),
                                        a.cancel && i.addEventListener(a.cancel, this.onTouchEnd, s),
                                        L || (t.addEventListener("touchstart", B), (L = !0));
                                }
                                ((e.simulateTouch && !M.ios && !M.android) || (e.simulateTouch && !o.touch && M.ios)) &&
                                    (i.addEventListener("mousedown", this.onTouchStart, !1), t.addEventListener("mousemove", this.onTouchMove, n), t.addEventListener("mouseup", this.onTouchEnd, !1));
                            }
                            (e.preventClicks || e.preventClicksPropagation) && i.addEventListener("click", this.onClick, !0),
                                e.cssMode && r.addEventListener("scroll", this.onScroll),
                                e.updateOnWindowResize ? this.on(M.ios || M.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", P, !0) : this.on("observerUpdate", P, !0);
                        },
                        detachEvents: function () {
                            var e = this.params,
                                a = this.touchEvents,
                                i = this.el,
                                r = this.wrapperEl,
                                n = !!e.nested;
                            if (!o.touch && o.pointerEvents) i.removeEventListener(a.start, this.onTouchStart, !1), t.removeEventListener(a.move, this.onTouchMove, n), t.removeEventListener(a.end, this.onTouchEnd, !1);
                            else {
                                if (o.touch) {
                                    var s = !("onTouchStart" !== a.start || !o.passiveListener || !e.passiveListeners) && { passive: !0, capture: !1 };
                                    i.removeEventListener(a.start, this.onTouchStart, s),
                                        i.removeEventListener(a.move, this.onTouchMove, n),
                                        i.removeEventListener(a.end, this.onTouchEnd, s),
                                        a.cancel && i.removeEventListener(a.cancel, this.onTouchEnd, s);
                                }
                                ((e.simulateTouch && !M.ios && !M.android) || (e.simulateTouch && !o.touch && M.ios)) &&
                                    (i.removeEventListener("mousedown", this.onTouchStart, !1), t.removeEventListener("mousemove", this.onTouchMove, n), t.removeEventListener("mouseup", this.onTouchEnd, !1));
                            }
                            (e.preventClicks || e.preventClicksPropagation) && i.removeEventListener("click", this.onClick, !0),
                                e.cssMode && r.removeEventListener("scroll", this.onScroll),
                                this.off(M.ios || M.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", P);
                        },
                    },
                    breakpoints: {
                        setBreakpoint: function () {
                            var t = this.activeIndex,
                                e = this.initialized,
                                a = this.loopedSlides;
                            void 0 === a && (a = 0);
                            var i = this.params,
                                r = this.$el,
                                n = i.breakpoints;
                            if (n && (!n || 0 !== Object.keys(n).length)) {
                                var o = this.getBreakpoint(n);
                                if (o && this.currentBreakpoint !== o) {
                                    var l = o in n ? n[o] : void 0;
                                    l &&
                                        ["slidesPerView", "spaceBetween", "slidesPerGroup", "slidesPerGroupSkip", "slidesPerColumn"].forEach(function (t) {
                                            var e = l[t];
                                            void 0 !== e && (l[t] = "slidesPerView" !== t || ("AUTO" !== e && "auto" !== e) ? ("slidesPerView" === t ? parseFloat(e) : parseInt(e, 10)) : "auto");
                                        });
                                    var c = l || this.originalParams,
                                        d = i.slidesPerColumn > 1,
                                        p = c.slidesPerColumn > 1;
                                    d && !p
                                        ? r.removeClass(i.containerModifierClass + "multirow " + i.containerModifierClass + "multirow-column")
                                        : !d && p && (r.addClass(i.containerModifierClass + "multirow"), "column" === c.slidesPerColumnFill && r.addClass(i.containerModifierClass + "multirow-column"));
                                    var h = c.direction && c.direction !== i.direction,
                                        u = i.loop && (c.slidesPerView !== i.slidesPerView || h);
                                    h && e && this.changeDirection(),
                                        s.extend(this.params, c),
                                        s.extend(this, { allowTouchMove: this.params.allowTouchMove, allowSlideNext: this.params.allowSlideNext, allowSlidePrev: this.params.allowSlidePrev }),
                                        (this.currentBreakpoint = o),
                                        u && e && (this.loopDestroy(), this.loopCreate(), this.updateSlides(), this.slideTo(t - a + this.loopedSlides, 0, !1)),
                                        this.emit("breakpoint", c);
                                }
                            }
                        },
                        getBreakpoint: function (t) {
                            if (t) {
                                var a = !1,
                                    i = Object.keys(t).map(function (t) {
                                        if ("string" == typeof t && t.startsWith("@")) {
                                            var a = parseFloat(t.substr(1));
                                            return { value: e.innerHeight * a, point: t };
                                        }
                                        return { value: t, point: t };
                                    });
                                i.sort(function (t, e) {
                                    return parseInt(t.value, 10) - parseInt(e.value, 10);
                                });
                                for (var r = 0; r < i.length; r += 1) {
                                    var n = i[r],
                                        s = n.point;
                                    n.value <= e.innerWidth && (a = s);
                                }
                                return a || "max";
                            }
                        },
                    },
                    checkOverflow: {
                        checkOverflow: function () {
                            var t = this.params,
                                e = this.isLocked,
                                a = this.slides.length > 0 && t.slidesOffsetBefore + t.spaceBetween * (this.slides.length - 1) + this.slides[0].offsetWidth * this.slides.length;
                            t.slidesOffsetBefore && t.slidesOffsetAfter && a ? (this.isLocked = a <= this.size) : (this.isLocked = 1 === this.snapGrid.length),
                                (this.allowSlideNext = !this.isLocked),
                                (this.allowSlidePrev = !this.isLocked),
                                e !== this.isLocked && this.emit(this.isLocked ? "lock" : "unlock"),
                                e && e !== this.isLocked && ((this.isEnd = !1), this.navigation.update());
                        },
                    },
                    classes: {
                        addClasses: function () {
                            var t = this.classNames,
                                e = this.params,
                                a = this.rtl,
                                i = this.$el,
                                r = [];
                            r.push("initialized"),
                                r.push(e.direction),
                                e.freeMode && r.push("free-mode"),
                                e.autoHeight && r.push("autoheight"),
                                a && r.push("rtl"),
                                e.slidesPerColumn > 1 && (r.push("multirow"), "column" === e.slidesPerColumnFill && r.push("multirow-column")),
                                M.android && r.push("android"),
                                M.ios && r.push("ios"),
                                e.cssMode && r.push("css-mode"),
                                r.forEach(function (a) {
                                    t.push(e.containerModifierClass + a);
                                }),
                                i.addClass(t.join(" "));
                        },
                        removeClasses: function () {
                            var t = this.$el,
                                e = this.classNames;
                            t.removeClass(e.join(" "));
                        },
                    },
                    images: {
                        loadImage: function (t, a, i, r, n, s) {
                            var o;
                            function l() {
                                s && s();
                            }
                            t.complete && n ? l() : a ? (((o = new e.Image()).onload = l), (o.onerror = l), r && (o.sizes = r), i && (o.srcset = i), a && (o.src = a)) : l();
                        },
                        preloadImages: function () {
                            var t = this;
                            function e() {
                                null != t && t && !t.destroyed && (void 0 !== t.imagesLoaded && (t.imagesLoaded += 1), t.imagesLoaded === t.imagesToLoad.length && (t.params.updateOnImagesReady && t.update(), t.emit("imagesReady")));
                            }
                            t.imagesToLoad = t.$el.find("img");
                            for (var a = 0; a < t.imagesToLoad.length; a += 1) {
                                var i = t.imagesToLoad[a];
                                t.loadImage(i, i.currentSrc || i.getAttribute("src"), i.srcset || i.getAttribute("srcset"), i.sizes || i.getAttribute("sizes"), !0, e);
                            }
                        },
                    },
                },
                R = {},
                N = (function (t) {
                    function e() {
                        for (var a, r, n, l = [], c = arguments.length; c--; ) l[c] = arguments[c];
                        1 === l.length && l[0].constructor && l[0].constructor === Object ? (n = l[0]) : ((r = (a = l)[0]), (n = a[1])),
                            n || (n = {}),
                            (n = s.extend({}, n)),
                            r && !n.el && (n.el = r),
                            t.call(this, n),
                            Object.keys(q).forEach(function (t) {
                                Object.keys(q[t]).forEach(function (a) {
                                    e.prototype[a] || (e.prototype[a] = q[t][a]);
                                });
                            });
                        var d = this;
                        void 0 === d.modules && (d.modules = {}),
                            Object.keys(d.modules).forEach(function (t) {
                                var e = d.modules[t];
                                if (e.params) {
                                    var a = Object.keys(e.params)[0],
                                        i = e.params[a];
                                    if ("object" != typeof i || null === i) return;
                                    if (!(a in n && "enabled" in i)) return;
                                    !0 === n[a] && (n[a] = { enabled: !0 }), "object" != typeof n[a] || "enabled" in n[a] || (n[a].enabled = !0), n[a] || (n[a] = { enabled: !1 });
                                }
                            });
                        var p = s.extend({}, $);
                        d.useModulesParams(p), (d.params = s.extend({}, p, R, n)), (d.originalParams = s.extend({}, d.params)), (d.passedParams = s.extend({}, n)), (d.$ = i);
                        var h = i(d.params.el);
                        if ((r = h[0])) {
                            if (h.length > 1) {
                                var u = [];
                                return (
                                    h.each(function (t, a) {
                                        var i = s.extend({}, n, { el: a });
                                        u.push(new e(i));
                                    }),
                                    u
                                );
                            }
                            var m, f, g;
                            return (
                                (r.swiper = d),
                                h.data("swiper", d),
                                r && r.shadowRoot && r.shadowRoot.querySelector
                                    ? ((m = i(r.shadowRoot.querySelector("." + d.params.wrapperClass))).children = function (t) {
                                          return h.children(t);
                                      })
                                    : (m = h.children("." + d.params.wrapperClass)),
                                s.extend(d, {
                                    $el: h,
                                    el: r,
                                    $wrapperEl: m,
                                    wrapperEl: m[0],
                                    classNames: [],
                                    slides: i(),
                                    slidesGrid: [],
                                    snapGrid: [],
                                    slidesSizesGrid: [],
                                    isHorizontal: function () {
                                        return "horizontal" === d.params.direction;
                                    },
                                    isVertical: function () {
                                        return "vertical" === d.params.direction;
                                    },
                                    rtl: "rtl" === r.dir.toLowerCase() || "rtl" === h.css("direction"),
                                    rtlTranslate: "horizontal" === d.params.direction && ("rtl" === r.dir.toLowerCase() || "rtl" === h.css("direction")),
                                    wrongRTL: "-webkit-box" === m.css("display"),
                                    activeIndex: 0,
                                    realIndex: 0,
                                    isBeginning: !0,
                                    isEnd: !1,
                                    translate: 0,
                                    previousTranslate: 0,
                                    progress: 0,
                                    velocity: 0,
                                    animating: !1,
                                    allowSlideNext: d.params.allowSlideNext,
                                    allowSlidePrev: d.params.allowSlidePrev,
                                    touchEvents:
                                        ((f = ["touchstart", "touchmove", "touchend", "touchcancel"]),
                                        (g = ["mousedown", "mousemove", "mouseup"]),
                                        o.pointerEvents && (g = ["pointerdown", "pointermove", "pointerup"]),
                                        (d.touchEventsTouch = { start: f[0], move: f[1], end: f[2], cancel: f[3] }),
                                        (d.touchEventsDesktop = { start: g[0], move: g[1], end: g[2] }),
                                        o.touch || !d.params.simulateTouch ? d.touchEventsTouch : d.touchEventsDesktop),
                                    touchEventsData: {
                                        isTouched: void 0,
                                        isMoved: void 0,
                                        allowTouchCallbacks: void 0,
                                        touchStartTime: void 0,
                                        isScrolling: void 0,
                                        currentTranslate: void 0,
                                        startTranslate: void 0,
                                        allowThresholdMove: void 0,
                                        formElements: "input, select, option, textarea, button, video",
                                        lastClickTime: s.now(),
                                        clickTimeout: void 0,
                                        velocities: [],
                                        allowMomentumBounce: void 0,
                                        isTouchEvent: void 0,
                                        startMoving: void 0,
                                    },
                                    allowClick: !0,
                                    allowTouchMove: d.params.allowTouchMove,
                                    touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 },
                                    imagesToLoad: [],
                                    imagesLoaded: 0,
                                }),
                                d.useModules(),
                                d.params.init && d.init(),
                                d
                            );
                        }
                    }
                    t && (e.__proto__ = t), (e.prototype = Object.create(t && t.prototype)), (e.prototype.constructor = e);
                    var a = { extendedDefaults: { configurable: !0 }, defaults: { configurable: !0 }, Class: { configurable: !0 }, $: { configurable: !0 } };
                    return (
                        (e.prototype.slidesPerViewDynamic = function () {
                            var t = this.params,
                                e = this.slides,
                                a = this.slidesGrid,
                                i = this.size,
                                r = this.activeIndex,
                                n = 1;
                            if (t.centeredSlides) {
                                for (var s, o = e[r].swiperSlideSize, l = r + 1; l < e.length; l += 1) e[l] && !s && ((n += 1), (o += e[l].swiperSlideSize) > i && (s = !0));
                                for (var c = r - 1; c >= 0; c -= 1) e[c] && !s && ((n += 1), (o += e[c].swiperSlideSize) > i && (s = !0));
                            } else for (var d = r + 1; d < e.length; d += 1) a[d] - a[r] < i && (n += 1);
                            return n;
                        }),
                        (e.prototype.update = function () {
                            var t = this;
                            if (t && !t.destroyed) {
                                var e = t.snapGrid,
                                    a = t.params;
                                a.breakpoints && t.setBreakpoint(),
                                    t.updateSize(),
                                    t.updateSlides(),
                                    t.updateProgress(),
                                    t.updateSlidesClasses(),
                                    t.params.freeMode
                                        ? (i(), t.params.autoHeight && t.updateAutoHeight())
                                        : (("auto" === t.params.slidesPerView || t.params.slidesPerView > 1) && t.isEnd && !t.params.centeredSlides ? t.slideTo(t.slides.length - 1, 0, !1, !0) : t.slideTo(t.activeIndex, 0, !1, !0)) || i(),
                                    a.watchOverflow && e !== t.snapGrid && t.checkOverflow(),
                                    t.emit("update");
                            }
                            function i() {
                                var e = t.rtlTranslate ? -1 * t.translate : t.translate,
                                    a = Math.min(Math.max(e, t.maxTranslate()), t.minTranslate());
                                t.setTranslate(a), t.updateActiveIndex(), t.updateSlidesClasses();
                            }
                        }),
                        (e.prototype.changeDirection = function (t, e) {
                            void 0 === e && (e = !0);
                            var a = this.params.direction;
                            return (
                                t || (t = "horizontal" === a ? "vertical" : "horizontal"),
                                t === a || ("horizontal" !== t && "vertical" !== t)
                                    ? this
                                    : (this.$el.removeClass("" + this.params.containerModifierClass + a).addClass("" + this.params.containerModifierClass + t),
                                      (this.params.direction = t),
                                      this.slides.each(function (e, a) {
                                          "vertical" === t ? (a.style.width = "") : (a.style.height = "");
                                      }),
                                      this.emit("changeDirection"),
                                      e && this.update(),
                                      this)
                            );
                        }),
                        (e.prototype.init = function () {
                            this.initialized ||
                                (this.emit("beforeInit"),
                                this.params.breakpoints && this.setBreakpoint(),
                                this.addClasses(),
                                this.params.loop && this.loopCreate(),
                                this.updateSize(),
                                this.updateSlides(),
                                this.params.watchOverflow && this.checkOverflow(),
                                this.params.grabCursor && this.setGrabCursor(),
                                this.params.preloadImages && this.preloadImages(),
                                this.params.loop ? this.slideTo(this.params.initialSlide + this.loopedSlides, 0, this.params.runCallbacksOnInit) : this.slideTo(this.params.initialSlide, 0, this.params.runCallbacksOnInit),
                                this.attachEvents(),
                                (this.initialized = !0),
                                this.emit("init"));
                        }),
                        (e.prototype.destroy = function (t, e) {
                            void 0 === t && (t = !0), void 0 === e && (e = !0);
                            var a = this,
                                i = a.params,
                                r = a.$el,
                                n = a.$wrapperEl,
                                o = a.slides;
                            return void 0 === a.params || a.destroyed
                                ? null
                                : (a.emit("beforeDestroy"),
                                  (a.initialized = !1),
                                  a.detachEvents(),
                                  i.loop && a.loopDestroy(),
                                  e &&
                                      (a.removeClasses(),
                                      r.removeAttr("style"),
                                      n.removeAttr("style"),
                                      o && o.length && o.removeClass([i.slideVisibleClass, i.slideActiveClass, i.slideNextClass, i.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index")),
                                  a.emit("destroy"),
                                  Object.keys(a.eventsListeners).forEach(function (t) {
                                      a.off(t);
                                  }),
                                  !1 !== t && ((a.$el[0].swiper = null), a.$el.data("swiper", null), s.deleteProps(a)),
                                  (a.destroyed = !0),
                                  null);
                        }),
                        (e.extendDefaults = function (t) {
                            s.extend(R, t);
                        }),
                        (a.extendedDefaults.get = function () {
                            return R;
                        }),
                        (a.defaults.get = function () {
                            return $;
                        }),
                        (a.Class.get = function () {
                            return t;
                        }),
                        (a.$.get = function () {
                            return i;
                        }),
                        Object.defineProperties(e, a),
                        e
                    );
                })(l),
                Y = { name: "device", proto: { device: M }, static: { device: M } },
                X = { name: "support", proto: { support: o }, static: { support: o } },
                V = {
                    isEdge: !!e.navigator.userAgent.match(/Edge/g),
                    isSafari: (function () {
                        var t = e.navigator.userAgent.toLowerCase();
                        return t.indexOf("safari") >= 0 && t.indexOf("chrome") < 0 && t.indexOf("android") < 0;
                    })(),
                    isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent),
                },
                G = { name: "browser", proto: { browser: V }, static: { browser: V } },
                j = {
                    name: "resize",
                    create: function () {
                        var t = this;
                        s.extend(t, {
                            resize: {
                                resizeHandler: function () {
                                    t && !t.destroyed && t.initialized && (t.emit("beforeResize"), t.emit("resize"));
                                },
                                orientationChangeHandler: function () {
                                    t && !t.destroyed && t.initialized && t.emit("orientationchange");
                                },
                            },
                        });
                    },
                    on: {
                        init: function () {
                            e.addEventListener("resize", this.resize.resizeHandler), e.addEventListener("orientationchange", this.resize.orientationChangeHandler);
                        },
                        destroy: function () {
                            e.removeEventListener("resize", this.resize.resizeHandler), e.removeEventListener("orientationchange", this.resize.orientationChangeHandler);
                        },
                    },
                },
                F = {
                    func: e.MutationObserver || e.WebkitMutationObserver,
                    attach: function (t, a) {
                        void 0 === a && (a = {});
                        var i = this,
                            r = new (0, F.func)(function (t) {
                                if (1 !== t.length) {
                                    var a = function () {
                                        i.emit("observerUpdate", t[0]);
                                    };
                                    e.requestAnimationFrame ? e.requestAnimationFrame(a) : e.setTimeout(a, 0);
                                } else i.emit("observerUpdate", t[0]);
                            });
                        r.observe(t, { attributes: void 0 === a.attributes || a.attributes, childList: void 0 === a.childList || a.childList, characterData: void 0 === a.characterData || a.characterData }), i.observer.observers.push(r);
                    },
                    init: function () {
                        if (o.observer && this.params.observer) {
                            if (this.params.observeParents) for (var t = this.$el.parents(), e = 0; e < t.length; e += 1) this.observer.attach(t[e]);
                            this.observer.attach(this.$el[0], { childList: this.params.observeSlideChildren }), this.observer.attach(this.$wrapperEl[0], { attributes: !1 });
                        }
                    },
                    destroy: function () {
                        this.observer.observers.forEach(function (t) {
                            t.disconnect();
                        }),
                            (this.observer.observers = []);
                    },
                },
                U = {
                    name: "observer",
                    params: { observer: !1, observeParents: !1, observeSlideChildren: !1 },
                    create: function () {
                        s.extend(this, { observer: { init: F.init.bind(this), attach: F.attach.bind(this), destroy: F.destroy.bind(this), observers: [] } });
                    },
                    on: {
                        init: function () {
                            this.observer.init();
                        },
                        destroy: function () {
                            this.observer.destroy();
                        },
                    },
                },
                W = {
                    update: function (t) {
                        var e = this,
                            a = e.params,
                            i = a.slidesPerView,
                            r = a.slidesPerGroup,
                            n = a.centeredSlides,
                            o = e.params.virtual,
                            l = o.addSlidesBefore,
                            c = o.addSlidesAfter,
                            d = e.virtual,
                            p = d.from,
                            h = d.to,
                            u = d.slides,
                            m = d.slidesGrid,
                            f = d.renderSlide,
                            g = d.offset;
                        e.updateActiveIndex();
                        var b,
                            w,
                            v,
                            y = e.activeIndex || 0;
                        (b = e.rtlTranslate ? "right" : e.isHorizontal() ? "left" : "top"), n ? ((w = Math.floor(i / 2) + r + l), (v = Math.floor(i / 2) + r + c)) : ((w = i + (r - 1) + l), (v = r + c));
                        var _ = Math.max((y || 0) - v, 0),
                            x = Math.min((y || 0) + w, u.length - 1),
                            k = (e.slidesGrid[_] || 0) - (e.slidesGrid[0] || 0);
                        function C() {
                            e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), e.lazy && e.params.lazy.enabled && e.lazy.load();
                        }
                        if ((s.extend(e.virtual, { from: _, to: x, offset: k, slidesGrid: e.slidesGrid }), p === _ && h === x && !t)) return e.slidesGrid !== m && k !== g && e.slides.css(b, k + "px"), void e.updateProgress();
                        if (e.params.virtual.renderExternal)
                            return (
                                e.params.virtual.renderExternal.call(e, {
                                    offset: k,
                                    from: _,
                                    to: x,
                                    slides: (function () {
                                        for (var t = [], e = _; e <= x; e += 1) t.push(u[e]);
                                        return t;
                                    })(),
                                }),
                                void C()
                            );
                        var S = [],
                            T = [];
                        if (t) e.$wrapperEl.find("." + e.params.slideClass).remove();
                        else for (var E = p; E <= h; E += 1) (E < _ || E > x) && e.$wrapperEl.find("." + e.params.slideClass + '[data-swiper-slide-index="' + E + '"]').remove();
                        for (var D = 0; D < u.length; D += 1) D >= _ && D <= x && (void 0 === h || t ? T.push(D) : (D > h && T.push(D), D < p && S.push(D)));
                        T.forEach(function (t) {
                            e.$wrapperEl.append(f(u[t], t));
                        }),
                            S.sort(function (t, e) {
                                return e - t;
                            }).forEach(function (t) {
                                e.$wrapperEl.prepend(f(u[t], t));
                            }),
                            e.$wrapperEl.children(".swiper-slide").css(b, k + "px"),
                            C();
                    },
                    renderSlide: function (t, e) {
                        var a = this.params.virtual;
                        if (a.cache && this.virtual.cache[e]) return this.virtual.cache[e];
                        var r = a.renderSlide ? i(a.renderSlide.call(this, t, e)) : i('<div class="' + this.params.slideClass + '" data-swiper-slide-index="' + e + '">' + t + "</div>");
                        return r.attr("data-swiper-slide-index") || r.attr("data-swiper-slide-index", e), a.cache && (this.virtual.cache[e] = r), r;
                    },
                    appendSlide: function (t) {
                        if ("object" == typeof t && "length" in t) for (var e = 0; e < t.length; e += 1) t[e] && this.virtual.slides.push(t[e]);
                        else this.virtual.slides.push(t);
                        this.virtual.update(!0);
                    },
                    prependSlide: function (t) {
                        var e = this.activeIndex,
                            a = e + 1,
                            i = 1;
                        if (Array.isArray(t)) {
                            for (var r = 0; r < t.length; r += 1) t[r] && this.virtual.slides.unshift(t[r]);
                            (a = e + t.length), (i = t.length);
                        } else this.virtual.slides.unshift(t);
                        if (this.params.virtual.cache) {
                            var n = this.virtual.cache,
                                s = {};
                            Object.keys(n).forEach(function (t) {
                                var e = n[t],
                                    a = e.attr("data-swiper-slide-index");
                                a && e.attr("data-swiper-slide-index", parseInt(a, 10) + 1), (s[parseInt(t, 10) + i] = e);
                            }),
                                (this.virtual.cache = s);
                        }
                        this.virtual.update(!0), this.slideTo(a, 0);
                    },
                    removeSlide: function (t) {
                        if (null != t) {
                            var e = this.activeIndex;
                            if (Array.isArray(t)) for (var a = t.length - 1; a >= 0; a -= 1) this.virtual.slides.splice(t[a], 1), this.params.virtual.cache && delete this.virtual.cache[t[a]], t[a] < e && (e -= 1), (e = Math.max(e, 0));
                            else this.virtual.slides.splice(t, 1), this.params.virtual.cache && delete this.virtual.cache[t], t < e && (e -= 1), (e = Math.max(e, 0));
                            this.virtual.update(!0), this.slideTo(e, 0);
                        }
                    },
                    removeAllSlides: function () {
                        (this.virtual.slides = []), this.params.virtual.cache && (this.virtual.cache = {}), this.virtual.update(!0), this.slideTo(0, 0);
                    },
                },
                Z = {
                    name: "virtual",
                    params: { virtual: { enabled: !1, slides: [], cache: !0, renderSlide: null, renderExternal: null, addSlidesBefore: 0, addSlidesAfter: 0 } },
                    create: function () {
                        s.extend(this, {
                            virtual: {
                                update: W.update.bind(this),
                                appendSlide: W.appendSlide.bind(this),
                                prependSlide: W.prependSlide.bind(this),
                                removeSlide: W.removeSlide.bind(this),
                                removeAllSlides: W.removeAllSlides.bind(this),
                                renderSlide: W.renderSlide.bind(this),
                                slides: this.params.virtual.slides,
                                cache: {},
                            },
                        });
                    },
                    on: {
                        beforeInit: function () {
                            if (this.params.virtual.enabled) {
                                this.classNames.push(this.params.containerModifierClass + "virtual");
                                var t = { watchSlidesProgress: !0 };
                                s.extend(this.params, t), s.extend(this.originalParams, t), this.params.initialSlide || this.virtual.update();
                            }
                        },
                        setTranslate: function () {
                            this.params.virtual.enabled && this.virtual.update();
                        },
                    },
                },
                K = {
                    handle: function (a) {
                        var i = this.rtlTranslate,
                            r = a;
                        r.originalEvent && (r = r.originalEvent);
                        var n = r.keyCode || r.charCode;
                        if (!this.allowSlideNext && ((this.isHorizontal() && 39 === n) || (this.isVertical() && 40 === n) || 34 === n)) return !1;
                        if (!this.allowSlidePrev && ((this.isHorizontal() && 37 === n) || (this.isVertical() && 38 === n) || 33 === n)) return !1;
                        if (
                            !(
                                r.shiftKey ||
                                r.altKey ||
                                r.ctrlKey ||
                                r.metaKey ||
                                (t.activeElement && t.activeElement.nodeName && ("input" === t.activeElement.nodeName.toLowerCase() || "textarea" === t.activeElement.nodeName.toLowerCase()))
                            )
                        ) {
                            if (this.params.keyboard.onlyInViewport && (33 === n || 34 === n || 37 === n || 39 === n || 38 === n || 40 === n)) {
                                var s = !1;
                                if (this.$el.parents("." + this.params.slideClass).length > 0 && 0 === this.$el.parents("." + this.params.slideActiveClass).length) return;
                                var o = e.innerWidth,
                                    l = e.innerHeight,
                                    c = this.$el.offset();
                                i && (c.left -= this.$el[0].scrollLeft);
                                for (
                                    var d = [
                                            [c.left, c.top],
                                            [c.left + this.width, c.top],
                                            [c.left, c.top + this.height],
                                            [c.left + this.width, c.top + this.height],
                                        ],
                                        p = 0;
                                    p < d.length;
                                    p += 1
                                ) {
                                    var h = d[p];
                                    h[0] >= 0 && h[0] <= o && h[1] >= 0 && h[1] <= l && (s = !0);
                                }
                                if (!s) return;
                            }
                            this.isHorizontal()
                                ? ((33 !== n && 34 !== n && 37 !== n && 39 !== n) || (r.preventDefault ? r.preventDefault() : (r.returnValue = !1)),
                                  (((34 !== n && 39 !== n) || i) && ((33 !== n && 37 !== n) || !i)) || this.slideNext(),
                                  (((33 !== n && 37 !== n) || i) && ((34 !== n && 39 !== n) || !i)) || this.slidePrev())
                                : ((33 !== n && 34 !== n && 38 !== n && 40 !== n) || (r.preventDefault ? r.preventDefault() : (r.returnValue = !1)), (34 !== n && 40 !== n) || this.slideNext(), (33 !== n && 38 !== n) || this.slidePrev()),
                                this.emit("keyPress", n);
                        }
                    },
                    enable: function () {
                        this.keyboard.enabled || (i(t).on("keydown", this.keyboard.handle), (this.keyboard.enabled = !0));
                    },
                    disable: function () {
                        this.keyboard.enabled && (i(t).off("keydown", this.keyboard.handle), (this.keyboard.enabled = !1));
                    },
                },
                Q = {
                    name: "keyboard",
                    params: { keyboard: { enabled: !1, onlyInViewport: !0 } },
                    create: function () {
                        s.extend(this, { keyboard: { enabled: !1, enable: K.enable.bind(this), disable: K.disable.bind(this), handle: K.handle.bind(this) } });
                    },
                    on: {
                        init: function () {
                            this.params.keyboard.enabled && this.keyboard.enable();
                        },
                        destroy: function () {
                            this.keyboard.enabled && this.keyboard.disable();
                        },
                    },
                },
                J = {
                    lastScrollTime: s.now(),
                    lastEventBeforeSnap: void 0,
                    recentWheelEvents: [],
                    event: function () {
                        return e.navigator.userAgent.indexOf("firefox") > -1
                            ? "DOMMouseScroll"
                            : (function () {
                                  var e = "onwheel" in t;
                                  if (!e) {
                                      var a = t.createElement("div");
                                      a.setAttribute("onwheel", "return;"), (e = "function" == typeof a.onwheel);
                                  }
                                  return !e && t.implementation && t.implementation.hasFeature && !0 !== t.implementation.hasFeature("", "") && (e = t.implementation.hasFeature("Events.wheel", "3.0")), e;
                              })()
                            ? "wheel"
                            : "mousewheel";
                    },
                    normalize: function (t) {
                        var e = 0,
                            a = 0,
                            i = 0,
                            r = 0;
                        return (
                            "detail" in t && (a = t.detail),
                            "wheelDelta" in t && (a = -t.wheelDelta / 120),
                            "wheelDeltaY" in t && (a = -t.wheelDeltaY / 120),
                            "wheelDeltaX" in t && (e = -t.wheelDeltaX / 120),
                            "axis" in t && t.axis === t.HORIZONTAL_AXIS && ((e = a), (a = 0)),
                            (i = 10 * e),
                            (r = 10 * a),
                            "deltaY" in t && (r = t.deltaY),
                            "deltaX" in t && (i = t.deltaX),
                            t.shiftKey && !i && ((i = r), (r = 0)),
                            (i || r) && t.deltaMode && (1 === t.deltaMode ? ((i *= 40), (r *= 40)) : ((i *= 800), (r *= 800))),
                            i && !e && (e = i < 1 ? -1 : 1),
                            r && !a && (a = r < 1 ? -1 : 1),
                            { spinX: e, spinY: a, pixelX: i, pixelY: r }
                        );
                    },
                    handleMouseEnter: function () {
                        this.mouseEntered = !0;
                    },
                    handleMouseLeave: function () {
                        this.mouseEntered = !1;
                    },
                    handle: function (t) {
                        var e = t,
                            a = this,
                            r = a.params.mousewheel;
                        a.params.cssMode && e.preventDefault();
                        var n = a.$el;
                        if (("container" !== a.params.mousewheel.eventsTarged && (n = i(a.params.mousewheel.eventsTarged)), !a.mouseEntered && !n[0].contains(e.target) && !r.releaseOnEdges)) return !0;
                        e.originalEvent && (e = e.originalEvent);
                        var o = 0,
                            l = a.rtlTranslate ? -1 : 1,
                            c = J.normalize(e);
                        if (r.forceToAxis)
                            if (a.isHorizontal()) {
                                if (!(Math.abs(c.pixelX) > Math.abs(c.pixelY))) return !0;
                                o = c.pixelX * l;
                            } else {
                                if (!(Math.abs(c.pixelY) > Math.abs(c.pixelX))) return !0;
                                o = c.pixelY;
                            }
                        else o = Math.abs(c.pixelX) > Math.abs(c.pixelY) ? -c.pixelX * l : -c.pixelY;
                        if (0 === o) return !0;
                        if ((r.invert && (o = -o), a.params.freeMode)) {
                            var d = { time: s.now(), delta: Math.abs(o), direction: Math.sign(o) },
                                p = a.mousewheel.lastEventBeforeSnap,
                                h = p && d.time < p.time + 500 && d.delta <= p.delta && d.direction === p.direction;
                            if (!h) {
                                (a.mousewheel.lastEventBeforeSnap = void 0), a.params.loop && a.loopFix();
                                var u = a.getTranslate() + o * r.sensitivity,
                                    m = a.isBeginning,
                                    f = a.isEnd;
                                if (
                                    (u >= a.minTranslate() && (u = a.minTranslate()),
                                    u <= a.maxTranslate() && (u = a.maxTranslate()),
                                    a.setTransition(0),
                                    a.setTranslate(u),
                                    a.updateProgress(),
                                    a.updateActiveIndex(),
                                    a.updateSlidesClasses(),
                                    ((!m && a.isBeginning) || (!f && a.isEnd)) && a.updateSlidesClasses(),
                                    a.params.freeModeSticky)
                                ) {
                                    clearTimeout(a.mousewheel.timeout), (a.mousewheel.timeout = void 0);
                                    var g = a.mousewheel.recentWheelEvents;
                                    g.length >= 15 && g.shift();
                                    var b = g.length ? g[g.length - 1] : void 0,
                                        w = g[0];
                                    if ((g.push(d), b && (d.delta > b.delta || d.direction !== b.direction))) g.splice(0);
                                    else if (g.length >= 15 && d.time - w.time < 500 && w.delta - d.delta >= 1 && d.delta <= 6) {
                                        var v = o > 0 ? 0.8 : 0.2;
                                        (a.mousewheel.lastEventBeforeSnap = d),
                                            g.splice(0),
                                            (a.mousewheel.timeout = s.nextTick(function () {
                                                a.slideToClosest(a.params.speed, !0, void 0, v);
                                            }, 0));
                                    }
                                    a.mousewheel.timeout ||
                                        (a.mousewheel.timeout = s.nextTick(function () {
                                            (a.mousewheel.lastEventBeforeSnap = d), g.splice(0), a.slideToClosest(a.params.speed, !0, void 0, 0.5);
                                        }, 500));
                                }
                                if ((h || a.emit("scroll", e), a.params.autoplay && a.params.autoplayDisableOnInteraction && a.autoplay.stop(), u === a.minTranslate() || u === a.maxTranslate())) return !0;
                            }
                        } else {
                            var y = { time: s.now(), delta: Math.abs(o), direction: Math.sign(o), raw: t },
                                _ = a.mousewheel.recentWheelEvents;
                            _.length >= 2 && _.shift();
                            var x = _.length ? _[_.length - 1] : void 0;
                            if ((_.push(y), x ? (y.direction !== x.direction || y.delta > x.delta) && a.mousewheel.animateSlider(y) : a.mousewheel.animateSlider(y), a.mousewheel.releaseScroll(y))) return !0;
                        }
                        return e.preventDefault ? e.preventDefault() : (e.returnValue = !1), !1;
                    },
                    animateSlider: function (t) {
                        return (
                            (t.delta >= 6 && s.now() - this.mousewheel.lastScrollTime < 60) ||
                            (t.direction < 0
                                ? (this.isEnd && !this.params.loop) || this.animating || (this.slideNext(), this.emit("scroll", t.raw))
                                : (this.isBeginning && !this.params.loop) || this.animating || (this.slidePrev(), this.emit("scroll", t.raw)),
                            (this.mousewheel.lastScrollTime = new e.Date().getTime()),
                            !1)
                        );
                    },
                    releaseScroll: function (t) {
                        var e = this.params.mousewheel;
                        if (t.direction < 0) {
                            if (this.isEnd && !this.params.loop && e.releaseOnEdges) return !0;
                        } else if (this.isBeginning && !this.params.loop && e.releaseOnEdges) return !0;
                        return !1;
                    },
                    enable: function () {
                        var t = J.event();
                        if (this.params.cssMode) return this.wrapperEl.removeEventListener(t, this.mousewheel.handle), !0;
                        if (!t) return !1;
                        if (this.mousewheel.enabled) return !1;
                        var e = this.$el;
                        return (
                            "container" !== this.params.mousewheel.eventsTarged && (e = i(this.params.mousewheel.eventsTarged)),
                            e.on("mouseenter", this.mousewheel.handleMouseEnter),
                            e.on("mouseleave", this.mousewheel.handleMouseLeave),
                            e.on(t, this.mousewheel.handle),
                            (this.mousewheel.enabled = !0),
                            !0
                        );
                    },
                    disable: function () {
                        var t = J.event();
                        if (this.params.cssMode) return this.wrapperEl.addEventListener(t, this.mousewheel.handle), !0;
                        if (!t) return !1;
                        if (!this.mousewheel.enabled) return !1;
                        var e = this.$el;
                        return "container" !== this.params.mousewheel.eventsTarged && (e = i(this.params.mousewheel.eventsTarged)), e.off(t, this.mousewheel.handle), (this.mousewheel.enabled = !1), !0;
                    },
                },
                tt = {
                    update: function () {
                        var t = this.params.navigation;
                        if (!this.params.loop) {
                            var e = this.navigation,
                                a = e.$nextEl,
                                i = e.$prevEl;
                            i && i.length > 0 && (this.isBeginning ? i.addClass(t.disabledClass) : i.removeClass(t.disabledClass), i[this.params.watchOverflow && this.isLocked ? "addClass" : "removeClass"](t.lockClass)),
                                a && a.length > 0 && (this.isEnd ? a.addClass(t.disabledClass) : a.removeClass(t.disabledClass), a[this.params.watchOverflow && this.isLocked ? "addClass" : "removeClass"](t.lockClass));
                        }
                    },
                    onPrevClick: function (t) {
                        t.preventDefault(), (this.isBeginning && !this.params.loop) || this.slidePrev();
                    },
                    onNextClick: function (t) {
                        t.preventDefault(), (this.isEnd && !this.params.loop) || this.slideNext();
                    },
                    init: function () {
                        var t,
                            e,
                            a = this.params.navigation;
                        (a.nextEl || a.prevEl) &&
                            (a.nextEl && ((t = i(a.nextEl)), this.params.uniqueNavElements && "string" == typeof a.nextEl && t.length > 1 && 1 === this.$el.find(a.nextEl).length && (t = this.$el.find(a.nextEl))),
                            a.prevEl && ((e = i(a.prevEl)), this.params.uniqueNavElements && "string" == typeof a.prevEl && e.length > 1 && 1 === this.$el.find(a.prevEl).length && (e = this.$el.find(a.prevEl))),
                            t && t.length > 0 && t.on("click", this.navigation.onNextClick),
                            e && e.length > 0 && e.on("click", this.navigation.onPrevClick),
                            s.extend(this.navigation, { $nextEl: t, nextEl: t && t[0], $prevEl: e, prevEl: e && e[0] }));
                    },
                    destroy: function () {
                        var t = this.navigation,
                            e = t.$nextEl,
                            a = t.$prevEl;
                        e && e.length && (e.off("click", this.navigation.onNextClick), e.removeClass(this.params.navigation.disabledClass)),
                            a && a.length && (a.off("click", this.navigation.onPrevClick), a.removeClass(this.params.navigation.disabledClass));
                    },
                },
                et = {
                    update: function () {
                        var t = this.rtl,
                            e = this.params.pagination;
                        if (e.el && this.pagination.el && this.pagination.$el && 0 !== this.pagination.$el.length) {
                            var a,
                                r = this.virtual && this.params.virtual.enabled ? this.virtual.slides.length : this.slides.length,
                                n = this.pagination.$el,
                                s = this.params.loop ? Math.ceil((r - 2 * this.loopedSlides) / this.params.slidesPerGroup) : this.snapGrid.length;
                            if (
                                (this.params.loop
                                    ? ((a = Math.ceil((this.activeIndex - this.loopedSlides) / this.params.slidesPerGroup)) > r - 1 - 2 * this.loopedSlides && (a -= r - 2 * this.loopedSlides),
                                      a > s - 1 && (a -= s),
                                      a < 0 && "bullets" !== this.params.paginationType && (a = s + a))
                                    : (a = void 0 !== this.snapIndex ? this.snapIndex : this.activeIndex || 0),
                                "bullets" === e.type && this.pagination.bullets && this.pagination.bullets.length > 0)
                            ) {
                                var o,
                                    l,
                                    c,
                                    d = this.pagination.bullets;
                                if (
                                    (e.dynamicBullets &&
                                        ((this.pagination.bulletSize = d.eq(0)[this.isHorizontal() ? "outerWidth" : "outerHeight"](!0)),
                                        n.css(this.isHorizontal() ? "width" : "height", this.pagination.bulletSize * (e.dynamicMainBullets + 4) + "px"),
                                        e.dynamicMainBullets > 1 &&
                                            void 0 !== this.previousIndex &&
                                            ((this.pagination.dynamicBulletIndex += a - this.previousIndex),
                                            this.pagination.dynamicBulletIndex > e.dynamicMainBullets - 1
                                                ? (this.pagination.dynamicBulletIndex = e.dynamicMainBullets - 1)
                                                : this.pagination.dynamicBulletIndex < 0 && (this.pagination.dynamicBulletIndex = 0)),
                                        (o = a - this.pagination.dynamicBulletIndex),
                                        (c = ((l = o + (Math.min(d.length, e.dynamicMainBullets) - 1)) + o) / 2)),
                                    d.removeClass(
                                        e.bulletActiveClass + " " + e.bulletActiveClass + "-next " + e.bulletActiveClass + "-next-next " + e.bulletActiveClass + "-prev " + e.bulletActiveClass + "-prev-prev " + e.bulletActiveClass + "-main"
                                    ),
                                    n.length > 1)
                                )
                                    d.each(function (t, r) {
                                        var n = i(r),
                                            s = n.index();
                                        s === a && n.addClass(e.bulletActiveClass),
                                            e.dynamicBullets &&
                                                (s >= o && s <= l && n.addClass(e.bulletActiveClass + "-main"),
                                                s === o &&
                                                    n
                                                        .prev()
                                                        .addClass(e.bulletActiveClass + "-prev")
                                                        .prev()
                                                        .addClass(e.bulletActiveClass + "-prev-prev"),
                                                s === l &&
                                                    n
                                                        .next()
                                                        .addClass(e.bulletActiveClass + "-next")
                                                        .next()
                                                        .addClass(e.bulletActiveClass + "-next-next"));
                                    });
                                else {
                                    var p = d.eq(a),
                                        h = p.index();
                                    if ((p.addClass(e.bulletActiveClass), e.dynamicBullets)) {
                                        for (var u = d.eq(o), m = d.eq(l), f = o; f <= l; f += 1) d.eq(f).addClass(e.bulletActiveClass + "-main");
                                        if (this.params.loop)
                                            if (h >= d.length - e.dynamicMainBullets) {
                                                for (var g = e.dynamicMainBullets; g >= 0; g -= 1) d.eq(d.length - g).addClass(e.bulletActiveClass + "-main");
                                                d.eq(d.length - e.dynamicMainBullets - 1).addClass(e.bulletActiveClass + "-prev");
                                            } else
                                                u
                                                    .prev()
                                                    .addClass(e.bulletActiveClass + "-prev")
                                                    .prev()
                                                    .addClass(e.bulletActiveClass + "-prev-prev"),
                                                    m
                                                        .next()
                                                        .addClass(e.bulletActiveClass + "-next")
                                                        .next()
                                                        .addClass(e.bulletActiveClass + "-next-next");
                                        else
                                            u
                                                .prev()
                                                .addClass(e.bulletActiveClass + "-prev")
                                                .prev()
                                                .addClass(e.bulletActiveClass + "-prev-prev"),
                                                m
                                                    .next()
                                                    .addClass(e.bulletActiveClass + "-next")
                                                    .next()
                                                    .addClass(e.bulletActiveClass + "-next-next");
                                    }
                                }
                                if (e.dynamicBullets) {
                                    var b = Math.min(d.length, e.dynamicMainBullets + 4),
                                        w = (this.pagination.bulletSize * b - this.pagination.bulletSize) / 2 - c * this.pagination.bulletSize,
                                        v = t ? "right" : "left";
                                    d.css(this.isHorizontal() ? v : "top", w + "px");
                                }
                            }
                            if (("fraction" === e.type && (n.find("." + e.currentClass).text(e.formatFractionCurrent(a + 1)), n.find("." + e.totalClass).text(e.formatFractionTotal(s))), "progressbar" === e.type)) {
                                var y;
                                y = e.progressbarOpposite ? (this.isHorizontal() ? "vertical" : "horizontal") : this.isHorizontal() ? "horizontal" : "vertical";
                                var _ = (a + 1) / s,
                                    x = 1,
                                    k = 1;
                                "horizontal" === y ? (x = _) : (k = _),
                                    n
                                        .find("." + e.progressbarFillClass)
                                        .transform("translate3d(0,0,0) scaleX(" + x + ") scaleY(" + k + ")")
                                        .transition(this.params.speed);
                            }
                            "custom" === e.type && e.renderCustom ? (n.html(e.renderCustom(this, a + 1, s)), this.emit("paginationRender", this, n[0])) : this.emit("paginationUpdate", this, n[0]),
                                n[this.params.watchOverflow && this.isLocked ? "addClass" : "removeClass"](e.lockClass);
                        }
                    },
                    render: function () {
                        var t = this.params.pagination;
                        if (t.el && this.pagination.el && this.pagination.$el && 0 !== this.pagination.$el.length) {
                            var e = this.virtual && this.params.virtual.enabled ? this.virtual.slides.length : this.slides.length,
                                a = this.pagination.$el,
                                i = "";
                            if ("bullets" === t.type) {
                                for (var r = this.params.loop ? Math.ceil((e - 2 * this.loopedSlides) / this.params.slidesPerGroup) : this.snapGrid.length, n = 0; n < r; n += 1)
                                    t.renderBullet ? (i += t.renderBullet.call(this, n, t.bulletClass)) : (i += "<" + t.bulletElement + ' class="' + t.bulletClass + '"></' + t.bulletElement + ">");
                                a.html(i), (this.pagination.bullets = a.find("." + t.bulletClass));
                            }
                            "fraction" === t.type &&
                                ((i = t.renderFraction ? t.renderFraction.call(this, t.currentClass, t.totalClass) : '<span class="' + t.currentClass + '"></span> / <span class="' + t.totalClass + '"></span>'), a.html(i)),
                                "progressbar" === t.type && ((i = t.renderProgressbar ? t.renderProgressbar.call(this, t.progressbarFillClass) : '<span class="' + t.progressbarFillClass + '"></span>'), a.html(i)),
                                "custom" !== t.type && this.emit("paginationRender", this.pagination.$el[0]);
                        }
                    },
                    init: function () {
                        var t = this,
                            e = t.params.pagination;
                        if (e.el) {
                            var a = i(e.el);
                            0 !== a.length &&
                                (t.params.uniqueNavElements && "string" == typeof e.el && a.length > 1 && 1 === t.$el.find(e.el).length && (a = t.$el.find(e.el)),
                                "bullets" === e.type && e.clickable && a.addClass(e.clickableClass),
                                a.addClass(e.modifierClass + e.type),
                                "bullets" === e.type && e.dynamicBullets && (a.addClass("" + e.modifierClass + e.type + "-dynamic"), (t.pagination.dynamicBulletIndex = 0), e.dynamicMainBullets < 1 && (e.dynamicMainBullets = 1)),
                                "progressbar" === e.type && e.progressbarOpposite && a.addClass(e.progressbarOppositeClass),
                                e.clickable &&
                                    a.on("click", "." + e.bulletClass, function (e) {
                                        e.preventDefault();
                                        var a = i(this).index() * t.params.slidesPerGroup;
                                        t.params.loop && (a += t.loopedSlides), t.slideTo(a);
                                    }),
                                s.extend(t.pagination, { $el: a, el: a[0] }));
                        }
                    },
                    destroy: function () {
                        var t = this.params.pagination;
                        if (t.el && this.pagination.el && this.pagination.$el && 0 !== this.pagination.$el.length) {
                            var e = this.pagination.$el;
                            e.removeClass(t.hiddenClass), e.removeClass(t.modifierClass + t.type), this.pagination.bullets && this.pagination.bullets.removeClass(t.bulletActiveClass), t.clickable && e.off("click", "." + t.bulletClass);
                        }
                    },
                },
                at = {
                    setTranslate: function () {
                        if (this.params.scrollbar.el && this.scrollbar.el) {
                            var t = this.scrollbar,
                                e = this.rtlTranslate,
                                a = this.progress,
                                i = t.dragSize,
                                r = t.trackSize,
                                n = t.$dragEl,
                                s = t.$el,
                                o = this.params.scrollbar,
                                l = i,
                                c = (r - i) * a;
                            e ? ((c = -c) > 0 ? ((l = i - c), (c = 0)) : -c + i > r && (l = r + c)) : c < 0 ? ((l = i + c), (c = 0)) : c + i > r && (l = r - c),
                                this.isHorizontal() ? (n.transform("translate3d(" + c + "px, 0, 0)"), (n[0].style.width = l + "px")) : (n.transform("translate3d(0px, " + c + "px, 0)"), (n[0].style.height = l + "px")),
                                o.hide &&
                                    (clearTimeout(this.scrollbar.timeout),
                                    (s[0].style.opacity = 1),
                                    (this.scrollbar.timeout = setTimeout(function () {
                                        (s[0].style.opacity = 0), s.transition(400);
                                    }, 1e3)));
                        }
                    },
                    setTransition: function (t) {
                        this.params.scrollbar.el && this.scrollbar.el && this.scrollbar.$dragEl.transition(t);
                    },
                    updateSize: function () {
                        if (this.params.scrollbar.el && this.scrollbar.el) {
                            var t = this.scrollbar,
                                e = t.$dragEl,
                                a = t.$el;
                            (e[0].style.width = ""), (e[0].style.height = "");
                            var i,
                                r = this.isHorizontal() ? a[0].offsetWidth : a[0].offsetHeight,
                                n = this.size / this.virtualSize,
                                o = n * (r / this.size);
                            (i = "auto" === this.params.scrollbar.dragSize ? r * n : parseInt(this.params.scrollbar.dragSize, 10)),
                                this.isHorizontal() ? (e[0].style.width = i + "px") : (e[0].style.height = i + "px"),
                                (a[0].style.display = n >= 1 ? "none" : ""),
                                this.params.scrollbar.hide && (a[0].style.opacity = 0),
                                s.extend(t, { trackSize: r, divider: n, moveDivider: o, dragSize: i }),
                                t.$el[this.params.watchOverflow && this.isLocked ? "addClass" : "removeClass"](this.params.scrollbar.lockClass);
                        }
                    },
                    getPointerPosition: function (t) {
                        return this.isHorizontal() ? ("touchstart" === t.type || "touchmove" === t.type ? t.targetTouches[0].clientX : t.clientX) : "touchstart" === t.type || "touchmove" === t.type ? t.targetTouches[0].clientY : t.clientY;
                    },
                    setDragPosition: function (t) {
                        var e,
                            a = this.scrollbar,
                            i = this.rtlTranslate,
                            r = a.$el,
                            n = a.dragSize,
                            s = a.trackSize,
                            o = a.dragStartPos;
                        (e = (a.getPointerPosition(t) - r.offset()[this.isHorizontal() ? "left" : "top"] - (null !== o ? o : n / 2)) / (s - n)), (e = Math.max(Math.min(e, 1), 0)), i && (e = 1 - e);
                        var l = this.minTranslate() + (this.maxTranslate() - this.minTranslate()) * e;
                        this.updateProgress(l), this.setTranslate(l), this.updateActiveIndex(), this.updateSlidesClasses();
                    },
                    onDragStart: function (t) {
                        var e = this.params.scrollbar,
                            a = this.scrollbar,
                            i = this.$wrapperEl,
                            r = a.$el,
                            n = a.$dragEl;
                        (this.scrollbar.isTouched = !0),
                            (this.scrollbar.dragStartPos = t.target === n[0] || t.target === n ? a.getPointerPosition(t) - t.target.getBoundingClientRect()[this.isHorizontal() ? "left" : "top"] : null),
                            t.preventDefault(),
                            t.stopPropagation(),
                            i.transition(100),
                            n.transition(100),
                            a.setDragPosition(t),
                            clearTimeout(this.scrollbar.dragTimeout),
                            r.transition(0),
                            e.hide && r.css("opacity", 1),
                            this.params.cssMode && this.$wrapperEl.css("scroll-snap-type", "none"),
                            this.emit("scrollbarDragStart", t);
                    },
                    onDragMove: function (t) {
                        var e = this.scrollbar,
                            a = this.$wrapperEl,
                            i = e.$el,
                            r = e.$dragEl;
                        this.scrollbar.isTouched && (t.preventDefault ? t.preventDefault() : (t.returnValue = !1), e.setDragPosition(t), a.transition(0), i.transition(0), r.transition(0), this.emit("scrollbarDragMove", t));
                    },
                    onDragEnd: function (t) {
                        var e = this.params.scrollbar,
                            a = this.scrollbar,
                            i = this.$wrapperEl,
                            r = a.$el;
                        this.scrollbar.isTouched &&
                            ((this.scrollbar.isTouched = !1),
                            this.params.cssMode && (this.$wrapperEl.css("scroll-snap-type", ""), i.transition("")),
                            e.hide &&
                                (clearTimeout(this.scrollbar.dragTimeout),
                                (this.scrollbar.dragTimeout = s.nextTick(function () {
                                    r.css("opacity", 0), r.transition(400);
                                }, 1e3))),
                            this.emit("scrollbarDragEnd", t),
                            e.snapOnRelease && this.slideToClosest());
                    },
                    enableDraggable: function () {
                        if (this.params.scrollbar.el) {
                            var e = this.scrollbar,
                                a = this.touchEventsTouch,
                                i = this.touchEventsDesktop,
                                r = this.params,
                                n = e.$el[0],
                                s = !(!o.passiveListener || !r.passiveListeners) && { passive: !1, capture: !1 },
                                l = !(!o.passiveListener || !r.passiveListeners) && { passive: !0, capture: !1 };
                            o.touch
                                ? (n.addEventListener(a.start, this.scrollbar.onDragStart, s), n.addEventListener(a.move, this.scrollbar.onDragMove, s), n.addEventListener(a.end, this.scrollbar.onDragEnd, l))
                                : (n.addEventListener(i.start, this.scrollbar.onDragStart, s), t.addEventListener(i.move, this.scrollbar.onDragMove, s), t.addEventListener(i.end, this.scrollbar.onDragEnd, l));
                        }
                    },
                    disableDraggable: function () {
                        if (this.params.scrollbar.el) {
                            var e = this.scrollbar,
                                a = this.touchEventsTouch,
                                i = this.touchEventsDesktop,
                                r = this.params,
                                n = e.$el[0],
                                s = !(!o.passiveListener || !r.passiveListeners) && { passive: !1, capture: !1 },
                                l = !(!o.passiveListener || !r.passiveListeners) && { passive: !0, capture: !1 };
                            o.touch
                                ? (n.removeEventListener(a.start, this.scrollbar.onDragStart, s), n.removeEventListener(a.move, this.scrollbar.onDragMove, s), n.removeEventListener(a.end, this.scrollbar.onDragEnd, l))
                                : (n.removeEventListener(i.start, this.scrollbar.onDragStart, s), t.removeEventListener(i.move, this.scrollbar.onDragMove, s), t.removeEventListener(i.end, this.scrollbar.onDragEnd, l));
                        }
                    },
                    init: function () {
                        if (this.params.scrollbar.el) {
                            var t = this.scrollbar,
                                e = this.$el,
                                a = this.params.scrollbar,
                                r = i(a.el);
                            this.params.uniqueNavElements && "string" == typeof a.el && r.length > 1 && 1 === e.find(a.el).length && (r = e.find(a.el));
                            var n = r.find("." + this.params.scrollbar.dragClass);
                            0 === n.length && ((n = i('<div class="' + this.params.scrollbar.dragClass + '"></div>')), r.append(n)), s.extend(t, { $el: r, el: r[0], $dragEl: n, dragEl: n[0] }), a.draggable && t.enableDraggable();
                        }
                    },
                    destroy: function () {
                        this.scrollbar.disableDraggable();
                    },
                },
                it = {
                    setTransform: function (t, e) {
                        var a = this.rtl,
                            r = i(t),
                            n = a ? -1 : 1,
                            s = r.attr("data-swiper-parallax") || "0",
                            o = r.attr("data-swiper-parallax-x"),
                            l = r.attr("data-swiper-parallax-y"),
                            c = r.attr("data-swiper-parallax-scale"),
                            d = r.attr("data-swiper-parallax-opacity");
                        if (
                            (o || l ? ((o = o || "0"), (l = l || "0")) : this.isHorizontal() ? ((o = s), (l = "0")) : ((l = s), (o = "0")),
                            (o = o.indexOf("%") >= 0 ? parseInt(o, 10) * e * n + "%" : o * e * n + "px"),
                            (l = l.indexOf("%") >= 0 ? parseInt(l, 10) * e + "%" : l * e + "px"),
                            null != d)
                        ) {
                            var p = d - (d - 1) * (1 - Math.abs(e));
                            r[0].style.opacity = p;
                        }
                        if (null == c) r.transform("translate3d(" + o + ", " + l + ", 0px)");
                        else {
                            var h = c - (c - 1) * (1 - Math.abs(e));
                            r.transform("translate3d(" + o + ", " + l + ", 0px) scale(" + h + ")");
                        }
                    },
                    setTranslate: function () {
                        var t = this,
                            e = t.$el,
                            a = t.slides,
                            r = t.progress,
                            n = t.snapGrid;
                        e.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each(function (e, a) {
                            t.parallax.setTransform(a, r);
                        }),
                            a.each(function (e, a) {
                                var s = a.progress;
                                t.params.slidesPerGroup > 1 && "auto" !== t.params.slidesPerView && (s += Math.ceil(e / 2) - r * (n.length - 1)),
                                    (s = Math.min(Math.max(s, -1), 1)),
                                    i(a)
                                        .find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]")
                                        .each(function (e, a) {
                                            t.parallax.setTransform(a, s);
                                        });
                            });
                    },
                    setTransition: function (t) {
                        void 0 === t && (t = this.params.speed),
                            this.$el.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").each(function (e, a) {
                                var r = i(a),
                                    n = parseInt(r.attr("data-swiper-parallax-duration"), 10) || t;
                                0 === t && (n = 0), r.transition(n);
                            });
                    },
                },
                rt = {
                    getDistanceBetweenTouches: function (t) {
                        if (t.targetTouches.length < 2) return 1;
                        var e = t.targetTouches[0].pageX,
                            a = t.targetTouches[0].pageY,
                            i = t.targetTouches[1].pageX,
                            r = t.targetTouches[1].pageY;
                        return Math.sqrt(Math.pow(i - e, 2) + Math.pow(r - a, 2));
                    },
                    onGestureStart: function (t) {
                        var e = this.params.zoom,
                            a = this.zoom,
                            r = a.gesture;
                        if (((a.fakeGestureTouched = !1), (a.fakeGestureMoved = !1), !o.gestures)) {
                            if ("touchstart" !== t.type || ("touchstart" === t.type && t.targetTouches.length < 2)) return;
                            (a.fakeGestureTouched = !0), (r.scaleStart = rt.getDistanceBetweenTouches(t));
                        }
                        (r.$slideEl && r.$slideEl.length) ||
                        ((r.$slideEl = i(t.target).closest(".swiper-slide")),
                        0 === r.$slideEl.length && (r.$slideEl = this.slides.eq(this.activeIndex)),
                        (r.$imageEl = r.$slideEl.find("img, svg, canvas")),
                        (r.$imageWrapEl = r.$imageEl.parent("." + e.containerClass)),
                        (r.maxRatio = r.$imageWrapEl.attr("data-swiper-zoom") || e.maxRatio),
                        0 !== r.$imageWrapEl.length)
                            ? (r.$imageEl.transition(0), (this.zoom.isScaling = !0))
                            : (r.$imageEl = void 0);
                    },
                    onGestureChange: function (t) {
                        var e = this.params.zoom,
                            a = this.zoom,
                            i = a.gesture;
                        if (!o.gestures) {
                            if ("touchmove" !== t.type || ("touchmove" === t.type && t.targetTouches.length < 2)) return;
                            (a.fakeGestureMoved = !0), (i.scaleMove = rt.getDistanceBetweenTouches(t));
                        }
                        i.$imageEl &&
                            0 !== i.$imageEl.length &&
                            (o.gestures ? (a.scale = t.scale * a.currentScale) : (a.scale = (i.scaleMove / i.scaleStart) * a.currentScale),
                            a.scale > i.maxRatio && (a.scale = i.maxRatio - 1 + Math.pow(a.scale - i.maxRatio + 1, 0.5)),
                            a.scale < e.minRatio && (a.scale = e.minRatio + 1 - Math.pow(e.minRatio - a.scale + 1, 0.5)),
                            i.$imageEl.transform("translate3d(0,0,0) scale(" + a.scale + ")"));
                    },
                    onGestureEnd: function (t) {
                        var e = this.params.zoom,
                            a = this.zoom,
                            i = a.gesture;
                        if (!o.gestures) {
                            if (!a.fakeGestureTouched || !a.fakeGestureMoved) return;
                            if ("touchend" !== t.type || ("touchend" === t.type && t.changedTouches.length < 2 && !M.android)) return;
                            (a.fakeGestureTouched = !1), (a.fakeGestureMoved = !1);
                        }
                        i.$imageEl &&
                            0 !== i.$imageEl.length &&
                            ((a.scale = Math.max(Math.min(a.scale, i.maxRatio), e.minRatio)),
                            i.$imageEl.transition(this.params.speed).transform("translate3d(0,0,0) scale(" + a.scale + ")"),
                            (a.currentScale = a.scale),
                            (a.isScaling = !1),
                            1 === a.scale && (i.$slideEl = void 0));
                    },
                    onTouchStart: function (t) {
                        var e = this.zoom,
                            a = e.gesture,
                            i = e.image;
                        a.$imageEl &&
                            0 !== a.$imageEl.length &&
                            (i.isTouched ||
                                (M.android && t.preventDefault(),
                                (i.isTouched = !0),
                                (i.touchesStart.x = "touchstart" === t.type ? t.targetTouches[0].pageX : t.pageX),
                                (i.touchesStart.y = "touchstart" === t.type ? t.targetTouches[0].pageY : t.pageY)));
                    },
                    onTouchMove: function (t) {
                        var e = this.zoom,
                            a = e.gesture,
                            i = e.image,
                            r = e.velocity;
                        if (a.$imageEl && 0 !== a.$imageEl.length && ((this.allowClick = !1), i.isTouched && a.$slideEl)) {
                            i.isMoved ||
                                ((i.width = a.$imageEl[0].offsetWidth),
                                (i.height = a.$imageEl[0].offsetHeight),
                                (i.startX = s.getTranslate(a.$imageWrapEl[0], "x") || 0),
                                (i.startY = s.getTranslate(a.$imageWrapEl[0], "y") || 0),
                                (a.slideWidth = a.$slideEl[0].offsetWidth),
                                (a.slideHeight = a.$slideEl[0].offsetHeight),
                                a.$imageWrapEl.transition(0),
                                this.rtl && ((i.startX = -i.startX), (i.startY = -i.startY)));
                            var n = i.width * e.scale,
                                o = i.height * e.scale;
                            if (!(n < a.slideWidth && o < a.slideHeight)) {
                                if (
                                    ((i.minX = Math.min(a.slideWidth / 2 - n / 2, 0)),
                                    (i.maxX = -i.minX),
                                    (i.minY = Math.min(a.slideHeight / 2 - o / 2, 0)),
                                    (i.maxY = -i.minY),
                                    (i.touchesCurrent.x = "touchmove" === t.type ? t.targetTouches[0].pageX : t.pageX),
                                    (i.touchesCurrent.y = "touchmove" === t.type ? t.targetTouches[0].pageY : t.pageY),
                                    !i.isMoved && !e.isScaling)
                                ) {
                                    if (
                                        this.isHorizontal() &&
                                        ((Math.floor(i.minX) === Math.floor(i.startX) && i.touchesCurrent.x < i.touchesStart.x) || (Math.floor(i.maxX) === Math.floor(i.startX) && i.touchesCurrent.x > i.touchesStart.x))
                                    )
                                        return void (i.isTouched = !1);
                                    if (
                                        !this.isHorizontal() &&
                                        ((Math.floor(i.minY) === Math.floor(i.startY) && i.touchesCurrent.y < i.touchesStart.y) || (Math.floor(i.maxY) === Math.floor(i.startY) && i.touchesCurrent.y > i.touchesStart.y))
                                    )
                                        return void (i.isTouched = !1);
                                }
                                t.preventDefault(),
                                    t.stopPropagation(),
                                    (i.isMoved = !0),
                                    (i.currentX = i.touchesCurrent.x - i.touchesStart.x + i.startX),
                                    (i.currentY = i.touchesCurrent.y - i.touchesStart.y + i.startY),
                                    i.currentX < i.minX && (i.currentX = i.minX + 1 - Math.pow(i.minX - i.currentX + 1, 0.8)),
                                    i.currentX > i.maxX && (i.currentX = i.maxX - 1 + Math.pow(i.currentX - i.maxX + 1, 0.8)),
                                    i.currentY < i.minY && (i.currentY = i.minY + 1 - Math.pow(i.minY - i.currentY + 1, 0.8)),
                                    i.currentY > i.maxY && (i.currentY = i.maxY - 1 + Math.pow(i.currentY - i.maxY + 1, 0.8)),
                                    r.prevPositionX || (r.prevPositionX = i.touchesCurrent.x),
                                    r.prevPositionY || (r.prevPositionY = i.touchesCurrent.y),
                                    r.prevTime || (r.prevTime = Date.now()),
                                    (r.x = (i.touchesCurrent.x - r.prevPositionX) / (Date.now() - r.prevTime) / 2),
                                    (r.y = (i.touchesCurrent.y - r.prevPositionY) / (Date.now() - r.prevTime) / 2),
                                    Math.abs(i.touchesCurrent.x - r.prevPositionX) < 2 && (r.x = 0),
                                    Math.abs(i.touchesCurrent.y - r.prevPositionY) < 2 && (r.y = 0),
                                    (r.prevPositionX = i.touchesCurrent.x),
                                    (r.prevPositionY = i.touchesCurrent.y),
                                    (r.prevTime = Date.now()),
                                    a.$imageWrapEl.transform("translate3d(" + i.currentX + "px, " + i.currentY + "px,0)");
                            }
                        }
                    },
                    onTouchEnd: function () {
                        var t = this.zoom,
                            e = t.gesture,
                            a = t.image,
                            i = t.velocity;
                        if (e.$imageEl && 0 !== e.$imageEl.length) {
                            if (!a.isTouched || !a.isMoved) return (a.isTouched = !1), void (a.isMoved = !1);
                            (a.isTouched = !1), (a.isMoved = !1);
                            var r = 300,
                                n = 300,
                                s = i.x * r,
                                o = a.currentX + s,
                                l = i.y * n,
                                c = a.currentY + l;
                            0 !== i.x && (r = Math.abs((o - a.currentX) / i.x)), 0 !== i.y && (n = Math.abs((c - a.currentY) / i.y));
                            var d = Math.max(r, n);
                            (a.currentX = o), (a.currentY = c);
                            var p = a.width * t.scale,
                                h = a.height * t.scale;
                            (a.minX = Math.min(e.slideWidth / 2 - p / 2, 0)),
                                (a.maxX = -a.minX),
                                (a.minY = Math.min(e.slideHeight / 2 - h / 2, 0)),
                                (a.maxY = -a.minY),
                                (a.currentX = Math.max(Math.min(a.currentX, a.maxX), a.minX)),
                                (a.currentY = Math.max(Math.min(a.currentY, a.maxY), a.minY)),
                                e.$imageWrapEl.transition(d).transform("translate3d(" + a.currentX + "px, " + a.currentY + "px,0)");
                        }
                    },
                    onTransitionEnd: function () {
                        var t = this.zoom,
                            e = t.gesture;
                        e.$slideEl &&
                            this.previousIndex !== this.activeIndex &&
                            (e.$imageEl.transform("translate3d(0,0,0) scale(1)"), e.$imageWrapEl.transform("translate3d(0,0,0)"), (t.scale = 1), (t.currentScale = 1), (e.$slideEl = void 0), (e.$imageEl = void 0), (e.$imageWrapEl = void 0));
                    },
                    toggle: function (t) {
                        var e = this.zoom;
                        e.scale && 1 !== e.scale ? e.out() : e.in(t);
                    },
                    in: function (t) {
                        var e,
                            a,
                            r,
                            n,
                            s,
                            o,
                            l,
                            c,
                            d,
                            p,
                            h,
                            u,
                            m,
                            f,
                            g,
                            b,
                            w = this.zoom,
                            v = this.params.zoom,
                            y = w.gesture,
                            _ = w.image;
                        y.$slideEl ||
                            ((y.$slideEl = this.clickedSlide ? i(this.clickedSlide) : this.slides.eq(this.activeIndex)), (y.$imageEl = y.$slideEl.find("img, svg, canvas")), (y.$imageWrapEl = y.$imageEl.parent("." + v.containerClass))),
                            y.$imageEl &&
                                0 !== y.$imageEl.length &&
                                (y.$slideEl.addClass("" + v.zoomedSlideClass),
                                void 0 === _.touchesStart.x && t
                                    ? ((e = "touchend" === t.type ? t.changedTouches[0].pageX : t.pageX), (a = "touchend" === t.type ? t.changedTouches[0].pageY : t.pageY))
                                    : ((e = _.touchesStart.x), (a = _.touchesStart.y)),
                                (w.scale = y.$imageWrapEl.attr("data-swiper-zoom") || v.maxRatio),
                                (w.currentScale = y.$imageWrapEl.attr("data-swiper-zoom") || v.maxRatio),
                                t
                                    ? ((g = y.$slideEl[0].offsetWidth),
                                      (b = y.$slideEl[0].offsetHeight),
                                      (r = y.$slideEl.offset().left + g / 2 - e),
                                      (n = y.$slideEl.offset().top + b / 2 - a),
                                      (l = y.$imageEl[0].offsetWidth),
                                      (c = y.$imageEl[0].offsetHeight),
                                      (d = l * w.scale),
                                      (p = c * w.scale),
                                      (m = -(h = Math.min(g / 2 - d / 2, 0))),
                                      (f = -(u = Math.min(b / 2 - p / 2, 0))),
                                      (s = r * w.scale) < h && (s = h),
                                      s > m && (s = m),
                                      (o = n * w.scale) < u && (o = u),
                                      o > f && (o = f))
                                    : ((s = 0), (o = 0)),
                                y.$imageWrapEl.transition(300).transform("translate3d(" + s + "px, " + o + "px,0)"),
                                y.$imageEl.transition(300).transform("translate3d(0,0,0) scale(" + w.scale + ")"));
                    },
                    out: function () {
                        var t = this.zoom,
                            e = this.params.zoom,
                            a = t.gesture;
                        a.$slideEl ||
                            ((a.$slideEl = this.clickedSlide ? i(this.clickedSlide) : this.slides.eq(this.activeIndex)), (a.$imageEl = a.$slideEl.find("img, svg, canvas")), (a.$imageWrapEl = a.$imageEl.parent("." + e.containerClass))),
                            a.$imageEl &&
                                0 !== a.$imageEl.length &&
                                ((t.scale = 1),
                                (t.currentScale = 1),
                                a.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"),
                                a.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)"),
                                a.$slideEl.removeClass("" + e.zoomedSlideClass),
                                (a.$slideEl = void 0));
                    },
                    enable: function () {
                        var t = this.zoom;
                        if (!t.enabled) {
                            t.enabled = !0;
                            var e = !("touchstart" !== this.touchEvents.start || !o.passiveListener || !this.params.passiveListeners) && { passive: !0, capture: !1 },
                                a = !o.passiveListener || { passive: !1, capture: !0 };
                            o.gestures
                                ? (this.$wrapperEl.on("gesturestart", ".swiper-slide", t.onGestureStart, e),
                                  this.$wrapperEl.on("gesturechange", ".swiper-slide", t.onGestureChange, e),
                                  this.$wrapperEl.on("gestureend", ".swiper-slide", t.onGestureEnd, e))
                                : "touchstart" === this.touchEvents.start &&
                                  (this.$wrapperEl.on(this.touchEvents.start, ".swiper-slide", t.onGestureStart, e),
                                  this.$wrapperEl.on(this.touchEvents.move, ".swiper-slide", t.onGestureChange, a),
                                  this.$wrapperEl.on(this.touchEvents.end, ".swiper-slide", t.onGestureEnd, e),
                                  this.touchEvents.cancel && this.$wrapperEl.on(this.touchEvents.cancel, ".swiper-slide", t.onGestureEnd, e)),
                                this.$wrapperEl.on(this.touchEvents.move, "." + this.params.zoom.containerClass, t.onTouchMove, a);
                        }
                    },
                    disable: function () {
                        var t = this.zoom;
                        if (t.enabled) {
                            this.zoom.enabled = !1;
                            var e = !("touchstart" !== this.touchEvents.start || !o.passiveListener || !this.params.passiveListeners) && { passive: !0, capture: !1 },
                                a = !o.passiveListener || { passive: !1, capture: !0 };
                            o.gestures
                                ? (this.$wrapperEl.off("gesturestart", ".swiper-slide", t.onGestureStart, e),
                                  this.$wrapperEl.off("gesturechange", ".swiper-slide", t.onGestureChange, e),
                                  this.$wrapperEl.off("gestureend", ".swiper-slide", t.onGestureEnd, e))
                                : "touchstart" === this.touchEvents.start &&
                                  (this.$wrapperEl.off(this.touchEvents.start, ".swiper-slide", t.onGestureStart, e),
                                  this.$wrapperEl.off(this.touchEvents.move, ".swiper-slide", t.onGestureChange, a),
                                  this.$wrapperEl.off(this.touchEvents.end, ".swiper-slide", t.onGestureEnd, e),
                                  this.touchEvents.cancel && this.$wrapperEl.off(this.touchEvents.cancel, ".swiper-slide", t.onGestureEnd, e)),
                                this.$wrapperEl.off(this.touchEvents.move, "." + this.params.zoom.containerClass, t.onTouchMove, a);
                        }
                    },
                },
                nt = {
                    loadInSlide: function (t, e) {
                        void 0 === e && (e = !0);
                        var a = this,
                            r = a.params.lazy;
                        if (void 0 !== t && 0 !== a.slides.length) {
                            var n = a.virtual && a.params.virtual.enabled ? a.$wrapperEl.children("." + a.params.slideClass + '[data-swiper-slide-index="' + t + '"]') : a.slides.eq(t),
                                s = n.find("." + r.elementClass + ":not(." + r.loadedClass + "):not(." + r.loadingClass + ")");
                            !n.hasClass(r.elementClass) || n.hasClass(r.loadedClass) || n.hasClass(r.loadingClass) || (s = s.add(n[0])),
                                0 !== s.length &&
                                    s.each(function (t, s) {
                                        var o = i(s);
                                        o.addClass(r.loadingClass);
                                        var l = o.attr("data-background"),
                                            c = o.attr("data-src"),
                                            d = o.attr("data-srcset"),
                                            p = o.attr("data-sizes");
                                        a.loadImage(o[0], c || l, d, p, !1, function () {
                                            if (null != a && a && (!a || a.params) && !a.destroyed) {
                                                if (
                                                    (l
                                                        ? (o.css("background-image", 'url("' + l + '")'), o.removeAttr("data-background"))
                                                        : (d && (o.attr("srcset", d), o.removeAttr("data-srcset")), p && (o.attr("sizes", p), o.removeAttr("data-sizes")), c && (o.attr("src", c), o.removeAttr("data-src"))),
                                                    o.addClass(r.loadedClass).removeClass(r.loadingClass),
                                                    n.find("." + r.preloaderClass).remove(),
                                                    a.params.loop && e)
                                                ) {
                                                    var t = n.attr("data-swiper-slide-index");
                                                    if (n.hasClass(a.params.slideDuplicateClass)) {
                                                        var i = a.$wrapperEl.children('[data-swiper-slide-index="' + t + '"]:not(.' + a.params.slideDuplicateClass + ")");
                                                        a.lazy.loadInSlide(i.index(), !1);
                                                    } else {
                                                        var s = a.$wrapperEl.children("." + a.params.slideDuplicateClass + '[data-swiper-slide-index="' + t + '"]');
                                                        a.lazy.loadInSlide(s.index(), !1);
                                                    }
                                                }
                                                a.emit("lazyImageReady", n[0], o[0]);
                                            }
                                        }),
                                            a.emit("lazyImageLoad", n[0], o[0]);
                                    });
                        }
                    },
                    load: function () {
                        var t = this,
                            e = t.$wrapperEl,
                            a = t.params,
                            r = t.slides,
                            n = t.activeIndex,
                            s = t.virtual && a.virtual.enabled,
                            o = a.lazy,
                            l = a.slidesPerView;
                        function c(t) {
                            if (s) {
                                if (e.children("." + a.slideClass + '[data-swiper-slide-index="' + t + '"]').length) return !0;
                            } else if (r[t]) return !0;
                            return !1;
                        }
                        function d(t) {
                            return s ? i(t).attr("data-swiper-slide-index") : i(t).index();
                        }
                        if (("auto" === l && (l = 0), t.lazy.initialImageLoaded || (t.lazy.initialImageLoaded = !0), t.params.watchSlidesVisibility))
                            e.children("." + a.slideVisibleClass).each(function (e, a) {
                                var r = s ? i(a).attr("data-swiper-slide-index") : i(a).index();
                                t.lazy.loadInSlide(r);
                            });
                        else if (l > 1) for (var p = n; p < n + l; p += 1) c(p) && t.lazy.loadInSlide(p);
                        else t.lazy.loadInSlide(n);
                        if (o.loadPrevNext)
                            if (l > 1 || (o.loadPrevNextAmount && o.loadPrevNextAmount > 1)) {
                                for (var h = o.loadPrevNextAmount, u = l, m = Math.min(n + u + Math.max(h, u), r.length), f = Math.max(n - Math.max(u, h), 0), g = n + l; g < m; g += 1) c(g) && t.lazy.loadInSlide(g);
                                for (var b = f; b < n; b += 1) c(b) && t.lazy.loadInSlide(b);
                            } else {
                                var w = e.children("." + a.slideNextClass);
                                w.length > 0 && t.lazy.loadInSlide(d(w));
                                var v = e.children("." + a.slidePrevClass);
                                v.length > 0 && t.lazy.loadInSlide(d(v));
                            }
                    },
                },
                st = {
                    LinearSpline: function (t, e) {
                        var a, i, r, n, s;
                        return (
                            (this.x = t),
                            (this.y = e),
                            (this.lastIndex = t.length - 1),
                            (this.interpolate = function (t) {
                                return t
                                    ? ((s = (function (t, e) {
                                          for (i = -1, a = t.length; a - i > 1; ) t[(r = (a + i) >> 1)] <= e ? (i = r) : (a = r);
                                          return a;
                                      })(this.x, t)),
                                      (n = s - 1),
                                      ((t - this.x[n]) * (this.y[s] - this.y[n])) / (this.x[s] - this.x[n]) + this.y[n])
                                    : 0;
                            }),
                            this
                        );
                    },
                    getInterpolateFunction: function (t) {
                        this.controller.spline || (this.controller.spline = this.params.loop ? new st.LinearSpline(this.slidesGrid, t.slidesGrid) : new st.LinearSpline(this.snapGrid, t.snapGrid));
                    },
                    setTranslate: function (t, e) {
                        var a,
                            i,
                            r = this,
                            n = r.controller.control;
                        function s(t) {
                            var e = r.rtlTranslate ? -r.translate : r.translate;
                            "slide" === r.params.controller.by && (r.controller.getInterpolateFunction(t), (i = -r.controller.spline.interpolate(-e))),
                                (i && "container" !== r.params.controller.by) || ((a = (t.maxTranslate() - t.minTranslate()) / (r.maxTranslate() - r.minTranslate())), (i = (e - r.minTranslate()) * a + t.minTranslate())),
                                r.params.controller.inverse && (i = t.maxTranslate() - i),
                                t.updateProgress(i),
                                t.setTranslate(i, r),
                                t.updateActiveIndex(),
                                t.updateSlidesClasses();
                        }
                        if (Array.isArray(n)) for (var o = 0; o < n.length; o += 1) n[o] !== e && n[o] instanceof N && s(n[o]);
                        else n instanceof N && e !== n && s(n);
                    },
                    setTransition: function (t, e) {
                        var a,
                            i = this,
                            r = i.controller.control;
                        function n(e) {
                            e.setTransition(t, i),
                                0 !== t &&
                                    (e.transitionStart(),
                                    e.params.autoHeight &&
                                        s.nextTick(function () {
                                            e.updateAutoHeight();
                                        }),
                                    e.$wrapperEl.transitionEnd(function () {
                                        r && (e.params.loop && "slide" === i.params.controller.by && e.loopFix(), e.transitionEnd());
                                    }));
                        }
                        if (Array.isArray(r)) for (a = 0; a < r.length; a += 1) r[a] !== e && r[a] instanceof N && n(r[a]);
                        else r instanceof N && e !== r && n(r);
                    },
                },
                ot = {
                    makeElFocusable: function (t) {
                        return t.attr("tabIndex", "0"), t;
                    },
                    addElRole: function (t, e) {
                        return t.attr("role", e), t;
                    },
                    addElLabel: function (t, e) {
                        return t.attr("aria-label", e), t;
                    },
                    disableEl: function (t) {
                        return t.attr("aria-disabled", !0), t;
                    },
                    enableEl: function (t) {
                        return t.attr("aria-disabled", !1), t;
                    },
                    onEnterKey: function (t) {
                        var e = this.params.a11y;
                        if (13 === t.keyCode) {
                            var a = i(t.target);
                            this.navigation &&
                                this.navigation.$nextEl &&
                                a.is(this.navigation.$nextEl) &&
                                ((this.isEnd && !this.params.loop) || this.slideNext(), this.isEnd ? this.a11y.notify(e.lastSlideMessage) : this.a11y.notify(e.nextSlideMessage)),
                                this.navigation &&
                                    this.navigation.$prevEl &&
                                    a.is(this.navigation.$prevEl) &&
                                    ((this.isBeginning && !this.params.loop) || this.slidePrev(), this.isBeginning ? this.a11y.notify(e.firstSlideMessage) : this.a11y.notify(e.prevSlideMessage)),
                                this.pagination && a.is("." + this.params.pagination.bulletClass) && a[0].click();
                        }
                    },
                    notify: function (t) {
                        var e = this.a11y.liveRegion;
                        0 !== e.length && (e.html(""), e.html(t));
                    },
                    updateNavigation: function () {
                        if (!this.params.loop && this.navigation) {
                            var t = this.navigation,
                                e = t.$nextEl,
                                a = t.$prevEl;
                            a && a.length > 0 && (this.isBeginning ? this.a11y.disableEl(a) : this.a11y.enableEl(a)), e && e.length > 0 && (this.isEnd ? this.a11y.disableEl(e) : this.a11y.enableEl(e));
                        }
                    },
                    updatePagination: function () {
                        var t = this,
                            e = t.params.a11y;
                        t.pagination &&
                            t.params.pagination.clickable &&
                            t.pagination.bullets &&
                            t.pagination.bullets.length &&
                            t.pagination.bullets.each(function (a, r) {
                                var n = i(r);
                                t.a11y.makeElFocusable(n), t.a11y.addElRole(n, "button"), t.a11y.addElLabel(n, e.paginationBulletMessage.replace(/{{index}}/, n.index() + 1));
                            });
                    },
                    init: function () {
                        this.$el.append(this.a11y.liveRegion);
                        var t,
                            e,
                            a = this.params.a11y;
                        this.navigation && this.navigation.$nextEl && (t = this.navigation.$nextEl),
                            this.navigation && this.navigation.$prevEl && (e = this.navigation.$prevEl),
                            t && (this.a11y.makeElFocusable(t), this.a11y.addElRole(t, "button"), this.a11y.addElLabel(t, a.nextSlideMessage), t.on("keydown", this.a11y.onEnterKey)),
                            e && (this.a11y.makeElFocusable(e), this.a11y.addElRole(e, "button"), this.a11y.addElLabel(e, a.prevSlideMessage), e.on("keydown", this.a11y.onEnterKey)),
                            this.pagination &&
                                this.params.pagination.clickable &&
                                this.pagination.bullets &&
                                this.pagination.bullets.length &&
                                this.pagination.$el.on("keydown", "." + this.params.pagination.bulletClass, this.a11y.onEnterKey);
                    },
                    destroy: function () {
                        var t, e;
                        this.a11y.liveRegion && this.a11y.liveRegion.length > 0 && this.a11y.liveRegion.remove(),
                            this.navigation && this.navigation.$nextEl && (t = this.navigation.$nextEl),
                            this.navigation && this.navigation.$prevEl && (e = this.navigation.$prevEl),
                            t && t.off("keydown", this.a11y.onEnterKey),
                            e && e.off("keydown", this.a11y.onEnterKey),
                            this.pagination &&
                                this.params.pagination.clickable &&
                                this.pagination.bullets &&
                                this.pagination.bullets.length &&
                                this.pagination.$el.off("keydown", "." + this.params.pagination.bulletClass, this.a11y.onEnterKey);
                    },
                },
                lt = {
                    init: function () {
                        if (this.params.history) {
                            if (!e.history || !e.history.pushState) return (this.params.history.enabled = !1), void (this.params.hashNavigation.enabled = !0);
                            var t = this.history;
                            (t.initialized = !0),
                                (t.paths = lt.getPathValues()),
                                (t.paths.key || t.paths.value) && (t.scrollToSlide(0, t.paths.value, this.params.runCallbacksOnInit), this.params.history.replaceState || e.addEventListener("popstate", this.history.setHistoryPopState));
                        }
                    },
                    destroy: function () {
                        this.params.history.replaceState || e.removeEventListener("popstate", this.history.setHistoryPopState);
                    },
                    setHistoryPopState: function () {
                        (this.history.paths = lt.getPathValues()), this.history.scrollToSlide(this.params.speed, this.history.paths.value, !1);
                    },
                    getPathValues: function () {
                        var t = e.location.pathname
                                .slice(1)
                                .split("/")
                                .filter(function (t) {
                                    return "" !== t;
                                }),
                            a = t.length;
                        return { key: t[a - 2], value: t[a - 1] };
                    },
                    setHistory: function (t, a) {
                        if (this.history.initialized && this.params.history.enabled) {
                            var i = this.slides.eq(a),
                                r = lt.slugify(i.attr("data-history"));
                            e.location.pathname.includes(t) || (r = t + "/" + r);
                            var n = e.history.state;
                            (n && n.value === r) || (this.params.history.replaceState ? e.history.replaceState({ value: r }, null, r) : e.history.pushState({ value: r }, null, r));
                        }
                    },
                    slugify: function (t) {
                        return t
                            .toString()
                            .replace(/\s+/g, "-")
                            .replace(/[^\w-]+/g, "")
                            .replace(/--+/g, "-")
                            .replace(/^-+/, "")
                            .replace(/-+$/, "");
                    },
                    scrollToSlide: function (t, e, a) {
                        if (e)
                            for (var i = 0, r = this.slides.length; i < r; i += 1) {
                                var n = this.slides.eq(i);
                                if (lt.slugify(n.attr("data-history")) === e && !n.hasClass(this.params.slideDuplicateClass)) {
                                    var s = n.index();
                                    this.slideTo(s, t, a);
                                }
                            }
                        else this.slideTo(0, t, a);
                    },
                },
                ct = {
                    onHashCange: function () {
                        var e = t.location.hash.replace("#", "");
                        if (e !== this.slides.eq(this.activeIndex).attr("data-hash")) {
                            var a = this.$wrapperEl.children("." + this.params.slideClass + '[data-hash="' + e + '"]').index();
                            if (void 0 === a) return;
                            this.slideTo(a);
                        }
                    },
                    setHash: function () {
                        if (this.hashNavigation.initialized && this.params.hashNavigation.enabled)
                            if (this.params.hashNavigation.replaceState && e.history && e.history.replaceState) e.history.replaceState(null, null, "#" + this.slides.eq(this.activeIndex).attr("data-hash") || "");
                            else {
                                var a = this.slides.eq(this.activeIndex),
                                    i = a.attr("data-hash") || a.attr("data-history");
                                t.location.hash = i || "";
                            }
                    },
                    init: function () {
                        if (!(!this.params.hashNavigation.enabled || (this.params.history && this.params.history.enabled))) {
                            this.hashNavigation.initialized = !0;
                            var a = t.location.hash.replace("#", "");
                            if (a)
                                for (var r = 0, n = this.slides.length; r < n; r += 1) {
                                    var s = this.slides.eq(r);
                                    if ((s.attr("data-hash") || s.attr("data-history")) === a && !s.hasClass(this.params.slideDuplicateClass)) {
                                        var o = s.index();
                                        this.slideTo(o, 0, this.params.runCallbacksOnInit, !0);
                                    }
                                }
                            this.params.hashNavigation.watchState && i(e).on("hashchange", this.hashNavigation.onHashCange);
                        }
                    },
                    destroy: function () {
                        this.params.hashNavigation.watchState && i(e).off("hashchange", this.hashNavigation.onHashCange);
                    },
                },
                dt = {
                    run: function () {
                        var t = this,
                            e = t.slides.eq(t.activeIndex),
                            a = t.params.autoplay.delay;
                        e.attr("data-swiper-autoplay") && (a = e.attr("data-swiper-autoplay") || t.params.autoplay.delay),
                            clearTimeout(t.autoplay.timeout),
                            (t.autoplay.timeout = s.nextTick(function () {
                                t.params.autoplay.reverseDirection
                                    ? t.params.loop
                                        ? (t.loopFix(), t.slidePrev(t.params.speed, !0, !0), t.emit("autoplay"))
                                        : t.isBeginning
                                        ? t.params.autoplay.stopOnLastSlide
                                            ? t.autoplay.stop()
                                            : (t.slideTo(t.slides.length - 1, t.params.speed, !0, !0), t.emit("autoplay"))
                                        : (t.slidePrev(t.params.speed, !0, !0), t.emit("autoplay"))
                                    : t.params.loop
                                    ? (t.loopFix(), t.slideNext(t.params.speed, !0, !0), t.emit("autoplay"))
                                    : t.isEnd
                                    ? t.params.autoplay.stopOnLastSlide
                                        ? t.autoplay.stop()
                                        : (t.slideTo(0, t.params.speed, !0, !0), t.emit("autoplay"))
                                    : (t.slideNext(t.params.speed, !0, !0), t.emit("autoplay")),
                                    t.params.cssMode && t.autoplay.running && t.autoplay.run();
                            }, a));
                    },
                    start: function () {
                        return void 0 === this.autoplay.timeout && !this.autoplay.running && ((this.autoplay.running = !0), this.emit("autoplayStart"), this.autoplay.run(), !0);
                    },
                    stop: function () {
                        return (
                            !!this.autoplay.running &&
                            void 0 !== this.autoplay.timeout &&
                            (this.autoplay.timeout && (clearTimeout(this.autoplay.timeout), (this.autoplay.timeout = void 0)), (this.autoplay.running = !1), this.emit("autoplayStop"), !0)
                        );
                    },
                    pause: function (t) {
                        this.autoplay.running &&
                            (this.autoplay.paused ||
                                (this.autoplay.timeout && clearTimeout(this.autoplay.timeout),
                                (this.autoplay.paused = !0),
                                0 !== t && this.params.autoplay.waitForTransition
                                    ? (this.$wrapperEl[0].addEventListener("transitionend", this.autoplay.onTransitionEnd), this.$wrapperEl[0].addEventListener("webkitTransitionEnd", this.autoplay.onTransitionEnd))
                                    : ((this.autoplay.paused = !1), this.autoplay.run())));
                    },
                },
                pt = {
                    setTranslate: function () {
                        for (var t = this.slides, e = 0; e < t.length; e += 1) {
                            var a = this.slides.eq(e),
                                i = -a[0].swiperSlideOffset;
                            this.params.virtualTranslate || (i -= this.translate);
                            var r = 0;
                            this.isHorizontal() || ((r = i), (i = 0));
                            var n = this.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(a[0].progress), 0) : 1 + Math.min(Math.max(a[0].progress, -1), 0);
                            a.css({ opacity: n }).transform("translate3d(" + i + "px, " + r + "px, 0px)");
                        }
                    },
                    setTransition: function (t) {
                        var e = this,
                            a = e.slides,
                            i = e.$wrapperEl;
                        if ((a.transition(t), e.params.virtualTranslate && 0 !== t)) {
                            var r = !1;
                            a.transitionEnd(function () {
                                if (!r && e && !e.destroyed) {
                                    (r = !0), (e.animating = !1);
                                    for (var t = ["webkitTransitionEnd", "transitionend"], a = 0; a < t.length; a += 1) i.trigger(t[a]);
                                }
                            });
                        }
                    },
                },
                ht = {
                    setTranslate: function () {
                        var t,
                            e = this.$el,
                            a = this.$wrapperEl,
                            r = this.slides,
                            n = this.width,
                            s = this.height,
                            o = this.rtlTranslate,
                            l = this.size,
                            c = this.params.cubeEffect,
                            d = this.isHorizontal(),
                            p = this.virtual && this.params.virtual.enabled,
                            h = 0;
                        c.shadow &&
                            (d
                                ? (0 === (t = a.find(".swiper-cube-shadow")).length && ((t = i('<div class="swiper-cube-shadow"></div>')), a.append(t)), t.css({ height: n + "px" }))
                                : 0 === (t = e.find(".swiper-cube-shadow")).length && ((t = i('<div class="swiper-cube-shadow"></div>')), e.append(t)));
                        for (var u = 0; u < r.length; u += 1) {
                            var m = r.eq(u),
                                f = u;
                            p && (f = parseInt(m.attr("data-swiper-slide-index"), 10));
                            var g = 90 * f,
                                b = Math.floor(g / 360);
                            o && ((g = -g), (b = Math.floor(-g / 360)));
                            var w = Math.max(Math.min(m[0].progress, 1), -1),
                                v = 0,
                                y = 0,
                                _ = 0;
                            f % 4 == 0 ? ((v = 4 * -b * l), (_ = 0)) : (f - 1) % 4 == 0 ? ((v = 0), (_ = 4 * -b * l)) : (f - 2) % 4 == 0 ? ((v = l + 4 * b * l), (_ = l)) : (f - 3) % 4 == 0 && ((v = -l), (_ = 3 * l + 4 * l * b)),
                                o && (v = -v),
                                d || ((y = v), (v = 0));
                            var x = "rotateX(" + (d ? 0 : -g) + "deg) rotateY(" + (d ? g : 0) + "deg) translate3d(" + v + "px, " + y + "px, " + _ + "px)";
                            if ((w <= 1 && w > -1 && ((h = 90 * f + 90 * w), o && (h = 90 * -f - 90 * w)), m.transform(x), c.slideShadows)) {
                                var k = d ? m.find(".swiper-slide-shadow-left") : m.find(".swiper-slide-shadow-top"),
                                    C = d ? m.find(".swiper-slide-shadow-right") : m.find(".swiper-slide-shadow-bottom");
                                0 === k.length && ((k = i('<div class="swiper-slide-shadow-' + (d ? "left" : "top") + '"></div>')), m.append(k)),
                                    0 === C.length && ((C = i('<div class="swiper-slide-shadow-' + (d ? "right" : "bottom") + '"></div>')), m.append(C)),
                                    k.length && (k[0].style.opacity = Math.max(-w, 0)),
                                    C.length && (C[0].style.opacity = Math.max(w, 0));
                            }
                        }
                        if (
                            (a.css({
                                "-webkit-transform-origin": "50% 50% -" + l / 2 + "px",
                                "-moz-transform-origin": "50% 50% -" + l / 2 + "px",
                                "-ms-transform-origin": "50% 50% -" + l / 2 + "px",
                                "transform-origin": "50% 50% -" + l / 2 + "px",
                            }),
                            c.shadow)
                        )
                            if (d) t.transform("translate3d(0px, " + (n / 2 + c.shadowOffset) + "px, " + -n / 2 + "px) rotateX(90deg) rotateZ(0deg) scale(" + c.shadowScale + ")");
                            else {
                                var S = Math.abs(h) - 90 * Math.floor(Math.abs(h) / 90),
                                    T = 1.5 - (Math.sin((2 * S * Math.PI) / 360) / 2 + Math.cos((2 * S * Math.PI) / 360) / 2),
                                    E = c.shadowScale,
                                    D = c.shadowScale / T,
                                    z = c.shadowOffset;
                                t.transform("scale3d(" + E + ", 1, " + D + ") translate3d(0px, " + (s / 2 + z) + "px, " + -s / 2 / D + "px) rotateX(-90deg)");
                            }
                        var A = V.isSafari || V.isUiWebView ? -l / 2 : 0;
                        a.transform("translate3d(0px,0," + A + "px) rotateX(" + (this.isHorizontal() ? 0 : h) + "deg) rotateY(" + (this.isHorizontal() ? -h : 0) + "deg)");
                    },
                    setTransition: function (t) {
                        var e = this.$el;
                        this.slides.transition(t).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(t),
                            this.params.cubeEffect.shadow && !this.isHorizontal() && e.find(".swiper-cube-shadow").transition(t);
                    },
                },
                ut = {
                    setTranslate: function () {
                        for (var t = this.slides, e = this.rtlTranslate, a = 0; a < t.length; a += 1) {
                            var r = t.eq(a),
                                n = r[0].progress;
                            this.params.flipEffect.limitRotation && (n = Math.max(Math.min(r[0].progress, 1), -1));
                            var s = -180 * n,
                                o = 0,
                                l = -r[0].swiperSlideOffset,
                                c = 0;
                            if ((this.isHorizontal() ? e && (s = -s) : ((c = l), (l = 0), (o = -s), (s = 0)), (r[0].style.zIndex = -Math.abs(Math.round(n)) + t.length), this.params.flipEffect.slideShadows)) {
                                var d = this.isHorizontal() ? r.find(".swiper-slide-shadow-left") : r.find(".swiper-slide-shadow-top"),
                                    p = this.isHorizontal() ? r.find(".swiper-slide-shadow-right") : r.find(".swiper-slide-shadow-bottom");
                                0 === d.length && ((d = i('<div class="swiper-slide-shadow-' + (this.isHorizontal() ? "left" : "top") + '"></div>')), r.append(d)),
                                    0 === p.length && ((p = i('<div class="swiper-slide-shadow-' + (this.isHorizontal() ? "right" : "bottom") + '"></div>')), r.append(p)),
                                    d.length && (d[0].style.opacity = Math.max(-n, 0)),
                                    p.length && (p[0].style.opacity = Math.max(n, 0));
                            }
                            r.transform("translate3d(" + l + "px, " + c + "px, 0px) rotateX(" + o + "deg) rotateY(" + s + "deg)");
                        }
                    },
                    setTransition: function (t) {
                        var e = this,
                            a = e.slides,
                            i = e.activeIndex,
                            r = e.$wrapperEl;
                        if ((a.transition(t).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(t), e.params.virtualTranslate && 0 !== t)) {
                            var n = !1;
                            a.eq(i).transitionEnd(function () {
                                if (!n && e && !e.destroyed) {
                                    (n = !0), (e.animating = !1);
                                    for (var t = ["webkitTransitionEnd", "transitionend"], a = 0; a < t.length; a += 1) r.trigger(t[a]);
                                }
                            });
                        }
                    },
                },
                mt = {
                    setTranslate: function () {
                        for (
                            var t = this.width,
                                e = this.height,
                                a = this.slides,
                                r = this.$wrapperEl,
                                n = this.slidesSizesGrid,
                                s = this.params.coverflowEffect,
                                l = this.isHorizontal(),
                                c = this.translate,
                                d = l ? t / 2 - c : e / 2 - c,
                                p = l ? s.rotate : -s.rotate,
                                h = s.depth,
                                u = 0,
                                m = a.length;
                            u < m;
                            u += 1
                        ) {
                            var f = a.eq(u),
                                g = n[u],
                                b = ((d - f[0].swiperSlideOffset - g / 2) / g) * s.modifier,
                                w = l ? p * b : 0,
                                v = l ? 0 : p * b,
                                y = -h * Math.abs(b),
                                _ = l ? 0 : s.stretch * b,
                                x = l ? s.stretch * b : 0;
                            Math.abs(x) < 0.001 && (x = 0), Math.abs(_) < 0.001 && (_ = 0), Math.abs(y) < 0.001 && (y = 0), Math.abs(w) < 0.001 && (w = 0), Math.abs(v) < 0.001 && (v = 0);
                            var k = "translate3d(" + x + "px," + _ + "px," + y + "px)  rotateX(" + v + "deg) rotateY(" + w + "deg)";
                            if ((f.transform(k), (f[0].style.zIndex = 1 - Math.abs(Math.round(b))), s.slideShadows)) {
                                var C = l ? f.find(".swiper-slide-shadow-left") : f.find(".swiper-slide-shadow-top"),
                                    S = l ? f.find(".swiper-slide-shadow-right") : f.find(".swiper-slide-shadow-bottom");
                                0 === C.length && ((C = i('<div class="swiper-slide-shadow-' + (l ? "left" : "top") + '"></div>')), f.append(C)),
                                    0 === S.length && ((S = i('<div class="swiper-slide-shadow-' + (l ? "right" : "bottom") + '"></div>')), f.append(S)),
                                    C.length && (C[0].style.opacity = b > 0 ? b : 0),
                                    S.length && (S[0].style.opacity = -b > 0 ? -b : 0);
                            }
                        }
                        (o.pointerEvents || o.prefixedPointerEvents) && (r[0].style.perspectiveOrigin = d + "px 50%");
                    },
                    setTransition: function (t) {
                        this.slides.transition(t).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(t);
                    },
                },
                ft = {
                    init: function () {
                        var t = this.params.thumbs,
                            e = this.constructor;
                        t.swiper instanceof e
                            ? ((this.thumbs.swiper = t.swiper),
                              s.extend(this.thumbs.swiper.originalParams, { watchSlidesProgress: !0, slideToClickedSlide: !1 }),
                              s.extend(this.thumbs.swiper.params, { watchSlidesProgress: !0, slideToClickedSlide: !1 }))
                            : s.isObject(t.swiper) && ((this.thumbs.swiper = new e(s.extend({}, t.swiper, { watchSlidesVisibility: !0, watchSlidesProgress: !0, slideToClickedSlide: !1 }))), (this.thumbs.swiperCreated = !0)),
                            this.thumbs.swiper.$el.addClass(this.params.thumbs.thumbsContainerClass),
                            this.thumbs.swiper.on("tap", this.thumbs.onThumbClick);
                    },
                    onThumbClick: function () {
                        var t = this.thumbs.swiper;
                        if (t) {
                            var e = t.clickedIndex,
                                a = t.clickedSlide;
                            if (!((a && i(a).hasClass(this.params.thumbs.slideThumbActiveClass)) || null == e)) {
                                var r;
                                if (((r = t.params.loop ? parseInt(i(t.clickedSlide).attr("data-swiper-slide-index"), 10) : e), this.params.loop)) {
                                    var n = this.activeIndex;
                                    this.slides.eq(n).hasClass(this.params.slideDuplicateClass) && (this.loopFix(), (this._clientLeft = this.$wrapperEl[0].clientLeft), (n = this.activeIndex));
                                    var s = this.slides
                                            .eq(n)
                                            .prevAll('[data-swiper-slide-index="' + r + '"]')
                                            .eq(0)
                                            .index(),
                                        o = this.slides
                                            .eq(n)
                                            .nextAll('[data-swiper-slide-index="' + r + '"]')
                                            .eq(0)
                                            .index();
                                    r = void 0 === s ? o : void 0 === o ? s : o - n < n - s ? o : s;
                                }
                                this.slideTo(r);
                            }
                        }
                    },
                    update: function (t) {
                        var e = this.thumbs.swiper;
                        if (e) {
                            var a = "auto" === e.params.slidesPerView ? e.slidesPerViewDynamic() : e.params.slidesPerView;
                            if (this.realIndex !== e.realIndex) {
                                var i,
                                    r = e.activeIndex;
                                if (e.params.loop) {
                                    e.slides.eq(r).hasClass(e.params.slideDuplicateClass) && (e.loopFix(), (e._clientLeft = e.$wrapperEl[0].clientLeft), (r = e.activeIndex));
                                    var n = e.slides
                                            .eq(r)
                                            .prevAll('[data-swiper-slide-index="' + this.realIndex + '"]')
                                            .eq(0)
                                            .index(),
                                        s = e.slides
                                            .eq(r)
                                            .nextAll('[data-swiper-slide-index="' + this.realIndex + '"]')
                                            .eq(0)
                                            .index();
                                    i = void 0 === n ? s : void 0 === s ? n : s - r == r - n ? r : s - r < r - n ? s : n;
                                } else i = this.realIndex;
                                e.visibleSlidesIndexes &&
                                    e.visibleSlidesIndexes.indexOf(i) < 0 &&
                                    (e.params.centeredSlides ? (i = i > r ? i - Math.floor(a / 2) + 1 : i + Math.floor(a / 2) - 1) : i > r && (i = i - a + 1), e.slideTo(i, t ? 0 : void 0));
                            }
                            var o = 1,
                                l = this.params.thumbs.slideThumbActiveClass;
                            if (
                                (this.params.slidesPerView > 1 && !this.params.centeredSlides && (o = this.params.slidesPerView),
                                this.params.thumbs.multipleActiveThumbs || (o = 1),
                                (o = Math.floor(o)),
                                e.slides.removeClass(l),
                                e.params.loop || (e.params.virtual && e.params.virtual.enabled))
                            )
                                for (var c = 0; c < o; c += 1) e.$wrapperEl.children('[data-swiper-slide-index="' + (this.realIndex + c) + '"]').addClass(l);
                            else for (var d = 0; d < o; d += 1) e.slides.eq(this.realIndex + d).addClass(l);
                        }
                    },
                },
                gt = [
                    Y,
                    X,
                    G,
                    j,
                    U,
                    Z,
                    Q,
                    {
                        name: "mousewheel",
                        params: { mousewheel: { enabled: !1, releaseOnEdges: !1, invert: !1, forceToAxis: !1, sensitivity: 1, eventsTarged: "container" } },
                        create: function () {
                            s.extend(this, {
                                mousewheel: {
                                    enabled: !1,
                                    enable: J.enable.bind(this),
                                    disable: J.disable.bind(this),
                                    handle: J.handle.bind(this),
                                    handleMouseEnter: J.handleMouseEnter.bind(this),
                                    handleMouseLeave: J.handleMouseLeave.bind(this),
                                    animateSlider: J.animateSlider.bind(this),
                                    releaseScroll: J.releaseScroll.bind(this),
                                    lastScrollTime: s.now(),
                                    lastEventBeforeSnap: void 0,
                                    recentWheelEvents: [],
                                },
                            });
                        },
                        on: {
                            init: function () {
                                !this.params.mousewheel.enabled && this.params.cssMode && this.mousewheel.disable(), this.params.mousewheel.enabled && this.mousewheel.enable();
                            },
                            destroy: function () {
                                this.params.cssMode && this.mousewheel.enable(), this.mousewheel.enabled && this.mousewheel.disable();
                            },
                        },
                    },
                    {
                        name: "navigation",
                        params: { navigation: { nextEl: null, prevEl: null, hideOnClick: !1, disabledClass: "swiper-button-disabled", hiddenClass: "swiper-button-hidden", lockClass: "swiper-button-lock" } },
                        create: function () {
                            s.extend(this, { navigation: { init: tt.init.bind(this), update: tt.update.bind(this), destroy: tt.destroy.bind(this), onNextClick: tt.onNextClick.bind(this), onPrevClick: tt.onPrevClick.bind(this) } });
                        },
                        on: {
                            init: function () {
                                this.navigation.init(), this.navigation.update();
                            },
                            toEdge: function () {
                                this.navigation.update();
                            },
                            fromEdge: function () {
                                this.navigation.update();
                            },
                            destroy: function () {
                                this.navigation.destroy();
                            },
                            click: function (t) {
                                var e,
                                    a = this.navigation,
                                    r = a.$nextEl,
                                    n = a.$prevEl;
                                !this.params.navigation.hideOnClick ||
                                    i(t.target).is(n) ||
                                    i(t.target).is(r) ||
                                    (r ? (e = r.hasClass(this.params.navigation.hiddenClass)) : n && (e = n.hasClass(this.params.navigation.hiddenClass)),
                                    !0 === e ? this.emit("navigationShow", this) : this.emit("navigationHide", this),
                                    r && r.toggleClass(this.params.navigation.hiddenClass),
                                    n && n.toggleClass(this.params.navigation.hiddenClass));
                            },
                        },
                    },
                    {
                        name: "pagination",
                        params: {
                            pagination: {
                                el: null,
                                bulletElement: "span",
                                clickable: !1,
                                hideOnClick: !1,
                                renderBullet: null,
                                renderProgressbar: null,
                                renderFraction: null,
                                renderCustom: null,
                                progressbarOpposite: !1,
                                type: "bullets",
                                dynamicBullets: !1,
                                dynamicMainBullets: 1,
                                formatFractionCurrent: function (t) {
                                    return t;
                                },
                                formatFractionTotal: function (t) {
                                    return t;
                                },
                                bulletClass: "swiper-pagination-bullet",
                                bulletActiveClass: "swiper-pagination-bullet-active",
                                modifierClass: "swiper-pagination-",
                                currentClass: "swiper-pagination-current",
                                totalClass: "swiper-pagination-total",
                                hiddenClass: "swiper-pagination-hidden",
                                progressbarFillClass: "swiper-pagination-progressbar-fill",
                                progressbarOppositeClass: "swiper-pagination-progressbar-opposite",
                                clickableClass: "swiper-pagination-clickable",
                                lockClass: "swiper-pagination-lock",
                            },
                        },
                        create: function () {
                            s.extend(this, { pagination: { init: et.init.bind(this), render: et.render.bind(this), update: et.update.bind(this), destroy: et.destroy.bind(this), dynamicBulletIndex: 0 } });
                        },
                        on: {
                            init: function () {
                                this.pagination.init(), this.pagination.render(), this.pagination.update();
                            },
                            activeIndexChange: function () {
                                this.params.loop ? this.pagination.update() : void 0 === this.snapIndex && this.pagination.update();
                            },
                            snapIndexChange: function () {
                                this.params.loop || this.pagination.update();
                            },
                            slidesLengthChange: function () {
                                this.params.loop && (this.pagination.render(), this.pagination.update());
                            },
                            snapGridLengthChange: function () {
                                this.params.loop || (this.pagination.render(), this.pagination.update());
                            },
                            destroy: function () {
                                this.pagination.destroy();
                            },
                            click: function (t) {
                                this.params.pagination.el &&
                                    this.params.pagination.hideOnClick &&
                                    this.pagination.$el.length > 0 &&
                                    !i(t.target).hasClass(this.params.pagination.bulletClass) &&
                                    (!0 === this.pagination.$el.hasClass(this.params.pagination.hiddenClass) ? this.emit("paginationShow", this) : this.emit("paginationHide", this),
                                    this.pagination.$el.toggleClass(this.params.pagination.hiddenClass));
                            },
                        },
                    },
                    {
                        name: "scrollbar",
                        params: { scrollbar: { el: null, dragSize: "auto", hide: !1, draggable: !1, snapOnRelease: !0, lockClass: "swiper-scrollbar-lock", dragClass: "swiper-scrollbar-drag" } },
                        create: function () {
                            s.extend(this, {
                                scrollbar: {
                                    init: at.init.bind(this),
                                    destroy: at.destroy.bind(this),
                                    updateSize: at.updateSize.bind(this),
                                    setTranslate: at.setTranslate.bind(this),
                                    setTransition: at.setTransition.bind(this),
                                    enableDraggable: at.enableDraggable.bind(this),
                                    disableDraggable: at.disableDraggable.bind(this),
                                    setDragPosition: at.setDragPosition.bind(this),
                                    getPointerPosition: at.getPointerPosition.bind(this),
                                    onDragStart: at.onDragStart.bind(this),
                                    onDragMove: at.onDragMove.bind(this),
                                    onDragEnd: at.onDragEnd.bind(this),
                                    isTouched: !1,
                                    timeout: null,
                                    dragTimeout: null,
                                },
                            });
                        },
                        on: {
                            init: function () {
                                this.scrollbar.init(), this.scrollbar.updateSize(), this.scrollbar.setTranslate();
                            },
                            update: function () {
                                this.scrollbar.updateSize();
                            },
                            resize: function () {
                                this.scrollbar.updateSize();
                            },
                            observerUpdate: function () {
                                this.scrollbar.updateSize();
                            },
                            setTranslate: function () {
                                this.scrollbar.setTranslate();
                            },
                            setTransition: function (t) {
                                this.scrollbar.setTransition(t);
                            },
                            destroy: function () {
                                this.scrollbar.destroy();
                            },
                        },
                    },
                    {
                        name: "parallax",
                        params: { parallax: { enabled: !1 } },
                        create: function () {
                            s.extend(this, { parallax: { setTransform: it.setTransform.bind(this), setTranslate: it.setTranslate.bind(this), setTransition: it.setTransition.bind(this) } });
                        },
                        on: {
                            beforeInit: function () {
                                this.params.parallax.enabled && ((this.params.watchSlidesProgress = !0), (this.originalParams.watchSlidesProgress = !0));
                            },
                            init: function () {
                                this.params.parallax.enabled && this.parallax.setTranslate();
                            },
                            setTranslate: function () {
                                this.params.parallax.enabled && this.parallax.setTranslate();
                            },
                            setTransition: function (t) {
                                this.params.parallax.enabled && this.parallax.setTransition(t);
                            },
                        },
                    },
                    {
                        name: "zoom",
                        params: { zoom: { enabled: !1, maxRatio: 3, minRatio: 1, toggle: !0, containerClass: "swiper-zoom-container", zoomedSlideClass: "swiper-slide-zoomed" } },
                        create: function () {
                            var t = this,
                                e = {
                                    enabled: !1,
                                    scale: 1,
                                    currentScale: 1,
                                    isScaling: !1,
                                    gesture: { $slideEl: void 0, slideWidth: void 0, slideHeight: void 0, $imageEl: void 0, $imageWrapEl: void 0, maxRatio: 3 },
                                    image: {
                                        isTouched: void 0,
                                        isMoved: void 0,
                                        currentX: void 0,
                                        currentY: void 0,
                                        minX: void 0,
                                        minY: void 0,
                                        maxX: void 0,
                                        maxY: void 0,
                                        width: void 0,
                                        height: void 0,
                                        startX: void 0,
                                        startY: void 0,
                                        touchesStart: {},
                                        touchesCurrent: {},
                                    },
                                    velocity: { x: void 0, y: void 0, prevPositionX: void 0, prevPositionY: void 0, prevTime: void 0 },
                                };
                            "onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out".split(" ").forEach(function (a) {
                                e[a] = rt[a].bind(t);
                            }),
                                s.extend(t, { zoom: e });
                            var a = 1;
                            Object.defineProperty(t.zoom, "scale", {
                                get: function () {
                                    return a;
                                },
                                set: function (e) {
                                    if (a !== e) {
                                        var i = t.zoom.gesture.$imageEl ? t.zoom.gesture.$imageEl[0] : void 0,
                                            r = t.zoom.gesture.$slideEl ? t.zoom.gesture.$slideEl[0] : void 0;
                                        t.emit("zoomChange", e, i, r);
                                    }
                                    a = e;
                                },
                            });
                        },
                        on: {
                            init: function () {
                                this.params.zoom.enabled && this.zoom.enable();
                            },
                            destroy: function () {
                                this.zoom.disable();
                            },
                            touchStart: function (t) {
                                this.zoom.enabled && this.zoom.onTouchStart(t);
                            },
                            touchEnd: function (t) {
                                this.zoom.enabled && this.zoom.onTouchEnd(t);
                            },
                            doubleTap: function (t) {
                                this.params.zoom.enabled && this.zoom.enabled && this.params.zoom.toggle && this.zoom.toggle(t);
                            },
                            transitionEnd: function () {
                                this.zoom.enabled && this.params.zoom.enabled && this.zoom.onTransitionEnd();
                            },
                            slideChange: function () {
                                this.zoom.enabled && this.params.zoom.enabled && this.params.cssMode && this.zoom.onTransitionEnd();
                            },
                        },
                    },
                    {
                        name: "lazy",
                        params: {
                            lazy: {
                                enabled: !1,
                                loadPrevNext: !1,
                                loadPrevNextAmount: 1,
                                loadOnTransitionStart: !1,
                                elementClass: "swiper-lazy",
                                loadingClass: "swiper-lazy-loading",
                                loadedClass: "swiper-lazy-loaded",
                                preloaderClass: "swiper-lazy-preloader",
                            },
                        },
                        create: function () {
                            s.extend(this, { lazy: { initialImageLoaded: !1, load: nt.load.bind(this), loadInSlide: nt.loadInSlide.bind(this) } });
                        },
                        on: {
                            beforeInit: function () {
                                this.params.lazy.enabled && this.params.preloadImages && (this.params.preloadImages = !1);
                            },
                            init: function () {
                                this.params.lazy.enabled && !this.params.loop && 0 === this.params.initialSlide && this.lazy.load();
                            },
                            scroll: function () {
                                this.params.freeMode && !this.params.freeModeSticky && this.lazy.load();
                            },
                            resize: function () {
                                this.params.lazy.enabled && this.lazy.load();
                            },
                            scrollbarDragMove: function () {
                                this.params.lazy.enabled && this.lazy.load();
                            },
                            transitionStart: function () {
                                this.params.lazy.enabled && (this.params.lazy.loadOnTransitionStart || (!this.params.lazy.loadOnTransitionStart && !this.lazy.initialImageLoaded)) && this.lazy.load();
                            },
                            transitionEnd: function () {
                                this.params.lazy.enabled && !this.params.lazy.loadOnTransitionStart && this.lazy.load();
                            },
                            slideChange: function () {
                                this.params.lazy.enabled && this.params.cssMode && this.lazy.load();
                            },
                        },
                    },
                    {
                        name: "controller",
                        params: { controller: { control: void 0, inverse: !1, by: "slide" } },
                        create: function () {
                            s.extend(this, {
                                controller: { control: this.params.controller.control, getInterpolateFunction: st.getInterpolateFunction.bind(this), setTranslate: st.setTranslate.bind(this), setTransition: st.setTransition.bind(this) },
                            });
                        },
                        on: {
                            update: function () {
                                this.controller.control && this.controller.spline && ((this.controller.spline = void 0), delete this.controller.spline);
                            },
                            resize: function () {
                                this.controller.control && this.controller.spline && ((this.controller.spline = void 0), delete this.controller.spline);
                            },
                            observerUpdate: function () {
                                this.controller.control && this.controller.spline && ((this.controller.spline = void 0), delete this.controller.spline);
                            },
                            setTranslate: function (t, e) {
                                this.controller.control && this.controller.setTranslate(t, e);
                            },
                            setTransition: function (t, e) {
                                this.controller.control && this.controller.setTransition(t, e);
                            },
                        },
                    },
                    {
                        name: "a11y",
                        params: {
                            a11y: {
                                enabled: !0,
                                notificationClass: "swiper-notification",
                                prevSlideMessage: "Previous slide",
                                nextSlideMessage: "Next slide",
                                firstSlideMessage: "This is the first slide",
                                lastSlideMessage: "This is the last slide",
                                paginationBulletMessage: "Go to slide {{index}}",
                            },
                        },
                        create: function () {
                            var t = this;
                            s.extend(t, { a11y: { liveRegion: i('<span class="' + t.params.a11y.notificationClass + '" aria-live="assertive" aria-atomic="true"></span>') } }),
                                Object.keys(ot).forEach(function (e) {
                                    t.a11y[e] = ot[e].bind(t);
                                });
                        },
                        on: {
                            init: function () {
                                this.params.a11y.enabled && (this.a11y.init(), this.a11y.updateNavigation());
                            },
                            toEdge: function () {
                                this.params.a11y.enabled && this.a11y.updateNavigation();
                            },
                            fromEdge: function () {
                                this.params.a11y.enabled && this.a11y.updateNavigation();
                            },
                            paginationUpdate: function () {
                                this.params.a11y.enabled && this.a11y.updatePagination();
                            },
                            destroy: function () {
                                this.params.a11y.enabled && this.a11y.destroy();
                            },
                        },
                    },
                    {
                        name: "history",
                        params: { history: { enabled: !1, replaceState: !1, key: "slides" } },
                        create: function () {
                            s.extend(this, {
                                history: { init: lt.init.bind(this), setHistory: lt.setHistory.bind(this), setHistoryPopState: lt.setHistoryPopState.bind(this), scrollToSlide: lt.scrollToSlide.bind(this), destroy: lt.destroy.bind(this) },
                            });
                        },
                        on: {
                            init: function () {
                                this.params.history.enabled && this.history.init();
                            },
                            destroy: function () {
                                this.params.history.enabled && this.history.destroy();
                            },
                            transitionEnd: function () {
                                this.history.initialized && this.history.setHistory(this.params.history.key, this.activeIndex);
                            },
                            slideChange: function () {
                                this.history.initialized && this.params.cssMode && this.history.setHistory(this.params.history.key, this.activeIndex);
                            },
                        },
                    },
                    {
                        name: "hash-navigation",
                        params: { hashNavigation: { enabled: !1, replaceState: !1, watchState: !1 } },
                        create: function () {
                            s.extend(this, { hashNavigation: { initialized: !1, init: ct.init.bind(this), destroy: ct.destroy.bind(this), setHash: ct.setHash.bind(this), onHashCange: ct.onHashCange.bind(this) } });
                        },
                        on: {
                            init: function () {
                                this.params.hashNavigation.enabled && this.hashNavigation.init();
                            },
                            destroy: function () {
                                this.params.hashNavigation.enabled && this.hashNavigation.destroy();
                            },
                            transitionEnd: function () {
                                this.hashNavigation.initialized && this.hashNavigation.setHash();
                            },
                            slideChange: function () {
                                this.hashNavigation.initialized && this.params.cssMode && this.hashNavigation.setHash();
                            },
                        },
                    },
                    {
                        name: "autoplay",
                        params: { autoplay: { enabled: !1, delay: 3e3, waitForTransition: !0, disableOnInteraction: !0, stopOnLastSlide: !1, reverseDirection: !1 } },
                        create: function () {
                            var t = this;
                            s.extend(t, {
                                autoplay: {
                                    running: !1,
                                    paused: !1,
                                    run: dt.run.bind(t),
                                    start: dt.start.bind(t),
                                    stop: dt.stop.bind(t),
                                    pause: dt.pause.bind(t),
                                    onVisibilityChange: function () {
                                        "hidden" === document.visibilityState && t.autoplay.running && t.autoplay.pause(), "visible" === document.visibilityState && t.autoplay.paused && (t.autoplay.run(), (t.autoplay.paused = !1));
                                    },
                                    onTransitionEnd: function (e) {
                                        t &&
                                            !t.destroyed &&
                                            t.$wrapperEl &&
                                            e.target === this &&
                                            (t.$wrapperEl[0].removeEventListener("transitionend", t.autoplay.onTransitionEnd),
                                            t.$wrapperEl[0].removeEventListener("webkitTransitionEnd", t.autoplay.onTransitionEnd),
                                            (t.autoplay.paused = !1),
                                            t.autoplay.running ? t.autoplay.run() : t.autoplay.stop());
                                    },
                                },
                            });
                        },
                        on: {
                            init: function () {
                                this.params.autoplay.enabled && (this.autoplay.start(), document.addEventListener("visibilitychange", this.autoplay.onVisibilityChange));
                            },
                            beforeTransitionStart: function (t, e) {
                                this.autoplay.running && (e || !this.params.autoplay.disableOnInteraction ? this.autoplay.pause(t) : this.autoplay.stop());
                            },
                            sliderFirstMove: function () {
                                this.autoplay.running && (this.params.autoplay.disableOnInteraction ? this.autoplay.stop() : this.autoplay.pause());
                            },
                            touchEnd: function () {
                                this.params.cssMode && this.autoplay.paused && !this.params.autoplay.disableOnInteraction && this.autoplay.run();
                            },
                            destroy: function () {
                                this.autoplay.running && this.autoplay.stop(), document.removeEventListener("visibilitychange", this.autoplay.onVisibilityChange);
                            },
                        },
                    },
                    {
                        name: "effect-fade",
                        params: { fadeEffect: { crossFade: !1 } },
                        create: function () {
                            s.extend(this, { fadeEffect: { setTranslate: pt.setTranslate.bind(this), setTransition: pt.setTransition.bind(this) } });
                        },
                        on: {
                            beforeInit: function () {
                                if ("fade" === this.params.effect) {
                                    this.classNames.push(this.params.containerModifierClass + "fade");
                                    var t = { slidesPerView: 1, slidesPerColumn: 1, slidesPerGroup: 1, watchSlidesProgress: !0, spaceBetween: 0, virtualTranslate: !0 };
                                    s.extend(this.params, t), s.extend(this.originalParams, t);
                                }
                            },
                            setTranslate: function () {
                                "fade" === this.params.effect && this.fadeEffect.setTranslate();
                            },
                            setTransition: function (t) {
                                "fade" === this.params.effect && this.fadeEffect.setTransition(t);
                            },
                        },
                    },
                    {
                        name: "effect-cube",
                        params: { cubeEffect: { slideShadows: !0, shadow: !0, shadowOffset: 20, shadowScale: 0.94 } },
                        create: function () {
                            s.extend(this, { cubeEffect: { setTranslate: ht.setTranslate.bind(this), setTransition: ht.setTransition.bind(this) } });
                        },
                        on: {
                            beforeInit: function () {
                                if ("cube" === this.params.effect) {
                                    this.classNames.push(this.params.containerModifierClass + "cube"), this.classNames.push(this.params.containerModifierClass + "3d");
                                    var t = { slidesPerView: 1, slidesPerColumn: 1, slidesPerGroup: 1, watchSlidesProgress: !0, resistanceRatio: 0, spaceBetween: 0, centeredSlides: !1, virtualTranslate: !0 };
                                    s.extend(this.params, t), s.extend(this.originalParams, t);
                                }
                            },
                            setTranslate: function () {
                                "cube" === this.params.effect && this.cubeEffect.setTranslate();
                            },
                            setTransition: function (t) {
                                "cube" === this.params.effect && this.cubeEffect.setTransition(t);
                            },
                        },
                    },
                    {
                        name: "effect-flip",
                        params: { flipEffect: { slideShadows: !0, limitRotation: !0 } },
                        create: function () {
                            s.extend(this, { flipEffect: { setTranslate: ut.setTranslate.bind(this), setTransition: ut.setTransition.bind(this) } });
                        },
                        on: {
                            beforeInit: function () {
                                if ("flip" === this.params.effect) {
                                    this.classNames.push(this.params.containerModifierClass + "flip"), this.classNames.push(this.params.containerModifierClass + "3d");
                                    var t = { slidesPerView: 1, slidesPerColumn: 1, slidesPerGroup: 1, watchSlidesProgress: !0, spaceBetween: 0, virtualTranslate: !0 };
                                    s.extend(this.params, t), s.extend(this.originalParams, t);
                                }
                            },
                            setTranslate: function () {
                                "flip" === this.params.effect && this.flipEffect.setTranslate();
                            },
                            setTransition: function (t) {
                                "flip" === this.params.effect && this.flipEffect.setTransition(t);
                            },
                        },
                    },
                    {
                        name: "effect-coverflow",
                        params: { coverflowEffect: { rotate: 50, stretch: 0, depth: 100, modifier: 1, slideShadows: !0 } },
                        create: function () {
                            s.extend(this, { coverflowEffect: { setTranslate: mt.setTranslate.bind(this), setTransition: mt.setTransition.bind(this) } });
                        },
                        on: {
                            beforeInit: function () {
                                "coverflow" === this.params.effect &&
                                    (this.classNames.push(this.params.containerModifierClass + "coverflow"),
                                    this.classNames.push(this.params.containerModifierClass + "3d"),
                                    (this.params.watchSlidesProgress = !0),
                                    (this.originalParams.watchSlidesProgress = !0));
                            },
                            setTranslate: function () {
                                "coverflow" === this.params.effect && this.coverflowEffect.setTranslate();
                            },
                            setTransition: function (t) {
                                "coverflow" === this.params.effect && this.coverflowEffect.setTransition(t);
                            },
                        },
                    },
                    {
                        name: "thumbs",
                        params: { thumbs: { multipleActiveThumbs: !0, swiper: null, slideThumbActiveClass: "swiper-slide-thumb-active", thumbsContainerClass: "swiper-container-thumbs" } },
                        create: function () {
                            s.extend(this, { thumbs: { swiper: null, init: ft.init.bind(this), update: ft.update.bind(this), onThumbClick: ft.onThumbClick.bind(this) } });
                        },
                        on: {
                            beforeInit: function () {
                                var t = this.params.thumbs;
                                t && t.swiper && (this.thumbs.init(), this.thumbs.update(!0));
                            },
                            slideChange: function () {
                                this.thumbs.swiper && this.thumbs.update();
                            },
                            update: function () {
                                this.thumbs.swiper && this.thumbs.update();
                            },
                            resize: function () {
                                this.thumbs.swiper && this.thumbs.update();
                            },
                            observerUpdate: function () {
                                this.thumbs.swiper && this.thumbs.update();
                            },
                            setTransition: function (t) {
                                var e = this.thumbs.swiper;
                                e && e.setTransition(t);
                            },
                            beforeDestroy: function () {
                                var t = this.thumbs.swiper;
                                t && this.thumbs.swiperCreated && t && t.destroy();
                            },
                        },
                    },
                ];
            return void 0 === N.use && ((N.use = N.Class.use), (N.installModule = N.Class.installModule)), N.use(gt), N;
        }),
        "object" == typeof exports && "undefined" != typeof module ? (module.exports = e()) : "function" == typeof define && define.amd ? define(e) : ((t = t || self).Swiper = e()),
        myAppJavaScript(jQuery191);
});